var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t
}
var lottie$1 = {
    exports: {}
};
(function(module, exports) {
    typeof navigator < "u" && function(t, e) {
        module.exports = e()
    }(commonjsGlobal, function() {
        var svgNS = "http://www.w3.org/2000/svg"
          , locationHref = ""
          , _useWebWorker = !1
          , initialDefaultFrame = -999999
          , setWebWorker = function(e) {
            _useWebWorker = !!e
        }
          , getWebWorker = function() {
            return _useWebWorker
        }
          , setLocationHref = function(e) {
            locationHref = e
        }
          , getLocationHref = function() {
            return locationHref
        };
        function createTag(t) {
            return document.createElement(t)
        }
        function extendPrototype(t, e) {
            var r, i = t.length, s;
            for (r = 0; r < i; r += 1) {
                s = t[r].prototype;
                for (var n in s)
                    Object.prototype.hasOwnProperty.call(s, n) && (e.prototype[n] = s[n])
            }
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e)
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t,
            e
        }
        var audioControllerFactory = function() {
            function t(e) {
                this.audios = [],
                this.audioFactory = e,
                this._volume = 1,
                this._isMuted = !1
            }
            return t.prototype = {
                addAudio: function(r) {
                    this.audios.push(r)
                },
                pause: function() {
                    var r, i = this.audios.length;
                    for (r = 0; r < i; r += 1)
                        this.audios[r].pause()
                },
                resume: function() {
                    var r, i = this.audios.length;
                    for (r = 0; r < i; r += 1)
                        this.audios[r].resume()
                },
                setRate: function(r) {
                    var i, s = this.audios.length;
                    for (i = 0; i < s; i += 1)
                        this.audios[i].setRate(r)
                },
                createAudio: function(r) {
                    return this.audioFactory ? this.audioFactory(r) : window.Howl ? new window.Howl({
                        src: [r]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0
                        },
                        seek: function() {
                            this.isPlaying = !1
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    }
                },
                setAudioFactory: function(r) {
                    this.audioFactory = r
                },
                setVolume: function(r) {
                    this._volume = r,
                    this._updateVolume()
                },
                mute: function() {
                    this._isMuted = !0,
                    this._updateVolume()
                },
                unmute: function() {
                    this._isMuted = !1,
                    this._updateVolume()
                },
                getVolume: function() {
                    return this._volume
                },
                _updateVolume: function() {
                    var r, i = this.audios.length;
                    for (r = 0; r < i; r += 1)
                        this.audios[r].volume(this._volume * (this._isMuted ? 0 : 1))
                }
            },
            function() {
                return new t
            }
        }()
          , createTypedArray = function() {
            function t(r, i) {
                var s = 0, n = [], a;
                switch (r) {
                case "int16":
                case "uint8c":
                    a = 1;
                    break;
                default:
                    a = 1.1;
                    break
                }
                for (s = 0; s < i; s += 1)
                    n.push(a);
                return n
            }
            function e(r, i) {
                return r === "float32" ? new Float32Array(i) : r === "int16" ? new Int16Array(i) : r === "uint8c" ? new Uint8ClampedArray(i) : t(r, i)
            }
            return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? e : t
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            })
        }
        function _typeof$6(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(r) {
                return typeof r
            }
            : _typeof$6 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$6(t)
        }
        var subframeEnabled = !0
          , expressionsPlugin = null
          , expressionsInterfaces = null
          , idPrefix$1 = ""
          , isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
          , bmPow = Math.pow
          , bmSqrt = Math.sqrt
          , bmFloor = Math.floor
          , bmMax = Math.max
          , bmMin = Math.min
          , BMMath = {};
        (function() {
            var t = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], e, r = t.length;
            for (e = 0; e < r; e += 1)
                BMMath[t[e]] = Math[t[e]]
        }
        )(),
        BMMath.random = Math.random,
        BMMath.abs = function(t) {
            var e = _typeof$6(t);
            if (e === "object" && t.length) {
                var r = createSizedArray(t.length), i, s = t.length;
                for (i = 0; i < s; i += 1)
                    r[i] = Math.abs(t[i]);
                return r
            }
            return Math.abs(t)
        }
        ;
        var defaultCurveSegments = 150
          , degToRads = Math.PI / 180
          , roundCorner = .5519;
        function styleDiv(t) {
            t.style.position = "absolute",
            t.style.top = 0,
            t.style.left = 0,
            t.style.display = "block",
            t.style.transformOrigin = "0 0",
            t.style.webkitTransformOrigin = "0 0",
            t.style.backfaceVisibility = "visible",
            t.style.webkitBackfaceVisibility = "visible",
            t.style.transformStyle = "preserve-3d",
            t.style.webkitTransformStyle = "preserve-3d",
            t.style.mozTransformStyle = "preserve-3d"
        }
        function BMEnterFrameEvent(t, e, r, i) {
            this.type = t,
            this.currentTime = e,
            this.totalTime = r,
            this.direction = i < 0 ? -1 : 1
        }
        function BMCompleteEvent(t, e) {
            this.type = t,
            this.direction = e < 0 ? -1 : 1
        }
        function BMCompleteLoopEvent(t, e, r, i) {
            this.type = t,
            this.currentLoop = r,
            this.totalLoops = e,
            this.direction = i < 0 ? -1 : 1
        }
        function BMSegmentStartEvent(t, e, r) {
            this.type = t,
            this.firstFrame = e,
            this.totalFrames = r
        }
        function BMDestroyEvent(t, e) {
            this.type = t,
            this.target = e
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError",
            this.nativeError = t,
            this.currentTime = e
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError",
            this.nativeError = t
        }
        var createElementID = function() {
            var t = 0;
            return function() {
                return t += 1,
                idPrefix$1 + "__lottie_element_" + t
            }
        }();
        function HSVtoRGB(t, e, r) {
            var i, s, n, a, l, o, h, p;
            switch (a = Math.floor(t * 6),
            l = t * 6 - a,
            o = r * (1 - e),
            h = r * (1 - l * e),
            p = r * (1 - (1 - l) * e),
            a % 6) {
            case 0:
                i = r,
                s = p,
                n = o;
                break;
            case 1:
                i = h,
                s = r,
                n = o;
                break;
            case 2:
                i = o,
                s = r,
                n = p;
                break;
            case 3:
                i = o,
                s = h,
                n = r;
                break;
            case 4:
                i = p,
                s = o,
                n = r;
                break;
            case 5:
                i = r,
                s = o,
                n = h;
                break
            }
            return [i, s, n]
        }
        function RGBtoHSV(t, e, r) {
            var i = Math.max(t, e, r), s = Math.min(t, e, r), n = i - s, a, l = i === 0 ? 0 : n / i, o = i / 255;
            switch (i) {
            case s:
                a = 0;
                break;
            case t:
                a = e - r + n * (e < r ? 6 : 0),
                a /= 6 * n;
                break;
            case e:
                a = r - t + n * 2,
                a /= 6 * n;
                break;
            case r:
                a = t - e + n * 4,
                a /= 6 * n;
                break
            }
            return [a, l, o]
        }
        function addSaturationToRGB(t, e) {
            var r = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
            return r[1] += e,
            r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0),
            HSVtoRGB(r[0], r[1], r[2])
        }
        function addBrightnessToRGB(t, e) {
            var r = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
            return r[2] += e,
            r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0),
            HSVtoRGB(r[0], r[1], r[2])
        }
        function addHueToRGB(t, e) {
            var r = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
            return r[0] += e / 360,
            r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1),
            HSVtoRGB(r[0], r[1], r[2])
        }
        var rgbToHex = function() {
            var t = [], e, r;
            for (e = 0; e < 256; e += 1)
                r = e.toString(16),
                t[e] = r.length === 1 ? "0" + r : r;
            return function(i, s, n) {
                return i < 0 && (i = 0),
                s < 0 && (s = 0),
                n < 0 && (n = 0),
                "#" + t[i] + t[s] + t[n]
            }
        }()
          , setSubframeEnabled = function(e) {
            subframeEnabled = !!e
        }
          , getSubframeEnabled = function() {
            return subframeEnabled
        }
          , setExpressionsPlugin = function(e) {
            expressionsPlugin = e
        }
          , getExpressionsPlugin = function() {
            return expressionsPlugin
        }
          , setExpressionInterfaces = function(e) {
            expressionsInterfaces = e
        }
          , getExpressionInterfaces = function() {
            return expressionsInterfaces
        }
          , setDefaultCurveSegments = function(e) {
            defaultCurveSegments = e
        }
          , getDefaultCurveSegments = function() {
            return defaultCurveSegments
        }
          , setIdPrefix = function(e) {
            idPrefix$1 = e
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t)
        }
        function _typeof$5(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(r) {
                return typeof r
            }
            : _typeof$5 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$5(t)
        }
        var dataManager = function() {
            var t = 1, e = [], r, i, s = {
                onmessage: function() {},
                postMessage: function(g) {
                    r({
                        data: g
                    })
                }
            }, n = {
                postMessage: function(g) {
                    s.onmessage({
                        data: g
                    })
                }
            };
            function a(c) {
                if (window.Worker && window.Blob && getWebWorker()) {
                    var g = new Blob(["var _workerSelf = self; self.onmessage = ", c.toString()],{
                        type: "text/javascript"
                    })
                      , v = URL.createObjectURL(g);
                    return new Worker(v)
                }
                return r = c,
                s
            }
            function l() {
                i || (i = a(function(g) {
                    function v() {
                        function b(R, P) {
                            var M, E, A = R.length, F, I, N, $;
                            for (E = 0; E < A; E += 1)
                                if (M = R[E],
                                "ks"in M && !M.completed) {
                                    if (M.completed = !0,
                                    M.hasMask) {
                                        var H = M.masksProperties;
                                        for (I = H.length,
                                        F = 0; F < I; F += 1)
                                            if (H[F].pt.k.i)
                                                _(H[F].pt.k);
                                            else
                                                for ($ = H[F].pt.k.length,
                                                N = 0; N < $; N += 1)
                                                    H[F].pt.k[N].s && _(H[F].pt.k[N].s[0]),
                                                    H[F].pt.k[N].e && _(H[F].pt.k[N].e[0])
                                    }
                                    M.ty === 0 ? (M.layers = f(M.refId, P),
                                    b(M.layers, P)) : M.ty === 4 ? y(M.shapes) : M.ty === 5 && V(M)
                                }
                        }
                        function u(R, P) {
                            if (R) {
                                var M = 0
                                  , E = R.length;
                                for (M = 0; M < E; M += 1)
                                    R[M].t === 1 && (R[M].data.layers = f(R[M].data.refId, P),
                                    b(R[M].data.layers, P))
                            }
                        }
                        function m(R, P) {
                            for (var M = 0, E = P.length; M < E; ) {
                                if (P[M].id === R)
                                    return P[M];
                                M += 1
                            }
                            return null
                        }
                        function f(R, P) {
                            var M = m(R, P);
                            return M ? M.layers.__used ? JSON.parse(JSON.stringify(M.layers)) : (M.layers.__used = !0,
                            M.layers) : null
                        }
                        function y(R) {
                            var P, M = R.length, E, A;
                            for (P = M - 1; P >= 0; P -= 1)
                                if (R[P].ty === "sh")
                                    if (R[P].ks.k.i)
                                        _(R[P].ks.k);
                                    else
                                        for (A = R[P].ks.k.length,
                                        E = 0; E < A; E += 1)
                                            R[P].ks.k[E].s && _(R[P].ks.k[E].s[0]),
                                            R[P].ks.k[E].e && _(R[P].ks.k[E].e[0]);
                                else
                                    R[P].ty === "gr" && y(R[P].it)
                        }
                        function _(R) {
                            var P, M = R.i.length;
                            for (P = 0; P < M; P += 1)
                                R.i[P][0] += R.v[P][0],
                                R.i[P][1] += R.v[P][1],
                                R.o[P][0] += R.v[P][0],
                                R.o[P][1] += R.v[P][1]
                        }
                        function T(R, P) {
                            var M = P ? P.split(".") : [100, 100, 100];
                            return R[0] > M[0] ? !0 : M[0] > R[0] ? !1 : R[1] > M[1] ? !0 : M[1] > R[1] ? !1 : R[2] > M[2] ? !0 : M[2] > R[2] ? !1 : null
                        }
                        var C = function() {
                            var R = [4, 4, 14];
                            function P(E) {
                                var A = E.t.d;
                                E.t.d = {
                                    k: [{
                                        s: A,
                                        t: 0
                                    }]
                                }
                            }
                            function M(E) {
                                var A, F = E.length;
                                for (A = 0; A < F; A += 1)
                                    E[A].ty === 5 && P(E[A])
                            }
                            return function(E) {
                                if (T(R, E.v) && (M(E.layers),
                                E.assets)) {
                                    var A, F = E.assets.length;
                                    for (A = 0; A < F; A += 1)
                                        E.assets[A].layers && M(E.assets[A].layers)
                                }
                            }
                        }()
                          , x = function() {
                            var R = [4, 7, 99];
                            return function(P) {
                                if (P.chars && !T(R, P.v)) {
                                    var M, E = P.chars.length;
                                    for (M = 0; M < E; M += 1) {
                                        var A = P.chars[M];
                                        A.data && A.data.shapes && (y(A.data.shapes),
                                        A.data.ip = 0,
                                        A.data.op = 99999,
                                        A.data.st = 0,
                                        A.data.sr = 1,
                                        A.data.ks = {
                                            p: {
                                                k: [0, 0],
                                                a: 0
                                            },
                                            s: {
                                                k: [100, 100],
                                                a: 0
                                            },
                                            a: {
                                                k: [0, 0],
                                                a: 0
                                            },
                                            r: {
                                                k: 0,
                                                a: 0
                                            },
                                            o: {
                                                k: 100,
                                                a: 0
                                            }
                                        },
                                        P.chars[M].t || (A.data.shapes.push({
                                            ty: "no"
                                        }),
                                        A.data.shapes[0].it.push({
                                            p: {
                                                k: [0, 0],
                                                a: 0
                                            },
                                            s: {
                                                k: [100, 100],
                                                a: 0
                                            },
                                            a: {
                                                k: [0, 0],
                                                a: 0
                                            },
                                            r: {
                                                k: 0,
                                                a: 0
                                            },
                                            o: {
                                                k: 100,
                                                a: 0
                                            },
                                            sk: {
                                                k: 0,
                                                a: 0
                                            },
                                            sa: {
                                                k: 0,
                                                a: 0
                                            },
                                            ty: "tr"
                                        })))
                                    }
                                }
                            }
                        }()
                          , w = function() {
                            var R = [5, 7, 15];
                            function P(E) {
                                var A = E.t.p;
                                typeof A.a == "number" && (A.a = {
                                    a: 0,
                                    k: A.a
                                }),
                                typeof A.p == "number" && (A.p = {
                                    a: 0,
                                    k: A.p
                                }),
                                typeof A.r == "number" && (A.r = {
                                    a: 0,
                                    k: A.r
                                })
                            }
                            function M(E) {
                                var A, F = E.length;
                                for (A = 0; A < F; A += 1)
                                    E[A].ty === 5 && P(E[A])
                            }
                            return function(E) {
                                if (T(R, E.v) && (M(E.layers),
                                E.assets)) {
                                    var A, F = E.assets.length;
                                    for (A = 0; A < F; A += 1)
                                        E.assets[A].layers && M(E.assets[A].layers)
                                }
                            }
                        }()
                          , D = function() {
                            var R = [4, 1, 9];
                            function P(E) {
                                var A, F = E.length, I, N;
                                for (A = 0; A < F; A += 1)
                                    if (E[A].ty === "gr")
                                        P(E[A].it);
                                    else if (E[A].ty === "fl" || E[A].ty === "st")
                                        if (E[A].c.k && E[A].c.k[0].i)
                                            for (N = E[A].c.k.length,
                                            I = 0; I < N; I += 1)
                                                E[A].c.k[I].s && (E[A].c.k[I].s[0] /= 255,
                                                E[A].c.k[I].s[1] /= 255,
                                                E[A].c.k[I].s[2] /= 255,
                                                E[A].c.k[I].s[3] /= 255),
                                                E[A].c.k[I].e && (E[A].c.k[I].e[0] /= 255,
                                                E[A].c.k[I].e[1] /= 255,
                                                E[A].c.k[I].e[2] /= 255,
                                                E[A].c.k[I].e[3] /= 255);
                                        else
                                            E[A].c.k[0] /= 255,
                                            E[A].c.k[1] /= 255,
                                            E[A].c.k[2] /= 255,
                                            E[A].c.k[3] /= 255
                            }
                            function M(E) {
                                var A, F = E.length;
                                for (A = 0; A < F; A += 1)
                                    E[A].ty === 4 && P(E[A].shapes)
                            }
                            return function(E) {
                                if (T(R, E.v) && (M(E.layers),
                                E.assets)) {
                                    var A, F = E.assets.length;
                                    for (A = 0; A < F; A += 1)
                                        E.assets[A].layers && M(E.assets[A].layers)
                                }
                            }
                        }()
                          , k = function() {
                            var R = [4, 4, 18];
                            function P(E) {
                                var A, F = E.length, I, N;
                                for (A = F - 1; A >= 0; A -= 1)
                                    if (E[A].ty === "sh")
                                        if (E[A].ks.k.i)
                                            E[A].ks.k.c = E[A].closed;
                                        else
                                            for (N = E[A].ks.k.length,
                                            I = 0; I < N; I += 1)
                                                E[A].ks.k[I].s && (E[A].ks.k[I].s[0].c = E[A].closed),
                                                E[A].ks.k[I].e && (E[A].ks.k[I].e[0].c = E[A].closed);
                                    else
                                        E[A].ty === "gr" && P(E[A].it)
                            }
                            function M(E) {
                                var A, F, I = E.length, N, $, H, W;
                                for (F = 0; F < I; F += 1) {
                                    if (A = E[F],
                                    A.hasMask) {
                                        var B = A.masksProperties;
                                        for ($ = B.length,
                                        N = 0; N < $; N += 1)
                                            if (B[N].pt.k.i)
                                                B[N].pt.k.c = B[N].cl;
                                            else
                                                for (W = B[N].pt.k.length,
                                                H = 0; H < W; H += 1)
                                                    B[N].pt.k[H].s && (B[N].pt.k[H].s[0].c = B[N].cl),
                                                    B[N].pt.k[H].e && (B[N].pt.k[H].e[0].c = B[N].cl)
                                    }
                                    A.ty === 4 && P(A.shapes)
                                }
                            }
                            return function(E) {
                                if (T(R, E.v) && (M(E.layers),
                                E.assets)) {
                                    var A, F = E.assets.length;
                                    for (A = 0; A < F; A += 1)
                                        E.assets[A].layers && M(E.assets[A].layers)
                                }
                            }
                        }();
                        function L(R) {
                            R.__complete || (D(R),
                            C(R),
                            x(R),
                            w(R),
                            k(R),
                            b(R.layers, R.assets),
                            u(R.chars, R.assets),
                            R.__complete = !0)
                        }
                        function V(R) {
                            R.t.a.length === 0 && "m"in R.t.p
                        }
                        var O = {};
                        return O.completeData = L,
                        O.checkColors = D,
                        O.checkChars = x,
                        O.checkPathProperties = w,
                        O.checkShapes = k,
                        O.completeLayers = b,
                        O
                    }
                    if (n.dataManager || (n.dataManager = v()),
                    n.assetLoader || (n.assetLoader = function() {
                        function b(m) {
                            var f = m.getResponseHeader("content-type");
                            return f && m.responseType === "json" && f.indexOf("json") !== -1 || m.response && _typeof$5(m.response) === "object" ? m.response : m.response && typeof m.response == "string" ? JSON.parse(m.response) : m.responseText ? JSON.parse(m.responseText) : null
                        }
                        function u(m, f, y, _) {
                            var T, C = new XMLHttpRequest;
                            try {
                                C.responseType = "json"
                            } catch {}
                            C.onreadystatechange = function() {
                                if (C.readyState === 4)
                                    if (C.status === 200)
                                        T = b(C),
                                        y(T);
                                    else
                                        try {
                                            T = b(C),
                                            y(T)
                                        } catch (x) {
                                            _ && _(x)
                                        }
                            }
                            ;
                            try {
                                C.open(["G", "E", "T"].join(""), m, !0)
                            } catch {
                                C.open(["G", "E", "T"].join(""), f + "/" + m, !0)
                            }
                            C.send()
                        }
                        return {
                            load: u
                        }
                    }()),
                    g.data.type === "loadAnimation")
                        n.assetLoader.load(g.data.path, g.data.fullPath, function(b) {
                            n.dataManager.completeData(b),
                            n.postMessage({
                                id: g.data.id,
                                payload: b,
                                status: "success"
                            })
                        }, function() {
                            n.postMessage({
                                id: g.data.id,
                                status: "error"
                            })
                        });
                    else if (g.data.type === "complete") {
                        var d = g.data.animation;
                        n.dataManager.completeData(d),
                        n.postMessage({
                            id: g.data.id,
                            payload: d,
                            status: "success"
                        })
                    } else
                        g.data.type === "loadData" && n.assetLoader.load(g.data.path, g.data.fullPath, function(b) {
                            n.postMessage({
                                id: g.data.id,
                                payload: b,
                                status: "success"
                            })
                        }, function() {
                            n.postMessage({
                                id: g.data.id,
                                status: "error"
                            })
                        })
                }),
                i.onmessage = function(c) {
                    var g = c.data
                      , v = g.id
                      , d = e[v];
                    e[v] = null,
                    g.status === "success" ? d.onComplete(g.payload) : d.onError && d.onError()
                }
                )
            }
            function o(c, g) {
                t += 1;
                var v = "processId_" + t;
                return e[v] = {
                    onComplete: c,
                    onError: g
                },
                v
            }
            function h(c, g, v) {
                l();
                var d = o(g, v);
                i.postMessage({
                    type: "loadAnimation",
                    path: c,
                    fullPath: window.location.origin + window.location.pathname,
                    id: d
                })
            }
            function p(c, g, v) {
                l();
                var d = o(g, v);
                i.postMessage({
                    type: "loadData",
                    path: c,
                    fullPath: window.location.origin + window.location.pathname,
                    id: d
                })
            }
            function S(c, g, v) {
                l();
                var d = o(g, v);
                i.postMessage({
                    type: "complete",
                    animation: c,
                    id: d
                })
            }
            return {
                loadAnimation: h,
                loadData: p,
                completeAnimation: S
            }
        }()
          , ImagePreloader = function() {
            var t = function() {
                var u = createTag("canvas");
                u.width = 1,
                u.height = 1;
                var m = u.getContext("2d");
                return m.fillStyle = "rgba(0,0,0,0)",
                m.fillRect(0, 0, 1, 1),
                u
            }();
            function e() {
                this.loadedAssets += 1,
                this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null)
            }
            function r() {
                this.loadedFootagesCount += 1,
                this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null)
            }
            function i(u, m, f) {
                var y = "";
                if (u.e)
                    y = u.p;
                else if (m) {
                    var _ = u.p;
                    _.indexOf("images/") !== -1 && (_ = _.split("/")[1]),
                    y = m + _
                } else
                    y = f,
                    y += u.u ? u.u : "",
                    y += u.p;
                return y
            }
            function s(u) {
                var m = 0
                  , f = setInterval((function() {
                    var y = u.getBBox();
                    (y.width || m > 500) && (this._imageLoaded(),
                    clearInterval(f)),
                    m += 1
                }
                ).bind(this), 50)
            }
            function n(u) {
                var m = i(u, this.assetsPath, this.path)
                  , f = createNS("image");
                isSafari ? this.testImageLoaded(f) : f.addEventListener("load", this._imageLoaded, !1),
                f.addEventListener("error", (function() {
                    y.img = t,
                    this._imageLoaded()
                }
                ).bind(this), !1),
                f.setAttributeNS("http://www.w3.org/1999/xlink", "href", m),
                this._elementHelper.append ? this._elementHelper.append(f) : this._elementHelper.appendChild(f);
                var y = {
                    img: f,
                    assetData: u
                };
                return y
            }
            function a(u) {
                var m = i(u, this.assetsPath, this.path)
                  , f = createTag("img");
                f.crossOrigin = "anonymous",
                f.addEventListener("load", this._imageLoaded, !1),
                f.addEventListener("error", (function() {
                    y.img = t,
                    this._imageLoaded()
                }
                ).bind(this), !1),
                f.src = m;
                var y = {
                    img: f,
                    assetData: u
                };
                return y
            }
            function l(u) {
                var m = {
                    assetData: u
                }
                  , f = i(u, this.assetsPath, this.path);
                return dataManager.loadData(f, (function(y) {
                    m.img = y,
                    this._footageLoaded()
                }
                ).bind(this), (function() {
                    m.img = {},
                    this._footageLoaded()
                }
                ).bind(this)),
                m
            }
            function o(u, m) {
                this.imagesLoadedCb = m;
                var f, y = u.length;
                for (f = 0; f < y; f += 1)
                    u[f].layers || (!u[f].t || u[f].t === "seq" ? (this.totalImages += 1,
                    this.images.push(this._createImageData(u[f]))) : u[f].t === 3 && (this.totalFootages += 1,
                    this.images.push(this.createFootageData(u[f]))))
            }
            function h(u) {
                this.path = u || ""
            }
            function p(u) {
                this.assetsPath = u || ""
            }
            function S(u) {
                for (var m = 0, f = this.images.length; m < f; ) {
                    if (this.images[m].assetData === u)
                        return this.images[m].img;
                    m += 1
                }
                return null
            }
            function c() {
                this.imagesLoadedCb = null,
                this.images.length = 0
            }
            function g() {
                return this.totalImages === this.loadedAssets
            }
            function v() {
                return this.totalFootages === this.loadedFootagesCount
            }
            function d(u, m) {
                u === "svg" ? (this._elementHelper = m,
                this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this)
            }
            function b() {
                this._imageLoaded = e.bind(this),
                this._footageLoaded = r.bind(this),
                this.testImageLoaded = s.bind(this),
                this.createFootageData = l.bind(this),
                this.assetsPath = "",
                this.path = "",
                this.totalImages = 0,
                this.totalFootages = 0,
                this.loadedAssets = 0,
                this.loadedFootagesCount = 0,
                this.imagesLoadedCb = null,
                this.images = []
            }
            return b.prototype = {
                loadAssets: o,
                setAssetsPath: p,
                setPath: h,
                loadedImages: g,
                loadedFootages: v,
                destroy: c,
                getAsset: S,
                createImgData: a,
                createImageData: n,
                imageLoaded: e,
                footageLoaded: r,
                setCacheType: d
            },
            b
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(e, r) {
                if (this._cbs[e])
                    for (var i = this._cbs[e], s = 0; s < i.length; s += 1)
                        i[s](r)
            },
            addEventListener: function(e, r) {
                return this._cbs[e] || (this._cbs[e] = []),
                this._cbs[e].push(r),
                (function() {
                    this.removeEventListener(e, r)
                }
                ).bind(this)
            },
            removeEventListener: function(e, r) {
                if (!r)
                    this._cbs[e] = null;
                else if (this._cbs[e]) {
                    for (var i = 0, s = this._cbs[e].length; i < s; )
                        this._cbs[e][i] === r && (this._cbs[e].splice(i, 1),
                        i -= 1,
                        s -= 1),
                        i += 1;
                    this._cbs[e].length || (this._cbs[e] = null)
                }
            }
        };
        var markerParser = function() {
            function t(e) {
                for (var r = e.split(`\r
`), i = {}, s, n = 0, a = 0; a < r.length; a += 1)
                    s = r[a].split(":"),
                    s.length === 2 && (i[s[0]] = s[1].trim(),
                    n += 1);
                if (n === 0)
                    throw new Error;
                return i
            }
            return function(e) {
                for (var r = [], i = 0; i < e.length; i += 1) {
                    var s = e[i]
                      , n = {
                        time: s.tm,
                        duration: s.dr
                    };
                    try {
                        n.payload = JSON.parse(e[i].cm)
                    } catch {
                        try {
                            n.payload = t(e[i].cm)
                        } catch {
                            n.payload = {
                                name: e[i].cm
                            }
                        }
                    }
                    r.push(n)
                }
                return r
            }
        }()
          , ProjectInterface = function() {
            function t(e) {
                this.compositions.push(e)
            }
            return function() {
                function e(r) {
                    for (var i = 0, s = this.compositions.length; i < s; ) {
                        if (this.compositions[i].data && this.compositions[i].data.nm === r)
                            return this.compositions[i].prepareFrame && this.compositions[i].data.xt && this.compositions[i].prepareFrame(this.currentFrame),
                            this.compositions[i].compInterface;
                        i += 1
                    }
                    return null
                }
                return e.compositions = [],
                e.currentFrame = 0,
                e.registerComposition = t,
                e
            }
        }()
          , renderers = {}
          , registerRenderer = function(e, r) {
            renderers[e] = r
        };
        function getRenderer(t) {
            return renderers[t]
        }
        function getRegisteredRenderer() {
            if (renderers.canvas)
                return "canvas";
            for (var t in renderers)
                if (renderers[t])
                    return t;
            return ""
        }
        function _typeof$4(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(r) {
                return typeof r
            }
            : _typeof$4 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$4(t)
        }
        var AnimationItem = function() {
            this._cbs = [],
            this.name = "",
            this.path = "",
            this.isLoaded = !1,
            this.currentFrame = 0,
            this.currentRawFrame = 0,
            this.firstFrame = 0,
            this.totalFrames = 0,
            this.frameRate = 0,
            this.frameMult = 0,
            this.playSpeed = 1,
            this.playDirection = 1,
            this.playCount = 0,
            this.animationData = {},
            this.assets = [],
            this.isPaused = !0,
            this.autoplay = !1,
            this.loop = !0,
            this.renderer = null,
            this.animationID = createElementID(),
            this.assetsPath = "",
            this.timeCompleted = 0,
            this.segmentPos = 0,
            this.isSubframeEnabled = getSubframeEnabled(),
            this.segments = [],
            this._idle = !0,
            this._completedLoop = !1,
            this.projectInterface = ProjectInterface(),
            this.imagePreloader = new ImagePreloader,
            this.audioController = audioControllerFactory(),
            this.markers = [],
            this.configAnimation = this.configAnimation.bind(this),
            this.onSetupError = this.onSetupError.bind(this),
            this.onSegmentComplete = this.onSegmentComplete.bind(this),
            this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame",0,0,0),
            this.expressionsPlugin = getExpressionsPlugin()
        };
        extendPrototype([BaseEvent], AnimationItem),
        AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r = getRenderer(e);
            this.renderer = new r(this,t.rendererSettings),
            this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
            this.renderer.setProjectInterface(this.projectInterface),
            this.animType = e,
            t.loop === "" || t.loop === null || t.loop === void 0 || t.loop === !0 ? this.loop = !0 : t.loop === !1 ? this.loop = !1 : this.loop = parseInt(t.loop, 10),
            this.autoplay = "autoplay"in t ? t.autoplay : !0,
            this.name = t.name ? t.name : "",
            this.autoloadSegments = Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ? t.autoloadSegments : !0,
            this.assetsPath = t.assetsPath,
            this.initialSegment = t.initialSegment,
            t.audioFactory && this.audioController.setAudioFactory(t.audioFactory),
            t.animationData ? this.setupAnimation(t.animationData) : t.path && (t.path.lastIndexOf("\\") !== -1 ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1),
            this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1),
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")),
            dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError))
        }
        ,
        AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed")
        }
        ,
        AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation)
        }
        ,
        AnimationItem.prototype.setData = function(t, e) {
            e && _typeof$4(e) !== "object" && (e = JSON.parse(e));
            var r = {
                wrapper: t,
                animationData: e
            }
              , i = t.attributes;
            r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "",
            r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var s = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            s === "false" ? r.loop = !1 : s === "true" ? r.loop = !0 : s !== "" && (r.loop = parseInt(s, 10));
            var n = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : i.getNamedItem("bm-autoplay") ? i.getNamedItem("bm-autoplay").value : !0;
            r.autoplay = n !== "false",
            r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "";
            var a = i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "";
            a === "false" && (r.prerender = !1),
            r.path ? this.setParams(r) : this.trigger("destroy")
        }
        ,
        AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op,
            this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e = this.animationData.layers, r, i = e.length, s = t.layers, n, a = s.length;
            for (n = 0; n < a; n += 1)
                for (r = 0; r < i; ) {
                    if (e[r].id === s[n].id) {
                        e[r] = s[n];
                        break
                    }
                    r += 1
                }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars),
            this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)),
            t.assets)
                for (i = t.assets.length,
                r = 0; r < i; r += 1)
                    this.animationData.assets.push(t.assets[r]);
            this.animationData.__complete = !1,
            dataManager.completeAnimation(this.animationData, this.onSegmentComplete)
        }
        ,
        AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this),
            this.loadNextSegment()
        }
        ,
        AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || t.length === 0 || !this.autoloadSegments) {
                this.trigger("data_ready"),
                this.timeCompleted = this.totalFrames;
                return
            }
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1,
            dataManager.loadData(r, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed")
            }
            ).bind(this))
        }
        ,
        AnimationItem.prototype.loadSegments = function() {
            var t = this.animationData.segments;
            t || (this.timeCompleted = this.totalFrames),
            this.loadNextSegment()
        }
        ,
        AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"),
            this.checkLoaded()
        }
        ,
        AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath),
            this.imagePreloader.setPath(this.path),
            this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this))
        }
        ,
        AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer)
                try {
                    this.animationData = t,
                    this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]),
                    this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip),
                    this.firstFrame = Math.round(this.animationData.ip)),
                    this.renderer.configAnimation(t),
                    t.assets || (t.assets = []),
                    this.assets = this.animationData.assets,
                    this.frameRate = this.animationData.fr,
                    this.frameMult = this.animationData.fr / 1e3,
                    this.renderer.searchExtraCompositions(t.assets),
                    this.markers = markerParser(t.markers || []),
                    this.trigger("config_ready"),
                    this.preloadImages(),
                    this.loadSegments(),
                    this.updaFrameModifier(),
                    this.waitForFontsLoaded(),
                    this.isPaused && this.audioController.pause()
                } catch (e) {
                    this.triggerConfigError(e)
                }
        }
        ,
        AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20))
        }
        ,
        AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this),
                this.renderer.initItems(),
                setTimeout((function() {
                    this.trigger("DOMLoaded")
                }
                ).bind(this), 0),
                this.gotoFrame(),
                this.autoplay && this.play()
            }
        }
        ,
        AnimationItem.prototype.resize = function(t, e) {
            var r = typeof t == "number" ? t : void 0
              , i = typeof e == "number" ? e : void 0;
            this.renderer.updateContainerSize(r, i)
        }
        ,
        AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t
        }
        ,
        AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame,
            this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted),
            this.trigger("enterFrame"),
            this.renderFrame(),
            this.trigger("drawnFrame")
        }
        ,
        AnimationItem.prototype.renderFrame = function() {
            if (!(this.isLoaded === !1 || !this.renderer))
                try {
                    this.expressionsPlugin && this.expressionsPlugin.resetFrame(),
                    this.renderer.renderFrame(this.currentFrame + this.firstFrame)
                } catch (t) {
                    this.triggerRenderFrameError(t)
                }
        }
        ,
        AnimationItem.prototype.play = function(t) {
            t && this.name !== t || this.isPaused === !0 && (this.isPaused = !1,
            this.trigger("_play"),
            this.audioController.resume(),
            this._idle && (this._idle = !1,
            this.trigger("_active")))
        }
        ,
        AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || this.isPaused === !1 && (this.isPaused = !0,
            this.trigger("_pause"),
            this._idle = !0,
            this.trigger("_idle"),
            this.audioController.pause())
        }
        ,
        AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (this.isPaused === !0 ? this.play() : this.pause())
        }
        ,
        AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(),
            this.playCount = 0,
            this._completedLoop = !1,
            this.setCurrentRawFrameValue(0))
        }
        ,
        AnimationItem.prototype.getMarkerData = function(t) {
            for (var e, r = 0; r < this.markers.length; r += 1)
                if (e = this.markers[r],
                e.payload && e.payload.name === t)
                    return e;
            return null
        }
        ,
        AnimationItem.prototype.goToAndStop = function(t, e, r) {
            if (!(r && this.name !== r)) {
                var i = Number(t);
                if (isNaN(i)) {
                    var s = this.getMarkerData(t);
                    s && this.goToAndStop(s.time, !0)
                } else
                    e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause()
            }
        }
        ,
        AnimationItem.prototype.goToAndPlay = function(t, e, r) {
            if (!(r && this.name !== r)) {
                var i = Number(t);
                if (isNaN(i)) {
                    var s = this.getMarkerData(t);
                    s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0))
                } else
                    this.goToAndStop(i, e, r);
                this.play()
            }
        }
        ,
        AnimationItem.prototype.advanceTime = function(t) {
            if (!(this.isPaused === !0 || this.isLoaded === !1)) {
                var e = this.currentRawFrame + t * this.frameModifier
                  , r = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r = !0,
                e = this.totalFrames - 1) : e >= this.totalFrames ? (this.playCount += 1,
                this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames),
                this._completedLoop = !0,
                this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : e < 0 ? this.checkSegments(e % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames),
                this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (r = !0,
                e = 0)) : this.setCurrentRawFrameValue(e),
                r && (this.setCurrentRawFrameValue(e),
                this.pause(),
                this.trigger("complete"))
            }
        }
        ,
        AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0,
            t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)),
            this.totalFrames = t[0] - t[1],
            this.timeCompleted = this.totalFrames,
            this.firstFrame = t[1],
            this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)),
            this.totalFrames = t[1] - t[0],
            this.timeCompleted = this.totalFrames,
            this.firstFrame = t[0],
            this.setCurrentRawFrameValue(.001 + e)),
            this.trigger("segmentStart")
        }
        ,
        AnimationItem.prototype.setSegment = function(t, e) {
            var r = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r = t : this.currentRawFrame + this.firstFrame > e && (r = e - t)),
            this.firstFrame = t,
            this.totalFrames = e - t,
            this.timeCompleted = this.totalFrames,
            r !== -1 && this.goToAndStop(r, !0)
        }
        ,
        AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0),
            _typeof$4(t[0]) === "object") {
                var r, i = t.length;
                for (r = 0; r < i; r += 1)
                    this.segments.push(t[r])
            } else
                this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0),
            this.isPaused && this.play()
        }
        ,
        AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0,
            this.segments.push([this.animationData.ip, this.animationData.op]),
            t && this.checkSegments(0)
        }
        ,
        AnimationItem.prototype.checkSegments = function(t) {
            return this.segments.length ? (this.adjustSegment(this.segments.shift(), t),
            !0) : !1
        }
        ,
        AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(),
            this.imagePreloader.destroy(),
            this.trigger("destroy"),
            this._cbs = null,
            this.onEnterFrame = null,
            this.onLoopComplete = null,
            this.onComplete = null,
            this.onSegmentStart = null,
            this.onDestroy = null,
            this.renderer = null,
            this.expressionsPlugin = null,
            this.imagePreloader = null,
            this.projectInterface = null)
        }
        ,
        AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t,
            this.gotoFrame()
        }
        ,
        AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t,
            this.updaFrameModifier()
        }
        ,
        AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1,
            this.updaFrameModifier()
        }
        ,
        AnimationItem.prototype.setLoop = function(t) {
            this.loop = t
        }
        ,
        AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t)
        }
        ,
        AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume()
        }
        ,
        AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute()
        }
        ,
        AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute()
        }
        ,
        AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection,
            this.audioController.setRate(this.playSpeed * this.playDirection)
        }
        ,
        AnimationItem.prototype.getPath = function() {
            return this.path
        }
        ,
        AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e)
                e = t.p;
            else if (this.assetsPath) {
                var r = t.p;
                r.indexOf("images/") !== -1 && (r = r.split("/")[1]),
                e = this.assetsPath + r
            } else
                e = this.path,
                e += t.u ? t.u : "",
                e += t.p;
            return e
        }
        ,
        AnimationItem.prototype.getAssetData = function(t) {
            for (var e = 0, r = this.assets.length; e < r; ) {
                if (t === this.assets[e].id)
                    return this.assets[e];
                e += 1
            }
            return null
        }
        ,
        AnimationItem.prototype.hide = function() {
            this.renderer.hide()
        }
        ,
        AnimationItem.prototype.show = function() {
            this.renderer.show()
        }
        ,
        AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate
        }
        ,
        AnimationItem.prototype.updateDocumentData = function(t, e, r) {
            try {
                var i = this.renderer.getElementByPath(t);
                i.updateDocumentData(e, r)
            } catch {}
        }
        ,
        AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t])
                switch (t) {
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t,this.currentFrame,this.totalFrames,this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame,
                    this.drawnFrameEvent.totalTime = this.totalFrames,
                    this.drawnFrameEvent.direction = this.frameModifier,
                    this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t,this.loop,this.playCount,this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t,this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t,this.firstFrame,this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t,this));
                    break;
                default:
                    this.triggerEvent(t)
                }
            t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t,this.currentFrame,this.totalFrames,this.frameMult)),
            t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t,this.loop,this.playCount,this.frameMult)),
            t === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t,this.frameMult)),
            t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t,this.firstFrame,this.totalFrames)),
            t === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t,this))
        }
        ,
        AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t,this.currentFrame);
            this.triggerEvent("error", e),
            this.onError && this.onError.call(this, e)
        }
        ,
        AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t,this.currentFrame);
            this.triggerEvent("error", e),
            this.onError && this.onError.call(this, e)
        }
        ;
        var animationManager = function() {
            var t = {}
              , e = []
              , r = 0
              , i = 0
              , s = 0
              , n = !0
              , a = !1;
            function l(P) {
                for (var M = 0, E = P.target; M < i; )
                    e[M].animation === E && (e.splice(M, 1),
                    M -= 1,
                    i -= 1,
                    E.isPaused || S()),
                    M += 1
            }
            function o(P, M) {
                if (!P)
                    return null;
                for (var E = 0; E < i; ) {
                    if (e[E].elem === P && e[E].elem !== null)
                        return e[E].animation;
                    E += 1
                }
                var A = new AnimationItem;
                return c(A, P),
                A.setData(P, M),
                A
            }
            function h() {
                var P, M = e.length, E = [];
                for (P = 0; P < M; P += 1)
                    E.push(e[P].animation);
                return E
            }
            function p() {
                s += 1,
                D()
            }
            function S() {
                s -= 1
            }
            function c(P, M) {
                P.addEventListener("destroy", l),
                P.addEventListener("_active", p),
                P.addEventListener("_idle", S),
                e.push({
                    elem: M,
                    animation: P
                }),
                i += 1
            }
            function g(P) {
                var M = new AnimationItem;
                return c(M, null),
                M.setParams(P),
                M
            }
            function v(P, M) {
                var E;
                for (E = 0; E < i; E += 1)
                    e[E].animation.setSpeed(P, M)
            }
            function d(P, M) {
                var E;
                for (E = 0; E < i; E += 1)
                    e[E].animation.setDirection(P, M)
            }
            function b(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.play(P)
            }
            function u(P) {
                var M = P - r, E;
                for (E = 0; E < i; E += 1)
                    e[E].animation.advanceTime(M);
                r = P,
                s && !a ? window.requestAnimationFrame(u) : n = !0
            }
            function m(P) {
                r = P,
                window.requestAnimationFrame(u)
            }
            function f(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.pause(P)
            }
            function y(P, M, E) {
                var A;
                for (A = 0; A < i; A += 1)
                    e[A].animation.goToAndStop(P, M, E)
            }
            function _(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.stop(P)
            }
            function T(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.togglePause(P)
            }
            function C(P) {
                var M;
                for (M = i - 1; M >= 0; M -= 1)
                    e[M].animation.destroy(P)
            }
            function x(P, M, E) {
                var A = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), F, I = A.length;
                for (F = 0; F < I; F += 1)
                    E && A[F].setAttribute("data-bm-type", E),
                    o(A[F], P);
                if (M && I === 0) {
                    E || (E = "svg");
                    var N = document.getElementsByTagName("body")[0];
                    N.innerText = "";
                    var $ = createTag("div");
                    $.style.width = "100%",
                    $.style.height = "100%",
                    $.setAttribute("data-bm-type", E),
                    N.appendChild($),
                    o($, P)
                }
            }
            function w() {
                var P;
                for (P = 0; P < i; P += 1)
                    e[P].animation.resize()
            }
            function D() {
                !a && s && n && (window.requestAnimationFrame(m),
                n = !1)
            }
            function k() {
                a = !0
            }
            function L() {
                a = !1,
                D()
            }
            function V(P, M) {
                var E;
                for (E = 0; E < i; E += 1)
                    e[E].animation.setVolume(P, M)
            }
            function O(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.mute(P)
            }
            function R(P) {
                var M;
                for (M = 0; M < i; M += 1)
                    e[M].animation.unmute(P)
            }
            return t.registerAnimation = o,
            t.loadAnimation = g,
            t.setSpeed = v,
            t.setDirection = d,
            t.play = b,
            t.pause = f,
            t.stop = _,
            t.togglePause = T,
            t.searchAnimations = x,
            t.resize = w,
            t.goToAndStop = y,
            t.destroy = C,
            t.freeze = k,
            t.unfreeze = L,
            t.setVolume = V,
            t.mute = O,
            t.unmute = R,
            t.getRegisteredAnimations = h,
            t
        }()
          , BezierFactory = function() {
            var t = {};
            t.getBezierEasing = r;
            var e = {};
            function r(m, f, y, _, T) {
                var C = T || ("bez_" + m + "_" + f + "_" + y + "_" + _).replace(/\./g, "p");
                if (e[C])
                    return e[C];
                var x = new u([m, f, y, _]);
                return e[C] = x,
                x
            }
            var i = 4
              , s = .001
              , n = 1e-7
              , a = 10
              , l = 11
              , o = 1 / (l - 1)
              , h = typeof Float32Array == "function";
            function p(m, f) {
                return 1 - 3 * f + 3 * m
            }
            function S(m, f) {
                return 3 * f - 6 * m
            }
            function c(m) {
                return 3 * m
            }
            function g(m, f, y) {
                return ((p(f, y) * m + S(f, y)) * m + c(f)) * m
            }
            function v(m, f, y) {
                return 3 * p(f, y) * m * m + 2 * S(f, y) * m + c(f)
            }
            function d(m, f, y, _, T) {
                var C, x, w = 0;
                do
                    x = f + (y - f) / 2,
                    C = g(x, _, T) - m,
                    C > 0 ? y = x : f = x;
                while (Math.abs(C) > n && ++w < a);
                return x
            }
            function b(m, f, y, _) {
                for (var T = 0; T < i; ++T) {
                    var C = v(f, y, _);
                    if (C === 0)
                        return f;
                    var x = g(f, y, _) - m;
                    f -= x / C
                }
                return f
            }
            function u(m) {
                this._p = m,
                this._mSampleValues = h ? new Float32Array(l) : new Array(l),
                this._precomputed = !1,
                this.get = this.get.bind(this)
            }
            return u.prototype = {
                get: function(f) {
                    var y = this._p[0]
                      , _ = this._p[1]
                      , T = this._p[2]
                      , C = this._p[3];
                    return this._precomputed || this._precompute(),
                    y === _ && T === C ? f : f === 0 ? 0 : f === 1 ? 1 : g(this._getTForX(f), _, C)
                },
                _precompute: function() {
                    var f = this._p[0]
                      , y = this._p[1]
                      , _ = this._p[2]
                      , T = this._p[3];
                    this._precomputed = !0,
                    (f !== y || _ !== T) && this._calcSampleValues()
                },
                _calcSampleValues: function() {
                    for (var f = this._p[0], y = this._p[2], _ = 0; _ < l; ++_)
                        this._mSampleValues[_] = g(_ * o, f, y)
                },
                _getTForX: function(f) {
                    for (var y = this._p[0], _ = this._p[2], T = this._mSampleValues, C = 0, x = 1, w = l - 1; x !== w && T[x] <= f; ++x)
                        C += o;
                    --x;
                    var D = (f - T[x]) / (T[x + 1] - T[x])
                      , k = C + D * o
                      , L = v(k, y, _);
                    return L >= s ? b(f, k, y, _) : L === 0 ? k : d(f, C, C + o, y, _)
                }
            },
            t
        }()
          , pooling = function() {
            function t(e) {
                return e.concat(createSizedArray(e.length))
            }
            return {
                double: t
            }
        }()
          , poolFactory = function() {
            return function(t, e, r) {
                var i = 0
                  , s = t
                  , n = createSizedArray(s)
                  , a = {
                    newElement: l,
                    release: o
                };
                function l() {
                    var h;
                    return i ? (i -= 1,
                    h = n[i]) : h = e(),
                    h
                }
                function o(h) {
                    i === s && (n = pooling.double(n),
                    s *= 2),
                    r && r(h),
                    n[i] = h,
                    i += 1
                }
                return a
            }
        }()
          , bezierLengthPool = function() {
            function t() {
                return {
                    addedLength: 0,
                    percents: createTypedArray("float32", getDefaultCurveSegments()),
                    lengths: createTypedArray("float32", getDefaultCurveSegments())
                }
            }
            return poolFactory(8, t)
        }()
          , segmentsLengthPool = function() {
            function t() {
                return {
                    lengths: [],
                    totalLength: 0
                }
            }
            function e(r) {
                var i, s = r.lengths.length;
                for (i = 0; i < s; i += 1)
                    bezierLengthPool.release(r.lengths[i]);
                r.lengths.length = 0
            }
            return poolFactory(8, t, e)
        }();
        function bezFunction() {
            var t = Math;
            function e(c, g, v, d, b, u) {
                var m = c * d + g * b + v * u - b * d - u * c - v * g;
                return m > -.001 && m < .001
            }
            function r(c, g, v, d, b, u, m, f, y) {
                if (v === 0 && u === 0 && y === 0)
                    return e(c, g, d, b, m, f);
                var _ = t.sqrt(t.pow(d - c, 2) + t.pow(b - g, 2) + t.pow(u - v, 2)), T = t.sqrt(t.pow(m - c, 2) + t.pow(f - g, 2) + t.pow(y - v, 2)), C = t.sqrt(t.pow(m - d, 2) + t.pow(f - b, 2) + t.pow(y - u, 2)), x;
                return _ > T ? _ > C ? x = _ - T - C : x = C - T - _ : C > T ? x = C - T - _ : x = T - _ - C,
                x > -1e-4 && x < 1e-4
            }
            var i = function() {
                return function(c, g, v, d) {
                    var b = getDefaultCurveSegments(), u, m, f, y, _, T = 0, C, x = [], w = [], D = bezierLengthPool.newElement();
                    for (f = v.length,
                    u = 0; u < b; u += 1) {
                        for (_ = u / (b - 1),
                        C = 0,
                        m = 0; m < f; m += 1)
                            y = bmPow(1 - _, 3) * c[m] + 3 * bmPow(1 - _, 2) * _ * v[m] + 3 * (1 - _) * bmPow(_, 2) * d[m] + bmPow(_, 3) * g[m],
                            x[m] = y,
                            w[m] !== null && (C += bmPow(x[m] - w[m], 2)),
                            w[m] = x[m];
                        C && (C = bmSqrt(C),
                        T += C),
                        D.percents[u] = _,
                        D.lengths[u] = T
                    }
                    return D.addedLength = T,
                    D
                }
            }();
            function s(c) {
                var g = segmentsLengthPool.newElement(), v = c.c, d = c.v, b = c.o, u = c.i, m, f = c._length, y = g.lengths, _ = 0;
                for (m = 0; m < f - 1; m += 1)
                    y[m] = i(d[m], d[m + 1], b[m], u[m + 1]),
                    _ += y[m].addedLength;
                return v && f && (y[m] = i(d[m], d[0], b[m], u[0]),
                _ += y[m].addedLength),
                g.totalLength = _,
                g
            }
            function n(c) {
                this.segmentLength = 0,
                this.points = new Array(c)
            }
            function a(c, g) {
                this.partialLength = c,
                this.point = g
            }
            var l = function() {
                var c = {};
                return function(g, v, d, b) {
                    var u = (g[0] + "_" + g[1] + "_" + v[0] + "_" + v[1] + "_" + d[0] + "_" + d[1] + "_" + b[0] + "_" + b[1]).replace(/\./g, "p");
                    if (!c[u]) {
                        var m = getDefaultCurveSegments(), f, y, _, T, C, x = 0, w, D, k = null;
                        g.length === 2 && (g[0] !== v[0] || g[1] !== v[1]) && e(g[0], g[1], v[0], v[1], g[0] + d[0], g[1] + d[1]) && e(g[0], g[1], v[0], v[1], v[0] + b[0], v[1] + b[1]) && (m = 2);
                        var L = new n(m);
                        for (_ = d.length,
                        f = 0; f < m; f += 1) {
                            for (D = createSizedArray(_),
                            C = f / (m - 1),
                            w = 0,
                            y = 0; y < _; y += 1)
                                T = bmPow(1 - C, 3) * g[y] + 3 * bmPow(1 - C, 2) * C * (g[y] + d[y]) + 3 * (1 - C) * bmPow(C, 2) * (v[y] + b[y]) + bmPow(C, 3) * v[y],
                                D[y] = T,
                                k !== null && (w += bmPow(D[y] - k[y], 2));
                            w = bmSqrt(w),
                            x += w,
                            L.points[f] = new a(w,D),
                            k = D
                        }
                        L.segmentLength = x,
                        c[u] = L
                    }
                    return c[u]
                }
            }();
            function o(c, g) {
                var v = g.percents
                  , d = g.lengths
                  , b = v.length
                  , u = bmFloor((b - 1) * c)
                  , m = c * g.addedLength
                  , f = 0;
                if (u === b - 1 || u === 0 || m === d[u])
                    return v[u];
                for (var y = d[u] > m ? -1 : 1, _ = !0; _; )
                    if (d[u] <= m && d[u + 1] > m ? (f = (m - d[u]) / (d[u + 1] - d[u]),
                    _ = !1) : u += y,
                    u < 0 || u >= b - 1) {
                        if (u === b - 1)
                            return v[u];
                        _ = !1
                    }
                return v[u] + (v[u + 1] - v[u]) * f
            }
            function h(c, g, v, d, b, u) {
                var m = o(b, u)
                  , f = 1 - m
                  , y = t.round((f * f * f * c[0] + (m * f * f + f * m * f + f * f * m) * v[0] + (m * m * f + f * m * m + m * f * m) * d[0] + m * m * m * g[0]) * 1e3) / 1e3
                  , _ = t.round((f * f * f * c[1] + (m * f * f + f * m * f + f * f * m) * v[1] + (m * m * f + f * m * m + m * f * m) * d[1] + m * m * m * g[1]) * 1e3) / 1e3;
                return [y, _]
            }
            var p = createTypedArray("float32", 8);
            function S(c, g, v, d, b, u, m) {
                b < 0 ? b = 0 : b > 1 && (b = 1);
                var f = o(b, m);
                u = u > 1 ? 1 : u;
                var y = o(u, m), _, T = c.length, C = 1 - f, x = 1 - y, w = C * C * C, D = f * C * C * 3, k = f * f * C * 3, L = f * f * f, V = C * C * x, O = f * C * x + C * f * x + C * C * y, R = f * f * x + C * f * y + f * C * y, P = f * f * y, M = C * x * x, E = f * x * x + C * y * x + C * x * y, A = f * y * x + C * y * y + f * x * y, F = f * y * y, I = x * x * x, N = y * x * x + x * y * x + x * x * y, $ = y * y * x + x * y * y + y * x * y, H = y * y * y;
                for (_ = 0; _ < T; _ += 1)
                    p[_ * 4] = t.round((w * c[_] + D * v[_] + k * d[_] + L * g[_]) * 1e3) / 1e3,
                    p[_ * 4 + 1] = t.round((V * c[_] + O * v[_] + R * d[_] + P * g[_]) * 1e3) / 1e3,
                    p[_ * 4 + 2] = t.round((M * c[_] + E * v[_] + A * d[_] + F * g[_]) * 1e3) / 1e3,
                    p[_ * 4 + 3] = t.round((I * c[_] + N * v[_] + $ * d[_] + H * g[_]) * 1e3) / 1e3;
                return p
            }
            return {
                getSegmentsLength: s,
                getNewSegment: S,
                getPointInSegment: h,
                buildBezierData: l,
                pointOnLine2D: e,
                pointOnLine3D: r
            }
        }
        var bez = bezFunction()
          , initFrame = initialDefaultFrame
          , mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r = this.offsetTime, i;
            this.propType === "multidimensional" && (i = createTypedArray("float32", this.pv.length));
            for (var s = e.lastIndex, n = s, a = this.keyframes.length - 1, l = !0, o, h, p; l; ) {
                if (o = this.keyframes[n],
                h = this.keyframes[n + 1],
                n === a - 1 && t >= h.t - r) {
                    o.h && (o = h),
                    s = 0;
                    break
                }
                if (h.t - r > t) {
                    s = n;
                    break
                }
                n < a - 1 ? n += 1 : (s = 0,
                l = !1)
            }
            p = this.keyframesMetadata[n] || {};
            var S, c, g, v, d, b, u = h.t - r, m = o.t - r, f;
            if (o.to) {
                p.bezierData || (p.bezierData = bez.buildBezierData(o.s, h.s || o.e, o.to, o.ti));
                var y = p.bezierData;
                if (t >= u || t < m) {
                    var _ = t >= u ? y.points.length - 1 : 0;
                    for (c = y.points[_].point.length,
                    S = 0; S < c; S += 1)
                        i[S] = y.points[_].point[S]
                } else {
                    p.__fnct ? b = p.__fnct : (b = BezierFactory.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get,
                    p.__fnct = b),
                    g = b((t - m) / (u - m));
                    var T = y.segmentLength * g, C, x = e.lastFrame < t && e._lastKeyframeIndex === n ? e._lastAddedLength : 0;
                    for (d = e.lastFrame < t && e._lastKeyframeIndex === n ? e._lastPoint : 0,
                    l = !0,
                    v = y.points.length; l; ) {
                        if (x += y.points[d].partialLength,
                        T === 0 || g === 0 || d === y.points.length - 1) {
                            for (c = y.points[d].point.length,
                            S = 0; S < c; S += 1)
                                i[S] = y.points[d].point[S];
                            break
                        } else if (T >= x && T < x + y.points[d + 1].partialLength) {
                            for (C = (T - x) / y.points[d + 1].partialLength,
                            c = y.points[d].point.length,
                            S = 0; S < c; S += 1)
                                i[S] = y.points[d].point[S] + (y.points[d + 1].point[S] - y.points[d].point[S]) * C;
                            break
                        }
                        d < v - 1 ? d += 1 : l = !1
                    }
                    e._lastPoint = d,
                    e._lastAddedLength = x - y.points[d].partialLength,
                    e._lastKeyframeIndex = n
                }
            } else {
                var w, D, k, L, V;
                if (a = o.s.length,
                f = h.s || o.e,
                this.sh && o.h !== 1)
                    if (t >= u)
                        i[0] = f[0],
                        i[1] = f[1],
                        i[2] = f[2];
                    else if (t <= m)
                        i[0] = o.s[0],
                        i[1] = o.s[1],
                        i[2] = o.s[2];
                    else {
                        var O = createQuaternion(o.s)
                          , R = createQuaternion(f)
                          , P = (t - m) / (u - m);
                        quaternionToEuler(i, slerp(O, R, P))
                    }
                else
                    for (n = 0; n < a; n += 1)
                        o.h !== 1 && (t >= u ? g = 1 : t < m ? g = 0 : (o.o.x.constructor === Array ? (p.__fnct || (p.__fnct = []),
                        p.__fnct[n] ? b = p.__fnct[n] : (w = o.o.x[n] === void 0 ? o.o.x[0] : o.o.x[n],
                        D = o.o.y[n] === void 0 ? o.o.y[0] : o.o.y[n],
                        k = o.i.x[n] === void 0 ? o.i.x[0] : o.i.x[n],
                        L = o.i.y[n] === void 0 ? o.i.y[0] : o.i.y[n],
                        b = BezierFactory.getBezierEasing(w, D, k, L).get,
                        p.__fnct[n] = b)) : p.__fnct ? b = p.__fnct : (w = o.o.x,
                        D = o.o.y,
                        k = o.i.x,
                        L = o.i.y,
                        b = BezierFactory.getBezierEasing(w, D, k, L).get,
                        o.keyframeMetadata = b),
                        g = b((t - m) / (u - m)))),
                        f = h.s || o.e,
                        V = o.h === 1 ? o.s[n] : o.s[n] + (f[n] - o.s[n]) * g,
                        this.propType === "multidimensional" ? i[n] = V : i = V
            }
            return e.lastIndex = s,
            i
        }
        function slerp(t, e, r) {
            var i = [], s = t[0], n = t[1], a = t[2], l = t[3], o = e[0], h = e[1], p = e[2], S = e[3], c, g, v, d, b;
            return g = s * o + n * h + a * p + l * S,
            g < 0 && (g = -g,
            o = -o,
            h = -h,
            p = -p,
            S = -S),
            1 - g > 1e-6 ? (c = Math.acos(g),
            v = Math.sin(c),
            d = Math.sin((1 - r) * c) / v,
            b = Math.sin(r * c) / v) : (d = 1 - r,
            b = r),
            i[0] = d * s + b * o,
            i[1] = d * n + b * h,
            i[2] = d * a + b * p,
            i[3] = d * l + b * S,
            i
        }
        function quaternionToEuler(t, e) {
            var r = e[0]
              , i = e[1]
              , s = e[2]
              , n = e[3]
              , a = Math.atan2(2 * i * n - 2 * r * s, 1 - 2 * i * i - 2 * s * s)
              , l = Math.asin(2 * r * i + 2 * s * n)
              , o = Math.atan2(2 * r * n - 2 * i * s, 1 - 2 * r * r - 2 * s * s);
            t[0] = a / degToRads,
            t[1] = l / degToRads,
            t[2] = o / degToRads
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads
              , r = t[1] * degToRads
              , i = t[2] * degToRads
              , s = Math.cos(e / 2)
              , n = Math.cos(r / 2)
              , a = Math.cos(i / 2)
              , l = Math.sin(e / 2)
              , o = Math.sin(r / 2)
              , h = Math.sin(i / 2)
              , p = s * n * a - l * o * h
              , S = l * o * a + s * n * h
              , c = l * n * a + s * o * h
              , g = s * o * a - l * n * h;
            return [S, c, g, p]
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime
              , e = this.keyframes[0].t - this.offsetTime
              , r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && t >= r || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1,
                this._caching.lastIndex = 0);
                var i = this.interpolateValue(t, this._caching);
                this.pv = i
            }
            return this._caching.lastFrame = t,
            this.pv
        }
        function setVValue(t) {
            var e;
            if (this.propType === "unidimensional")
                e = t * this.mult,
                mathAbs(this.v - e) > 1e-5 && (this.v = e,
                this._mdf = !0);
            else
                for (var r = 0, i = this.v.length; r < i; )
                    e = t[r] * this.mult,
                    mathAbs(this.v[r] - e) > 1e-5 && (this.v[r] = e,
                    this._mdf = !0),
                    r += 1
        }
        function processEffectsSequence() {
            if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
                if (this.lock) {
                    this.setVValue(this.pv);
                    return
                }
                this.lock = !0,
                this._mdf = this._isFirstFrame;
                var t, e = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
                for (t = 0; t < e; t += 1)
                    r = this.effectsSequence[t](r);
                this.setVValue(r),
                this._isFirstFrame = !1,
                this.lock = !1,
                this.frameId = this.elem.globalData.frameId
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t),
            this.container.addDynamicProperty(this)
        }
        function ValueProperty(t, e, r, i) {
            this.propType = "unidimensional",
            this.mult = r || 1,
            this.data = e,
            this.v = r ? e.k * r : e.k,
            this.pv = e.k,
            this._mdf = !1,
            this.elem = t,
            this.container = i,
            this.comp = t.comp,
            this.k = !1,
            this.kf = !1,
            this.vel = 0,
            this.effectsSequence = [],
            this._isFirstFrame = !0,
            this.getValue = processEffectsSequence,
            this.setVValue = setVValue,
            this.addEffect = addEffect
        }
        function MultiDimensionalProperty(t, e, r, i) {
            this.propType = "multidimensional",
            this.mult = r || 1,
            this.data = e,
            this._mdf = !1,
            this.elem = t,
            this.container = i,
            this.comp = t.comp,
            this.k = !1,
            this.kf = !1,
            this.frameId = -1;
            var s, n = e.k.length;
            for (this.v = createTypedArray("float32", n),
            this.pv = createTypedArray("float32", n),
            this.vel = createTypedArray("float32", n),
            s = 0; s < n; s += 1)
                this.v[s] = e.k[s] * this.mult,
                this.pv[s] = e.k[s];
            this._isFirstFrame = !0,
            this.effectsSequence = [],
            this.getValue = processEffectsSequence,
            this.setVValue = setVValue,
            this.addEffect = addEffect
        }
        function KeyframedValueProperty(t, e, r, i) {
            this.propType = "unidimensional",
            this.keyframes = e.k,
            this.keyframesMetadata = [],
            this.offsetTime = t.data.st,
            this.frameId = -1,
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            },
            this.k = !0,
            this.kf = !0,
            this.data = e,
            this.mult = r || 1,
            this.elem = t,
            this.container = i,
            this.comp = t.comp,
            this.v = initFrame,
            this.pv = initFrame,
            this._isFirstFrame = !0,
            this.getValue = processEffectsSequence,
            this.setVValue = setVValue,
            this.interpolateValue = interpolateValue,
            this.effectsSequence = [getValueAtCurrentTime.bind(this)],
            this.addEffect = addEffect
        }
        function KeyframedMultidimensionalProperty(t, e, r, i) {
            this.propType = "multidimensional";
            var s, n = e.k.length, a, l, o, h;
            for (s = 0; s < n - 1; s += 1)
                e.k[s].to && e.k[s].s && e.k[s + 1] && e.k[s + 1].s && (a = e.k[s].s,
                l = e.k[s + 1].s,
                o = e.k[s].to,
                h = e.k[s].ti,
                (a.length === 2 && !(a[0] === l[0] && a[1] === l[1]) && bez.pointOnLine2D(a[0], a[1], l[0], l[1], a[0] + o[0], a[1] + o[1]) && bez.pointOnLine2D(a[0], a[1], l[0], l[1], l[0] + h[0], l[1] + h[1]) || a.length === 3 && !(a[0] === l[0] && a[1] === l[1] && a[2] === l[2]) && bez.pointOnLine3D(a[0], a[1], a[2], l[0], l[1], l[2], a[0] + o[0], a[1] + o[1], a[2] + o[2]) && bez.pointOnLine3D(a[0], a[1], a[2], l[0], l[1], l[2], l[0] + h[0], l[1] + h[1], l[2] + h[2])) && (e.k[s].to = null,
                e.k[s].ti = null),
                a[0] === l[0] && a[1] === l[1] && o[0] === 0 && o[1] === 0 && h[0] === 0 && h[1] === 0 && (a.length === 2 || a[2] === l[2] && o[2] === 0 && h[2] === 0) && (e.k[s].to = null,
                e.k[s].ti = null));
            this.effectsSequence = [getValueAtCurrentTime.bind(this)],
            this.data = e,
            this.keyframes = e.k,
            this.keyframesMetadata = [],
            this.offsetTime = t.data.st,
            this.k = !0,
            this.kf = !0,
            this._isFirstFrame = !0,
            this.mult = r || 1,
            this.elem = t,
            this.container = i,
            this.comp = t.comp,
            this.getValue = processEffectsSequence,
            this.setVValue = setVValue,
            this.interpolateValue = interpolateValue,
            this.frameId = -1;
            var p = e.k[0].s.length;
            for (this.v = createTypedArray("float32", p),
            this.pv = createTypedArray("float32", p),
            s = 0; s < p; s += 1)
                this.v[s] = initFrame,
                this.pv[s] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            },
            this.addEffect = addEffect
        }
        var PropertyFactory = function() {
            function t(r, i, s, n, a) {
                i.sid && (i = r.globalData.slotManager.getProp(i));
                var l;
                if (!i.k.length)
                    l = new ValueProperty(r,i,n,a);
                else if (typeof i.k[0] == "number")
                    l = new MultiDimensionalProperty(r,i,n,a);
                else
                    switch (s) {
                    case 0:
                        l = new KeyframedValueProperty(r,i,n,a);
                        break;
                    case 1:
                        l = new KeyframedMultidimensionalProperty(r,i,n,a);
                        break
                    }
                return l.effectsSequence.length && a.addDynamicProperty(l),
                l
            }
            var e = {
                getProp: t
            };
            return e
        }();
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(e) {
                this.dynamicProperties.indexOf(e) === -1 && (this.dynamicProperties.push(e),
                this.container.addDynamicProperty(this),
                this._isAnimated = !0)
            },
            iterateDynamicProperties: function() {
                this._mdf = !1;
                var e, r = this.dynamicProperties.length;
                for (e = 0; e < r; e += 1)
                    this.dynamicProperties[e].getValue(),
                    this.dynamicProperties[e]._mdf && (this._mdf = !0)
            },
            initDynamicPropertyContainer: function(e) {
                this.container = e,
                this.dynamicProperties = [],
                this._mdf = !1,
                this._isAnimated = !1
            }
        };
        var pointPool = function() {
            function t() {
                return createTypedArray("float32", 2)
            }
            return poolFactory(8, t)
        }();
        function ShapePath() {
            this.c = !1,
            this._length = 0,
            this._maxLength = 8,
            this.v = createSizedArray(this._maxLength),
            this.o = createSizedArray(this._maxLength),
            this.i = createSizedArray(this._maxLength)
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t,
            this.setLength(e);
            for (var r = 0; r < e; )
                this.v[r] = pointPool.newElement(),
                this.o[r] = pointPool.newElement(),
                this.i[r] = pointPool.newElement(),
                r += 1
        }
        ,
        ShapePath.prototype.setLength = function(t) {
            for (; this._maxLength < t; )
                this.doubleArrayLength();
            this._length = t
        }
        ,
        ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)),
            this.i = this.i.concat(createSizedArray(this._maxLength)),
            this.o = this.o.concat(createSizedArray(this._maxLength)),
            this._maxLength *= 2
        }
        ,
        ShapePath.prototype.setXYAt = function(t, e, r, i, s) {
            var n;
            switch (this._length = Math.max(this._length, i + 1),
            this._length >= this._maxLength && this.doubleArrayLength(),
            r) {
            case "v":
                n = this.v;
                break;
            case "i":
                n = this.i;
                break;
            case "o":
                n = this.o;
                break;
            default:
                n = [];
                break
            }
            (!n[i] || n[i] && !s) && (n[i] = pointPool.newElement()),
            n[i][0] = t,
            n[i][1] = e
        }
        ,
        ShapePath.prototype.setTripleAt = function(t, e, r, i, s, n, a, l) {
            this.setXYAt(t, e, "v", a, l),
            this.setXYAt(r, i, "o", a, l),
            this.setXYAt(s, n, "i", a, l)
        }
        ,
        ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v
              , r = this.o
              , i = this.i
              , s = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1),
            s = 1);
            var n = this._length - 1, a = this._length, l;
            for (l = s; l < a; l += 1)
                t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r[n][0], r[n][1], l, !1),
                n -= 1;
            return t
        }
        ,
        ShapePath.prototype.length = function() {
            return this._length
        }
        ;
        var shapePool = function() {
            function t() {
                return new ShapePath
            }
            function e(s) {
                var n = s._length, a;
                for (a = 0; a < n; a += 1)
                    pointPool.release(s.v[a]),
                    pointPool.release(s.i[a]),
                    pointPool.release(s.o[a]),
                    s.v[a] = null,
                    s.i[a] = null,
                    s.o[a] = null;
                s._length = 0,
                s.c = !1
            }
            function r(s) {
                var n = i.newElement(), a, l = s._length === void 0 ? s.v.length : s._length;
                for (n.setLength(l),
                n.c = s.c,
                a = 0; a < l; a += 1)
                    n.setTripleAt(s.v[a][0], s.v[a][1], s.o[a][0], s.o[a][1], s.i[a][0], s.i[a][1], a);
                return n
            }
            var i = poolFactory(4, t, e);
            return i.clone = r,
            i
        }();
        function ShapeCollection() {
            this._length = 0,
            this._maxLength = 4,
            this.shapes = createSizedArray(this._maxLength)
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)),
            this._maxLength *= 2),
            this.shapes[this._length] = t,
            this._length += 1
        }
        ,
        ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for (t = 0; t < this._length; t += 1)
                shapePool.release(this.shapes[t]);
            this._length = 0
        }
        ;
        var shapeCollectionPool = function() {
            var t = {
                newShapeCollection: s,
                release: n
            }
              , e = 0
              , r = 4
              , i = createSizedArray(r);
            function s() {
                var a;
                return e ? (e -= 1,
                a = i[e]) : a = new ShapeCollection,
                a
            }
            function n(a) {
                var l, o = a._length;
                for (l = 0; l < o; l += 1)
                    shapePool.release(a.shapes[l]);
                a._length = 0,
                e === r && (i = pooling.double(i),
                r *= 2),
                i[e] = a,
                e += 1
            }
            return t
        }()
          , ShapePropertyFactory = function() {
            var t = -999999;
            function e(u, m, f) {
                var y = f.lastIndex, _, T, C, x, w, D, k, L, V, O = this.keyframes;
                if (u < O[0].t - this.offsetTime)
                    _ = O[0].s[0],
                    C = !0,
                    y = 0;
                else if (u >= O[O.length - 1].t - this.offsetTime)
                    _ = O[O.length - 1].s ? O[O.length - 1].s[0] : O[O.length - 2].e[0],
                    C = !0;
                else {
                    for (var R = y, P = O.length - 1, M = !0, E, A, F; M && (E = O[R],
                    A = O[R + 1],
                    !(A.t - this.offsetTime > u)); )
                        R < P - 1 ? R += 1 : M = !1;
                    if (F = this.keyframesMetadata[R] || {},
                    C = E.h === 1,
                    y = R,
                    !C) {
                        if (u >= A.t - this.offsetTime)
                            L = 1;
                        else if (u < E.t - this.offsetTime)
                            L = 0;
                        else {
                            var I;
                            F.__fnct ? I = F.__fnct : (I = BezierFactory.getBezierEasing(E.o.x, E.o.y, E.i.x, E.i.y).get,
                            F.__fnct = I),
                            L = I((u - (E.t - this.offsetTime)) / (A.t - this.offsetTime - (E.t - this.offsetTime)))
                        }
                        T = A.s ? A.s[0] : E.e[0]
                    }
                    _ = E.s[0]
                }
                for (D = m._length,
                k = _.i[0].length,
                f.lastIndex = y,
                x = 0; x < D; x += 1)
                    for (w = 0; w < k; w += 1)
                        V = C ? _.i[x][w] : _.i[x][w] + (T.i[x][w] - _.i[x][w]) * L,
                        m.i[x][w] = V,
                        V = C ? _.o[x][w] : _.o[x][w] + (T.o[x][w] - _.o[x][w]) * L,
                        m.o[x][w] = V,
                        V = C ? _.v[x][w] : _.v[x][w] + (T.v[x][w] - _.v[x][w]) * L,
                        m.v[x][w] = V
            }
            function r() {
                var u = this.comp.renderedFrame - this.offsetTime
                  , m = this.keyframes[0].t - this.offsetTime
                  , f = this.keyframes[this.keyframes.length - 1].t - this.offsetTime
                  , y = this._caching.lastFrame;
                return y !== t && (y < m && u < m || y > f && u > f) || (this._caching.lastIndex = y < u ? this._caching.lastIndex : 0,
                this.interpolateShape(u, this.pv, this._caching)),
                this._caching.lastFrame = u,
                this.pv
            }
            function i() {
                this.paths = this.localShapeCollection
            }
            function s(u, m) {
                if (u._length !== m._length || u.c !== m.c)
                    return !1;
                var f, y = u._length;
                for (f = 0; f < y; f += 1)
                    if (u.v[f][0] !== m.v[f][0] || u.v[f][1] !== m.v[f][1] || u.o[f][0] !== m.o[f][0] || u.o[f][1] !== m.o[f][1] || u.i[f][0] !== m.i[f][0] || u.i[f][1] !== m.i[f][1])
                        return !1;
                return !0
            }
            function n(u) {
                s(this.v, u) || (this.v = shapePool.clone(u),
                this.localShapeCollection.releaseShapes(),
                this.localShapeCollection.addShape(this.v),
                this._mdf = !0,
                this.paths = this.localShapeCollection)
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (!this.effectsSequence.length) {
                        this._mdf = !1;
                        return
                    }
                    if (this.lock) {
                        this.setVValue(this.pv);
                        return
                    }
                    this.lock = !0,
                    this._mdf = !1;
                    var u;
                    this.kf ? u = this.pv : this.data.ks ? u = this.data.ks.k : u = this.data.pt.k;
                    var m, f = this.effectsSequence.length;
                    for (m = 0; m < f; m += 1)
                        u = this.effectsSequence[m](u);
                    this.setVValue(u),
                    this.lock = !1,
                    this.frameId = this.elem.globalData.frameId
                }
            }
            function l(u, m, f) {
                this.propType = "shape",
                this.comp = u.comp,
                this.container = u,
                this.elem = u,
                this.data = m,
                this.k = !1,
                this.kf = !1,
                this._mdf = !1;
                var y = f === 3 ? m.pt.k : m.ks.k;
                this.v = shapePool.clone(y),
                this.pv = shapePool.clone(this.v),
                this.localShapeCollection = shapeCollectionPool.newShapeCollection(),
                this.paths = this.localShapeCollection,
                this.paths.addShape(this.v),
                this.reset = i,
                this.effectsSequence = []
            }
            function o(u) {
                this.effectsSequence.push(u),
                this.container.addDynamicProperty(this)
            }
            l.prototype.interpolateShape = e,
            l.prototype.getValue = a,
            l.prototype.setVValue = n,
            l.prototype.addEffect = o;
            function h(u, m, f) {
                this.propType = "shape",
                this.comp = u.comp,
                this.elem = u,
                this.container = u,
                this.offsetTime = u.data.st,
                this.keyframes = f === 3 ? m.pt.k : m.ks.k,
                this.keyframesMetadata = [],
                this.k = !0,
                this.kf = !0;
                var y = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(),
                this.v.setPathData(this.keyframes[0].s[0].c, y),
                this.pv = shapePool.clone(this.v),
                this.localShapeCollection = shapeCollectionPool.newShapeCollection(),
                this.paths = this.localShapeCollection,
                this.paths.addShape(this.v),
                this.lastFrame = t,
                this.reset = i,
                this._caching = {
                    lastFrame: t,
                    lastIndex: 0
                },
                this.effectsSequence = [r.bind(this)]
            }
            h.prototype.getValue = a,
            h.prototype.interpolateShape = e,
            h.prototype.setVValue = n,
            h.prototype.addEffect = o;
            var p = function() {
                var u = roundCorner;
                function m(f, y) {
                    this.v = shapePool.newElement(),
                    this.v.setPathData(!0, 4),
                    this.localShapeCollection = shapeCollectionPool.newShapeCollection(),
                    this.paths = this.localShapeCollection,
                    this.localShapeCollection.addShape(this.v),
                    this.d = y.d,
                    this.elem = f,
                    this.comp = f.comp,
                    this.frameId = -1,
                    this.initDynamicPropertyContainer(f),
                    this.p = PropertyFactory.getProp(f, y.p, 1, 0, this),
                    this.s = PropertyFactory.getProp(f, y.s, 1, 0, this),
                    this.dynamicProperties.length ? this.k = !0 : (this.k = !1,
                    this.convertEllToPath())
                }
                return m.prototype = {
                    reset: i,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId,
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertEllToPath())
                    },
                    convertEllToPath: function() {
                        var y = this.p.v[0]
                          , _ = this.p.v[1]
                          , T = this.s.v[0] / 2
                          , C = this.s.v[1] / 2
                          , x = this.d !== 3
                          , w = this.v;
                        w.v[0][0] = y,
                        w.v[0][1] = _ - C,
                        w.v[1][0] = x ? y + T : y - T,
                        w.v[1][1] = _,
                        w.v[2][0] = y,
                        w.v[2][1] = _ + C,
                        w.v[3][0] = x ? y - T : y + T,
                        w.v[3][1] = _,
                        w.i[0][0] = x ? y - T * u : y + T * u,
                        w.i[0][1] = _ - C,
                        w.i[1][0] = x ? y + T : y - T,
                        w.i[1][1] = _ - C * u,
                        w.i[2][0] = x ? y + T * u : y - T * u,
                        w.i[2][1] = _ + C,
                        w.i[3][0] = x ? y - T : y + T,
                        w.i[3][1] = _ + C * u,
                        w.o[0][0] = x ? y + T * u : y - T * u,
                        w.o[0][1] = _ - C,
                        w.o[1][0] = x ? y + T : y - T,
                        w.o[1][1] = _ + C * u,
                        w.o[2][0] = x ? y - T * u : y + T * u,
                        w.o[2][1] = _ + C,
                        w.o[3][0] = x ? y - T : y + T,
                        w.o[3][1] = _ - C * u
                    }
                },
                extendPrototype([DynamicPropertyContainer], m),
                m
            }()
              , S = function() {
                function u(m, f) {
                    this.v = shapePool.newElement(),
                    this.v.setPathData(!0, 0),
                    this.elem = m,
                    this.comp = m.comp,
                    this.data = f,
                    this.frameId = -1,
                    this.d = f.d,
                    this.initDynamicPropertyContainer(m),
                    f.sy === 1 ? (this.ir = PropertyFactory.getProp(m, f.ir, 0, 0, this),
                    this.is = PropertyFactory.getProp(m, f.is, 0, .01, this),
                    this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath,
                    this.pt = PropertyFactory.getProp(m, f.pt, 0, 0, this),
                    this.p = PropertyFactory.getProp(m, f.p, 1, 0, this),
                    this.r = PropertyFactory.getProp(m, f.r, 0, degToRads, this),
                    this.or = PropertyFactory.getProp(m, f.or, 0, 0, this),
                    this.os = PropertyFactory.getProp(m, f.os, 0, .01, this),
                    this.localShapeCollection = shapeCollectionPool.newShapeCollection(),
                    this.localShapeCollection.addShape(this.v),
                    this.paths = this.localShapeCollection,
                    this.dynamicProperties.length ? this.k = !0 : (this.k = !1,
                    this.convertToPath())
                }
                return u.prototype = {
                    reset: i,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId,
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertToPath())
                    },
                    convertStarToPath: function() {
                        var f = Math.floor(this.pt.v) * 2, y = Math.PI * 2 / f, _ = !0, T = this.or.v, C = this.ir.v, x = this.os.v, w = this.is.v, D = 2 * Math.PI * T / (f * 2), k = 2 * Math.PI * C / (f * 2), L, V, O, R, P = -Math.PI / 2;
                        P += this.r.v;
                        var M = this.data.d === 3 ? -1 : 1;
                        for (this.v._length = 0,
                        L = 0; L < f; L += 1) {
                            V = _ ? T : C,
                            O = _ ? x : w,
                            R = _ ? D : k;
                            var E = V * Math.cos(P)
                              , A = V * Math.sin(P)
                              , F = E === 0 && A === 0 ? 0 : A / Math.sqrt(E * E + A * A)
                              , I = E === 0 && A === 0 ? 0 : -E / Math.sqrt(E * E + A * A);
                            E += +this.p.v[0],
                            A += +this.p.v[1],
                            this.v.setTripleAt(E, A, E - F * R * O * M, A - I * R * O * M, E + F * R * O * M, A + I * R * O * M, L, !0),
                            _ = !_,
                            P += y * M
                        }
                    },
                    convertPolygonToPath: function() {
                        var f = Math.floor(this.pt.v), y = Math.PI * 2 / f, _ = this.or.v, T = this.os.v, C = 2 * Math.PI * _ / (f * 4), x, w = -Math.PI * .5, D = this.data.d === 3 ? -1 : 1;
                        for (w += this.r.v,
                        this.v._length = 0,
                        x = 0; x < f; x += 1) {
                            var k = _ * Math.cos(w)
                              , L = _ * Math.sin(w)
                              , V = k === 0 && L === 0 ? 0 : L / Math.sqrt(k * k + L * L)
                              , O = k === 0 && L === 0 ? 0 : -k / Math.sqrt(k * k + L * L);
                            k += +this.p.v[0],
                            L += +this.p.v[1],
                            this.v.setTripleAt(k, L, k - V * C * T * D, L - O * C * T * D, k + V * C * T * D, L + O * C * T * D, x, !0),
                            w += y * D
                        }
                        this.paths.length = 0,
                        this.paths[0] = this.v
                    }
                },
                extendPrototype([DynamicPropertyContainer], u),
                u
            }()
              , c = function() {
                function u(m, f) {
                    this.v = shapePool.newElement(),
                    this.v.c = !0,
                    this.localShapeCollection = shapeCollectionPool.newShapeCollection(),
                    this.localShapeCollection.addShape(this.v),
                    this.paths = this.localShapeCollection,
                    this.elem = m,
                    this.comp = m.comp,
                    this.frameId = -1,
                    this.d = f.d,
                    this.initDynamicPropertyContainer(m),
                    this.p = PropertyFactory.getProp(m, f.p, 1, 0, this),
                    this.s = PropertyFactory.getProp(m, f.s, 1, 0, this),
                    this.r = PropertyFactory.getProp(m, f.r, 0, 0, this),
                    this.dynamicProperties.length ? this.k = !0 : (this.k = !1,
                    this.convertRectToPath())
                }
                return u.prototype = {
                    convertRectToPath: function() {
                        var f = this.p.v[0]
                          , y = this.p.v[1]
                          , _ = this.s.v[0] / 2
                          , T = this.s.v[1] / 2
                          , C = bmMin(_, T, this.r.v)
                          , x = C * (1 - roundCorner);
                        this.v._length = 0,
                        this.d === 2 || this.d === 1 ? (this.v.setTripleAt(f + _, y - T + C, f + _, y - T + C, f + _, y - T + x, 0, !0),
                        this.v.setTripleAt(f + _, y + T - C, f + _, y + T - x, f + _, y + T - C, 1, !0),
                        C !== 0 ? (this.v.setTripleAt(f + _ - C, y + T, f + _ - C, y + T, f + _ - x, y + T, 2, !0),
                        this.v.setTripleAt(f - _ + C, y + T, f - _ + x, y + T, f - _ + C, y + T, 3, !0),
                        this.v.setTripleAt(f - _, y + T - C, f - _, y + T - C, f - _, y + T - x, 4, !0),
                        this.v.setTripleAt(f - _, y - T + C, f - _, y - T + x, f - _, y - T + C, 5, !0),
                        this.v.setTripleAt(f - _ + C, y - T, f - _ + C, y - T, f - _ + x, y - T, 6, !0),
                        this.v.setTripleAt(f + _ - C, y - T, f + _ - x, y - T, f + _ - C, y - T, 7, !0)) : (this.v.setTripleAt(f - _, y + T, f - _ + x, y + T, f - _, y + T, 2),
                        this.v.setTripleAt(f - _, y - T, f - _, y - T + x, f - _, y - T, 3))) : (this.v.setTripleAt(f + _, y - T + C, f + _, y - T + x, f + _, y - T + C, 0, !0),
                        C !== 0 ? (this.v.setTripleAt(f + _ - C, y - T, f + _ - C, y - T, f + _ - x, y - T, 1, !0),
                        this.v.setTripleAt(f - _ + C, y - T, f - _ + x, y - T, f - _ + C, y - T, 2, !0),
                        this.v.setTripleAt(f - _, y - T + C, f - _, y - T + C, f - _, y - T + x, 3, !0),
                        this.v.setTripleAt(f - _, y + T - C, f - _, y + T - x, f - _, y + T - C, 4, !0),
                        this.v.setTripleAt(f - _ + C, y + T, f - _ + C, y + T, f - _ + x, y + T, 5, !0),
                        this.v.setTripleAt(f + _ - C, y + T, f + _ - x, y + T, f + _ - C, y + T, 6, !0),
                        this.v.setTripleAt(f + _, y + T - C, f + _, y + T - C, f + _, y + T - x, 7, !0)) : (this.v.setTripleAt(f - _, y - T, f - _ + x, y - T, f - _, y - T, 1, !0),
                        this.v.setTripleAt(f - _, y + T, f - _, y + T - x, f - _, y + T, 2, !0),
                        this.v.setTripleAt(f + _, y + T, f + _ - x, y + T, f + _, y + T, 3, !0)))
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId,
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertRectToPath())
                    },
                    reset: i
                },
                extendPrototype([DynamicPropertyContainer], u),
                u
            }();
            function g(u, m, f) {
                var y;
                if (f === 3 || f === 4) {
                    var _ = f === 3 ? m.pt : m.ks
                      , T = _.k;
                    T.length ? y = new h(u,m,f) : y = new l(u,m,f)
                } else
                    f === 5 ? y = new c(u,m) : f === 6 ? y = new p(u,m) : f === 7 && (y = new S(u,m));
                return y.k && u.addDynamicProperty(y),
                y
            }
            function v() {
                return l
            }
            function d() {
                return h
            }
            var b = {};
            return b.getShapeProp = g,
            b.getConstructorFunction = v,
            b.getKeyframedConstructorFunction = d,
            b
        }();
        /*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */
        var Matrix = function() {
            var t = Math.cos
              , e = Math.sin
              , r = Math.tan
              , i = Math.round;
            function s() {
                return this.props[0] = 1,
                this.props[1] = 0,
                this.props[2] = 0,
                this.props[3] = 0,
                this.props[4] = 0,
                this.props[5] = 1,
                this.props[6] = 0,
                this.props[7] = 0,
                this.props[8] = 0,
                this.props[9] = 0,
                this.props[10] = 1,
                this.props[11] = 0,
                this.props[12] = 0,
                this.props[13] = 0,
                this.props[14] = 0,
                this.props[15] = 1,
                this
            }
            function n(E) {
                if (E === 0)
                    return this;
                var A = t(E)
                  , F = e(E);
                return this._t(A, -F, 0, 0, F, A, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            }
            function a(E) {
                if (E === 0)
                    return this;
                var A = t(E)
                  , F = e(E);
                return this._t(1, 0, 0, 0, 0, A, -F, 0, 0, F, A, 0, 0, 0, 0, 1)
            }
            function l(E) {
                if (E === 0)
                    return this;
                var A = t(E)
                  , F = e(E);
                return this._t(A, 0, F, 0, 0, 1, 0, 0, -F, 0, A, 0, 0, 0, 0, 1)
            }
            function o(E) {
                if (E === 0)
                    return this;
                var A = t(E)
                  , F = e(E);
                return this._t(A, -F, 0, 0, F, A, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            }
            function h(E, A) {
                return this._t(1, A, E, 1, 0, 0)
            }
            function p(E, A) {
                return this.shear(r(E), r(A))
            }
            function S(E, A) {
                var F = t(A)
                  , I = e(A);
                return this._t(F, I, 0, 0, -I, F, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(E), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(F, -I, 0, 0, I, F, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            }
            function c(E, A, F) {
                return !F && F !== 0 && (F = 1),
                E === 1 && A === 1 && F === 1 ? this : this._t(E, 0, 0, 0, 0, A, 0, 0, 0, 0, F, 0, 0, 0, 0, 1)
            }
            function g(E, A, F, I, N, $, H, W, B, q, X, U, j, Y, Z, G) {
                return this.props[0] = E,
                this.props[1] = A,
                this.props[2] = F,
                this.props[3] = I,
                this.props[4] = N,
                this.props[5] = $,
                this.props[6] = H,
                this.props[7] = W,
                this.props[8] = B,
                this.props[9] = q,
                this.props[10] = X,
                this.props[11] = U,
                this.props[12] = j,
                this.props[13] = Y,
                this.props[14] = Z,
                this.props[15] = G,
                this
            }
            function v(E, A, F) {
                return F = F || 0,
                E !== 0 || A !== 0 || F !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, E, A, F, 1) : this
            }
            function d(E, A, F, I, N, $, H, W, B, q, X, U, j, Y, Z, G) {
                var z = this.props;
                if (E === 1 && A === 0 && F === 0 && I === 0 && N === 0 && $ === 1 && H === 0 && W === 0 && B === 0 && q === 0 && X === 1 && U === 0)
                    return z[12] = z[12] * E + z[15] * j,
                    z[13] = z[13] * $ + z[15] * Y,
                    z[14] = z[14] * X + z[15] * Z,
                    z[15] *= G,
                    this._identityCalculated = !1,
                    this;
                var K = z[0]
                  , J = z[1]
                  , tt = z[2]
                  , it = z[3]
                  , st = z[4]
                  , nt = z[5]
                  , Q = z[6]
                  , at = z[7]
                  , ot = z[8]
                  , et = z[9]
                  , lt = z[10]
                  , rt = z[11]
                  , ht = z[12]
                  , ft = z[13]
                  , ct = z[14]
                  , pt = z[15];
                return z[0] = K * E + J * N + tt * B + it * j,
                z[1] = K * A + J * $ + tt * q + it * Y,
                z[2] = K * F + J * H + tt * X + it * Z,
                z[3] = K * I + J * W + tt * U + it * G,
                z[4] = st * E + nt * N + Q * B + at * j,
                z[5] = st * A + nt * $ + Q * q + at * Y,
                z[6] = st * F + nt * H + Q * X + at * Z,
                z[7] = st * I + nt * W + Q * U + at * G,
                z[8] = ot * E + et * N + lt * B + rt * j,
                z[9] = ot * A + et * $ + lt * q + rt * Y,
                z[10] = ot * F + et * H + lt * X + rt * Z,
                z[11] = ot * I + et * W + lt * U + rt * G,
                z[12] = ht * E + ft * N + ct * B + pt * j,
                z[13] = ht * A + ft * $ + ct * q + pt * Y,
                z[14] = ht * F + ft * H + ct * X + pt * Z,
                z[15] = ht * I + ft * W + ct * U + pt * G,
                this._identityCalculated = !1,
                this
            }
            function b(E) {
                var A = E.props;
                return this.transform(A[0], A[1], A[2], A[3], A[4], A[5], A[6], A[7], A[8], A[9], A[10], A[11], A[12], A[13], A[14], A[15])
            }
            function u() {
                return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1),
                this._identityCalculated = !0),
                this._identity
            }
            function m(E) {
                for (var A = 0; A < 16; ) {
                    if (E.props[A] !== this.props[A])
                        return !1;
                    A += 1
                }
                return !0
            }
            function f(E) {
                var A;
                for (A = 0; A < 16; A += 1)
                    E.props[A] = this.props[A];
                return E
            }
            function y(E) {
                var A;
                for (A = 0; A < 16; A += 1)
                    this.props[A] = E[A]
            }
            function _(E, A, F) {
                return {
                    x: E * this.props[0] + A * this.props[4] + F * this.props[8] + this.props[12],
                    y: E * this.props[1] + A * this.props[5] + F * this.props[9] + this.props[13],
                    z: E * this.props[2] + A * this.props[6] + F * this.props[10] + this.props[14]
                }
            }
            function T(E, A, F) {
                return E * this.props[0] + A * this.props[4] + F * this.props[8] + this.props[12]
            }
            function C(E, A, F) {
                return E * this.props[1] + A * this.props[5] + F * this.props[9] + this.props[13]
            }
            function x(E, A, F) {
                return E * this.props[2] + A * this.props[6] + F * this.props[10] + this.props[14]
            }
            function w() {
                var E = this.props[0] * this.props[5] - this.props[1] * this.props[4]
                  , A = this.props[5] / E
                  , F = -this.props[1] / E
                  , I = -this.props[4] / E
                  , N = this.props[0] / E
                  , $ = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / E
                  , H = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / E
                  , W = new Matrix;
                return W.props[0] = A,
                W.props[1] = F,
                W.props[4] = I,
                W.props[5] = N,
                W.props[12] = $,
                W.props[13] = H,
                W
            }
            function D(E) {
                var A = this.getInverseMatrix();
                return A.applyToPointArray(E[0], E[1], E[2] || 0)
            }
            function k(E) {
                var A, F = E.length, I = [];
                for (A = 0; A < F; A += 1)
                    I[A] = D(E[A]);
                return I
            }
            function L(E, A, F) {
                var I = createTypedArray("float32", 6);
                if (this.isIdentity())
                    I[0] = E[0],
                    I[1] = E[1],
                    I[2] = A[0],
                    I[3] = A[1],
                    I[4] = F[0],
                    I[5] = F[1];
                else {
                    var N = this.props[0]
                      , $ = this.props[1]
                      , H = this.props[4]
                      , W = this.props[5]
                      , B = this.props[12]
                      , q = this.props[13];
                    I[0] = E[0] * N + E[1] * H + B,
                    I[1] = E[0] * $ + E[1] * W + q,
                    I[2] = A[0] * N + A[1] * H + B,
                    I[3] = A[0] * $ + A[1] * W + q,
                    I[4] = F[0] * N + F[1] * H + B,
                    I[5] = F[0] * $ + F[1] * W + q
                }
                return I
            }
            function V(E, A, F) {
                var I;
                return this.isIdentity() ? I = [E, A, F] : I = [E * this.props[0] + A * this.props[4] + F * this.props[8] + this.props[12], E * this.props[1] + A * this.props[5] + F * this.props[9] + this.props[13], E * this.props[2] + A * this.props[6] + F * this.props[10] + this.props[14]],
                I
            }
            function O(E, A) {
                if (this.isIdentity())
                    return E + "," + A;
                var F = this.props;
                return Math.round((E * F[0] + A * F[4] + F[12]) * 100) / 100 + "," + Math.round((E * F[1] + A * F[5] + F[13]) * 100) / 100
            }
            function R() {
                for (var E = 0, A = this.props, F = "matrix3d(", I = 1e4; E < 16; )
                    F += i(A[E] * I) / I,
                    F += E === 15 ? ")" : ",",
                    E += 1;
                return F
            }
            function P(E) {
                var A = 1e4;
                return E < 1e-6 && E > 0 || E > -1e-6 && E < 0 ? i(E * A) / A : E
            }
            function M() {
                var E = this.props
                  , A = P(E[0])
                  , F = P(E[1])
                  , I = P(E[4])
                  , N = P(E[5])
                  , $ = P(E[12])
                  , H = P(E[13]);
                return "matrix(" + A + "," + F + "," + I + "," + N + "," + $ + "," + H + ")"
            }
            return function() {
                this.reset = s,
                this.rotate = n,
                this.rotateX = a,
                this.rotateY = l,
                this.rotateZ = o,
                this.skew = p,
                this.skewFromAxis = S,
                this.shear = h,
                this.scale = c,
                this.setTransform = g,
                this.translate = v,
                this.transform = d,
                this.multiply = b,
                this.applyToPoint = _,
                this.applyToX = T,
                this.applyToY = C,
                this.applyToZ = x,
                this.applyToPointArray = V,
                this.applyToTriplePoints = L,
                this.applyToPointStringified = O,
                this.toCSS = R,
                this.to2dCSS = M,
                this.clone = f,
                this.cloneFromProps = y,
                this.equals = m,
                this.inversePoints = k,
                this.inversePoint = D,
                this.getInverseMatrix = w,
                this._t = this.transform,
                this.isIdentity = u,
                this._identity = !0,
                this._identityCalculated = !1,
                this.props = createTypedArray("float32", 16),
                this.reset()
            }
        }();
        function _typeof$3(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(r) {
                return typeof r
            }
            : _typeof$3 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$3(t)
        }
        var lottie = {};
        function setLocation(t) {
            setLocationHref(t)
        }
        function searchAnimations() {
            animationManager.searchAnimations()
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t)
        }
        function setPrefix(t) {
            setIdPrefix(t)
        }
        function loadAnimation(t) {
            return animationManager.loadAnimation(t)
        }
        function setQuality(t) {
            if (typeof t == "string")
                switch (t) {
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
                    break
                }
            else
                !isNaN(t) && t > 1 && setDefaultCurveSegments(t)
        }
        function inBrowser() {
            return typeof navigator < "u"
        }
        function installPlugin(t, e) {
            t === "expressions" && setExpressionsPlugin(e)
        }
        function getFactory(t) {
            switch (t) {
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null
            }
        }
        lottie.play = animationManager.play,
        lottie.pause = animationManager.pause,
        lottie.setLocationHref = setLocation,
        lottie.togglePause = animationManager.togglePause,
        lottie.setSpeed = animationManager.setSpeed,
        lottie.setDirection = animationManager.setDirection,
        lottie.stop = animationManager.stop,
        lottie.searchAnimations = searchAnimations,
        lottie.registerAnimation = animationManager.registerAnimation,
        lottie.loadAnimation = loadAnimation,
        lottie.setSubframeRendering = setSubframeRendering,
        lottie.resize = animationManager.resize,
        lottie.goToAndStop = animationManager.goToAndStop,
        lottie.destroy = animationManager.destroy,
        lottie.setQuality = setQuality,
        lottie.inBrowser = inBrowser,
        lottie.installPlugin = installPlugin,
        lottie.freeze = animationManager.freeze,
        lottie.unfreeze = animationManager.unfreeze,
        lottie.setVolume = animationManager.setVolume,
        lottie.mute = animationManager.mute,
        lottie.unmute = animationManager.unmute,
        lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations,
        lottie.useWebWorker = setWebWorker,
        lottie.setIDPrefix = setPrefix,
        lottie.__getFactory = getFactory,
        lottie.version = "5.12.2";
        function checkReady() {
            document.readyState === "complete" && (clearInterval(readyStateCheckInterval),
            searchAnimations())
        }
        function getQueryVariable(t) {
            for (var e = queryString.split("&"), r = 0; r < e.length; r += 1) {
                var i = e[r].split("=");
                if (decodeURIComponent(i[0]) == t)
                    return decodeURIComponent(i[1])
            }
            return null
        }
        var queryString = "";
        {
            var scripts = document.getElementsByTagName("script")
              , index = scripts.length - 1
              , myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "",
            getQueryVariable("renderer")
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            _typeof$3(exports) !== "object" && (window.bodymovin = lottie)
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}
              , e = {};
            t.registerModifier = r,
            t.getModifier = i;
            function r(s, n) {
                e[s] || (e[s] = n)
            }
            function i(s, n, a) {
                return new e[s](n,a)
            }
            return t
        }();
        function ShapeModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}
        ,
        ShapeModifier.prototype.addShapeToModifier = function() {}
        ,
        ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e),
                this.addShapeToModifier(e),
                this._isAnimated && t.setAsAnimated()
            }
        }
        ,
        ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [],
            this.elem = t,
            this.initDynamicPropertyContainer(t),
            this.initModifierProperties(t, e),
            this.frameId = initialDefaultFrame,
            this.closed = !1,
            this.k = !1,
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0)
        }
        ,
        ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId,
            this.iterateDynamicProperties())
        }
        ,
        extendPrototype([DynamicPropertyContainer], ShapeModifier);
        function TrimModifier() {}
        extendPrototype([ShapeModifier], TrimModifier),
        TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this),
            this.e = PropertyFactory.getProp(t, e.e, 0, .01, this),
            this.o = PropertyFactory.getProp(t, e.o, 0, 0, this),
            this.sValue = 0,
            this.eValue = 0,
            this.getValue = this.processKeys,
            this.m = e.m,
            this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length
        }
        ,
        TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = []
        }
        ,
        TrimModifier.prototype.calculateShapeEdges = function(t, e, r, i, s) {
            var n = [];
            e <= 1 ? n.push({
                s: t,
                e
            }) : t >= 1 ? n.push({
                s: t - 1,
                e: e - 1
            }) : (n.push({
                s: t,
                e: 1
            }),
            n.push({
                s: 0,
                e: e - 1
            }));
            var a = [], l, o = n.length, h;
            for (l = 0; l < o; l += 1)
                if (h = n[l],
                !(h.e * s < i || h.s * s > i + r)) {
                    var p, S;
                    h.s * s <= i ? p = 0 : p = (h.s * s - i) / r,
                    h.e * s >= i + r ? S = 1 : S = (h.e * s - i) / r,
                    a.push([p, S])
                }
            return a.length || a.push([0, 0]),
            a
        }
        ,
        TrimModifier.prototype.releasePathsData = function(t) {
            var e, r = t.length;
            for (e = 0; e < r; e += 1)
                segmentsLengthPool.release(t[e]);
            return t.length = 0,
            t
        }
        ,
        TrimModifier.prototype.processShapes = function(t) {
            var e, r;
            if (this._mdf || t) {
                var i = this.o.v % 360 / 360;
                if (i < 0 && (i += 1),
                this.s.v > 1 ? e = 1 + i : this.s.v < 0 ? e = 0 + i : e = this.s.v + i,
                this.e.v > 1 ? r = 1 + i : this.e.v < 0 ? r = 0 + i : r = this.e.v + i,
                e > r) {
                    var s = e;
                    e = r,
                    r = s
                }
                e = Math.round(e * 1e4) * 1e-4,
                r = Math.round(r * 1e4) * 1e-4,
                this.sValue = e,
                this.eValue = r
            } else
                e = this.sValue,
                r = this.eValue;
            var n, a, l = this.shapes.length, o, h, p, S, c, g = 0;
            if (r === e)
                for (a = 0; a < l; a += 1)
                    this.shapes[a].localShapeCollection.releaseShapes(),
                    this.shapes[a].shape._mdf = !0,
                    this.shapes[a].shape.paths = this.shapes[a].localShapeCollection,
                    this._mdf && (this.shapes[a].pathsData.length = 0);
            else if (r === 1 && e === 0 || r === 0 && e === 1) {
                if (this._mdf)
                    for (a = 0; a < l; a += 1)
                        this.shapes[a].pathsData.length = 0,
                        this.shapes[a].shape._mdf = !0
            } else {
                var v = [], d, b;
                for (a = 0; a < l; a += 1)
                    if (d = this.shapes[a],
                    !d.shape._mdf && !this._mdf && !t && this.m !== 2)
                        d.shape.paths = d.localShapeCollection;
                    else {
                        if (n = d.shape.paths,
                        h = n._length,
                        c = 0,
                        !d.shape._mdf && d.pathsData.length)
                            c = d.totalShapeLength;
                        else {
                            for (p = this.releasePathsData(d.pathsData),
                            o = 0; o < h; o += 1)
                                S = bez.getSegmentsLength(n.shapes[o]),
                                p.push(S),
                                c += S.totalLength;
                            d.totalShapeLength = c,
                            d.pathsData = p
                        }
                        g += c,
                        d.shape._mdf = !0
                    }
                var u = e, m = r, f = 0, y;
                for (a = l - 1; a >= 0; a -= 1)
                    if (d = this.shapes[a],
                    d.shape._mdf) {
                        for (b = d.localShapeCollection,
                        b.releaseShapes(),
                        this.m === 2 && l > 1 ? (y = this.calculateShapeEdges(e, r, d.totalShapeLength, f, g),
                        f += d.totalShapeLength) : y = [[u, m]],
                        h = y.length,
                        o = 0; o < h; o += 1) {
                            u = y[o][0],
                            m = y[o][1],
                            v.length = 0,
                            m <= 1 ? v.push({
                                s: d.totalShapeLength * u,
                                e: d.totalShapeLength * m
                            }) : u >= 1 ? v.push({
                                s: d.totalShapeLength * (u - 1),
                                e: d.totalShapeLength * (m - 1)
                            }) : (v.push({
                                s: d.totalShapeLength * u,
                                e: d.totalShapeLength
                            }),
                            v.push({
                                s: 0,
                                e: d.totalShapeLength * (m - 1)
                            }));
                            var _ = this.addShapes(d, v[0]);
                            if (v[0].s !== v[0].e) {
                                if (v.length > 1) {
                                    var T = d.shape.paths.shapes[d.shape.paths._length - 1];
                                    if (T.c) {
                                        var C = _.pop();
                                        this.addPaths(_, b),
                                        _ = this.addShapes(d, v[1], C)
                                    } else
                                        this.addPaths(_, b),
                                        _ = this.addShapes(d, v[1])
                                }
                                this.addPaths(_, b)
                            }
                        }
                        d.shape.paths = b
                    }
            }
        }
        ,
        TrimModifier.prototype.addPaths = function(t, e) {
            var r, i = t.length;
            for (r = 0; r < i; r += 1)
                e.addShape(t[r])
        }
        ,
        TrimModifier.prototype.addSegment = function(t, e, r, i, s, n, a) {
            s.setXYAt(e[0], e[1], "o", n),
            s.setXYAt(r[0], r[1], "i", n + 1),
            a && s.setXYAt(t[0], t[1], "v", n),
            s.setXYAt(i[0], i[1], "v", n + 1)
        }
        ,
        TrimModifier.prototype.addSegmentFromArray = function(t, e, r, i) {
            e.setXYAt(t[1], t[5], "o", r),
            e.setXYAt(t[2], t[6], "i", r + 1),
            i && e.setXYAt(t[0], t[4], "v", r),
            e.setXYAt(t[3], t[7], "v", r + 1)
        }
        ,
        TrimModifier.prototype.addShapes = function(t, e, r) {
            var i = t.pathsData, s = t.shape.paths.shapes, n, a = t.shape.paths._length, l, o, h = 0, p, S, c, g, v = [], d, b = !0;
            for (r ? (S = r._length,
            d = r._length) : (r = shapePool.newElement(),
            S = 0,
            d = 0),
            v.push(r),
            n = 0; n < a; n += 1) {
                for (c = i[n].lengths,
                r.c = s[n].c,
                o = s[n].c ? c.length : c.length + 1,
                l = 1; l < o; l += 1)
                    if (p = c[l - 1],
                    h + p.addedLength < e.s)
                        h += p.addedLength,
                        r.c = !1;
                    else if (h > e.e) {
                        r.c = !1;
                        break
                    } else
                        e.s <= h && e.e >= h + p.addedLength ? (this.addSegment(s[n].v[l - 1], s[n].o[l - 1], s[n].i[l], s[n].v[l], r, S, b),
                        b = !1) : (g = bez.getNewSegment(s[n].v[l - 1], s[n].v[l], s[n].o[l - 1], s[n].i[l], (e.s - h) / p.addedLength, (e.e - h) / p.addedLength, c[l - 1]),
                        this.addSegmentFromArray(g, r, S, b),
                        b = !1,
                        r.c = !1),
                        h += p.addedLength,
                        S += 1;
                if (s[n].c && c.length) {
                    if (p = c[l - 1],
                    h <= e.e) {
                        var u = c[l - 1].addedLength;
                        e.s <= h && e.e >= h + u ? (this.addSegment(s[n].v[l - 1], s[n].o[l - 1], s[n].i[0], s[n].v[0], r, S, b),
                        b = !1) : (g = bez.getNewSegment(s[n].v[l - 1], s[n].v[0], s[n].o[l - 1], s[n].i[0], (e.s - h) / u, (e.e - h) / u, c[l - 1]),
                        this.addSegmentFromArray(g, r, S, b),
                        b = !1,
                        r.c = !1)
                    } else
                        r.c = !1;
                    h += p.addedLength,
                    S += 1
                }
                if (r._length && (r.setXYAt(r.v[d][0], r.v[d][1], "i", d),
                r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)),
                h > e.e)
                    break;
                n < a - 1 && (r = shapePool.newElement(),
                b = !0,
                v.push(r),
                S = 0)
            }
            return v
        }
        ;
        function PuckerAndBloatModifier() {}
        extendPrototype([ShapeModifier], PuckerAndBloatModifier),
        PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys,
            this.amount = PropertyFactory.getProp(t, e.a, 0, null, this),
            this._isAnimated = !!this.amount.effectsSequence.length
        }
        ,
        PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r = e / 100
              , i = [0, 0]
              , s = t._length
              , n = 0;
            for (n = 0; n < s; n += 1)
                i[0] += t.v[n][0],
                i[1] += t.v[n][1];
            i[0] /= s,
            i[1] /= s;
            var a = shapePool.newElement();
            a.c = t.c;
            var l, o, h, p, S, c;
            for (n = 0; n < s; n += 1)
                l = t.v[n][0] + (i[0] - t.v[n][0]) * r,
                o = t.v[n][1] + (i[1] - t.v[n][1]) * r,
                h = t.o[n][0] + (i[0] - t.o[n][0]) * -r,
                p = t.o[n][1] + (i[1] - t.o[n][1]) * -r,
                S = t.i[n][0] + (i[0] - t.i[n][0]) * -r,
                c = t.i[n][1] + (i[1] - t.i[n][1]) * -r,
                a.setTripleAt(l, o, h, p, S, c, n);
            return a
        }
        ,
        PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r, i = this.shapes.length, s, n, a = this.amount.v;
            if (a !== 0) {
                var l, o;
                for (r = 0; r < i; r += 1) {
                    if (l = this.shapes[r],
                    o = l.localShapeCollection,
                    !(!l.shape._mdf && !this._mdf && !t))
                        for (o.releaseShapes(),
                        l.shape._mdf = !0,
                        e = l.shape.paths.shapes,
                        n = l.shape.paths._length,
                        s = 0; s < n; s += 1)
                            o.addShape(this.processPath(e[s], a));
                    l.shape.paths = l.localShapeCollection
                }
            }
            this.dynamicProperties.length || (this._mdf = !1)
        }
        ;
        var TransformPropertyFactory = function() {
            var t = [0, 0];
            function e(o) {
                var h = this._mdf;
                this.iterateDynamicProperties(),
                this._mdf = this._mdf || h,
                this.a && o.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                this.s && o.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                this.sk && o.skewFromAxis(-this.sk.v, this.sa.v),
                this.r ? o.rotate(-this.r.v) : o.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                this.data.p.s ? this.data.p.z ? o.translate(this.px.v, this.py.v, -this.pz.v) : o.translate(this.px.v, this.py.v, 0) : o.translate(this.p.v[0], this.p.v[1], -this.p.v[2])
            }
            function r(o) {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this._isDirty && (this.precalculateMatrix(),
                    this._isDirty = !1),
                    this.iterateDynamicProperties(),
                    this._mdf || o) {
                        var h;
                        if (this.v.cloneFromProps(this.pre.props),
                        this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                        this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                        this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v),
                        this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                        this.autoOriented) {
                            var p, S;
                            if (h = this.elem.globalData.frameRate,
                            this.p && this.p.keyframes && this.p.getValueAtTime)
                                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (p = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / h, 0),
                                S = this.p.getValueAtTime(this.p.keyframes[0].t / h, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (p = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / h, 0),
                                S = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / h, 0)) : (p = this.p.pv,
                                S = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / h, this.p.offsetTime));
                            else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                p = [],
                                S = [];
                                var c = this.px
                                  , g = this.py;
                                c._caching.lastFrame + c.offsetTime <= c.keyframes[0].t ? (p[0] = c.getValueAtTime((c.keyframes[0].t + .01) / h, 0),
                                p[1] = g.getValueAtTime((g.keyframes[0].t + .01) / h, 0),
                                S[0] = c.getValueAtTime(c.keyframes[0].t / h, 0),
                                S[1] = g.getValueAtTime(g.keyframes[0].t / h, 0)) : c._caching.lastFrame + c.offsetTime >= c.keyframes[c.keyframes.length - 1].t ? (p[0] = c.getValueAtTime(c.keyframes[c.keyframes.length - 1].t / h, 0),
                                p[1] = g.getValueAtTime(g.keyframes[g.keyframes.length - 1].t / h, 0),
                                S[0] = c.getValueAtTime((c.keyframes[c.keyframes.length - 1].t - .01) / h, 0),
                                S[1] = g.getValueAtTime((g.keyframes[g.keyframes.length - 1].t - .01) / h, 0)) : (p = [c.pv, g.pv],
                                S[0] = c.getValueAtTime((c._caching.lastFrame + c.offsetTime - .01) / h, c.offsetTime),
                                S[1] = g.getValueAtTime((g._caching.lastFrame + g.offsetTime - .01) / h, g.offsetTime))
                            } else
                                S = t,
                                p = S;
                            this.v.rotate(-Math.atan2(p[1] - S[1], p[0] - S[0]))
                        }
                        this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2])
                    }
                    this.frameId = this.elem.globalData.frameId
                }
            }
            function i() {
                if (this.appliedTransformations = 0,
                this.pre.reset(),
                !this.a.effectsSequence.length)
                    this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                    this.appliedTransformations = 1;
                else
                    return;
                if (!this.s.effectsSequence.length)
                    this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                    this.appliedTransformations = 2;
                else
                    return;
                if (this.sk)
                    if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
                        this.pre.skewFromAxis(-this.sk.v, this.sa.v),
                        this.appliedTransformations = 3;
                    else
                        return;
                this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v),
                this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                this.appliedTransformations = 4)
            }
            function s() {}
            function n(o) {
                this._addDynamicProperty(o),
                this.elem.addDynamicProperty(o),
                this._isDirty = !0
            }
            function a(o, h, p) {
                if (this.elem = o,
                this.frameId = -1,
                this.propType = "transform",
                this.data = h,
                this.v = new Matrix,
                this.pre = new Matrix,
                this.appliedTransformations = 0,
                this.initDynamicPropertyContainer(p || o),
                h.p && h.p.s ? (this.px = PropertyFactory.getProp(o, h.p.x, 0, 0, this),
                this.py = PropertyFactory.getProp(o, h.p.y, 0, 0, this),
                h.p.z && (this.pz = PropertyFactory.getProp(o, h.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(o, h.p || {
                    k: [0, 0, 0]
                }, 1, 0, this),
                h.rx) {
                    if (this.rx = PropertyFactory.getProp(o, h.rx, 0, degToRads, this),
                    this.ry = PropertyFactory.getProp(o, h.ry, 0, degToRads, this),
                    this.rz = PropertyFactory.getProp(o, h.rz, 0, degToRads, this),
                    h.or.k[0].ti) {
                        var S, c = h.or.k.length;
                        for (S = 0; S < c; S += 1)
                            h.or.k[S].to = null,
                            h.or.k[S].ti = null
                    }
                    this.or = PropertyFactory.getProp(o, h.or, 1, degToRads, this),
                    this.or.sh = !0
                } else
                    this.r = PropertyFactory.getProp(o, h.r || {
                        k: 0
                    }, 0, degToRads, this);
                h.sk && (this.sk = PropertyFactory.getProp(o, h.sk, 0, degToRads, this),
                this.sa = PropertyFactory.getProp(o, h.sa, 0, degToRads, this)),
                this.a = PropertyFactory.getProp(o, h.a || {
                    k: [0, 0, 0]
                }, 1, 0, this),
                this.s = PropertyFactory.getProp(o, h.s || {
                    k: [100, 100, 100]
                }, 1, .01, this),
                h.o ? this.o = PropertyFactory.getProp(o, h.o, 0, .01, o) : this.o = {
                    _mdf: !1,
                    v: 1
                },
                this._isDirty = !0,
                this.dynamicProperties.length || this.getValue(!0)
            }
            a.prototype = {
                applyToMatrix: e,
                getValue: r,
                precalculateMatrix: i,
                autoOrient: s
            },
            extendPrototype([DynamicPropertyContainer], a),
            a.prototype.addDynamicProperty = n,
            a.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
            function l(o, h, p) {
                return new a(o,h,p)
            }
            return {
                getTransformProperty: l
            }
        }();
        function RepeaterModifier() {}
        extendPrototype([ShapeModifier], RepeaterModifier),
        RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys,
            this.c = PropertyFactory.getProp(t, e.c, 0, null, this),
            this.o = PropertyFactory.getProp(t, e.o, 0, null, this),
            this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this),
            this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this),
            this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this),
            this.data = e,
            this.dynamicProperties.length || this.getValue(!0),
            this._isAnimated = !!this.dynamicProperties.length,
            this.pMatrix = new Matrix,
            this.rMatrix = new Matrix,
            this.sMatrix = new Matrix,
            this.tMatrix = new Matrix,
            this.matrix = new Matrix
        }
        ,
        RepeaterModifier.prototype.applyTransforms = function(t, e, r, i, s, n) {
            var a = n ? -1 : 1
              , l = i.s.v[0] + (1 - i.s.v[0]) * (1 - s)
              , o = i.s.v[1] + (1 - i.s.v[1]) * (1 - s);
            t.translate(i.p.v[0] * a * s, i.p.v[1] * a * s, i.p.v[2]),
            e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
            e.rotate(-i.r.v * a * s),
            e.translate(i.a.v[0], i.a.v[1], i.a.v[2]),
            r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
            r.scale(n ? 1 / l : l, n ? 1 / o : o),
            r.translate(i.a.v[0], i.a.v[1], i.a.v[2])
        }
        ,
        RepeaterModifier.prototype.init = function(t, e, r, i) {
            for (this.elem = t,
            this.arr = e,
            this.pos = r,
            this.elemsData = i,
            this._currentCopies = 0,
            this._elements = [],
            this._groups = [],
            this.frameId = -1,
            this.initDynamicPropertyContainer(t),
            this.initModifierProperties(t, e[r]); r > 0; )
                r -= 1,
                this._elements.unshift(e[r]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0)
        }
        ,
        RepeaterModifier.prototype.resetElements = function(t) {
            var e, r = t.length;
            for (e = 0; e < r; e += 1)
                t[e]._processed = !1,
                t[e].ty === "gr" && this.resetElements(t[e].it)
        }
        ,
        RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e),
            e
        }
        ,
        RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r, i = t.length;
            for (r = 0; r < i; r += 1)
                t[r]._render = e,
                t[r].ty === "gr" && this.changeGroupRender(t[r].it, e)
        }
        ,
        RepeaterModifier.prototype.processShapes = function(t) {
            var e, r, i, s, n, a = !1;
            if (this._mdf || t) {
                var l = Math.ceil(this.c.v);
                if (this._groups.length < l) {
                    for (; this._groups.length < l; ) {
                        var o = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        o.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [0, 0]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [0, 0]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [{
                                    s: 0,
                                    e: 0,
                                    t: 0
                                }, {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [100, 100]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }),
                        this.arr.splice(0, 0, o),
                        this._groups.splice(0, 0, o),
                        this._currentCopies += 1
                    }
                    this.elem.reloadShapes(),
                    a = !0
                }
                n = 0;
                var h;
                for (i = 0; i <= this._groups.length - 1; i += 1) {
                    if (h = n < l,
                    this._groups[i]._render = h,
                    this.changeGroupRender(this._groups[i].it, h),
                    !h) {
                        var p = this.elemsData[i].it
                          , S = p[p.length - 1];
                        S.transform.op.v !== 0 ? (S.transform.op._mdf = !0,
                        S.transform.op.v = 0) : S.transform.op._mdf = !1
                    }
                    n += 1
                }
                this._currentCopies = l;
                var c = this.o.v
                  , g = c % 1
                  , v = c > 0 ? Math.floor(c) : Math.ceil(c)
                  , d = this.pMatrix.props
                  , b = this.rMatrix.props
                  , u = this.sMatrix.props;
                this.pMatrix.reset(),
                this.rMatrix.reset(),
                this.sMatrix.reset(),
                this.tMatrix.reset(),
                this.matrix.reset();
                var m = 0;
                if (c > 0) {
                    for (; m < v; )
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1),
                        m += 1;
                    g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, g, !1),
                    m += g)
                } else if (c < 0) {
                    for (; m > v; )
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0),
                        m -= 1;
                    g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -g, !0),
                    m -= g)
                }
                i = this.data.m === 1 ? 0 : this._currentCopies - 1,
                s = this.data.m === 1 ? 1 : -1,
                n = this._currentCopies;
                for (var f, y; n; ) {
                    if (e = this.elemsData[i].it,
                    r = e[e.length - 1].transform.mProps.v.props,
                    y = r.length,
                    e[e.length - 1].transform.mProps._mdf = !0,
                    e[e.length - 1].transform.op._mdf = !0,
                    e[e.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)),
                    m !== 0) {
                        for ((i !== 0 && s === 1 || i !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1),
                        this.matrix.transform(b[0], b[1], b[2], b[3], b[4], b[5], b[6], b[7], b[8], b[9], b[10], b[11], b[12], b[13], b[14], b[15]),
                        this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]),
                        this.matrix.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]),
                        f = 0; f < y; f += 1)
                            r[f] = this.matrix.props[f];
                        this.matrix.reset()
                    } else
                        for (this.matrix.reset(),
                        f = 0; f < y; f += 1)
                            r[f] = this.matrix.props[f];
                    m += 1,
                    n -= 1,
                    i += s
                }
            } else
                for (n = this._currentCopies,
                i = 0,
                s = 1; n; )
                    e = this.elemsData[i].it,
                    r = e[e.length - 1].transform.mProps.v.props,
                    e[e.length - 1].transform.mProps._mdf = !1,
                    e[e.length - 1].transform.op._mdf = !1,
                    n -= 1,
                    i += s;
            return a
        }
        ,
        RepeaterModifier.prototype.addShape = function() {}
        ;
        function RoundCornersModifier() {}
        extendPrototype([ShapeModifier], RoundCornersModifier),
        RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys,
            this.rd = PropertyFactory.getProp(t, e.r, 0, null, this),
            this._isAnimated = !!this.rd.effectsSequence.length
        }
        ,
        RoundCornersModifier.prototype.processPath = function(t, e) {
            var r = shapePool.newElement();
            r.c = t.c;
            var i, s = t._length, n, a, l, o, h, p, S = 0, c, g, v, d, b, u;
            for (i = 0; i < s; i += 1)
                n = t.v[i],
                l = t.o[i],
                a = t.i[i],
                n[0] === l[0] && n[1] === l[1] && n[0] === a[0] && n[1] === a[1] ? (i === 0 || i === s - 1) && !t.c ? (r.setTripleAt(n[0], n[1], l[0], l[1], a[0], a[1], S),
                S += 1) : (i === 0 ? o = t.v[s - 1] : o = t.v[i - 1],
                h = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2)),
                p = h ? Math.min(h / 2, e) / h : 0,
                b = n[0] + (o[0] - n[0]) * p,
                c = b,
                u = n[1] - (n[1] - o[1]) * p,
                g = u,
                v = c - (c - n[0]) * roundCorner,
                d = g - (g - n[1]) * roundCorner,
                r.setTripleAt(c, g, v, d, b, u, S),
                S += 1,
                i === s - 1 ? o = t.v[0] : o = t.v[i + 1],
                h = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2)),
                p = h ? Math.min(h / 2, e) / h : 0,
                v = n[0] + (o[0] - n[0]) * p,
                c = v,
                d = n[1] + (o[1] - n[1]) * p,
                g = d,
                b = c - (c - n[0]) * roundCorner,
                u = g - (g - n[1]) * roundCorner,
                r.setTripleAt(c, g, v, d, b, u, S),
                S += 1) : (r.setTripleAt(t.v[i][0], t.v[i][1], t.o[i][0], t.o[i][1], t.i[i][0], t.i[i][1], S),
                S += 1);
            return r
        }
        ,
        RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r, i = this.shapes.length, s, n, a = this.rd.v;
            if (a !== 0) {
                var l, o;
                for (r = 0; r < i; r += 1) {
                    if (l = this.shapes[r],
                    o = l.localShapeCollection,
                    !(!l.shape._mdf && !this._mdf && !t))
                        for (o.releaseShapes(),
                        l.shape._mdf = !0,
                        e = l.shape.paths.shapes,
                        n = l.shape.paths._length,
                        s = 0; s < n; s += 1)
                            o.addShape(this.processPath(e[s], a));
                    l.shape.paths = l.localShapeCollection
                }
            }
            this.dynamicProperties.length || (this._mdf = !1)
        }
        ;
        function floatEqual(t, e) {
            return Math.abs(t - e) * 1e5 <= Math.min(Math.abs(t), Math.abs(e))
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5
        }
        function lerp(t, e, r) {
            return t * (1 - r) + e * r
        }
        function lerpPoint(t, e, r) {
            return [lerp(t[0], e[0], r), lerp(t[1], e[1], r)]
        }
        function quadRoots(t, e, r) {
            if (t === 0)
                return [];
            var i = e * e - 4 * t * r;
            if (i < 0)
                return [];
            var s = -e / (2 * t);
            if (i === 0)
                return [s];
            var n = Math.sqrt(i) / (2 * t);
            return [s - n, s + n]
        }
        function polynomialCoefficients(t, e, r, i) {
            return [-t + 3 * e - 3 * r + i, 3 * t - 6 * e + 3 * r, -3 * t + 3 * e, t]
        }
        function singlePoint(t) {
            return new PolynomialBezier(t,t,t,t,!1)
        }
        function PolynomialBezier(t, e, r, i, s) {
            s && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)),
            s && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
            var n = polynomialCoefficients(t[0], e[0], r[0], i[0])
              , a = polynomialCoefficients(t[1], e[1], r[1], i[1]);
            this.a = [n[0], a[0]],
            this.b = [n[1], a[1]],
            this.c = [n[2], a[2]],
            this.d = [n[3], a[3]],
            this.points = [t, e, r, i]
        }
        PolynomialBezier.prototype.point = function(t) {
            return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]]
        }
        ,
        PolynomialBezier.prototype.derivative = function(t) {
            return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]]
        }
        ,
        PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0])
        }
        ,
        PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1])
        }
        ,
        PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t))
                return [];
            var e = -.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t
              , r = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r < 0)
                return [];
            var i = Math.sqrt(r);
            return floatZero(i) ? i > 0 && i < 1 ? [e] : [] : [e - i, e + i].filter(function(s) {
                return s > 0 && s < 1
            })
        }
        ,
        PolynomialBezier.prototype.split = function(t) {
            if (t <= 0)
                return [singlePoint(this.points[0]), this];
            if (t >= 1)
                return [this, singlePoint(this.points[this.points.length - 1])];
            var e = lerpPoint(this.points[0], this.points[1], t)
              , r = lerpPoint(this.points[1], this.points[2], t)
              , i = lerpPoint(this.points[2], this.points[3], t)
              , s = lerpPoint(e, r, t)
              , n = lerpPoint(r, i, t)
              , a = lerpPoint(s, n, t);
            return [new PolynomialBezier(this.points[0],e,s,a,!0), new PolynomialBezier(a,n,i,this.points[3],!0)]
        }
        ;
        function extrema(t, e) {
            var r = t.points[0][e]
              , i = t.points[t.points.length - 1][e];
            if (r > i) {
                var s = i;
                i = r,
                r = s
            }
            for (var n = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), a = 0; a < n.length; a += 1)
                if (n[a] > 0 && n[a] < 1) {
                    var l = t.point(n[a])[e];
                    l < r ? r = l : l > i && (i = l)
                }
            return {
                min: r,
                max: i
            }
        }
        PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            }
        }
        ,
        PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            }
        }
        ;
        function intersectData(t, e, r) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r) / 2,
                t1: e,
                t2: r
            }
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [intersectData(e[0], t.t1, t.t), intersectData(e[1], t.t, t.t2)]
        }
        function boxIntersect(t, e) {
            return Math.abs(t.cx - e.cx) * 2 < t.width + e.width && Math.abs(t.cy - e.cy) * 2 < t.height + e.height
        }
        function intersectsImpl(t, e, r, i, s, n) {
            if (boxIntersect(t, e)) {
                if (r >= n || t.width <= i && t.height <= i && e.width <= i && e.height <= i) {
                    s.push([t.t, e.t]);
                    return
                }
                var a = splitData(t)
                  , l = splitData(e);
                intersectsImpl(a[0], l[0], r + 1, i, s, n),
                intersectsImpl(a[0], l[1], r + 1, i, s, n),
                intersectsImpl(a[1], l[0], r + 1, i, s, n),
                intersectsImpl(a[1], l[1], r + 1, i, s, n)
            }
        }
        PolynomialBezier.prototype.intersections = function(t, e, r) {
            e === void 0 && (e = 2),
            r === void 0 && (r = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r),
            i
        }
        ,
        PolynomialBezier.shapeSegment = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e],t.o[e],t.i[r],t.v[r],!0)
        }
        ,
        PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r],t.i[r],t.o[e],t.v[e],!0)
        }
        ;
        function crossProduct(t, e) {
            return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]]
        }
        function lineIntersection(t, e, r, i) {
            var s = [t[0], t[1], 1]
              , n = [e[0], e[1], 1]
              , a = [r[0], r[1], 1]
              , l = [i[0], i[1], 1]
              , o = crossProduct(crossProduct(s, n), crossProduct(a, l));
            return floatZero(o[2]) ? null : [o[0] / o[2], o[1] / o[2]]
        }
        function polarOffset(t, e, r) {
            return [t[0] + Math.cos(e) * r, t[1] - Math.sin(e) * r]
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1])
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1])
        }
        function ZigZagModifier() {}
        extendPrototype([ShapeModifier], ZigZagModifier),
        ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys,
            this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this),
            this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this),
            this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this),
            this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0
        }
        ;
        function setPoint(t, e, r, i, s, n, a) {
            var l = r - Math.PI / 2
              , o = r + Math.PI / 2
              , h = e[0] + Math.cos(r) * i * s
              , p = e[1] - Math.sin(r) * i * s;
            t.setTripleAt(h, p, h + Math.cos(l) * n, p - Math.sin(l) * n, h + Math.cos(o) * a, p - Math.sin(o) * a, t.length())
        }
        function getPerpendicularVector(t, e) {
            var r = [e[0] - t[0], e[1] - t[1]]
              , i = -Math.PI * .5
              , s = [Math.cos(i) * r[0] - Math.sin(i) * r[1], Math.sin(i) * r[0] + Math.cos(i) * r[1]];
            return s
        }
        function getProjectingAngle(t, e) {
            var r = e === 0 ? t.length() - 1 : e - 1
              , i = (e + 1) % t.length()
              , s = t.v[r]
              , n = t.v[i]
              , a = getPerpendicularVector(s, n);
            return Math.atan2(0, 1) - Math.atan2(a[1], a[0])
        }
        function zigZagCorner(t, e, r, i, s, n, a) {
            var l = getProjectingAngle(e, r)
              , o = e.v[r % e._length]
              , h = e.v[r === 0 ? e._length - 1 : r - 1]
              , p = e.v[(r + 1) % e._length]
              , S = n === 2 ? Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)) : 0
              , c = n === 2 ? Math.sqrt(Math.pow(o[0] - p[0], 2) + Math.pow(o[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r % e._length], l, a, i, c / ((s + 1) * 2), S / ((s + 1) * 2))
        }
        function zigZagSegment(t, e, r, i, s, n) {
            for (var a = 0; a < i; a += 1) {
                var l = (a + 1) / (i + 1)
                  , o = s === 2 ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0
                  , h = e.normalAngle(l)
                  , p = e.point(l);
                setPoint(t, p, h, n, r, o / ((i + 1) * 2), o / ((i + 1) * 2)),
                n = -n
            }
            return n
        }
        ZigZagModifier.prototype.processPath = function(t, e, r, i) {
            var s = t._length
              , n = shapePool.newElement();
            if (n.c = t.c,
            t.c || (s -= 1),
            s === 0)
                return n;
            var a = -1
              , l = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(n, t, 0, e, r, i, a);
            for (var o = 0; o < s; o += 1)
                a = zigZagSegment(n, l, e, r, i, -a),
                o === s - 1 && !t.c ? l = null : l = PolynomialBezier.shapeSegment(t, (o + 1) % s),
                zigZagCorner(n, t, o + 1, e, r, i, a);
            return n
        }
        ,
        ZigZagModifier.prototype.processShapes = function(t) {
            var e, r, i = this.shapes.length, s, n, a = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), o = this.pointsType.v;
            if (a !== 0) {
                var h, p;
                for (r = 0; r < i; r += 1) {
                    if (h = this.shapes[r],
                    p = h.localShapeCollection,
                    !(!h.shape._mdf && !this._mdf && !t))
                        for (p.releaseShapes(),
                        h.shape._mdf = !0,
                        e = h.shape.paths.shapes,
                        n = h.shape.paths._length,
                        s = 0; s < n; s += 1)
                            p.addShape(this.processPath(e[s], a, l, o));
                    h.shape.paths = h.localShapeCollection
                }
            }
            this.dynamicProperties.length || (this._mdf = !1)
        }
        ;
        function linearOffset(t, e, r) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [polarOffset(t, i, r), polarOffset(e, i, r)]
        }
        function offsetSegment(t, e) {
            var r, i, s, n, a, l, o;
            o = linearOffset(t.points[0], t.points[1], e),
            r = o[0],
            i = o[1],
            o = linearOffset(t.points[1], t.points[2], e),
            s = o[0],
            n = o[1],
            o = linearOffset(t.points[2], t.points[3], e),
            a = o[0],
            l = o[1];
            var h = lineIntersection(r, i, s, n);
            h === null && (h = i);
            var p = lineIntersection(a, l, s, n);
            return p === null && (p = a),
            new PolynomialBezier(r,h,p,l)
        }
        function joinLines(t, e, r, i, s) {
            var n = e.points[3]
              , a = r.points[0];
            if (i === 3 || pointEqual(n, a))
                return n;
            if (i === 2) {
                var l = -e.tangentAngle(1)
                  , o = -r.tangentAngle(0) + Math.PI
                  , h = lineIntersection(n, polarOffset(n, l + Math.PI / 2, 100), a, polarOffset(a, l + Math.PI / 2, 100))
                  , p = h ? pointDistance(h, n) : pointDistance(n, a) / 2
                  , S = polarOffset(n, l, 2 * p * roundCorner);
                return t.setXYAt(S[0], S[1], "o", t.length() - 1),
                S = polarOffset(a, o, 2 * p * roundCorner),
                t.setTripleAt(a[0], a[1], a[0], a[1], S[0], S[1], t.length()),
                a
            }
            var c = pointEqual(n, e.points[2]) ? e.points[0] : e.points[2]
              , g = pointEqual(a, r.points[1]) ? r.points[3] : r.points[1]
              , v = lineIntersection(c, n, a, g);
            return v && pointDistance(v, n) < s ? (t.setTripleAt(v[0], v[1], v[0], v[1], v[0], v[1], t.length()),
            v) : n
        }
        function getIntersection(t, e) {
            var r = t.intersections(e);
            return r.length && floatEqual(r[0][0], 1) && r.shift(),
            r.length ? r[0] : null
        }
        function pruneSegmentIntersection(t, e) {
            var r = t.slice()
              , i = e.slice()
              , s = getIntersection(t[t.length - 1], e[0]);
            return s && (r[t.length - 1] = t[t.length - 1].split(s[0])[0],
            i[0] = e[0].split(s[1])[1]),
            t.length > 1 && e.length > 1 && (s = getIntersection(t[0], e[e.length - 1]),
            s) ? [[t[0].split(s[0])[0]], [e[e.length - 1].split(s[1])[1]]] : [r, i]
        }
        function pruneIntersections(t) {
            for (var e, r = 1; r < t.length; r += 1)
                e = pruneSegmentIntersection(t[r - 1], t[r]),
                t[r - 1] = e[0],
                t[r] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]),
            t[t.length - 1] = e[0],
            t[0] = e[1]),
            t
        }
        function offsetSegmentSplit(t, e) {
            var r = t.inflectionPoints(), i, s, n, a;
            if (r.length === 0)
                return [offsetSegment(t, e)];
            if (r.length === 1 || floatEqual(r[1], 1))
                return n = t.split(r[0]),
                i = n[0],
                s = n[1],
                [offsetSegment(i, e), offsetSegment(s, e)];
            n = t.split(r[0]),
            i = n[0];
            var l = (r[1] - r[0]) / (1 - r[0]);
            return n = n[1].split(l),
            a = n[0],
            s = n[1],
            [offsetSegment(i, e), offsetSegment(a, e), offsetSegment(s, e)]
        }
        function OffsetPathModifier() {}
        extendPrototype([ShapeModifier], OffsetPathModifier),
        OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys,
            this.amount = PropertyFactory.getProp(t, e.a, 0, null, this),
            this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this),
            this.lineJoin = e.lj,
            this._isAnimated = this.amount.effectsSequence.length !== 0
        }
        ,
        OffsetPathModifier.prototype.processPath = function(t, e, r, i) {
            var s = shapePool.newElement();
            s.c = t.c;
            var n = t.length();
            t.c || (n -= 1);
            var a, l, o, h = [];
            for (a = 0; a < n; a += 1)
                o = PolynomialBezier.shapeSegment(t, a),
                h.push(offsetSegmentSplit(o, e));
            if (!t.c)
                for (a = n - 1; a >= 0; a -= 1)
                    o = PolynomialBezier.shapeSegmentInverted(t, a),
                    h.push(offsetSegmentSplit(o, e));
            h = pruneIntersections(h);
            var p = null
              , S = null;
            for (a = 0; a < h.length; a += 1) {
                var c = h[a];
                for (S && (p = joinLines(s, S, c[0], r, i)),
                S = c[c.length - 1],
                l = 0; l < c.length; l += 1)
                    o = c[l],
                    p && pointEqual(o.points[0], p) ? s.setXYAt(o.points[1][0], o.points[1][1], "o", s.length() - 1) : s.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], s.length()),
                    s.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], s.length()),
                    p = o.points[3]
            }
            return h.length && joinLines(s, S, h[0][0], r, i),
            s
        }
        ,
        OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r, i = this.shapes.length, s, n, a = this.amount.v, l = this.miterLimit.v, o = this.lineJoin;
            if (a !== 0) {
                var h, p;
                for (r = 0; r < i; r += 1) {
                    if (h = this.shapes[r],
                    p = h.localShapeCollection,
                    !(!h.shape._mdf && !this._mdf && !t))
                        for (p.releaseShapes(),
                        h.shape._mdf = !0,
                        e = h.shape.paths.shapes,
                        n = h.shape.paths._length,
                        s = 0; s < n; s += 1)
                            p.addShape(this.processPath(e[s], a, o, l));
                    h.shape.paths = h.localShapeCollection
                }
            }
            this.dynamicProperties.length || (this._mdf = !1)
        }
        ;
        function getFontProperties(t) {
            for (var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", s = e.length, n, a = 0; a < s; a += 1)
                switch (n = e[a].toLowerCase(),
                n) {
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r = "700";
                    break;
                case "black":
                    r = "900";
                    break;
                case "medium":
                    r = "500";
                    break;
                case "regular":
                case "normal":
                    r = "400";
                    break;
                case "light":
                case "thin":
                    r = "200";
                    break
                }
            return {
                style: i,
                weight: t.fWeight || r
            }
        }
        var FontManager = function() {
            var t = 5e3
              , e = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }
              , r = [];
            r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
            var i = 127988
              , s = 917631
              , n = 917601
              , a = 917626
              , l = 65039
              , o = 8205
              , h = 127462
              , p = 127487
              , S = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
            function c(P) {
                var M = P.split(","), E, A = M.length, F = [];
                for (E = 0; E < A; E += 1)
                    M[E] !== "sans-serif" && M[E] !== "monospace" && F.push(M[E]);
                return F.join(",")
            }
            function g(P, M) {
                var E = createTag("span");
                E.setAttribute("aria-hidden", !0),
                E.style.fontFamily = M;
                var A = createTag("span");
                A.innerText = "giItT1WQy@!-/#",
                E.style.position = "absolute",
                E.style.left = "-10000px",
                E.style.top = "-10000px",
                E.style.fontSize = "300px",
                E.style.fontVariant = "normal",
                E.style.fontStyle = "normal",
                E.style.fontWeight = "normal",
                E.style.letterSpacing = "0",
                E.appendChild(A),
                document.body.appendChild(E);
                var F = A.offsetWidth;
                return A.style.fontFamily = c(P) + ", " + M,
                {
                    node: A,
                    w: F,
                    parent: E
                }
            }
            function v() {
                var P, M = this.fonts.length, E, A, F = M;
                for (P = 0; P < M; P += 1)
                    this.fonts[P].loaded ? F -= 1 : this.fonts[P].fOrigin === "n" || this.fonts[P].origin === 0 ? this.fonts[P].loaded = !0 : (E = this.fonts[P].monoCase.node,
                    A = this.fonts[P].monoCase.w,
                    E.offsetWidth !== A ? (F -= 1,
                    this.fonts[P].loaded = !0) : (E = this.fonts[P].sansCase.node,
                    A = this.fonts[P].sansCase.w,
                    E.offsetWidth !== A && (F -= 1,
                    this.fonts[P].loaded = !0)),
                    this.fonts[P].loaded && (this.fonts[P].sansCase.parent.parentNode.removeChild(this.fonts[P].sansCase.parent),
                    this.fonts[P].monoCase.parent.parentNode.removeChild(this.fonts[P].monoCase.parent)));
                F !== 0 && Date.now() - this.initTime < t ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10)
            }
            function d(P, M) {
                var E = document.body && M ? "svg" : "canvas", A, F = getFontProperties(P);
                if (E === "svg") {
                    var I = createNS("text");
                    I.style.fontSize = "100px",
                    I.setAttribute("font-family", P.fFamily),
                    I.setAttribute("font-style", F.style),
                    I.setAttribute("font-weight", F.weight),
                    I.textContent = "1",
                    P.fClass ? (I.style.fontFamily = "inherit",
                    I.setAttribute("class", P.fClass)) : I.style.fontFamily = P.fFamily,
                    M.appendChild(I),
                    A = I
                } else {
                    var N = new OffscreenCanvas(500,500).getContext("2d");
                    N.font = F.style + " " + F.weight + " 100px " + P.fFamily,
                    A = N
                }
                function $(H) {
                    return E === "svg" ? (A.textContent = H,
                    A.getComputedTextLength()) : A.measureText(H).width
                }
                return {
                    measureText: $
                }
            }
            function b(P, M) {
                if (!P) {
                    this.isLoaded = !0;
                    return
                }
                if (this.chars) {
                    this.isLoaded = !0,
                    this.fonts = P.list;
                    return
                }
                if (!document.body) {
                    this.isLoaded = !0,
                    P.list.forEach(function(X) {
                        X.helper = d(X),
                        X.cache = {}
                    }),
                    this.fonts = P.list;
                    return
                }
                var E = P.list, A, F = E.length, I = F;
                for (A = 0; A < F; A += 1) {
                    var N = !0, $, H;
                    if (E[A].loaded = !1,
                    E[A].monoCase = g(E[A].fFamily, "monospace"),
                    E[A].sansCase = g(E[A].fFamily, "sans-serif"),
                    !E[A].fPath)
                        E[A].loaded = !0,
                        I -= 1;
                    else if (E[A].fOrigin === "p" || E[A].origin === 3) {
                        if ($ = document.querySelectorAll('style[f-forigin="p"][f-family="' + E[A].fFamily + '"], style[f-origin="3"][f-family="' + E[A].fFamily + '"]'),
                        $.length > 0 && (N = !1),
                        N) {
                            var W = createTag("style");
                            W.setAttribute("f-forigin", E[A].fOrigin),
                            W.setAttribute("f-origin", E[A].origin),
                            W.setAttribute("f-family", E[A].fFamily),
                            W.type = "text/css",
                            W.innerText = "@font-face {font-family: " + E[A].fFamily + "; font-style: normal; src: url('" + E[A].fPath + "');}",
                            M.appendChild(W)
                        }
                    } else if (E[A].fOrigin === "g" || E[A].origin === 1) {
                        for ($ = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'),
                        H = 0; H < $.length; H += 1)
                            $[H].href.indexOf(E[A].fPath) !== -1 && (N = !1);
                        if (N) {
                            var B = createTag("link");
                            B.setAttribute("f-forigin", E[A].fOrigin),
                            B.setAttribute("f-origin", E[A].origin),
                            B.type = "text/css",
                            B.rel = "stylesheet",
                            B.href = E[A].fPath,
                            document.body.appendChild(B)
                        }
                    } else if (E[A].fOrigin === "t" || E[A].origin === 2) {
                        for ($ = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'),
                        H = 0; H < $.length; H += 1)
                            E[A].fPath === $[H].src && (N = !1);
                        if (N) {
                            var q = createTag("link");
                            q.setAttribute("f-forigin", E[A].fOrigin),
                            q.setAttribute("f-origin", E[A].origin),
                            q.setAttribute("rel", "stylesheet"),
                            q.setAttribute("href", E[A].fPath),
                            M.appendChild(q)
                        }
                    }
                    E[A].helper = d(E[A], M),
                    E[A].cache = {},
                    this.fonts.push(E[A])
                }
                I === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100)
            }
            function u(P) {
                if (P) {
                    this.chars || (this.chars = []);
                    var M, E = P.length, A, F = this.chars.length, I;
                    for (M = 0; M < E; M += 1) {
                        for (A = 0,
                        I = !1; A < F; )
                            this.chars[A].style === P[M].style && this.chars[A].fFamily === P[M].fFamily && this.chars[A].ch === P[M].ch && (I = !0),
                            A += 1;
                        I || (this.chars.push(P[M]),
                        F += 1)
                    }
                }
            }
            function m(P, M, E) {
                for (var A = 0, F = this.chars.length; A < F; ) {
                    if (this.chars[A].ch === P && this.chars[A].style === M && this.chars[A].fFamily === E)
                        return this.chars[A];
                    A += 1
                }
                return (typeof P == "string" && P.charCodeAt(0) !== 13 || !P) && console && console.warn && !this._warned && (this._warned = !0,
                console.warn("Missing character from exported characters list: ", P, M, E)),
                e
            }
            function f(P, M, E) {
                var A = this.getFontByName(M)
                  , F = P;
                if (!A.cache[F]) {
                    var I = A.helper;
                    if (P === " ") {
                        var N = I.measureText("|" + P + "|")
                          , $ = I.measureText("||");
                        A.cache[F] = (N - $) / 100
                    } else
                        A.cache[F] = I.measureText(P) / 100
                }
                return A.cache[F] * E
            }
            function y(P) {
                for (var M = 0, E = this.fonts.length; M < E; ) {
                    if (this.fonts[M].fName === P)
                        return this.fonts[M];
                    M += 1
                }
                return this.fonts[0]
            }
            function _(P) {
                var M = 0
                  , E = P.charCodeAt(0);
                if (E >= 55296 && E <= 56319) {
                    var A = P.charCodeAt(1);
                    A >= 56320 && A <= 57343 && (M = (E - 55296) * 1024 + A - 56320 + 65536)
                }
                return M
            }
            function T(P, M) {
                var E = P.toString(16) + M.toString(16);
                return S.indexOf(E) !== -1
            }
            function C(P) {
                return P === o
            }
            function x(P) {
                return P === l
            }
            function w(P) {
                var M = _(P);
                return M >= h && M <= p
            }
            function D(P) {
                return w(P.substr(0, 2)) && w(P.substr(2, 2))
            }
            function k(P) {
                return r.indexOf(P) !== -1
            }
            function L(P, M) {
                var E = _(P.substr(M, 2));
                if (E !== i)
                    return !1;
                var A = 0;
                for (M += 2; A < 5; ) {
                    if (E = _(P.substr(M, 2)),
                    E < n || E > a)
                        return !1;
                    A += 1,
                    M += 2
                }
                return _(P.substr(M, 2)) === s
            }
            function V() {
                this.isLoaded = !0
            }
            var O = function() {
                this.fonts = [],
                this.chars = null,
                this.typekitLoaded = 0,
                this.isLoaded = !1,
                this._warned = !1,
                this.initTime = Date.now(),
                this.setIsLoadedBinded = this.setIsLoaded.bind(this),
                this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this)
            };
            O.isModifier = T,
            O.isZeroWidthJoiner = C,
            O.isFlagEmoji = D,
            O.isRegionalCode = w,
            O.isCombinedCharacter = k,
            O.isRegionalFlag = L,
            O.isVariationSelector = x,
            O.BLACK_FLAG_CODE_POINT = i;
            var R = {
                addChars: u,
                addFonts: b,
                getCharData: m,
                getFontByName: y,
                measureText: f,
                checkLoadedFonts: v,
                setIsLoaded: V
            };
            return O.prototype = R,
            O
        }();
        function SlotManager(t) {
            this.animationData = t
        }
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t
        }
        ;
        function slotFactory(t) {
            return new SlotManager(t)
        }
        function RenderableElement() {}
        RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1,
                this.hidden = !1,
                this.isTransparent = !1,
                this.renderableComponents = []
            },
            addRenderableComponent: function(e) {
                this.renderableComponents.indexOf(e) === -1 && this.renderableComponents.push(e)
            },
            removeRenderableComponent: function(e) {
                this.renderableComponents.indexOf(e) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(e), 1)
            },
            prepareRenderableFrame: function(e) {
                this.checkLayerLimits(e)
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0,
                this.hide()) : this.isTransparent && (this.isTransparent = !1,
                this.show())
            },
            checkLayerLimits: function(e) {
                this.data.ip - this.data.st <= e && this.data.op - this.data.st > e ? this.isInRange !== !0 && (this.globalData._mdf = !0,
                this._mdf = !0,
                this.isInRange = !0,
                this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0,
                this.isInRange = !1,
                this.hide())
            },
            renderRenderable: function() {
                var e, r = this.renderableComponents.length;
                for (e = 0; e < r; e += 1)
                    this.renderableComponents[e].renderFrame(this._isFirstFrame)
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                }
            },
            getLayerSize: function() {
                return this.data.ty === 5 ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                }
            }
        };
        var getBlendMode = function() {
            var t = {
                0: "source-over",
                1: "multiply",
                2: "screen",
                3: "overlay",
                4: "darken",
                5: "lighten",
                6: "color-dodge",
                7: "color-burn",
                8: "hard-light",
                9: "soft-light",
                10: "difference",
                11: "exclusion",
                12: "hue",
                13: "saturation",
                14: "color",
                15: "luminosity"
            };
            return function(e) {
                return t[e] || ""
            }
        }();
        function SliderEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r)
        }
        function AngleEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r)
        }
        function ColorEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r)
        }
        function PointEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r)
        }
        function LayerIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r)
        }
        function MaskIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r)
        }
        function CheckboxEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r)
        }
        function NoValueEffect() {
            this.p = {}
        }
        function EffectsManager(t, e) {
            var r = t.ef || [];
            this.effectElements = [];
            var i, s = r.length, n;
            for (i = 0; i < s; i += 1)
                n = new GroupEffect(r[i],e),
                this.effectElements.push(n)
        }
        function GroupEffect(t, e) {
            this.init(t, e)
        }
        extendPrototype([DynamicPropertyContainer], GroupEffect),
        GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties,
        GroupEffect.prototype.init = function(t, e) {
            this.data = t,
            this.effectElements = [],
            this.initDynamicPropertyContainer(e);
            var r, i = this.data.ef.length, s, n = this.data.ef;
            for (r = 0; r < i; r += 1) {
                switch (s = null,
                n[r].ty) {
                case 0:
                    s = new SliderEffect(n[r],e,this);
                    break;
                case 1:
                    s = new AngleEffect(n[r],e,this);
                    break;
                case 2:
                    s = new ColorEffect(n[r],e,this);
                    break;
                case 3:
                    s = new PointEffect(n[r],e,this);
                    break;
                case 4:
                case 7:
                    s = new CheckboxEffect(n[r],e,this);
                    break;
                case 10:
                    s = new LayerIndexEffect(n[r],e,this);
                    break;
                case 11:
                    s = new MaskIndexEffect(n[r],e,this);
                    break;
                case 5:
                    s = new EffectsManager(n[r],e);
                    break;
                default:
                    s = new NoValueEffect(n[r]);
                    break
                }
                s && this.effectElements.push(s)
            }
        }
        ;
        function BaseElement() {}
        BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask)
                    return !1;
                for (var e = 0, r = this.data.masksProperties.length; e < r; ) {
                    if (this.data.masksProperties[e].mode !== "n" && this.data.masksProperties[e].cl !== !1)
                        return !0;
                    e += 1
                }
                return !1
            },
            initExpressions: function() {
                var e = getExpressionInterfaces();
                if (e) {
                    var r = e("layer")
                      , i = e("effects")
                      , s = e("shape")
                      , n = e("text")
                      , a = e("comp");
                    this.layerInterface = r(this),
                    this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var l = i.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(l),
                    this.data.ty === 0 || this.data.xt ? this.compInterface = a(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = s(this.shapesData, this.itemsData, this.layerInterface),
                    this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = n(this),
                    this.layerInterface.text = this.layerInterface.textInterface)
                }
            },
            setBlendMode: function() {
                var e = getBlendMode(this.data.bm)
                  , r = this.baseElement || this.layerElement;
                r.style["mix-blend-mode"] = e
            },
            initBaseData: function(e, r, i) {
                this.globalData = r,
                this.comp = i,
                this.data = e,
                this.layerId = createElementID(),
                this.data.sr || (this.data.sr = 1),
                this.effectsManager = new EffectsManager(this.data,this,this.dynamicProperties)
            },
            getType: function() {
                return this.type
            },
            sourceRectAtTime: function() {}
        };
        function FrameElement() {}
        FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1,
                this.dynamicProperties = [],
                this._mdf = !1
            },
            prepareProperties: function(e, r) {
                var i, s = this.dynamicProperties.length;
                for (i = 0; i < s; i += 1)
                    (r || this._isParent && this.dynamicProperties[i].propType === "transform") && (this.dynamicProperties[i].getValue(),
                    this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0,
                    this._mdf = !0))
            },
            addDynamicProperty: function(e) {
                this.dynamicProperties.indexOf(e) === -1 && this.dynamicProperties.push(e)
            }
        };
        function FootageElement(t, e, r) {
            this.initFrame(),
            this.initRenderable(),
            this.assetData = e.getAssetData(t.refId),
            this.footageData = e.imageLoader.getAsset(this.assetData),
            this.initBaseData(t, e, r)
        }
        FootageElement.prototype.prepareFrame = function() {}
        ,
        extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement),
        FootageElement.prototype.getBaseElement = function() {
            return null
        }
        ,
        FootageElement.prototype.renderFrame = function() {}
        ,
        FootageElement.prototype.destroy = function() {}
        ,
        FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this)
            }
        }
        ,
        FootageElement.prototype.getFootageData = function() {
            return this.footageData
        }
        ;
        function AudioElement(t, e, r) {
            this.initFrame(),
            this.initRenderable(),
            this.assetData = e.getAssetData(t.refId),
            this.initBaseData(t, e, r),
            this._isPlaying = !1,
            this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i),
            this._currentTime = 0,
            this.globalData.audioController.addAudio(this),
            this._volumeMultiplier = 1,
            this._volume = 1,
            this._previousVolume = null,
            this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            },
            this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [100]
            }, 1, .01, this)
        }
        AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0),
            this.prepareProperties(t, !0),
            this.tm._placeholder)
                this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r && (this._previousVolume = r,
            this.audio.volume(r))
        }
        ,
        extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement),
        AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(),
            this.audio.seek(this._currentTime / this.globalData.frameRate),
            this._isPlaying = !0))
        }
        ,
        AudioElement.prototype.show = function() {}
        ,
        AudioElement.prototype.hide = function() {
            this.audio.pause(),
            this._isPlaying = !1
        }
        ,
        AudioElement.prototype.pause = function() {
            this.audio.pause(),
            this._isPlaying = !1,
            this._canPlay = !1
        }
        ,
        AudioElement.prototype.resume = function() {
            this._canPlay = !0
        }
        ,
        AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t)
        }
        ,
        AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t,
            this._previousVolume = t * this._volume,
            this.audio.volume(this._previousVolume)
        }
        ,
        AudioElement.prototype.getBaseElement = function() {
            return null
        }
        ,
        AudioElement.prototype.destroy = function() {}
        ,
        AudioElement.prototype.sourceRectAtTime = function() {}
        ,
        AudioElement.prototype.initExpressions = function() {}
        ;
        function BaseRenderer() {}
        BaseRenderer.prototype.checkLayers = function(t) {
            var e, r = this.layers.length, i;
            for (this.completeLayers = !0,
            e = r - 1; e >= 0; e -= 1)
                this.elements[e] || (i = this.layers[e],
                i.ip - i.st <= t - this.layers[e].st && i.op - i.st > t - this.layers[e].st && this.buildItem(e)),
                this.completeLayers = this.elements[e] ? this.completeLayers : !1;
            this.checkPendingElements()
        }
        ,
        BaseRenderer.prototype.createItem = function(t) {
            switch (t.ty) {
            case 2:
                return this.createImage(t);
            case 0:
                return this.createComp(t);
            case 1:
                return this.createSolid(t);
            case 3:
                return this.createNull(t);
            case 4:
                return this.createShape(t);
            case 5:
                return this.createText(t);
            case 6:
                return this.createAudio(t);
            case 13:
                return this.createCamera(t);
            case 15:
                return this.createFootage(t);
            default:
                return this.createNull(t)
            }
        }
        ,
        BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.")
        }
        ,
        BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t,this.globalData,this)
        }
        ,
        BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t,this.globalData,this)
        }
        ,
        BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for (t = 0; t < e; t += 1)
                this.buildItem(t);
            this.checkPendingElements()
        }
        ,
        BaseRenderer.prototype.includeLayers = function(t) {
            this.completeLayers = !1;
            var e, r = t.length, i, s = this.layers.length;
            for (e = 0; e < r; e += 1)
                for (i = 0; i < s; ) {
                    if (this.layers[i].id === t[e].id) {
                        this.layers[i] = t[e];
                        break
                    }
                    i += 1
                }
        }
        ,
        BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t
        }
        ,
        BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems()
        }
        ,
        BaseRenderer.prototype.buildElementParenting = function(t, e, r) {
            for (var i = this.elements, s = this.layers, n = 0, a = s.length; n < a; )
                s[n].ind == e && (!i[n] || i[n] === !0 ? (this.buildItem(n),
                this.addPendingElement(t)) : (r.push(i[n]),
                i[n].setAsParent(),
                s[n].parent !== void 0 ? this.buildElementParenting(t, s[n].parent, r) : t.setHierarchy(r))),
                n += 1
        }
        ,
        BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t)
        }
        ,
        BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length;
            for (e = 0; e < r; e += 1)
                if (t[e].xt) {
                    var i = this.createComp(t[e]);
                    i.initExpressions(),
                    this.globalData.projectInterface.registerComposition(i)
                }
        }
        ,
        BaseRenderer.prototype.getElementById = function(t) {
            var e, r = this.elements.length;
            for (e = 0; e < r; e += 1)
                if (this.elements[e].data.ind === t)
                    return this.elements[e];
            return null
        }
        ,
        BaseRenderer.prototype.getElementByPath = function(t) {
            var e = t.shift(), r;
            if (typeof e == "number")
                r = this.elements[e];
            else {
                var i, s = this.elements.length;
                for (i = 0; i < s; i += 1)
                    if (this.elements[i].data.nm === e) {
                        r = this.elements[i];
                        break
                    }
            }
            return t.length === 0 ? r : r.getElementByPath(t)
        }
        ,
        BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager,
            this.globalData.slotManager = slotFactory(t),
            this.globalData.fontManager.addChars(t.chars),
            this.globalData.fontManager.addFonts(t.fonts, e),
            this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem),
            this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem),
            this.globalData.imageLoader = this.animationItem.imagePreloader,
            this.globalData.audioController = this.animationItem.audioController,
            this.globalData.frameId = 0,
            this.globalData.frameRate = t.fr,
            this.globalData.nm = t.nm,
            this.globalData.compSize = {
                w: t.w,
                h: t.h
            }
        }
        ;
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        TransformElement.prototype = {
            initTransform: function() {
                var e = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: e,
                    localMat: e,
                    localOpacity: 1
                },
                this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
                this.data.ty
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame,
                this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame,
                this.hierarchy) {
                    var e, r = this.finalTransform.mat, i = 0, s = this.hierarchy.length;
                    if (!this.finalTransform._matMdf)
                        for (; i < s; ) {
                            if (this.hierarchy[i].finalTransform.mProp._mdf) {
                                this.finalTransform._matMdf = !0;
                                break
                            }
                            i += 1
                        }
                    if (this.finalTransform._matMdf)
                        for (e = this.finalTransform.mProp.v.props,
                        r.cloneFromProps(e),
                        i = 0; i < s; i += 1)
                            r.multiply(this.hierarchy[i].finalTransform.mProp.v)
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf),
                this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v)
            },
            renderLocalTransform: function() {
                if (this.localTransforms) {
                    var e = 0
                      , r = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf,
                    !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
                        for (; e < r; )
                            this.localTransforms[e]._mdf && (this.finalTransform._localMatMdf = !0),
                            this.localTransforms[e]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v,
                            this.finalTransform._opMdf = !0),
                            e += 1;
                    if (this.finalTransform._localMatMdf) {
                        var i = this.finalTransform.localMat;
                        for (this.localTransforms[0].matrix.clone(i),
                        e = 1; e < r; e += 1) {
                            var s = this.localTransforms[e].matrix;
                            i.multiply(s)
                        }
                        i.multiply(this.finalTransform.mat)
                    }
                    if (this.finalTransform._opMdf) {
                        var n = this.finalTransform.localOpacity;
                        for (e = 0; e < r; e += 1)
                            n *= this.localTransforms[e].opacity * .01;
                        this.finalTransform.localOpacity = n
                    }
                }
            },
            searchEffectTransforms: function() {
                if (this.renderableEffectsManager) {
                    var e = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (e.length) {
                        this.localTransforms = [],
                        this.finalTransform.localMat = new Matrix;
                        var r = 0
                          , i = e.length;
                        for (r = 0; r < i; r += 1)
                            this.localTransforms.push(e[r])
                    }
                }
            },
            globalToLocal: function(e) {
                var r = [];
                r.push(this.finalTransform);
                for (var i = !0, s = this.comp; i; )
                    s.finalTransform ? (s.data.hasMask && r.splice(0, 0, s.finalTransform),
                    s = s.comp) : i = !1;
                var n, a = r.length, l;
                for (n = 0; n < a; n += 1)
                    l = r[n].mat.applyToPointArray(0, 0, 0),
                    e = [e[0] - l[0], e[1] - l[1], 0];
                return e
            },
            mHelper: new Matrix
        };
        function MaskElement(t, e, r) {
            this.data = t,
            this.element = e,
            this.globalData = r,
            this.storedData = [],
            this.masksProperties = this.data.masksProperties || [],
            this.maskElement = null;
            var i = this.globalData.defs, s, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n),
            this.solidPath = "";
            var a, l = this.masksProperties, o = 0, h = [], p, S, c = createElementID(), g, v, d, b, u = "clipPath", m = "clip-path";
            for (s = 0; s < n; s += 1)
                if ((l[s].mode !== "a" && l[s].mode !== "n" || l[s].inv || l[s].o.k !== 100 || l[s].o.x) && (u = "mask",
                m = "mask"),
                (l[s].mode === "s" || l[s].mode === "i") && o === 0 ? (g = createNS("rect"),
                g.setAttribute("fill", "#ffffff"),
                g.setAttribute("width", this.element.comp.data.w || 0),
                g.setAttribute("height", this.element.comp.data.h || 0),
                h.push(g)) : g = null,
                a = createNS("path"),
                l[s].mode === "n")
                    this.viewData[s] = {
                        op: PropertyFactory.getProp(this.element, l[s].o, 0, .01, this.element),
                        prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
                        elem: a,
                        lastPath: ""
                    },
                    i.appendChild(a);
                else {
                    o += 1,
                    a.setAttribute("fill", l[s].mode === "s" ? "#000000" : "#ffffff"),
                    a.setAttribute("clip-rule", "nonzero");
                    var f;
                    if (l[s].x.k !== 0 ? (u = "mask",
                    m = "mask",
                    b = PropertyFactory.getProp(this.element, l[s].x, 0, null, this.element),
                    f = createElementID(),
                    v = createNS("filter"),
                    v.setAttribute("id", f),
                    d = createNS("feMorphology"),
                    d.setAttribute("operator", "erode"),
                    d.setAttribute("in", "SourceGraphic"),
                    d.setAttribute("radius", "0"),
                    v.appendChild(d),
                    i.appendChild(v),
                    a.setAttribute("stroke", l[s].mode === "s" ? "#000000" : "#ffffff")) : (d = null,
                    b = null),
                    this.storedData[s] = {
                        elem: a,
                        x: b,
                        expan: d,
                        lastPath: "",
                        lastOperator: "",
                        filterId: f,
                        lastRadius: 0
                    },
                    l[s].mode === "i") {
                        S = h.length;
                        var y = createNS("g");
                        for (p = 0; p < S; p += 1)
                            y.appendChild(h[p]);
                        var _ = createNS("mask");
                        _.setAttribute("mask-type", "alpha"),
                        _.setAttribute("id", c + "_" + o),
                        _.appendChild(a),
                        i.appendChild(_),
                        y.setAttribute("mask", "url(" + getLocationHref() + "#" + c + "_" + o + ")"),
                        h.length = 0,
                        h.push(y)
                    } else
                        h.push(a);
                    l[s].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()),
                    this.viewData[s] = {
                        elem: a,
                        lastPath: "",
                        op: PropertyFactory.getProp(this.element, l[s].o, 0, .01, this.element),
                        prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
                        invRect: g
                    },
                    this.viewData[s].prop.k || this.drawPath(l[s], this.viewData[s].prop.v, this.viewData[s])
                }
            for (this.maskElement = createNS(u),
            n = h.length,
            s = 0; s < n; s += 1)
                this.maskElement.appendChild(h[s]);
            o > 0 && (this.maskElement.setAttribute("id", c),
            this.element.maskedElement.setAttribute(m, "url(" + getLocationHref() + "#" + c + ")"),
            i.appendChild(this.maskElement)),
            this.viewData.length && this.element.addRenderableComponent(this)
        }
        MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop
        }
        ,
        MaskElement.prototype.renderFrame = function(t) {
            var e = this.element.finalTransform.mat, r, i = this.masksProperties.length;
            for (r = 0; r < i; r += 1)
                if ((this.viewData[r].prop._mdf || t) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]),
                (this.viewData[r].op._mdf || t) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v),
                this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[r].invRect.setAttribute("transform", e.getInverseMatrix().to2dCSS()),
                this.storedData[r].x && (this.storedData[r].x._mdf || t))) {
                    var s = this.storedData[r].expan;
                    this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode",
                    this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")),
                    s.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate",
                    this.storedData[r].elem.setAttribute("filter", null)),
                    this.storedData[r].elem.setAttribute("stroke-width", this.storedData[r].x.v * 2))
                }
        }
        ,
        MaskElement.prototype.getMaskelement = function() {
            return this.maskElement
        }
        ,
        MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w,
            t += " v" + this.globalData.compSize.h,
            t += " h-" + this.globalData.compSize.w,
            t += " v-" + this.globalData.compSize.h + " ",
            t
        }
        ,
        MaskElement.prototype.drawPath = function(t, e, r) {
            var i = " M" + e.v[0][0] + "," + e.v[0][1], s, n;
            for (n = e._length,
            s = 1; s < n; s += 1)
                i += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[s][0] + "," + e.i[s][1] + " " + e.v[s][0] + "," + e.v[s][1];
            if (e.c && n > 1 && (i += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]),
            r.lastPath !== i) {
                var a = "";
                r.elem && (e.c && (a = t.inv ? this.solidPath + i : i),
                r.elem.setAttribute("d", a)),
                r.lastPath = i
            }
        }
        ,
        MaskElement.prototype.destroy = function() {
            this.element = null,
            this.globalData = null,
            this.maskElement = null,
            this.data = null,
            this.masksProperties = null
        }
        ;
        var filtersFactory = function() {
            var t = {};
            t.createFilter = e,
            t.createAlphaToLuminanceFilter = r;
            function e(i, s) {
                var n = createNS("filter");
                return n.setAttribute("id", i),
                s !== !0 && (n.setAttribute("filterUnits", "objectBoundingBox"),
                n.setAttribute("x", "0%"),
                n.setAttribute("y", "0%"),
                n.setAttribute("width", "100%"),
                n.setAttribute("height", "100%")),
                n
            }
            function r() {
                var i = createNS("feColorMatrix");
                return i.setAttribute("type", "matrix"),
                i.setAttribute("color-interpolation-filters", "sRGB"),
                i.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"),
                i
            }
            return t
        }()
          , featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: typeof OffscreenCanvas < "u"
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1),
            /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1),
            t
        }()
          , registeredEffects$1 = {}
          , idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r = "SourceGraphic", i = t.data.ef ? t.data.ef.length : 0, s = createElementID(), n = filtersFactory.createFilter(s, !0), a = 0;
            this.filters = [];
            var l;
            for (e = 0; e < i; e += 1) {
                l = null;
                var o = t.data.ef[e].ty;
                if (registeredEffects$1[o]) {
                    var h = registeredEffects$1[o].effect;
                    l = new h(n,t.effectsManager.effectElements[e],t,idPrefix + a,r),
                    r = idPrefix + a,
                    registeredEffects$1[o].countsAsEffect && (a += 1)
                }
                l && this.filters.push(l)
            }
            a && (t.globalData.defs.appendChild(n),
            t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")),
            this.filters.length && t.addRenderableComponent(this)
        }
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for (e = 0; e < r; e += 1)
                this.filters[e].renderFrame(t)
        }
        ,
        SVGEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for (e = 0; e < r; e += 1)
                this.filters[e].type === t && i.push(this.filters[e]);
            return i
        }
        ;
        function registerEffect$1(t, e, r) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r
            }
        }
        function SVGBaseElement() {}
        SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g")
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"),
                this.transformedElement = this.layerElement,
                this.maskedElement = this.layerElement,
                this._sizeChanged = !1;
                var e = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var r = createNS("g");
                    r.setAttribute("id", this.layerId),
                    r.appendChild(this.layerElement),
                    e = r,
                    this.globalData.defs.appendChild(r)
                } else
                    this.data.tt ? (this.matteElement.appendChild(this.layerElement),
                    e = this.matteElement,
                    this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
                this.data.cl && this.layerElement.setAttribute("class", this.data.cl),
                this.data.ty === 0 && !this.data.hd) {
                    var i = createNS("clipPath")
                      , s = createNS("path");
                    s.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var n = createElementID();
                    if (i.setAttribute("id", n),
                    i.appendChild(s),
                    this.globalData.defs.appendChild(i),
                    this.checkMasks()) {
                        var a = createNS("g");
                        a.setAttribute("clip-path", "url(" + getLocationHref() + "#" + n + ")"),
                        a.appendChild(this.layerElement),
                        this.transformedElement = a,
                        e ? e.appendChild(this.transformedElement) : this.baseElement = this.transformedElement
                    } else
                        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + n + ")")
                }
                this.data.bm !== 0 && this.setBlendMode()
            },
            renderElement: function() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()),
                this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity)
            },
            destroyBaseElement: function() {
                this.layerElement = null,
                this.matteElement = null,
                this.maskManager.destroy()
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data,this,this.globalData),
                this.renderableEffectsManager = new SVGEffects(this),
                this.searchEffectTransforms()
            },
            getMatte: function(e) {
                if (this.matteMasks || (this.matteMasks = {}),
                !this.matteMasks[e]) {
                    var r = this.layerId + "_" + e, i, s, n, a;
                    if (e === 1 || e === 3) {
                        var l = createNS("mask");
                        l.setAttribute("id", r),
                        l.setAttribute("mask-type", e === 3 ? "luminance" : "alpha"),
                        n = createNS("use"),
                        n.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId),
                        l.appendChild(n),
                        this.globalData.defs.appendChild(l),
                        !featureSupport.maskType && e === 1 && (l.setAttribute("mask-type", "luminance"),
                        i = createElementID(),
                        s = filtersFactory.createFilter(i),
                        this.globalData.defs.appendChild(s),
                        s.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                        a = createNS("g"),
                        a.appendChild(n),
                        l.appendChild(a),
                        a.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"))
                    } else if (e === 2) {
                        var o = createNS("mask");
                        o.setAttribute("id", r),
                        o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h),
                        i = createElementID(),
                        s = filtersFactory.createFilter(i);
                        var p = createNS("feComponentTransfer");
                        p.setAttribute("in", "SourceGraphic"),
                        s.appendChild(p);
                        var S = createNS("feFuncA");
                        S.setAttribute("type", "table"),
                        S.setAttribute("tableValues", "1.0 0.0"),
                        p.appendChild(S),
                        this.globalData.defs.appendChild(s);
                        var c = createNS("rect");
                        c.setAttribute("width", this.comp.data.w),
                        c.setAttribute("height", this.comp.data.h),
                        c.setAttribute("x", "0"),
                        c.setAttribute("y", "0"),
                        c.setAttribute("fill", "#ffffff"),
                        c.setAttribute("opacity", "0"),
                        h.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"),
                        h.appendChild(c),
                        n = createNS("use"),
                        n.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId),
                        h.appendChild(n),
                        featureSupport.maskType || (o.setAttribute("mask-type", "luminance"),
                        s.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                        a = createNS("g"),
                        h.appendChild(c),
                        a.appendChild(this.layerElement),
                        h.appendChild(a)),
                        this.globalData.defs.appendChild(o)
                    }
                    this.matteMasks[e] = r
                }
                return this.matteMasks[e]
            },
            setMatte: function(e) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + e + ")")
            }
        };
        function HierarchyElement() {}
        HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [],
                this._isParent = !1,
                this.checkParenting()
            },
            setHierarchy: function(e) {
                this.hierarchy = e
            },
            setAsParent: function() {
                this._isParent = !0
            },
            checkParenting: function() {
                this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, [])
            }
        };
        function RenderableDOMElement() {}
        (function() {
            var t = {
                initElement: function(r, i, s) {
                    this.initFrame(),
                    this.initBaseData(r, i, s),
                    this.initTransform(r, i, s),
                    this.initHierarchy(),
                    this.initRenderable(),
                    this.initRendererElement(),
                    this.createContainerElements(),
                    this.createRenderableComponents(),
                    this.createContent(),
                    this.hide()
                },
                hide: function() {
                    if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                        var r = this.baseElement || this.layerElement;
                        r.style.display = "none",
                        this.hidden = !0
                    }
                },
                show: function() {
                    if (this.isInRange && !this.isTransparent) {
                        if (!this.data.hd) {
                            var r = this.baseElement || this.layerElement;
                            r.style.display = "block"
                        }
                        this.hidden = !1,
                        this._isFirstFrame = !0
                    }
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(),
                    this.renderRenderable(),
                    this.renderLocalTransform(),
                    this.renderElement(),
                    this.renderInnerContent(),
                    this._isFirstFrame && (this._isFirstFrame = !1))
                },
                renderInnerContent: function() {},
                prepareFrame: function(r) {
                    this._mdf = !1,
                    this.prepareRenderableFrame(r),
                    this.prepareProperties(r, this.isInRange),
                    this.checkTransparency()
                },
                destroy: function() {
                    this.innerElem = null,
                    this.destroyBaseElement()
                }
            };
            extendPrototype([RenderableElement, createProxyFunction(t)], RenderableDOMElement)
        }
        )();
        function IImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId),
            this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)),
            this.initElement(t, e, r),
            this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            }
        }
        extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement),
        IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"),
            this.innerElem.setAttribute("width", this.assetData.w + "px"),
            this.innerElem.setAttribute("height", this.assetData.h + "px"),
            this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio),
            this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
            this.layerElement.appendChild(this.innerElem)
        }
        ,
        IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect
        }
        ;
        function ProcessedElement(t, e) {
            this.elem = t,
            this.pos = e
        }
        function IShapeElement() {}
        IShapeElement.prototype = {
            addShapeToModifiers: function(e) {
                var r, i = this.shapeModifiers.length;
                for (r = 0; r < i; r += 1)
                    this.shapeModifiers[r].addShape(e)
            },
            isShapeInAnimatedModifiers: function(e) {
                for (var r = 0, i = this.shapeModifiers.length; r < i; )
                    if (this.shapeModifiers[r].isAnimatedWithShape(e))
                        return !0;
                return !1
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var e, r = this.shapes.length;
                    for (e = 0; e < r; e += 1)
                        this.shapes[e].sh.reset();
                    r = this.shapeModifiers.length;
                    var i;
                    for (e = r - 1; e >= 0 && (i = this.shapeModifiers[e].processShapes(this._isFirstFrame),
                    !i); e -= 1)
                        ;
                }
            },
            searchProcessedElement: function(e) {
                for (var r = this.processedElements, i = 0, s = r.length; i < s; ) {
                    if (r[i].elem === e)
                        return r[i].pos;
                    i += 1
                }
                return 0
            },
            addProcessedElement: function(e, r) {
                for (var i = this.processedElements, s = i.length; s; )
                    if (s -= 1,
                    i[s].elem === e) {
                        i[s].pos = r;
                        return
                    }
                i.push(new ProcessedElement(e,r))
            },
            prepareFrame: function(e) {
                this.prepareRenderableFrame(e),
                this.prepareProperties(e, this.isInRange)
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }
          , lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r) {
            this.caches = [],
            this.styles = [],
            this.transformers = t,
            this.lStr = "",
            this.sh = r,
            this.lvl = e,
            this._isAnimated = !!r.k;
            for (var i = 0, s = t.length; i < s; ) {
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break
                }
                i += 1
            }
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0
        }
        ;
        function SVGStyleData(t, e) {
            this.data = t,
            this.type = t.ty,
            this.d = "",
            this.lvl = e,
            this._mdf = !1,
            this.closed = t.hd === !0,
            this.pElem = createNS("path"),
            this.msElem = null
        }
        SVGStyleData.prototype.reset = function() {
            this.d = "",
            this._mdf = !1
        }
        ;
        function DashProperty(t, e, r, i) {
            this.elem = t,
            this.frameId = -1,
            this.dataProps = createSizedArray(e.length),
            this.renderer = r,
            this.k = !1,
            this.dashStr = "",
            this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0),
            this.dashoffset = createTypedArray("float32", 1),
            this.initDynamicPropertyContainer(i);
            var s, n = e.length || 0, a;
            for (s = 0; s < n; s += 1)
                a = PropertyFactory.getProp(t, e[s].v, 0, 0, this),
                this.k = a.k || this.k,
                this.dataProps[s] = {
                    n: e[s].n,
                    p: a
                };
            this.k || this.getValue(!0),
            this._isAnimated = this.k
        }
        DashProperty.prototype.getValue = function(t) {
            if (!(this.elem.globalData.frameId === this.frameId && !t) && (this.frameId = this.elem.globalData.frameId,
            this.iterateDynamicProperties(),
            this._mdf = this._mdf || t,
            this._mdf)) {
                var e = 0
                  , r = this.dataProps.length;
                for (this.renderer === "svg" && (this.dashStr = ""),
                e = 0; e < r; e += 1)
                    this.dataProps[e].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v
            }
        }
        ,
        extendPrototype([DynamicPropertyContainer], DashProperty);
        function SVGStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t),
            this.getValue = this.iterateDynamicProperties,
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this),
            this.w = PropertyFactory.getProp(t, e.w, 0, null, this),
            this.d = new DashProperty(t,e.d || {},"svg",this),
            this.c = PropertyFactory.getProp(t, e.c, 1, 255, this),
            this.style = r,
            this._isAnimated = !!this._isAnimated
        }
        extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
        function SVGFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t),
            this.getValue = this.iterateDynamicProperties,
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this),
            this.c = PropertyFactory.getProp(t, e.c, 1, 255, this),
            this.style = r
        }
        extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
        function SVGNoStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t),
            this.getValue = this.iterateDynamicProperties,
            this.style = r
        }
        extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
        function GradientProperty(t, e, r) {
            this.data = e,
            this.c = createTypedArray("uint8c", e.p * 4);
            var i = e.k.k[0].s ? e.k.k[0].s.length - e.p * 4 : e.k.k.length - e.p * 4;
            this.o = createTypedArray("float32", i),
            this._cmdf = !1,
            this._omdf = !1,
            this._collapsable = this.checkCollapsable(),
            this._hasOpacity = i,
            this.initDynamicPropertyContainer(r),
            this.prop = PropertyFactory.getProp(t, e.k, 1, null, this),
            this.k = this.prop.k,
            this.getValue(!0)
        }
        GradientProperty.prototype.comparePoints = function(t, e) {
            for (var r = 0, i = this.o.length / 2, s; r < i; ) {
                if (s = Math.abs(t[r * 4] - t[e * 4 + r * 2]),
                s > .01)
                    return !1;
                r += 1
            }
            return !0
        }
        ,
        GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 !== this.c.length / 4)
                return !1;
            if (this.data.k.k[0].s)
                for (var t = 0, e = this.data.k.k.length; t < e; ) {
                    if (!this.comparePoints(this.data.k.k[t].s, this.data.p))
                        return !1;
                    t += 1
                }
            else if (!this.comparePoints(this.data.k.k, this.data.p))
                return !1;
            return !0
        }
        ,
        GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(),
            this._mdf = !1,
            this._cmdf = !1,
            this._omdf = !1,
            this.prop._mdf || t) {
                var e, r = this.data.p * 4, i, s;
                for (e = 0; e < r; e += 1)
                    i = e % 4 === 0 ? 100 : 255,
                    s = Math.round(this.prop.v[e] * i),
                    this.c[e] !== s && (this.c[e] = s,
                    this._cmdf = !t);
                if (this.o.length)
                    for (r = this.prop.v.length,
                    e = this.data.p * 4; e < r; e += 1)
                        i = e % 2 === 0 ? 100 : 1,
                        s = e % 2 === 0 ? Math.round(this.prop.v[e] * 100) : this.prop.v[e],
                        this.o[e - this.data.p * 4] !== s && (this.o[e - this.data.p * 4] = s,
                        this._omdf = !t);
                this._mdf = !t
            }
        }
        ,
        extendPrototype([DynamicPropertyContainer], GradientProperty);
        function SVGGradientFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t),
            this.getValue = this.iterateDynamicProperties,
            this.initGradientData(t, e, r)
        }
        SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this),
            this.s = PropertyFactory.getProp(t, e.s, 1, null, this),
            this.e = PropertyFactory.getProp(t, e.e, 1, null, this),
            this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this),
            this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this),
            this.g = new GradientProperty(t,e.g,this),
            this.style = r,
            this.stops = [],
            this.setGradientData(r.pElem, e),
            this.setGradientOpacity(e, r),
            this._isAnimated = !!this._isAnimated
        }
        ,
        SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r = createElementID()
              , i = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r),
            i.setAttribute("spreadMethod", "pad"),
            i.setAttribute("gradientUnits", "userSpaceOnUse");
            var s = [], n, a, l;
            for (l = e.g.p * 4,
            a = 0; a < l; a += 4)
                n = createNS("stop"),
                i.appendChild(n),
                s.push(n);
            t.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"),
            this.gf = i,
            this.cst = s
        }
        ,
        SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r, i, s, n = createNS("mask"), a = createNS("path");
                n.appendChild(a);
                var l = createElementID()
                  , o = createElementID();
                n.setAttribute("id", o);
                var h = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
                h.setAttribute("id", l),
                h.setAttribute("spreadMethod", "pad"),
                h.setAttribute("gradientUnits", "userSpaceOnUse"),
                s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for (i = t.g.p * 4; i < s; i += 2)
                    r = createNS("stop"),
                    r.setAttribute("stop-color", "rgb(255,255,255)"),
                    h.appendChild(r),
                    p.push(r);
                a.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + l + ")"),
                t.ty === "gs" && (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
                a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
                t.lj === 1 && a.setAttribute("stroke-miterlimit", t.ml)),
                this.of = h,
                this.ms = n,
                this.ost = p,
                this.maskId = o,
                e.msElem = a
            }
        }
        ,
        extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
        function SVGGradientStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t),
            this.getValue = this.iterateDynamicProperties,
            this.w = PropertyFactory.getProp(t, e.w, 0, null, this),
            this.d = new DashProperty(t,e.d || {},"svg",this),
            this.initGradientData(t, e, r),
            this._isAnimated = !!this._isAnimated
        }
        extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
        function ShapeGroupData() {
            this.it = [],
            this.prevViewData = [],
            this.gr = createNS("g")
        }
        function SVGTransformData(t, e, r) {
            this.transform = {
                mProps: t,
                op: e,
                container: r
            },
            this.elements = [],
            this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length
        }
        var buildShapeString = function(e, r, i, s) {
            if (r === 0)
                return "";
            var n = e.o, a = e.i, l = e.v, o, h = " M" + s.applyToPointStringified(l[0][0], l[0][1]);
            for (o = 1; o < r; o += 1)
                h += " C" + s.applyToPointStringified(n[o - 1][0], n[o - 1][1]) + " " + s.applyToPointStringified(a[o][0], a[o][1]) + " " + s.applyToPointStringified(l[o][0], l[o][1]);
            return i && r && (h += " C" + s.applyToPointStringified(n[o - 1][0], n[o - 1][1]) + " " + s.applyToPointStringified(a[0][0], a[0][1]) + " " + s.applyToPointStringified(l[0][0], l[0][1]),
            h += "z"),
            h
        }
          , SVGElementsRenderer = function() {
            var t = new Matrix
              , e = new Matrix
              , r = {
                createRenderFunction: i
            };
            function i(S) {
                switch (S.ty) {
                case "fl":
                    return l;
                case "gf":
                    return h;
                case "gs":
                    return o;
                case "st":
                    return p;
                case "sh":
                case "el":
                case "rc":
                case "sr":
                    return a;
                case "tr":
                    return s;
                case "no":
                    return n;
                default:
                    return null
                }
            }
            function s(S, c, g) {
                (g || c.transform.op._mdf) && c.transform.container.setAttribute("opacity", c.transform.op.v),
                (g || c.transform.mProps._mdf) && c.transform.container.setAttribute("transform", c.transform.mProps.v.to2dCSS())
            }
            function n() {}
            function a(S, c, g) {
                var v, d, b, u, m, f, y = c.styles.length, _ = c.lvl, T, C, x, w;
                for (f = 0; f < y; f += 1) {
                    if (u = c.sh._mdf || g,
                    c.styles[f].lvl < _) {
                        for (C = e.reset(),
                        x = _ - c.styles[f].lvl,
                        w = c.transformers.length - 1; !u && x > 0; )
                            u = c.transformers[w].mProps._mdf || u,
                            x -= 1,
                            w -= 1;
                        if (u)
                            for (x = _ - c.styles[f].lvl,
                            w = c.transformers.length - 1; x > 0; )
                                C.multiply(c.transformers[w].mProps.v),
                                x -= 1,
                                w -= 1
                    } else
                        C = t;
                    if (T = c.sh.paths,
                    d = T._length,
                    u) {
                        for (b = "",
                        v = 0; v < d; v += 1)
                            m = T.shapes[v],
                            m && m._length && (b += buildShapeString(m, m._length, m.c, C));
                        c.caches[f] = b
                    } else
                        b = c.caches[f];
                    c.styles[f].d += S.hd === !0 ? "" : b,
                    c.styles[f]._mdf = u || c.styles[f]._mdf
                }
            }
            function l(S, c, g) {
                var v = c.style;
                (c.c._mdf || g) && v.pElem.setAttribute("fill", "rgb(" + bmFloor(c.c.v[0]) + "," + bmFloor(c.c.v[1]) + "," + bmFloor(c.c.v[2]) + ")"),
                (c.o._mdf || g) && v.pElem.setAttribute("fill-opacity", c.o.v)
            }
            function o(S, c, g) {
                h(S, c, g),
                p(S, c, g)
            }
            function h(S, c, g) {
                var v = c.gf
                  , d = c.g._hasOpacity
                  , b = c.s.v
                  , u = c.e.v;
                if (c.o._mdf || g) {
                    var m = S.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                    c.style.pElem.setAttribute(m, c.o.v)
                }
                if (c.s._mdf || g) {
                    var f = S.t === 1 ? "x1" : "cx"
                      , y = f === "x1" ? "y1" : "cy";
                    v.setAttribute(f, b[0]),
                    v.setAttribute(y, b[1]),
                    d && !c.g._collapsable && (c.of.setAttribute(f, b[0]),
                    c.of.setAttribute(y, b[1]))
                }
                var _, T, C, x;
                if (c.g._cmdf || g) {
                    _ = c.cst;
                    var w = c.g.c;
                    for (C = _.length,
                    T = 0; T < C; T += 1)
                        x = _[T],
                        x.setAttribute("offset", w[T * 4] + "%"),
                        x.setAttribute("stop-color", "rgb(" + w[T * 4 + 1] + "," + w[T * 4 + 2] + "," + w[T * 4 + 3] + ")")
                }
                if (d && (c.g._omdf || g)) {
                    var D = c.g.o;
                    for (c.g._collapsable ? _ = c.cst : _ = c.ost,
                    C = _.length,
                    T = 0; T < C; T += 1)
                        x = _[T],
                        c.g._collapsable || x.setAttribute("offset", D[T * 2] + "%"),
                        x.setAttribute("stop-opacity", D[T * 2 + 1])
                }
                if (S.t === 1)
                    (c.e._mdf || g) && (v.setAttribute("x2", u[0]),
                    v.setAttribute("y2", u[1]),
                    d && !c.g._collapsable && (c.of.setAttribute("x2", u[0]),
                    c.of.setAttribute("y2", u[1])));
                else {
                    var k;
                    if ((c.s._mdf || c.e._mdf || g) && (k = Math.sqrt(Math.pow(b[0] - u[0], 2) + Math.pow(b[1] - u[1], 2)),
                    v.setAttribute("r", k),
                    d && !c.g._collapsable && c.of.setAttribute("r", k)),
                    c.e._mdf || c.h._mdf || c.a._mdf || g) {
                        k || (k = Math.sqrt(Math.pow(b[0] - u[0], 2) + Math.pow(b[1] - u[1], 2)));
                        var L = Math.atan2(u[1] - b[1], u[0] - b[0])
                          , V = c.h.v;
                        V >= 1 ? V = .99 : V <= -1 && (V = -.99);
                        var O = k * V
                          , R = Math.cos(L + c.a.v) * O + b[0]
                          , P = Math.sin(L + c.a.v) * O + b[1];
                        v.setAttribute("fx", R),
                        v.setAttribute("fy", P),
                        d && !c.g._collapsable && (c.of.setAttribute("fx", R),
                        c.of.setAttribute("fy", P))
                    }
                }
            }
            function p(S, c, g) {
                var v = c.style
                  , d = c.d;
                d && (d._mdf || g) && d.dashStr && (v.pElem.setAttribute("stroke-dasharray", d.dashStr),
                v.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0])),
                c.c && (c.c._mdf || g) && v.pElem.setAttribute("stroke", "rgb(" + bmFloor(c.c.v[0]) + "," + bmFloor(c.c.v[1]) + "," + bmFloor(c.c.v[2]) + ")"),
                (c.o._mdf || g) && v.pElem.setAttribute("stroke-opacity", c.o.v),
                (c.w._mdf || g) && (v.pElem.setAttribute("stroke-width", c.w.v),
                v.msElem && v.msElem.setAttribute("stroke-width", c.w.v))
            }
            return r
        }();
        function SVGShapeElement(t, e, r) {
            this.shapes = [],
            this.shapesData = t.shapes,
            this.stylesList = [],
            this.shapeModifiers = [],
            this.itemsData = [],
            this.processedElements = [],
            this.animatedContents = [],
            this.initElement(t, e, r),
            this.prevViewData = []
        }
        extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement),
        SVGShapeElement.prototype.initSecondaryElement = function() {}
        ,
        SVGShapeElement.prototype.identityMatrix = new Matrix,
        SVGShapeElement.prototype.buildExpressionInterface = function() {}
        ,
        SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0),
            this.filterUniqueShapes()
        }
        ,
        SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e = this.shapes.length, r, i, s = this.stylesList.length, n, a = [], l = !1;
            for (i = 0; i < s; i += 1) {
                for (n = this.stylesList[i],
                l = !1,
                a.length = 0,
                t = 0; t < e; t += 1)
                    r = this.shapes[t],
                    r.styles.indexOf(n) !== -1 && (a.push(r),
                    l = r._isAnimated || l);
                a.length > 1 && l && this.setShapesAsAnimated(a)
            }
        }
        ,
        SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r = t.length;
            for (e = 0; e < r; e += 1)
                t[e].setAsAnimated()
        }
        ,
        SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r, i = new SVGStyleData(t,e), s = i.pElem;
            if (t.ty === "st")
                r = new SVGStrokeStyleData(this,t,i);
            else if (t.ty === "fl")
                r = new SVGFillStyleData(this,t,i);
            else if (t.ty === "gf" || t.ty === "gs") {
                var n = t.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
                r = new n(this,t,i),
                this.globalData.defs.appendChild(r.gf),
                r.maskId && (this.globalData.defs.appendChild(r.ms),
                this.globalData.defs.appendChild(r.of),
                s.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"))
            } else
                t.ty === "no" && (r = new SVGNoStyleData(this,t,i));
            return (t.ty === "st" || t.ty === "gs") && (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
            s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
            s.setAttribute("fill-opacity", "0"),
            t.lj === 1 && s.setAttribute("stroke-miterlimit", t.ml)),
            t.r === 2 && s.setAttribute("fill-rule", "evenodd"),
            t.ln && s.setAttribute("id", t.ln),
            t.cl && s.setAttribute("class", t.cl),
            t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)),
            this.stylesList.push(i),
            this.addToAnimatedContents(t, r),
            r
        }
        ,
        SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln),
            t.cl && e.gr.setAttribute("class", t.cl),
            t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)),
            e
        }
        ,
        SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r = TransformPropertyFactory.getTransformProperty(this, t, this)
              , i = new SVGTransformData(r,r.o,e);
            return this.addToAnimatedContents(t, i),
            i
        }
        ,
        SVGShapeElement.prototype.createShapeElement = function(t, e, r) {
            var i = 4;
            t.ty === "rc" ? i = 5 : t.ty === "el" ? i = 6 : t.ty === "sr" && (i = 7);
            var s = ShapePropertyFactory.getShapeProp(this, t, i, this)
              , n = new SVGShapeData(e,r,s);
            return this.shapes.push(n),
            this.addShapeToModifiers(n),
            this.addToAnimatedContents(t, n),
            n
        }
        ,
        SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for (var r = 0, i = this.animatedContents.length; r < i; ) {
                if (this.animatedContents[r].element === e)
                    return;
                r += 1
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            })
        }
        ,
        SVGShapeElement.prototype.setElementStyles = function(t) {
            var e = t.styles, r, i = this.stylesList.length;
            for (r = 0; r < i; r += 1)
                this.stylesList[r].closed || e.push(this.stylesList[r])
        }
        ,
        SVGShapeElement.prototype.reloadShapes = function() {
            this._isFirstFrame = !0;
            var t, e = this.itemsData.length;
            for (t = 0; t < e; t += 1)
                this.prevViewData[t] = this.itemsData[t];
            for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0),
            this.filterUniqueShapes(),
            e = this.dynamicProperties.length,
            t = 0; t < e; t += 1)
                this.dynamicProperties[t].getValue();
            this.renderModifiers()
        }
        ,
        SVGShapeElement.prototype.searchShapes = function(t, e, r, i, s, n, a) {
            var l = [].concat(n), o, h = t.length - 1, p, S, c = [], g = [], v, d, b;
            for (o = h; o >= 0; o -= 1) {
                if (b = this.searchProcessedElement(t[o]),
                b ? e[o] = r[b - 1] : t[o]._render = a,
                t[o].ty === "fl" || t[o].ty === "st" || t[o].ty === "gf" || t[o].ty === "gs" || t[o].ty === "no")
                    b ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], s),
                    t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem),
                    c.push(e[o].style);
                else if (t[o].ty === "gr") {
                    if (!b)
                        e[o] = this.createGroupElement(t[o]);
                    else
                        for (S = e[o].it.length,
                        p = 0; p < S; p += 1)
                            e[o].prevViewData[p] = e[o].it[p];
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, s + 1, l, a),
                    t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr)
                } else
                    t[o].ty === "tr" ? (b || (e[o] = this.createTransformElement(t[o], i)),
                    v = e[o].transform,
                    l.push(v)) : t[o].ty === "sh" || t[o].ty === "rc" || t[o].ty === "el" || t[o].ty === "sr" ? (b || (e[o] = this.createShapeElement(t[o], l, s)),
                    this.setElementStyles(e[o])) : t[o].ty === "tm" || t[o].ty === "rd" || t[o].ty === "ms" || t[o].ty === "pb" || t[o].ty === "zz" || t[o].ty === "op" ? (b ? (d = e[o],
                    d.closed = !1) : (d = ShapeModifiers.getModifier(t[o].ty),
                    d.init(this, t[o]),
                    e[o] = d,
                    this.shapeModifiers.push(d)),
                    g.push(d)) : t[o].ty === "rp" && (b ? (d = e[o],
                    d.closed = !0) : (d = ShapeModifiers.getModifier(t[o].ty),
                    e[o] = d,
                    d.init(this, t, o, e),
                    this.shapeModifiers.push(d),
                    a = !1),
                    g.push(d));
                this.addProcessedElement(t[o], o + 1)
            }
            for (h = c.length,
            o = 0; o < h; o += 1)
                c[o].closed = !0;
            for (h = g.length,
            o = 0; o < h; o += 1)
                g[o].closed = !0
        }
        ,
        SVGShapeElement.prototype.renderInnerContent = function() {
            this.renderModifiers();
            var t, e = this.stylesList.length;
            for (t = 0; t < e; t += 1)
                this.stylesList[t].reset();
            for (this.renderShape(),
            t = 0; t < e; t += 1)
                (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d),
                this.stylesList[t].d = "M0 0" + this.stylesList[t].d),
                this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"))
        }
        ,
        SVGShapeElement.prototype.renderShape = function() {
            var t, e = this.animatedContents.length, r;
            for (t = 0; t < e; t += 1)
                r = this.animatedContents[t],
                (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame)
        }
        ,
        SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(),
            this.shapesData = null,
            this.itemsData = null
        }
        ;
        function LetterProps(t, e, r, i, s, n) {
            this.o = t,
            this.sw = e,
            this.sc = r,
            this.fc = i,
            this.m = s,
            this.p = n,
            this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r,
                fc: !!i,
                m: !0,
                p: !0
            }
        }
        LetterProps.prototype.update = function(t, e, r, i, s, n) {
            this._mdf.o = !1,
            this._mdf.sw = !1,
            this._mdf.sc = !1,
            this._mdf.fc = !1,
            this._mdf.m = !1,
            this._mdf.p = !1;
            var a = !1;
            return this.o !== t && (this.o = t,
            this._mdf.o = !0,
            a = !0),
            this.sw !== e && (this.sw = e,
            this._mdf.sw = !0,
            a = !0),
            this.sc !== r && (this.sc = r,
            this._mdf.sc = !0,
            a = !0),
            this.fc !== i && (this.fc = i,
            this._mdf.fc = !0,
            a = !0),
            this.m !== s && (this.m = s,
            this._mdf.m = !0,
            a = !0),
            n.length && (this.p[0] !== n[0] || this.p[1] !== n[1] || this.p[4] !== n[4] || this.p[5] !== n[5] || this.p[12] !== n[12] || this.p[13] !== n[13]) && (this.p = n,
            this._mdf.p = !0,
            a = !0),
            a
        }
        ;
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame,
            this.pv = "",
            this.v = "",
            this.kf = !1,
            this._isFirstFrame = !0,
            this._mdf = !1,
            e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)),
            this.data = e,
            this.elem = t,
            this.comp = this.elem.comp,
            this.keysIndex = 0,
            this.canResize = !1,
            this.minimumFontSize = 1,
            this.effectsSequence = [],
            this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            },
            this.copyData(this.currentData, this.data.d.k[0].s),
            this.searchProperty() || this.completeTextData(this.currentData)
        }
        TextProperty.prototype.defaultBoxWidth = [0, 0],
        TextProperty.prototype.copyData = function(t, e) {
            for (var r in e)
                Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t
        }
        ,
        TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t),
            this.currentData = t,
            this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth,
            this._mdf = !0
        }
        ,
        TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes()
        }
        ,
        TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1,
            this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
            this.kf
        }
        ,
        TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t),
            this.elem.addDynamicProperty(this)
        }
        ,
        TextProperty.prototype.getValue = function(t) {
            if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !t)) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData
                  , r = this.keysIndex;
                if (this.lock) {
                    this.setCurrentData(this.currentData);
                    return
                }
                this.lock = !0,
                this._mdf = !1;
                var i, s = this.effectsSequence.length, n = t || this.data.d.k[this.keysIndex].s;
                for (i = 0; i < s; i += 1)
                    r !== this.keysIndex ? n = this.effectsSequence[i](n, n.t) : n = this.effectsSequence[i](this.currentData, n.t);
                e !== n && this.setCurrentData(n),
                this.v = this.currentData,
                this.pv = this.v,
                this.lock = !1,
                this.frameId = this.elem.globalData.frameId
            }
        }
        ,
        TextProperty.prototype.getKeyframeValue = function() {
            for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e); )
                r += 1;
            return this.keysIndex !== r && (this.keysIndex = r),
            this.data.d.k[this.keysIndex].s
        }
        ,
        TextProperty.prototype.buildFinalText = function(t) {
            for (var e = [], r = 0, i = t.length, s, n, a = !1, l = !1, o = ""; r < i; )
                a = l,
                l = !1,
                s = t.charCodeAt(r),
                o = t.charAt(r),
                FontManager.isCombinedCharacter(s) ? a = !0 : s >= 55296 && s <= 56319 ? FontManager.isRegionalFlag(t, r) ? o = t.substr(r, 14) : (n = t.charCodeAt(r + 1),
                n >= 56320 && n <= 57343 && (FontManager.isModifier(s, n) ? (o = t.substr(r, 2),
                a = !0) : FontManager.isFlagEmoji(t.substr(r, 4)) ? o = t.substr(r, 4) : o = t.substr(r, 2))) : s > 56319 ? (n = t.charCodeAt(r + 1),
                FontManager.isVariationSelector(s) && (a = !0)) : FontManager.isZeroWidthJoiner(s) && (a = !0,
                l = !0),
                a ? (e[e.length - 1] += o,
                a = !1) : e.push(o),
                r += o.length;
            return e
        }
        ,
        TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e = this.elem.globalData.fontManager, r = this.data, i = [], s, n, a, l = 0, o, h = r.m.g, p = 0, S = 0, c = 0, g = [], v = 0, d = 0, b, u, m = e.getFontByName(t.f), f, y = 0, _ = getFontProperties(m);
            t.fWeight = _.weight,
            t.fStyle = _.style,
            t.finalSize = t.s,
            t.finalText = this.buildFinalText(t.t),
            n = t.finalText.length,
            t.finalLineHeight = t.lh;
            var T = t.tr / 1e3 * t.finalSize, C;
            if (t.sz)
                for (var x = !0, w = t.sz[0], D = t.sz[1], k, L; x; ) {
                    L = this.buildFinalText(t.t),
                    k = 0,
                    v = 0,
                    n = L.length,
                    T = t.tr / 1e3 * t.finalSize;
                    var V = -1;
                    for (s = 0; s < n; s += 1)
                        C = L[s].charCodeAt(0),
                        a = !1,
                        L[s] === " " ? V = s : (C === 13 || C === 3) && (v = 0,
                        a = !0,
                        k += t.finalLineHeight || t.finalSize * 1.2),
                        e.chars ? (f = e.getCharData(L[s], m.fStyle, m.fFamily),
                        y = a ? 0 : f.w * t.finalSize / 100) : y = e.measureText(L[s], t.f, t.finalSize),
                        v + y > w && L[s] !== " " ? (V === -1 ? n += 1 : s = V,
                        k += t.finalLineHeight || t.finalSize * 1.2,
                        L.splice(s, V === s ? 1 : 0, "\r"),
                        V = -1,
                        v = 0) : (v += y,
                        v += T);
                    k += m.ascent * t.finalSize / 100,
                    this.canResize && t.finalSize > this.minimumFontSize && D < k ? (t.finalSize -= 1,
                    t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = L,
                    n = t.finalText.length,
                    x = !1)
                }
            v = -T,
            y = 0;
            var O = 0, R;
            for (s = 0; s < n; s += 1)
                if (a = !1,
                R = t.finalText[s],
                C = R.charCodeAt(0),
                C === 13 || C === 3 ? (O = 0,
                g.push(v),
                d = v > d ? v : d,
                v = -2 * T,
                o = "",
                a = !0,
                c += 1) : o = R,
                e.chars ? (f = e.getCharData(R, m.fStyle, e.getFontByName(t.f).fFamily),
                y = a ? 0 : f.w * t.finalSize / 100) : y = e.measureText(o, t.f, t.finalSize),
                R === " " ? O += y + T : (v += y + T + O,
                O = 0),
                i.push({
                    l: y,
                    an: y,
                    add: p,
                    n: a,
                    anIndexes: [],
                    val: o,
                    line: c,
                    animatorJustifyOffset: 0
                }),
                h == 2) {
                    if (p += y,
                    o === "" || o === " " || s === n - 1) {
                        for ((o === "" || o === " ") && (p -= y); S <= s; )
                            i[S].an = p,
                            i[S].ind = l,
                            i[S].extra = y,
                            S += 1;
                        l += 1,
                        p = 0
                    }
                } else if (h == 3) {
                    if (p += y,
                    o === "" || s === n - 1) {
                        for (o === "" && (p -= y); S <= s; )
                            i[S].an = p,
                            i[S].ind = l,
                            i[S].extra = y,
                            S += 1;
                        p = 0,
                        l += 1
                    }
                } else
                    i[l].ind = l,
                    i[l].extra = 0,
                    l += 1;
            if (t.l = i,
            d = v > d ? v : d,
            g.push(v),
            t.sz)
                t.boxWidth = t.sz[0],
                t.justifyOffset = 0;
            else
                switch (t.boxWidth = d,
                t.j) {
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0
                }
            t.lineWidths = g;
            var P = r.a, M, E;
            u = P.length;
            var A, F, I = [];
            for (b = 0; b < u; b += 1) {
                for (M = P[b],
                M.a.sc && (t.strokeColorAnim = !0),
                M.a.sw && (t.strokeWidthAnim = !0),
                (M.a.fc || M.a.fh || M.a.fs || M.a.fb) && (t.fillColorAnim = !0),
                F = 0,
                A = M.s.b,
                s = 0; s < n; s += 1)
                    E = i[s],
                    E.anIndexes[b] = F,
                    (A == 1 && E.val !== "" || A == 2 && E.val !== "" && E.val !== " " || A == 3 && (E.n || E.val == " " || s == n - 1) || A == 4 && (E.n || s == n - 1)) && (M.s.rn === 1 && I.push(F),
                    F += 1);
                r.a[b].s.totalChars = F;
                var N = -1, $;
                if (M.s.rn === 1)
                    for (s = 0; s < n; s += 1)
                        E = i[s],
                        N != E.anIndexes[b] && (N = E.anIndexes[b],
                        $ = I.splice(Math.floor(Math.random() * I.length), 1)[0]),
                        E.anIndexes[b] = $
            }
            t.yOffset = t.finalLineHeight || t.finalSize * 1.2,
            t.ls = t.ls || 0,
            t.ascent = m.ascent * t.finalSize / 100
        }
        ,
        TextProperty.prototype.updateDocumentData = function(t, e) {
            e = e === void 0 ? this.keysIndex : e;
            var r = this.copyData({}, this.data.d.k[e].s);
            r = this.copyData(r, t),
            this.data.d.k[e].s = r,
            this.recalculate(e),
            this.setCurrentData(r),
            this.elem.addDynamicProperty(this)
        }
        ,
        TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1,
            this.keysIndex = 0,
            this._isFirstFrame = !0,
            this.getValue(e)
        }
        ,
        TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t,
            this.recalculate(this.keysIndex),
            this.elem.addDynamicProperty(this)
        }
        ,
        TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1,
            this.recalculate(this.keysIndex),
            this.elem.addDynamicProperty(this)
        }
        ;
        var TextSelectorProp = function() {
            var t = Math.max
              , e = Math.min
              , r = Math.floor;
            function i(n, a) {
                this._currentTextLength = -1,
                this.k = !1,
                this.data = a,
                this.elem = n,
                this.comp = n.comp,
                this.finalS = 0,
                this.finalE = 0,
                this.initDynamicPropertyContainer(n),
                this.s = PropertyFactory.getProp(n, a.s || {
                    k: 0
                }, 0, 0, this),
                "e"in a ? this.e = PropertyFactory.getProp(n, a.e, 0, 0, this) : this.e = {
                    v: 100
                },
                this.o = PropertyFactory.getProp(n, a.o || {
                    k: 0
                }, 0, 0, this),
                this.xe = PropertyFactory.getProp(n, a.xe || {
                    k: 0
                }, 0, 0, this),
                this.ne = PropertyFactory.getProp(n, a.ne || {
                    k: 0
                }, 0, 0, this),
                this.sm = PropertyFactory.getProp(n, a.sm || {
                    k: 100
                }, 0, 0, this),
                this.a = PropertyFactory.getProp(n, a.a, 0, .01, this),
                this.dynamicProperties.length || this.getValue()
            }
            i.prototype = {
                getMult: function(a) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var l = 0
                      , o = 0
                      , h = 1
                      , p = 1;
                    this.ne.v > 0 ? l = this.ne.v / 100 : o = -this.ne.v / 100,
                    this.xe.v > 0 ? h = 1 - this.xe.v / 100 : p = 1 + this.xe.v / 100;
                    var S = BezierFactory.getBezierEasing(l, o, h, p).get
                      , c = 0
                      , g = this.finalS
                      , v = this.finalE
                      , d = this.data.sh;
                    if (d === 2)
                        v === g ? c = a >= v ? 1 : 0 : c = t(0, e(.5 / (v - g) + (a - g) / (v - g), 1)),
                        c = S(c);
                    else if (d === 3)
                        v === g ? c = a >= v ? 0 : 1 : c = 1 - t(0, e(.5 / (v - g) + (a - g) / (v - g), 1)),
                        c = S(c);
                    else if (d === 4)
                        v === g ? c = 0 : (c = t(0, e(.5 / (v - g) + (a - g) / (v - g), 1)),
                        c < .5 ? c *= 2 : c = 1 - 2 * (c - .5)),
                        c = S(c);
                    else if (d === 5) {
                        if (v === g)
                            c = 0;
                        else {
                            var b = v - g;
                            a = e(t(0, a + .5 - g), v - g);
                            var u = -b / 2 + a
                              , m = b / 2;
                            c = Math.sqrt(1 - u * u / (m * m))
                        }
                        c = S(c)
                    } else
                        d === 6 ? (v === g ? c = 0 : (a = e(t(0, a + .5 - g), v - g),
                        c = (1 + Math.cos(Math.PI + Math.PI * 2 * a / (v - g))) / 2),
                        c = S(c)) : (a >= r(g) && (a - g < 0 ? c = t(0, e(e(v, 1) - (g - a), 1)) : c = t(0, e(v - a, 1))),
                        c = S(c));
                    if (this.sm.v !== 100) {
                        var f = this.sm.v * .01;
                        f === 0 && (f = 1e-8);
                        var y = .5 - f * .5;
                        c < y ? c = 0 : (c = (c - y) / f,
                        c > 1 && (c = 1))
                    }
                    return c * this.a.v
                },
                getValue: function(a) {
                    this.iterateDynamicProperties(),
                    this._mdf = a || this._mdf,
                    this._currentTextLength = this.elem.textProperty.currentData.l.length || 0,
                    a && this.data.r === 2 && (this.e.v = this._currentTextLength);
                    var l = this.data.r === 2 ? 1 : 100 / this.data.totalChars
                      , o = this.o.v / l
                      , h = this.s.v / l + o
                      , p = this.e.v / l + o;
                    if (h > p) {
                        var S = h;
                        h = p,
                        p = S
                    }
                    this.finalS = h,
                    this.finalE = p
                }
            },
            extendPrototype([DynamicPropertyContainer], i);
            function s(n, a, l) {
                return new i(n,a)
            }
            return {
                getTextSelectorProp: s
            }
        }();
        function TextAnimatorDataProperty(t, e, r) {
            var i = {
                propType: !1
            }
              , s = PropertyFactory.getProp
              , n = e.a;
            this.a = {
                r: n.r ? s(t, n.r, 0, degToRads, r) : i,
                rx: n.rx ? s(t, n.rx, 0, degToRads, r) : i,
                ry: n.ry ? s(t, n.ry, 0, degToRads, r) : i,
                sk: n.sk ? s(t, n.sk, 0, degToRads, r) : i,
                sa: n.sa ? s(t, n.sa, 0, degToRads, r) : i,
                s: n.s ? s(t, n.s, 1, .01, r) : i,
                a: n.a ? s(t, n.a, 1, 0, r) : i,
                o: n.o ? s(t, n.o, 0, .01, r) : i,
                p: n.p ? s(t, n.p, 1, 0, r) : i,
                sw: n.sw ? s(t, n.sw, 0, 0, r) : i,
                sc: n.sc ? s(t, n.sc, 1, 0, r) : i,
                fc: n.fc ? s(t, n.fc, 1, 0, r) : i,
                fh: n.fh ? s(t, n.fh, 0, 0, r) : i,
                fs: n.fs ? s(t, n.fs, 0, .01, r) : i,
                fb: n.fb ? s(t, n.fb, 0, .01, r) : i,
                t: n.t ? s(t, n.t, 0, 0, r) : i
            },
            this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r),
            this.s.t = e.s.t
        }
        function TextAnimatorProperty(t, e, r) {
            this._isFirstFrame = !0,
            this._hasMaskedPath = !1,
            this._frameId = -1,
            this._textData = t,
            this._renderType = e,
            this._elem = r,
            this._animatorsData = createSizedArray(this._textData.a.length),
            this._pathData = {},
            this._moreOptions = {
                alignment: {}
            },
            this.renderedLetters = [],
            this.lettersChangedFlag = !1,
            this.initDynamicPropertyContainer(r)
        }
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e = this._textData.a.length, r, i = PropertyFactory.getProp;
            for (t = 0; t < e; t += 1)
                r = this._textData.a[t],
                this._animatorsData[t] = new TextAnimatorDataProperty(this._elem,r,this);
            this._textData.p && "m"in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            },
            this._hasMaskedPath = !0) : this._hasMaskedPath = !1,
            this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this)
        }
        ,
        TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e,
            !(!this._mdf && !this._isFirstFrame && !e && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
                this._isFirstFrame = !1;
                var r = this._moreOptions.alignment.v, i = this._animatorsData, s = this._textData, n = this.mHelper, a = this._renderType, l = this.renderedLetters.length, o, h, p, S, c = t.l, g, v, d, b, u, m, f, y, _, T, C, x, w, D, k;
                if (this._hasMaskedPath) {
                    if (k = this._pathData.m,
                    !this._pathData.n || this._pathData._mdf) {
                        var L = k.v;
                        this._pathData.r.v && (L = L.reverse()),
                        g = {
                            tLength: 0,
                            segments: []
                        },
                        S = L._length - 1;
                        var V;
                        for (x = 0,
                        p = 0; p < S; p += 1)
                            V = bez.buildBezierData(L.v[p], L.v[p + 1], [L.o[p][0] - L.v[p][0], L.o[p][1] - L.v[p][1]], [L.i[p + 1][0] - L.v[p + 1][0], L.i[p + 1][1] - L.v[p + 1][1]]),
                            g.tLength += V.segmentLength,
                            g.segments.push(V),
                            x += V.segmentLength;
                        p = S,
                        k.v.c && (V = bez.buildBezierData(L.v[p], L.v[0], [L.o[p][0] - L.v[p][0], L.o[p][1] - L.v[p][1]], [L.i[0][0] - L.v[0][0], L.i[0][1] - L.v[0][1]]),
                        g.tLength += V.segmentLength,
                        g.segments.push(V),
                        x += V.segmentLength),
                        this._pathData.pi = g
                    }
                    if (g = this._pathData.pi,
                    v = this._pathData.f.v,
                    f = 0,
                    m = 1,
                    b = 0,
                    u = !0,
                    T = g.segments,
                    v < 0 && k.v.c)
                        for (g.tLength < Math.abs(v) && (v = -Math.abs(v) % g.tLength),
                        f = T.length - 1,
                        _ = T[f].points,
                        m = _.length - 1; v < 0; )
                            v += _[m].partialLength,
                            m -= 1,
                            m < 0 && (f -= 1,
                            _ = T[f].points,
                            m = _.length - 1);
                    _ = T[f].points,
                    y = _[m - 1],
                    d = _[m],
                    C = d.partialLength
                }
                S = c.length,
                o = 0,
                h = 0;
                var O = t.finalSize * 1.2 * .714, R = !0, P, M, E, A, F;
                A = i.length;
                var I, N = -1, $, H, W, B = v, q = f, X = m, U = -1, j, Y, Z, G, z, K, J, tt, it = "", st = this.defaultPropsArray, nt;
                if (t.j === 2 || t.j === 1) {
                    var Q = 0
                      , at = 0
                      , ot = t.j === 2 ? -.5 : -1
                      , et = 0
                      , lt = !0;
                    for (p = 0; p < S; p += 1)
                        if (c[p].n) {
                            for (Q && (Q += at); et < p; )
                                c[et].animatorJustifyOffset = Q,
                                et += 1;
                            Q = 0,
                            lt = !0
                        } else {
                            for (E = 0; E < A; E += 1)
                                P = i[E].a,
                                P.t.propType && (lt && t.j === 2 && (at += P.t.v * ot),
                                M = i[E].s,
                                I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                                I.length ? Q += P.t.v * I[0] * ot : Q += P.t.v * I * ot);
                            lt = !1
                        }
                    for (Q && (Q += at); et < p; )
                        c[et].animatorJustifyOffset = Q,
                        et += 1
                }
                for (p = 0; p < S; p += 1) {
                    if (n.reset(),
                    j = 1,
                    c[p].n)
                        o = 0,
                        h += t.yOffset,
                        h += R ? 1 : 0,
                        v = B,
                        R = !1,
                        this._hasMaskedPath && (f = q,
                        m = X,
                        _ = T[f].points,
                        y = _[m - 1],
                        d = _[m],
                        C = d.partialLength,
                        b = 0),
                        it = "",
                        tt = "",
                        K = "",
                        nt = "",
                        st = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (U !== c[p].line) {
                                switch (t.j) {
                                case 1:
                                    v += x - t.lineWidths[c[p].line];
                                    break;
                                case 2:
                                    v += (x - t.lineWidths[c[p].line]) / 2;
                                    break
                                }
                                U = c[p].line
                            }
                            N !== c[p].ind && (c[N] && (v += c[N].extra),
                            v += c[p].an / 2,
                            N = c[p].ind),
                            v += r[0] * c[p].an * .005;
                            var rt = 0;
                            for (E = 0; E < A; E += 1)
                                P = i[E].a,
                                P.p.propType && (M = i[E].s,
                                I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                                I.length ? rt += P.p.v[0] * I[0] : rt += P.p.v[0] * I),
                                P.a.propType && (M = i[E].s,
                                I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                                I.length ? rt += P.a.v[0] * I[0] : rt += P.a.v[0] * I);
                            for (u = !0,
                            this._pathData.a.v && (v = c[0].an * .5 + (x - this._pathData.f.v - c[0].an * .5 - c[c.length - 1].an * .5) * N / (S - 1),
                            v += this._pathData.f.v); u; )
                                b + C >= v + rt || !_ ? (w = (v + rt - b) / d.partialLength,
                                H = y.point[0] + (d.point[0] - y.point[0]) * w,
                                W = y.point[1] + (d.point[1] - y.point[1]) * w,
                                n.translate(-r[0] * c[p].an * .005, -(r[1] * O) * .01),
                                u = !1) : _ && (b += d.partialLength,
                                m += 1,
                                m >= _.length && (m = 0,
                                f += 1,
                                T[f] ? _ = T[f].points : k.v.c ? (m = 0,
                                f = 0,
                                _ = T[f].points) : (b -= d.partialLength,
                                _ = null)),
                                _ && (y = d,
                                d = _[m],
                                C = d.partialLength));
                            $ = c[p].an / 2 - c[p].add,
                            n.translate(-$, 0, 0)
                        } else
                            $ = c[p].an / 2 - c[p].add,
                            n.translate(-$, 0, 0),
                            n.translate(-r[0] * c[p].an * .005, -r[1] * O * .01, 0);
                        for (E = 0; E < A; E += 1)
                            P = i[E].a,
                            P.t.propType && (M = i[E].s,
                            I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                            (o !== 0 || t.j !== 0) && (this._hasMaskedPath ? I.length ? v += P.t.v * I[0] : v += P.t.v * I : I.length ? o += P.t.v * I[0] : o += P.t.v * I));
                        for (t.strokeWidthAnim && (Z = t.sw || 0),
                        t.strokeColorAnim && (t.sc ? Y = [t.sc[0], t.sc[1], t.sc[2]] : Y = [0, 0, 0]),
                        t.fillColorAnim && t.fc && (G = [t.fc[0], t.fc[1], t.fc[2]]),
                        E = 0; E < A; E += 1)
                            P = i[E].a,
                            P.a.propType && (M = i[E].s,
                            I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                            I.length ? n.translate(-P.a.v[0] * I[0], -P.a.v[1] * I[1], P.a.v[2] * I[2]) : n.translate(-P.a.v[0] * I, -P.a.v[1] * I, P.a.v[2] * I));
                        for (E = 0; E < A; E += 1)
                            P = i[E].a,
                            P.s.propType && (M = i[E].s,
                            I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                            I.length ? n.scale(1 + (P.s.v[0] - 1) * I[0], 1 + (P.s.v[1] - 1) * I[1], 1) : n.scale(1 + (P.s.v[0] - 1) * I, 1 + (P.s.v[1] - 1) * I, 1));
                        for (E = 0; E < A; E += 1) {
                            if (P = i[E].a,
                            M = i[E].s,
                            I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                            P.sk.propType && (I.length ? n.skewFromAxis(-P.sk.v * I[0], P.sa.v * I[1]) : n.skewFromAxis(-P.sk.v * I, P.sa.v * I)),
                            P.r.propType && (I.length ? n.rotateZ(-P.r.v * I[2]) : n.rotateZ(-P.r.v * I)),
                            P.ry.propType && (I.length ? n.rotateY(P.ry.v * I[1]) : n.rotateY(P.ry.v * I)),
                            P.rx.propType && (I.length ? n.rotateX(P.rx.v * I[0]) : n.rotateX(P.rx.v * I)),
                            P.o.propType && (I.length ? j += (P.o.v * I[0] - j) * I[0] : j += (P.o.v * I - j) * I),
                            t.strokeWidthAnim && P.sw.propType && (I.length ? Z += P.sw.v * I[0] : Z += P.sw.v * I),
                            t.strokeColorAnim && P.sc.propType)
                                for (z = 0; z < 3; z += 1)
                                    I.length ? Y[z] += (P.sc.v[z] - Y[z]) * I[0] : Y[z] += (P.sc.v[z] - Y[z]) * I;
                            if (t.fillColorAnim && t.fc) {
                                if (P.fc.propType)
                                    for (z = 0; z < 3; z += 1)
                                        I.length ? G[z] += (P.fc.v[z] - G[z]) * I[0] : G[z] += (P.fc.v[z] - G[z]) * I;
                                P.fh.propType && (I.length ? G = addHueToRGB(G, P.fh.v * I[0]) : G = addHueToRGB(G, P.fh.v * I)),
                                P.fs.propType && (I.length ? G = addSaturationToRGB(G, P.fs.v * I[0]) : G = addSaturationToRGB(G, P.fs.v * I)),
                                P.fb.propType && (I.length ? G = addBrightnessToRGB(G, P.fb.v * I[0]) : G = addBrightnessToRGB(G, P.fb.v * I))
                            }
                        }
                        for (E = 0; E < A; E += 1)
                            P = i[E].a,
                            P.p.propType && (M = i[E].s,
                            I = M.getMult(c[p].anIndexes[E], s.a[E].s.totalChars),
                            this._hasMaskedPath ? I.length ? n.translate(0, P.p.v[1] * I[0], -P.p.v[2] * I[1]) : n.translate(0, P.p.v[1] * I, -P.p.v[2] * I) : I.length ? n.translate(P.p.v[0] * I[0], P.p.v[1] * I[1], -P.p.v[2] * I[2]) : n.translate(P.p.v[0] * I, P.p.v[1] * I, -P.p.v[2] * I));
                        if (t.strokeWidthAnim && (K = Z < 0 ? 0 : Z),
                        t.strokeColorAnim && (J = "rgb(" + Math.round(Y[0] * 255) + "," + Math.round(Y[1] * 255) + "," + Math.round(Y[2] * 255) + ")"),
                        t.fillColorAnim && t.fc && (tt = "rgb(" + Math.round(G[0] * 255) + "," + Math.round(G[1] * 255) + "," + Math.round(G[2] * 255) + ")"),
                        this._hasMaskedPath) {
                            if (n.translate(0, -t.ls),
                            n.translate(0, r[1] * O * .01 + h, 0),
                            this._pathData.p.v) {
                                D = (d.point[1] - y.point[1]) / (d.point[0] - y.point[0]);
                                var ht = Math.atan(D) * 180 / Math.PI;
                                d.point[0] < y.point[0] && (ht += 180),
                                n.rotate(-ht * Math.PI / 180)
                            }
                            n.translate(H, W, 0),
                            v -= r[0] * c[p].an * .005,
                            c[p + 1] && N !== c[p + 1].ind && (v += c[p].an / 2,
                            v += t.tr * .001 * t.finalSize)
                        } else {
                            switch (n.translate(o, h, 0),
                            t.ps && n.translate(t.ps[0], t.ps[1] + t.ascent, 0),
                            t.j) {
                            case 1:
                                n.translate(c[p].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[c[p].line]), 0, 0);
                                break;
                            case 2:
                                n.translate(c[p].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[c[p].line]) / 2, 0, 0);
                                break
                            }
                            n.translate(0, -t.ls),
                            n.translate($, 0, 0),
                            n.translate(r[0] * c[p].an * .005, r[1] * O * .01, 0),
                            o += c[p].l + t.tr * .001 * t.finalSize
                        }
                        a === "html" ? it = n.toCSS() : a === "svg" ? it = n.to2dCSS() : st = [n.props[0], n.props[1], n.props[2], n.props[3], n.props[4], n.props[5], n.props[6], n.props[7], n.props[8], n.props[9], n.props[10], n.props[11], n.props[12], n.props[13], n.props[14], n.props[15]],
                        nt = j
                    }
                    l <= p ? (F = new LetterProps(nt,K,J,tt,it,st),
                    this.renderedLetters.push(F),
                    l += 1,
                    this.lettersChangedFlag = !0) : (F = this.renderedLetters[p],
                    this.lettersChangedFlag = F.update(nt, K, J, tt, it, st) || this.lettersChangedFlag)
                }
            }
        }
        ,
        TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId,
            this.iterateDynamicProperties())
        }
        ,
        TextAnimatorProperty.prototype.mHelper = new Matrix,
        TextAnimatorProperty.prototype.defaultPropsArray = [],
        extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
        function ITextElement() {}
        ITextElement.prototype.initElement = function(t, e, r) {
            this.lettersChangedFlag = !0,
            this.initFrame(),
            this.initBaseData(t, e, r),
            this.textProperty = new TextProperty(this,t.t,this.dynamicProperties),
            this.textAnimator = new TextAnimatorProperty(t.t,this.renderType,this),
            this.initTransform(t, e, r),
            this.initHierarchy(),
            this.initRenderable(),
            this.initRendererElement(),
            this.createContainerElements(),
            this.createRenderableComponents(),
            this.createContent(),
            this.hide(),
            this.textAnimator.searchProperties(this.dynamicProperties)
        }
        ,
        ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1,
            this.prepareRenderableFrame(t),
            this.prepareProperties(t, this.isInRange)
        }
        ,
        ITextElement.prototype.createPathShape = function(t, e) {
            var r, i = e.length, s, n = "";
            for (r = 0; r < i; r += 1)
                e[r].ty === "sh" && (s = e[r].ks.k,
                n += buildShapeString(s, s.i.length, !0, t));
            return n
        }
        ,
        ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e)
        }
        ,
        ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t)
        }
        ,
        ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t)
        }
        ,
        ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r, i, s) {
            switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0),
            e.translate(0, -t.ls, 0),
            t.j) {
            case 1:
                e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                break;
            case 2:
                e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
                break
            }
            e.translate(i, s, 0)
        }
        ,
        ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(t[0] * 255) + "," + Math.round(t[1] * 255) + "," + Math.round(t[2] * 255) + ")"
        }
        ,
        ITextElement.prototype.emptyProp = new LetterProps,
        ITextElement.prototype.destroy = function() {}
        ,
        ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(),
            this.textProperty._isFirstFrame = !1,
            this.textProperty._mdf = !1)
        }
        ;
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r) {
            this.textSpans = [],
            this.renderType = "svg",
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement),
        SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"))
        }
        ,
        SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for (var e = 0, r = t.length, i = [], s = ""; e < r; )
                t[e] === "\r" || t[e] === "" ? (i.push(s),
                s = "") : s += t[e],
                e += 1;
            return i.push(s),
            i
        }
        ,
        SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r = t.shapes[0];
                if (r.it) {
                    var i = r.it[r.it.length - 1];
                    i.s && (i.s.k[0] = e,
                    i.s.k[1] = e)
                }
            }
            return t
        }
        ,
        SVGTextLottieElement.prototype.buildNewText = function() {
            this.addDynamicProperty(this);
            var t, e, r = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r ? r.l.length : 0),
            r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
            r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)),
            this.layerElement.setAttribute("stroke-width", r.sw)),
            this.layerElement.setAttribute("font-size", r.finalSize);
            var i = this.globalData.fontManager.getFontByName(r.f);
            if (i.fClass)
                this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var s = r.fWeight
                  , n = r.fStyle;
                this.layerElement.setAttribute("font-style", n),
                this.layerElement.setAttribute("font-weight", s)
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var a = r.l || []
              , l = !!this.globalData.fontManager.chars;
            e = a.length;
            var o, h = this.mHelper, p = "", S = this.data.singleShape, c = 0, g = 0, v = !0, d = r.tr * .001 * r.finalSize;
            if (S && !l && !r.sz) {
                var b = this.textContainer
                  , u = "start";
                switch (r.j) {
                case 1:
                    u = "end";
                    break;
                case 2:
                    u = "middle";
                    break;
                default:
                    u = "start";
                    break
                }
                b.setAttribute("text-anchor", u),
                b.setAttribute("letter-spacing", d);
                var m = this.buildTextContents(r.finalText);
                for (e = m.length,
                g = r.ps ? r.ps[1] + r.ascent : 0,
                t = 0; t < e; t += 1)
                    o = this.textSpans[t].span || createNS("tspan"),
                    o.textContent = m[t],
                    o.setAttribute("x", 0),
                    o.setAttribute("y", g),
                    o.style.display = "inherit",
                    b.appendChild(o),
                    this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        glyph: null
                    }),
                    this.textSpans[t].span = o,
                    g += r.finalLineHeight;
                this.layerElement.appendChild(b)
            } else {
                var f = this.textSpans.length, y;
                for (t = 0; t < e; t += 1) {
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }),
                    !l || !S || t === 0) {
                        if (o = f > t ? this.textSpans[t].span : createNS(l ? "g" : "text"),
                        f <= t) {
                            if (o.setAttribute("stroke-linecap", "butt"),
                            o.setAttribute("stroke-linejoin", "round"),
                            o.setAttribute("stroke-miterlimit", "4"),
                            this.textSpans[t].span = o,
                            l) {
                                var _ = createNS("g");
                                o.appendChild(_),
                                this.textSpans[t].childSpan = _
                            }
                            this.textSpans[t].span = o,
                            this.layerElement.appendChild(o)
                        }
                        o.style.display = "inherit"
                    }
                    if (h.reset(),
                    S && (a[t].n && (c = -d,
                    g += r.yOffset,
                    g += v ? 1 : 0,
                    v = !1),
                    this.applyTextPropertiesToMatrix(r, h, a[t].line, c, g),
                    c += a[t].l || 0,
                    c += d),
                    l) {
                        y = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily);
                        var T;
                        if (y.t === 1)
                            T = new SVGCompElement(y.data,this.globalData,this);
                        else {
                            var C = emptyShapeData;
                            y.data && y.data.shapes && (C = this.buildShapeData(y.data, r.finalSize)),
                            T = new SVGShapeElement(C,this.globalData,this)
                        }
                        if (this.textSpans[t].glyph) {
                            var x = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(x.layerElement),
                            x.destroy()
                        }
                        this.textSpans[t].glyph = T,
                        T._debug = !0,
                        T.prepareFrame(0),
                        T.renderFrame(),
                        this.textSpans[t].childSpan.appendChild(T.layerElement),
                        y.t === 1 && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")")
                    } else
                        S && o.setAttribute("transform", "translate(" + h.props[12] + "," + h.props[13] + ")"),
                        o.textContent = a[t].val,
                        o.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve")
                }
                S && o && o.setAttribute("d", p)
            }
            for (; t < this.textSpans.length; )
                this.textSpans[t].span.style.display = "none",
                t += 1;
            this._sizeChanged = !0
        }
        ,
        SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st),
            this.renderInnerContent(),
            this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                }
            }
            return this.bbox
        }
        ,
        SVGTextLottieElement.prototype.getValue = function() {
            var t, e = this.textSpans.length, r;
            for (this.renderedFrame = this.comp.renderedFrame,
            t = 0; t < e; t += 1)
                r = this.textSpans[t].glyph,
                r && (r.prepareFrame(this.comp.renderedFrame - this.data.st),
                r._mdf && (this._mdf = !0))
        }
        ,
        SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(),
            (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag),
            this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                this._sizeChanged = !0;
                var t, e, r = this.textAnimator.renderedLetters, i = this.textProperty.currentData.l;
                e = i.length;
                var s, n, a;
                for (t = 0; t < e; t += 1)
                    i[t].n || (s = r[t],
                    n = this.textSpans[t].span,
                    a = this.textSpans[t].glyph,
                    a && a.renderFrame(),
                    s._mdf.m && n.setAttribute("transform", s.m),
                    s._mdf.o && n.setAttribute("opacity", s.o),
                    s._mdf.sw && n.setAttribute("stroke-width", s.sw),
                    s._mdf.sc && n.setAttribute("stroke", s.sc),
                    s._mdf.fc && n.setAttribute("fill", s.fc))
            }
        }
        ;
        function ISolidElement(t, e, r) {
            this.initElement(t, e, r)
        }
        extendPrototype([IImageElement], ISolidElement),
        ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw),
            t.setAttribute("height", this.data.sh),
            t.setAttribute("fill", this.data.sc),
            this.layerElement.appendChild(t)
        }
        ;
        function NullElement(t, e, r) {
            this.initFrame(),
            this.initBaseData(t, e, r),
            this.initFrame(),
            this.initTransform(t, e, r),
            this.initHierarchy()
        }
        NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0)
        }
        ,
        NullElement.prototype.renderFrame = function() {}
        ,
        NullElement.prototype.getBaseElement = function() {
            return null
        }
        ,
        NullElement.prototype.destroy = function() {}
        ,
        NullElement.prototype.sourceRectAtTime = function() {}
        ,
        NullElement.prototype.hide = function() {}
        ,
        extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
        function SVGRendererBase() {}
        extendPrototype([BaseRenderer], SVGRendererBase),
        SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t,this.globalData,this)
        }
        ,
        SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t,this.globalData,this)
        }
        ,
        SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t,this.globalData,this)
        }
        ,
        SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t,this.globalData,this)
        }
        ,
        SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t,this.globalData,this)
        }
        ,
        SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
            this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"),
            this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
            this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w),
            this.svgElement.setAttribute("height", t.h),
            this.svgElement.style.width = "100%",
            this.svgElement.style.height = "100%",
            this.svgElement.style.transform = "translate3d(0,0,0)",
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility),
            this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width),
            this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height),
            this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className),
            this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id),
            this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable),
            this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio),
            this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e),
            this.globalData.progressiveLoad = this.renderConfig.progressiveLoad,
            this.data = t;
            var r = createNS("clipPath")
              , i = createNS("rect");
            i.setAttribute("width", t.w),
            i.setAttribute("height", t.h),
            i.setAttribute("x", 0),
            i.setAttribute("y", 0);
            var s = createElementID();
            r.setAttribute("id", s),
            r.appendChild(i),
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"),
            e.appendChild(r),
            this.layers = t.layers,
            this.elements = createSizedArray(t.layers.length)
        }
        ,
        SVGRendererBase.prototype.destroy = function() {
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""),
            this.layerElement = null,
            this.globalData.defs = null;
            var t, e = this.layers ? this.layers.length : 0;
            for (t = 0; t < e; t += 1)
                this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0,
            this.destroyed = !0,
            this.animationItem = null
        }
        ,
        SVGRendererBase.prototype.updateContainerSize = function() {}
        ,
        SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0
              , r = this.layers.length;
            for (e = 0; e < r; e += 1)
                if (this.layers[e].ind === t)
                    return e;
            return -1
        }
        ,
        SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!(e[t] || this.layers[t].ty === 99)) {
                e[t] = !0;
                var r = this.createItem(this.layers[t]);
                if (e[t] = r,
                getExpressionsPlugin() && (this.layers[t].ty === 0 && this.globalData.projectInterface.registerComposition(r),
                r.initExpressions()),
                this.appendElementInPos(r, t),
                this.layers[t].tt) {
                    var i = "tp"in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (i === -1)
                        return;
                    if (!this.elements[i] || this.elements[i] === !0)
                        this.buildItem(i),
                        this.addPendingElement(r);
                    else {
                        var s = e[i]
                          , n = s.getMatte(this.layers[t].tt);
                        r.setMatte(n)
                    }
                }
            }
        }
        ,
        SVGRendererBase.prototype.checkPendingElements = function() {
            for (; this.pendingElements.length; ) {
                var t = this.pendingElements.pop();
                if (t.checkParenting(),
                t.data.tt)
                    for (var e = 0, r = this.elements.length; e < r; ) {
                        if (this.elements[e] === t) {
                            var i = "tp"in t.data ? this.findIndexByInd(t.data.tp) : e - 1
                              , s = this.elements[i]
                              , n = s.getMatte(this.layers[e].tt);
                            t.setMatte(n);
                            break
                        }
                        e += 1
                    }
            }
        }
        ,
        SVGRendererBase.prototype.renderFrame = function(t) {
            if (!(this.renderedFrame === t || this.destroyed)) {
                t === null ? t = this.renderedFrame : this.renderedFrame = t,
                this.globalData.frameNum = t,
                this.globalData.frameId += 1,
                this.globalData.projectInterface.currentFrame = t,
                this.globalData._mdf = !1;
                var e, r = this.layers.length;
                for (this.completeLayers || this.checkLayers(t),
                e = r - 1; e >= 0; e -= 1)
                    (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf)
                    for (e = 0; e < r; e += 1)
                        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame()
            }
        }
        ,
        SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                for (var i = 0, s; i < e; )
                    this.elements[i] && this.elements[i] !== !0 && this.elements[i].getBaseElement() && (s = this.elements[i].getBaseElement()),
                    i += 1;
                s ? this.layerElement.insertBefore(r, s) : this.layerElement.appendChild(r)
            }
        }
        ,
        SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none"
        }
        ,
        SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block"
        }
        ;
        function ICompElement() {}
        extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement),
        ICompElement.prototype.initElement = function(t, e, r) {
            this.initFrame(),
            this.initBaseData(t, e, r),
            this.initTransform(t, e, r),
            this.initRenderable(),
            this.initHierarchy(),
            this.initRendererElement(),
            this.createContainerElements(),
            this.createRenderableComponents(),
            (this.data.xt || !e.progressiveLoad) && this.buildAllItems(),
            this.hide()
        }
        ,
        ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1,
            this.prepareRenderableFrame(t),
            this.prepareProperties(t, this.isInRange),
            !(!this.isInRange && !this.data.xt)) {
                if (this.tm._placeholder)
                    this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1),
                    this.renderedFrame = e
                }
                var r, i = this.elements.length;
                for (this.completeLayers || this.checkLayers(this.renderedFrame),
                r = i - 1; r >= 0; r -= 1)
                    (this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st),
                    this.elements[r]._mdf && (this._mdf = !0))
            }
        }
        ,
        ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for (t = 0; t < e; t += 1)
                (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame()
        }
        ,
        ICompElement.prototype.setElements = function(t) {
            this.elements = t
        }
        ,
        ICompElement.prototype.getElements = function() {
            return this.elements
        }
        ,
        ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for (t = 0; t < e; t += 1)
                this.elements[t] && this.elements[t].destroy()
        }
        ,
        ICompElement.prototype.destroy = function() {
            this.destroyElements(),
            this.destroyBaseElement()
        }
        ;
        function SVGCompElement(t, e, r) {
            this.layers = t.layers,
            this.supports3d = !0,
            this.completeLayers = !1,
            this.pendingElements = [],
            this.elements = this.layers ? createSizedArray(this.layers.length) : [],
            this.initElement(t, e, r),
            this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }
        }
        extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement),
        SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t,this.globalData,this)
        }
        ;
        function SVGRenderer(t, e) {
            this.animationItem = t,
            this.layers = null,
            this.renderedFrame = -1,
            this.svgElement = createNS("svg");
            var r = "";
            if (e && e.title) {
                var i = createNS("title")
                  , s = createElementID();
                i.setAttribute("id", s),
                i.textContent = e.title,
                this.svgElement.appendChild(i),
                r += s
            }
            if (e && e.description) {
                var n = createNS("desc")
                  , a = createElementID();
                n.setAttribute("id", a),
                n.textContent = e.description,
                this.svgElement.appendChild(n),
                r += " " + a
            }
            r && this.svgElement.setAttribute("aria-labelledby", r);
            var l = createNS("defs");
            this.svgElement.appendChild(l);
            var o = createNS("g");
            this.svgElement.appendChild(o),
            this.layerElement = o,
            this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && e.hideOnTransparent === !1),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || e.runExpressions === void 0 || e.runExpressions
            },
            this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: l,
                renderConfig: this.renderConfig
            },
            this.elements = [],
            this.pendingElements = [],
            this.destroyed = !1,
            this.rendererType = "svg"
        }
        extendPrototype([SVGRendererBase], SVGRenderer),
        SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t,this.globalData,this)
        }
        ;
        function ShapeTransformManager() {
            this.sequences = {},
            this.sequenceList = [],
            this.transform_key_count = 0
        }
        ShapeTransformManager.prototype = {
            addTransformSequence: function(e) {
                var r, i = e.length, s = "_";
                for (r = 0; r < i; r += 1)
                    s += e[r].transform.key + "_";
                var n = this.sequences[s];
                return n || (n = {
                    transforms: [].concat(e),
                    finalTransform: new Matrix,
                    _mdf: !1
                },
                this.sequences[s] = n,
                this.sequenceList.push(n)),
                n
            },
            processSequence: function(e, r) {
                for (var i = 0, s = e.transforms.length, n = r; i < s && !r; ) {
                    if (e.transforms[i].transform.mProps._mdf) {
                        n = !0;
                        break
                    }
                    i += 1
                }
                if (n)
                    for (e.finalTransform.reset(),
                    i = s - 1; i >= 0; i -= 1)
                        e.finalTransform.multiply(e.transforms[i].transform.mProps.v);
                e._mdf = n
            },
            processSequences: function(e) {
                var r, i = this.sequenceList.length;
                for (r = 0; r < i; r += 1)
                    this.processSequence(this.sequenceList[r], e)
            },
            getNewKey: function() {
                return this.transform_key_count += 1,
                "_" + this.transform_key_count
            }
        };
        var lumaLoader = function() {
            var e = "__lottie_element_luma_buffer"
              , r = null
              , i = null
              , s = null;
            function n() {
                var o = createNS("svg")
                  , h = createNS("filter")
                  , p = createNS("feColorMatrix");
                return h.setAttribute("id", e),
                p.setAttribute("type", "matrix"),
                p.setAttribute("color-interpolation-filters", "sRGB"),
                p.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"),
                h.appendChild(p),
                o.appendChild(h),
                o.setAttribute("id", e + "_svg"),
                featureSupport.svgLumaHidden && (o.style.display = "none"),
                o
            }
            function a() {
                r || (s = n(),
                document.body.appendChild(s),
                r = createTag("canvas"),
                i = r.getContext("2d"),
                i.filter = "url(#" + e + ")",
                i.fillStyle = "rgba(0,0,0,0)",
                i.fillRect(0, 0, 1, 1))
            }
            function l(o) {
                return r || a(),
                r.width = o.width,
                r.height = o.height,
                i.filter = "url(#" + e + ")",
                r
            }
            return {
                load: a,
                get: l
            }
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas)
                return new OffscreenCanvas(t,e);
            var r = createTag("canvas");
            return r.width = t,
            r.height = e,
            r
        }
        var assetLoader = function() {
            return {
                loadLumaCanvas: lumaLoader.load,
                getLumaCanvas: lumaLoader.get,
                createCanvas
            }
        }()
          , registeredEffects = {};
        function CVEffects(t) {
            var e, r = t.data.ef ? t.data.ef.length : 0;
            this.filters = [];
            var i;
            for (e = 0; e < r; e += 1) {
                i = null;
                var s = t.data.ef[e].ty;
                if (registeredEffects[s]) {
                    var n = registeredEffects[s].effect;
                    i = new n(t.effectsManager.effectElements[e],t)
                }
                i && this.filters.push(i)
            }
            this.filters.length && t.addRenderableComponent(this)
        }
        CVEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for (e = 0; e < r; e += 1)
                this.filters[e].renderFrame(t)
        }
        ,
        CVEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for (e = 0; e < r; e += 1)
                this.filters[e].type === t && i.push(this.filters[e]);
            return i
        }
        ;
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            }
        }
        function CVMaskElement(t, e) {
            this.data = t,
            this.element = e,
            this.masksProperties = this.data.masksProperties || [],
            this.viewData = createSizedArray(this.masksProperties.length);
            var r, i = this.masksProperties.length, s = !1;
            for (r = 0; r < i; r += 1)
                this.masksProperties[r].mode !== "n" && (s = !0),
                this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
            this.hasMasks = s,
            s && this.element.addRenderableComponent(this)
        }
        CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t = this.element.finalTransform.mat, e = this.element.canvasContext, r, i = this.masksProperties.length, s, n, a;
                for (e.beginPath(),
                r = 0; r < i; r += 1)
                    if (this.masksProperties[r].mode !== "n") {
                        this.masksProperties[r].inv && (e.moveTo(0, 0),
                        e.lineTo(this.element.globalData.compSize.w, 0),
                        e.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h),
                        e.lineTo(0, this.element.globalData.compSize.h),
                        e.lineTo(0, 0)),
                        a = this.viewData[r].v,
                        s = t.applyToPointArray(a.v[0][0], a.v[0][1], 0),
                        e.moveTo(s[0], s[1]);
                        var l, o = a._length;
                        for (l = 1; l < o; l += 1)
                            n = t.applyToTriplePoints(a.o[l - 1], a.i[l], a.v[l]),
                            e.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
                        n = t.applyToTriplePoints(a.o[l - 1], a.i[0], a.v[0]),
                        e.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5])
                    }
                this.element.globalData.renderer.save(!0),
                e.clip()
            }
        }
        ,
        CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty,
        CVMaskElement.prototype.destroy = function() {
            this.element = null
        }
        ;
        function CVBaseElement() {}
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var e = this.globalData.canvasContext
                      , r = assetLoader.createCanvas(e.canvas.width, e.canvas.height);
                    this.buffers.push(r);
                    var i = assetLoader.createCanvas(e.canvas.width, e.canvas.height);
                    this.buffers.push(i),
                    this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas()
                }
                this.canvasContext = this.globalData.canvasContext,
                this.transformCanvas = this.globalData.transformCanvas,
                this.renderableEffectsManager = new CVEffects(this),
                this.searchEffectTransforms()
            },
            createContent: function() {},
            setBlendMode: function() {
                var e = this.globalData;
                if (e.blendMode !== this.data.bm) {
                    e.blendMode = this.data.bm;
                    var r = getBlendMode(this.data.bm);
                    e.canvasContext.globalCompositeOperation = r
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data,this),
                this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT)
            },
            hideElement: function() {
                !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0)
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1,
                this._isFirstFrame = !0,
                this.maskManager._isFirstFrame = !0)
            },
            clearCanvas: function(e) {
                e.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy)
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var e = this.buffers[0]
                      , r = e.getContext("2d");
                    this.clearCanvas(r),
                    r.drawImage(this.canvasContext.canvas, 0, 0),
                    this.currentTransform = this.canvasContext.getTransform(),
                    this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                    this.clearCanvas(this.canvasContext),
                    this.canvasContext.setTransform(this.currentTransform)
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var e = this.buffers[1]
                      , r = e.getContext("2d");
                    this.clearCanvas(r),
                    r.drawImage(this.canvasContext.canvas, 0, 0),
                    this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                    this.clearCanvas(this.canvasContext),
                    this.canvasContext.setTransform(this.currentTransform);
                    var i = this.comp.getElementById("tp"in this.data ? this.data.tp : this.data.ind - 1);
                    if (i.renderFrame(!0),
                    this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                    this.data.tt >= 3 && !document._isProxy) {
                        var s = assetLoader.getLumaCanvas(this.canvasContext.canvas)
                          , n = s.getContext("2d");
                        n.drawImage(this.canvasContext.canvas, 0, 0),
                        this.clearCanvas(this.canvasContext),
                        this.canvasContext.drawImage(s, 0, 0)
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt],
                    this.canvasContext.drawImage(e, 0, 0),
                    this.canvasContext.globalCompositeOperation = "destination-over",
                    this.canvasContext.drawImage(this.buffers[0], 0, 0),
                    this.canvasContext.setTransform(this.currentTransform),
                    this.canvasContext.globalCompositeOperation = "source-over"
                }
            },
            renderFrame: function(e) {
                if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !e)) {
                    this.renderTransform(),
                    this.renderRenderable(),
                    this.renderLocalTransform(),
                    this.setBlendMode();
                    var r = this.data.ty === 0;
                    this.prepareLayer(),
                    this.globalData.renderer.save(r),
                    this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props),
                    this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity),
                    this.renderInnerContent(),
                    this.globalData.renderer.restore(r),
                    this.exitLayer(),
                    this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
                    this._isFirstFrame && (this._isFirstFrame = !1)
                }
            },
            destroy: function() {
                this.canvasContext = null,
                this.data = null,
                this.globalData = null,
                this.maskManager.destroy()
            },
            mHelper: new Matrix
        },
        CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement,
        CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
        function CVShapeData(t, e, r, i) {
            this.styledShapes = [],
            this.tr = [0, 0, 0, 0, 0, 0];
            var s = 4;
            e.ty === "rc" ? s = 5 : e.ty === "el" ? s = 6 : e.ty === "sr" && (s = 7),
            this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t);
            var n, a = r.length, l;
            for (n = 0; n < a; n += 1)
                r[n].closed || (l = {
                    transforms: i.addTransformSequence(r[n].transforms),
                    trNodes: []
                },
                this.styledShapes.push(l),
                r[n].elements.push(l))
        }
        CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
        function CVShapeElement(t, e, r) {
            this.shapes = [],
            this.shapesData = t.shapes,
            this.stylesList = [],
            this.itemsData = [],
            this.prevViewData = [],
            this.shapeModifiers = [],
            this.processedElements = [],
            this.transformsManager = new ShapeTransformManager,
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement),
        CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement,
        CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        },
        CVShapeElement.prototype.dashResetter = [],
        CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, [])
        }
        ,
        CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: t.hd === !0
            }
              , i = {};
            if (t.ty === "fl" || t.ty === "st" ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this),
            i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : (t.ty === "gf" || t.ty === "gs") && (i.s = PropertyFactory.getProp(this, t.s, 1, null, this),
            i.e = PropertyFactory.getProp(this, t.e, 1, null, this),
            i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this),
            i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this),
            i.g = new GradientProperty(this,t.g,this)),
            i.o = PropertyFactory.getProp(this, t.o, 0, .01, this),
            t.ty === "st" || t.ty === "gs") {
                if (r.lc = lineCapEnum[t.lc || 2],
                r.lj = lineJoinEnum[t.lj || 2],
                t.lj == 1 && (r.ml = t.ml),
                i.w = PropertyFactory.getProp(this, t.w, 0, null, this),
                i.w.k || (r.wi = i.w.v),
                t.d) {
                    var s = new DashProperty(this,t.d,"canvas",this);
                    i.d = s,
                    i.d.k || (r.da = i.d.dashArray,
                    r.do = i.d.dashoffset[0])
                }
            } else
                r.r = t.r === 2 ? "evenodd" : "nonzero";
            return this.stylesList.push(r),
            i.style = r,
            i
        }
        ,
        CVShapeElement.prototype.createGroupElement = function() {
            var t = {
                it: [],
                prevViewData: []
            };
            return t
        }
        ,
        CVShapeElement.prototype.createTransformElement = function(t) {
            var e = {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
            return e
        }
        ,
        CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this,t,this.stylesList,this.transformsManager);
            return this.shapes.push(e),
            this.addShapeToModifiers(e),
            e
        }
        ,
        CVShapeElement.prototype.reloadShapes = function() {
            this._isFirstFrame = !0;
            var t, e = this.itemsData.length;
            for (t = 0; t < e; t += 1)
                this.prevViewData[t] = this.itemsData[t];
            for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []),
            e = this.dynamicProperties.length,
            t = 0; t < e; t += 1)
                this.dynamicProperties[t].getValue();
            this.renderModifiers(),
            this.transformsManager.processSequences(this._isFirstFrame)
        }
        ,
        CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r = this.stylesList.length;
            for (e = 0; e < r; e += 1)
                this.stylesList[e].closed || this.stylesList[e].transforms.push(t)
        }
        ,
        CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for (t = 0; t < e; t += 1)
                this.stylesList[t].closed || this.stylesList[t].transforms.pop()
        }
        ,
        CVShapeElement.prototype.closeStyles = function(t) {
            var e, r = t.length;
            for (e = 0; e < r; e += 1)
                t[e].closed = !0
        }
        ,
        CVShapeElement.prototype.searchShapes = function(t, e, r, i, s) {
            var n, a = t.length - 1, l, o, h = [], p = [], S, c, g, v = [].concat(s);
            for (n = a; n >= 0; n -= 1) {
                if (S = this.searchProcessedElement(t[n]),
                S ? e[n] = r[S - 1] : t[n]._shouldRender = i,
                t[n].ty === "fl" || t[n].ty === "st" || t[n].ty === "gf" || t[n].ty === "gs")
                    S ? e[n].style.closed = !1 : e[n] = this.createStyleElement(t[n], v),
                    h.push(e[n].style);
                else if (t[n].ty === "gr") {
                    if (!S)
                        e[n] = this.createGroupElement(t[n]);
                    else
                        for (o = e[n].it.length,
                        l = 0; l < o; l += 1)
                            e[n].prevViewData[l] = e[n].it[l];
                    this.searchShapes(t[n].it, e[n].it, e[n].prevViewData, i, v)
                } else
                    t[n].ty === "tr" ? (S || (g = this.createTransformElement(t[n]),
                    e[n] = g),
                    v.push(e[n]),
                    this.addTransformToStyleList(e[n])) : t[n].ty === "sh" || t[n].ty === "rc" || t[n].ty === "el" || t[n].ty === "sr" ? S || (e[n] = this.createShapeElement(t[n])) : t[n].ty === "tm" || t[n].ty === "rd" || t[n].ty === "pb" || t[n].ty === "zz" || t[n].ty === "op" ? (S ? (c = e[n],
                    c.closed = !1) : (c = ShapeModifiers.getModifier(t[n].ty),
                    c.init(this, t[n]),
                    e[n] = c,
                    this.shapeModifiers.push(c)),
                    p.push(c)) : t[n].ty === "rp" && (S ? (c = e[n],
                    c.closed = !0) : (c = ShapeModifiers.getModifier(t[n].ty),
                    e[n] = c,
                    c.init(this, t, n, e),
                    this.shapeModifiers.push(c),
                    i = !1),
                    p.push(c));
                this.addProcessedElement(t[n], n + 1)
            }
            for (this.removeTransformFromStyleList(),
            this.closeStyles(h),
            a = p.length,
            n = 0; n < a; n += 1)
                p[n].closed = !0
        }
        ,
        CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1,
            this.transformHelper._opMdf = !1,
            this.renderModifiers(),
            this.transformsManager.processSequences(this._isFirstFrame),
            this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0)
        }
        ,
        CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity,
            e.opacity *= e.op.v,
            e._opMdf = !0)
        }
        ,
        CVShapeElement.prototype.drawLayer = function() {
            var t, e = this.stylesList.length, r, i, s, n, a, l, o = this.globalData.renderer, h = this.globalData.canvasContext, p, S;
            for (t = 0; t < e; t += 1)
                if (S = this.stylesList[t],
                p = S.type,
                !((p === "st" || p === "gs") && S.wi === 0 || !S.data._shouldRender || S.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                    for (o.save(),
                    a = S.elements,
                    p === "st" || p === "gs" ? (o.ctxStrokeStyle(p === "st" ? S.co : S.grd),
                    o.ctxLineWidth(S.wi),
                    o.ctxLineCap(S.lc),
                    o.ctxLineJoin(S.lj),
                    o.ctxMiterLimit(S.ml || 0)) : o.ctxFillStyle(p === "fl" ? S.co : S.grd),
                    o.ctxOpacity(S.coOp),
                    p !== "st" && p !== "gs" && h.beginPath(),
                    o.ctxTransform(S.preTransforms.finalTransform.props),
                    i = a.length,
                    r = 0; r < i; r += 1) {
                        for ((p === "st" || p === "gs") && (h.beginPath(),
                        S.da && (h.setLineDash(S.da),
                        h.lineDashOffset = S.do)),
                        l = a[r].trNodes,
                        n = l.length,
                        s = 0; s < n; s += 1)
                            l[s].t === "m" ? h.moveTo(l[s].p[0], l[s].p[1]) : l[s].t === "c" ? h.bezierCurveTo(l[s].pts[0], l[s].pts[1], l[s].pts[2], l[s].pts[3], l[s].pts[4], l[s].pts[5]) : h.closePath();
                        (p === "st" || p === "gs") && (o.ctxStroke(),
                        S.da && h.setLineDash(this.dashResetter))
                    }
                    p !== "st" && p !== "gs" && this.globalData.renderer.ctxFill(S.r),
                    o.restore()
                }
        }
        ,
        CVShapeElement.prototype.renderShape = function(t, e, r, i) {
            var s, n = e.length - 1, a;
            for (a = t,
            s = n; s >= 0; s -= 1)
                e[s].ty === "tr" ? (a = r[s].transform,
                this.renderShapeTransform(t, a)) : e[s].ty === "sh" || e[s].ty === "el" || e[s].ty === "rc" || e[s].ty === "sr" ? this.renderPath(e[s], r[s]) : e[s].ty === "fl" ? this.renderFill(e[s], r[s], a) : e[s].ty === "st" ? this.renderStroke(e[s], r[s], a) : e[s].ty === "gf" || e[s].ty === "gs" ? this.renderGradientFill(e[s], r[s], a) : e[s].ty === "gr" ? this.renderShape(a, e[s].it, r[s].it) : e[s].ty;
            i && this.drawLayer()
        }
        ,
        CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r = t.trNodes, i = e.paths, s, n, a, l = i._length;
                r.length = 0;
                var o = t.transforms.finalTransform;
                for (a = 0; a < l; a += 1) {
                    var h = i.shapes[a];
                    if (h && h.v) {
                        for (n = h._length,
                        s = 1; s < n; s += 1)
                            s === 1 && r.push({
                                t: "m",
                                p: o.applyToPointArray(h.v[0][0], h.v[0][1], 0)
                            }),
                            r.push({
                                t: "c",
                                pts: o.applyToTriplePoints(h.o[s - 1], h.i[s], h.v[s])
                            });
                        n === 1 && r.push({
                            t: "m",
                            p: o.applyToPointArray(h.v[0][0], h.v[0][1], 0)
                        }),
                        h.c && n && (r.push({
                            t: "c",
                            pts: o.applyToTriplePoints(h.o[s - 1], h.i[0], h.v[0])
                        }),
                        r.push({
                            t: "z"
                        }))
                    }
                }
                t.trNodes = r
            }
        }
        ,
        CVShapeElement.prototype.renderPath = function(t, e) {
            if (t.hd !== !0 && t._shouldRender) {
                var r, i = e.styledShapes.length;
                for (r = 0; r < i; r += 1)
                    this.renderStyledShape(e.styledShapes[r], e.sh)
            }
        }
        ,
        CVShapeElement.prototype.renderFill = function(t, e, r) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"),
            (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity)
        }
        ,
        CVShapeElement.prototype.renderGradientFill = function(t, e, r) {
            var i = e.style, s;
            if (!i.grd || e.g._mdf || e.s._mdf || e.e._mdf || t.t !== 1 && (e.h._mdf || e.a._mdf)) {
                var n = this.globalData.canvasContext
                  , a = e.s.v
                  , l = e.e.v;
                if (t.t === 1)
                    s = n.createLinearGradient(a[0], a[1], l[0], l[1]);
                else {
                    var o = Math.sqrt(Math.pow(a[0] - l[0], 2) + Math.pow(a[1] - l[1], 2))
                      , h = Math.atan2(l[1] - a[1], l[0] - a[0])
                      , p = e.h.v;
                    p >= 1 ? p = .99 : p <= -1 && (p = -.99);
                    var S = o * p
                      , c = Math.cos(h + e.a.v) * S + a[0]
                      , g = Math.sin(h + e.a.v) * S + a[1];
                    s = n.createRadialGradient(c, g, 0, a[0], a[1], o)
                }
                var v, d = t.g.p, b = e.g.c, u = 1;
                for (v = 0; v < d; v += 1)
                    e.g._hasOpacity && e.g._collapsable && (u = e.g.o[v * 2 + 1]),
                    s.addColorStop(b[v * 4] / 100, "rgba(" + b[v * 4 + 1] + "," + b[v * 4 + 2] + "," + b[v * 4 + 3] + "," + u + ")");
                i.grd = s
            }
            i.coOp = e.o.v * r.opacity
        }
        ,
        CVShapeElement.prototype.renderStroke = function(t, e, r) {
            var i = e.style
              , s = e.d;
            s && (s._mdf || this._isFirstFrame) && (i.da = s.dashArray,
            i.do = s.dashoffset[0]),
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"),
            (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity),
            (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v)
        }
        ,
        CVShapeElement.prototype.destroy = function() {
            this.shapesData = null,
            this.globalData = null,
            this.canvasContext = null,
            this.stylesList.length = 0,
            this.itemsData.length = 0
        }
        ;
        function CVTextElement(t, e, r) {
            this.textSpans = [],
            this.yOffset = 0,
            this.fillColorAnim = !1,
            this.strokeColorAnim = !1,
            this.strokeWidthAnim = !1,
            this.stroke = !1,
            this.fill = !1,
            this.justifyOffset = 0,
            this.currentRender = null,
            this.renderType = "canvas",
            this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            },
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement),
        CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"),
        CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0,
            this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)",
            this.fill = e;
            var r = !1;
            t.sc && (r = !0,
            this.values.stroke = this.buildColor(t.sc),
            this.values.sWidth = t.sw);
            var i = this.globalData.fontManager.getFontByName(t.f), s, n, a = t.l, l = this.mHelper;
            this.stroke = r,
            this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily,
            n = t.finalText.length;
            var o, h, p, S, c, g, v, d, b, u, m = this.data.singleShape, f = t.tr * .001 * t.finalSize, y = 0, _ = 0, T = !0, C = 0;
            for (s = 0; s < n; s += 1) {
                o = this.globalData.fontManager.getCharData(t.finalText[s], i.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily),
                h = o && o.data || {},
                l.reset(),
                m && a[s].n && (y = -f,
                _ += t.yOffset,
                _ += T ? 1 : 0,
                T = !1),
                c = h.shapes ? h.shapes[0].it : [],
                v = c.length,
                l.scale(t.finalSize / 100, t.finalSize / 100),
                m && this.applyTextPropertiesToMatrix(t, l, a[s].line, y, _),
                b = createSizedArray(v - 1);
                var x = 0;
                for (g = 0; g < v; g += 1)
                    if (c[g].ty === "sh") {
                        for (S = c[g].ks.k.i.length,
                        d = c[g].ks.k,
                        u = [],
                        p = 1; p < S; p += 1)
                            p === 1 && u.push(l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)),
                            u.push(l.applyToX(d.o[p - 1][0], d.o[p - 1][1], 0), l.applyToY(d.o[p - 1][0], d.o[p - 1][1], 0), l.applyToX(d.i[p][0], d.i[p][1], 0), l.applyToY(d.i[p][0], d.i[p][1], 0), l.applyToX(d.v[p][0], d.v[p][1], 0), l.applyToY(d.v[p][0], d.v[p][1], 0));
                        u.push(l.applyToX(d.o[p - 1][0], d.o[p - 1][1], 0), l.applyToY(d.o[p - 1][0], d.o[p - 1][1], 0), l.applyToX(d.i[0][0], d.i[0][1], 0), l.applyToY(d.i[0][0], d.i[0][1], 0), l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)),
                        b[x] = u,
                        x += 1
                    }
                m && (y += a[s].l,
                y += f),
                this.textSpans[C] ? this.textSpans[C].elem = b : this.textSpans[C] = {
                    elem: b
                },
                C += 1
            }
        }
        ,
        CVTextElement.prototype.renderInnerContent = function() {
            this.validateText();
            var t = this.canvasContext;
            t.font = this.values.fValue,
            this.globalData.renderer.ctxLineCap("butt"),
            this.globalData.renderer.ctxLineJoin("miter"),
            this.globalData.renderer.ctxMiterLimit(4),
            this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var e, r, i, s, n, a, l = this.textAnimator.renderedLetters, o = this.textProperty.currentData.l;
            r = o.length;
            var h, p = null, S = null, c = null, g, v, d = this.globalData.renderer;
            for (e = 0; e < r; e += 1)
                if (!o[e].n) {
                    if (h = l[e],
                    h && (d.save(),
                    d.ctxTransform(h.p),
                    d.ctxOpacity(h.o)),
                    this.fill) {
                        for (h && h.fc ? p !== h.fc && (d.ctxFillStyle(h.fc),
                        p = h.fc) : p !== this.values.fill && (p = this.values.fill,
                        d.ctxFillStyle(this.values.fill)),
                        g = this.textSpans[e].elem,
                        s = g.length,
                        this.globalData.canvasContext.beginPath(),
                        i = 0; i < s; i += 1)
                            for (v = g[i],
                            a = v.length,
                            this.globalData.canvasContext.moveTo(v[0], v[1]),
                            n = 2; n < a; n += 6)
                                this.globalData.canvasContext.bezierCurveTo(v[n], v[n + 1], v[n + 2], v[n + 3], v[n + 4], v[n + 5]);
                        this.globalData.canvasContext.closePath(),
                        d.ctxFill()
                    }
                    if (this.stroke) {
                        for (h && h.sw ? c !== h.sw && (c = h.sw,
                        d.ctxLineWidth(h.sw)) : c !== this.values.sWidth && (c = this.values.sWidth,
                        d.ctxLineWidth(this.values.sWidth)),
                        h && h.sc ? S !== h.sc && (S = h.sc,
                        d.ctxStrokeStyle(h.sc)) : S !== this.values.stroke && (S = this.values.stroke,
                        d.ctxStrokeStyle(this.values.stroke)),
                        g = this.textSpans[e].elem,
                        s = g.length,
                        this.globalData.canvasContext.beginPath(),
                        i = 0; i < s; i += 1)
                            for (v = g[i],
                            a = v.length,
                            this.globalData.canvasContext.moveTo(v[0], v[1]),
                            n = 2; n < a; n += 6)
                                this.globalData.canvasContext.bezierCurveTo(v[n], v[n + 1], v[n + 2], v[n + 3], v[n + 4], v[n + 5]);
                        this.globalData.canvasContext.closePath(),
                        d.ctxStroke()
                    }
                    h && this.globalData.renderer.restore()
                }
        }
        ;
        function CVImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId),
            this.img = e.imageLoader.getAsset(this.assetData),
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement),
        CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement,
        CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame,
        CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w,
                t.height = this.assetData.h;
                var e = t.getContext("2d"), r = this.img.width, i = this.img.height, s = r / i, n = this.assetData.w / this.assetData.h, a, l, o = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                s > n && o === "xMidYMid slice" || s < n && o !== "xMidYMid slice" ? (l = i,
                a = l * n) : (a = r,
                l = a / n),
                e.drawImage(this.img, (r - a) / 2, (i - l) / 2, a, l, 0, 0, this.assetData.w, this.assetData.h),
                this.img = t
            }
        }
        ,
        CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0)
        }
        ,
        CVImageElement.prototype.destroy = function() {
            this.img = null
        }
        ;
        function CVSolidElement(t, e, r) {
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement),
        CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement,
        CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame,
        CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc),
            this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh)
        }
        ;
        function CanvasRendererBase() {}
        extendPrototype([BaseRenderer], CanvasRendererBase),
        CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t,this.globalData,this)
        }
        ,
        CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t,this.globalData,this)
        }
        ,
        CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t,this.globalData,this)
        }
        ,
        CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t,this.globalData,this)
        }
        ,
        CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull,
        CanvasRendererBase.prototype.ctxTransform = function(t) {
            t[0] === 1 && t[1] === 0 && t[4] === 0 && t[5] === 1 && t[12] === 0 && t[13] === 0 || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13])
        }
        ,
        CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t
        }
        ,
        CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t
        }
        ,
        CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t
        }
        ,
        CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t
        }
        ,
        CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t
        }
        ,
        CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t
        }
        ,
        CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t
        }
        ,
        CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t)
        }
        ,
        CanvasRendererBase.prototype.ctxFillRect = function(t, e, r, i) {
            this.canvasContext.fillRect(t, e, r, i)
        }
        ,
        CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke()
        }
        ,
        CanvasRendererBase.prototype.reset = function() {
            if (!this.renderConfig.clearCanvas) {
                this.canvasContext.restore();
                return
            }
            this.contextData.reset()
        }
        ,
        CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save()
        }
        ,
        CanvasRendererBase.prototype.restore = function(t) {
            if (!this.renderConfig.clearCanvas) {
                this.canvasContext.restore();
                return
            }
            t && (this.globalData.blendMode = "source-over"),
            this.contextData.restore(t)
        }
        ,
        CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%",
                e.height = "100%";
                var r = "0px 0px 0px";
                e.transformOrigin = r,
                e.mozTransformOrigin = r,
                e.webkitTransformOrigin = r,
                e["-webkit-transform"] = r,
                e.contentVisibility = this.renderConfig.contentVisibility,
                this.animationItem.wrapper.appendChild(this.animationItem.container),
                this.canvasContext = this.animationItem.container.getContext("2d"),
                this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className),
                this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id)
            } else
                this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext),
            this.data = t,
            this.layers = t.layers,
            this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            },
            this.setupGlobalData(t, document.body),
            this.globalData.canvasContext = this.canvasContext,
            this.globalData.renderer = this,
            this.globalData.isDashed = !1,
            this.globalData.progressiveLoad = this.renderConfig.progressiveLoad,
            this.globalData.transformCanvas = this.transformCanvas,
            this.elements = createSizedArray(t.layers.length),
            this.updateContainerSize()
        }
        ,
        CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            this.reset();
            var r, i;
            t ? (r = t,
            i = e,
            this.canvasContext.canvas.width = r,
            this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth,
            i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width,
            i = this.canvasContext.canvas.height),
            this.canvasContext.canvas.width = r * this.renderConfig.dpr,
            this.canvasContext.canvas.height = i * this.renderConfig.dpr);
            var s, n;
            if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
                var a = this.renderConfig.preserveAspectRatio.split(" ")
                  , l = a[1] || "meet"
                  , o = a[0] || "xMidYMid"
                  , h = o.substr(0, 4)
                  , p = o.substr(4);
                s = r / i,
                n = this.transformCanvas.w / this.transformCanvas.h,
                n > s && l === "meet" || n < s && l === "slice" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr),
                this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr),
                this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)),
                h === "xMid" && (n < s && l === "meet" || n > s && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : h === "xMax" && (n < s && l === "meet" || n > s && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0,
                p === "YMid" && (n > s && l === "meet" || n < s && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : p === "YMax" && (n > s && l === "meet" || n < s && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0
            } else
                this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr),
                this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr),
                this.transformCanvas.tx = 0,
                this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr,
                this.transformCanvas.sy = this.renderConfig.dpr,
                this.transformCanvas.tx = 0,
                this.transformCanvas.ty = 0);
            this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1],
            this.ctxTransform(this.transformCanvas.props),
            this.canvasContext.beginPath(),
            this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h),
            this.canvasContext.closePath(),
            this.canvasContext.clip(),
            this.renderFrame(this.renderedFrame, !0)
        }
        ,
        CanvasRendererBase.prototype.destroy = function() {
            this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
            var t, e = this.layers ? this.layers.length : 0;
            for (t = e - 1; t >= 0; t -= 1)
                this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0,
            this.globalData.canvasContext = null,
            this.animationItem.container = null,
            this.destroyed = !0
        }
        ,
        CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if (!(this.renderedFrame === t && this.renderConfig.clearCanvas === !0 && !e || this.destroyed || t === -1)) {
                this.renderedFrame = t,
                this.globalData.frameNum = t - this.animationItem._isFirstFrame,
                this.globalData.frameId += 1,
                this.globalData._mdf = !this.renderConfig.clearCanvas || e,
                this.globalData.projectInterface.currentFrame = t;
                var r, i = this.layers.length;
                for (this.completeLayers || this.checkLayers(t),
                r = i - 1; r >= 0; r -= 1)
                    (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                if (this.globalData._mdf) {
                    for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(),
                    r = i - 1; r >= 0; r -= 1)
                        (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                    this.renderConfig.clearCanvas !== !0 && this.restore()
                }
            }
        }
        ,
        CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!(e[t] || this.layers[t].ty === 99)) {
                var r = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r,
                r.initExpressions()
            }
        }
        ,
        CanvasRendererBase.prototype.checkPendingElements = function() {
            for (; this.pendingElements.length; ) {
                var t = this.pendingElements.pop();
                t.checkParenting()
            }
        }
        ,
        CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none"
        }
        ,
        CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block"
        }
        ;
        function CanvasContext() {
            this.opacity = -1,
            this.transform = createTypedArray("float32", 16),
            this.fillStyle = "",
            this.strokeStyle = "",
            this.lineWidth = "",
            this.lineCap = "",
            this.lineJoin = "",
            this.miterLimit = "",
            this.id = Math.random()
        }
        function CVContextData() {
            this.stack = [],
            this.cArrPos = 0,
            this.cTr = new Matrix;
            var t, e = 15;
            for (t = 0; t < e; t += 1) {
                var r = new CanvasContext;
                this.stack[t] = r
            }
            this._length = e,
            this.nativeContext = null,
            this.transformMat = new Matrix,
            this.currentOpacity = 1,
            this.currentFillStyle = "",
            this.appliedFillStyle = "",
            this.currentStrokeStyle = "",
            this.appliedStrokeStyle = "",
            this.currentLineWidth = "",
            this.appliedLineWidth = "",
            this.currentLineCap = "",
            this.appliedLineCap = "",
            this.currentLineJoin = "",
            this.appliedLineJoin = "",
            this.appliedMiterLimit = "",
            this.currentMiterLimit = ""
        }
        CVContextData.prototype.duplicate = function() {
            var t = this._length * 2
              , e = 0;
            for (e = this._length; e < t; e += 1)
                this.stack[e] = new CanvasContext;
            this._length = t
        }
        ,
        CVContextData.prototype.reset = function() {
            this.cArrPos = 0,
            this.cTr.reset(),
            this.stack[this.cArrPos].opacity = 1
        }
        ,
        CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e = this.stack[this.cArrPos], r = e.transform, i, s = this.cTr.props;
            for (i = 0; i < 16; i += 1)
                s[i] = r[i];
            if (t) {
                this.nativeContext.restore();
                var n = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = n.fillStyle,
                this.appliedStrokeStyle = n.strokeStyle,
                this.appliedLineWidth = n.lineWidth,
                this.appliedLineCap = n.lineCap,
                this.appliedLineJoin = n.lineJoin,
                this.appliedMiterLimit = n.miterLimit
            }
            this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
            (t || e.opacity !== -1 && this.currentOpacity !== e.opacity) && (this.nativeContext.globalAlpha = e.opacity,
            this.currentOpacity = e.opacity),
            this.currentFillStyle = e.fillStyle,
            this.currentStrokeStyle = e.strokeStyle,
            this.currentLineWidth = e.lineWidth,
            this.currentLineCap = e.lineCap,
            this.currentLineJoin = e.lineJoin,
            this.currentMiterLimit = e.miterLimit
        }
        ,
        CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r = this.stack[this.cArrPos], i;
            for (i = 0; i < 16; i += 1)
                r.transform[i] = e[i];
            this.cArrPos += 1;
            var s = this.stack[this.cArrPos];
            s.opacity = r.opacity,
            s.fillStyle = r.fillStyle,
            s.strokeStyle = r.strokeStyle,
            s.lineWidth = r.lineWidth,
            s.lineCap = r.lineCap,
            s.lineJoin = r.lineJoin,
            s.miterLimit = r.miterLimit
        }
        ,
        CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t
        }
        ,
        CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t
        }
        ,
        CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t,
            this.stack[this.cArrPos].fillStyle = t)
        }
        ,
        CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t,
            this.stack[this.cArrPos].strokeStyle = t)
        }
        ,
        CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t,
            this.stack[this.cArrPos].lineWidth = t)
        }
        ,
        CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t,
            this.stack[this.cArrPos].lineCap = t)
        }
        ,
        CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t,
            this.stack[this.cArrPos].lineJoin = t)
        }
        ,
        CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t,
            this.stack[this.cArrPos].miterLimit = t)
        }
        ,
        CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e),
            e.cloneFromProps(this.transformMat.props);
            var r = e.props;
            this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13])
        }
        ,
        CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t,
            this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t,
            this.currentOpacity = t),
            this.stack[this.cArrPos].opacity = e)
        }
        ,
        CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle,
            this.nativeContext.fillStyle = this.appliedFillStyle),
            this.nativeContext.fill(t)
        }
        ,
        CVContextData.prototype.fillRect = function(t, e, r, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle,
            this.nativeContext.fillStyle = this.appliedFillStyle),
            this.nativeContext.fillRect(t, e, r, i)
        }
        ,
        CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle,
            this.nativeContext.strokeStyle = this.appliedStrokeStyle),
            this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth,
            this.nativeContext.lineWidth = this.appliedLineWidth),
            this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap,
            this.nativeContext.lineCap = this.appliedLineCap),
            this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin,
            this.nativeContext.lineJoin = this.appliedLineJoin),
            this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit,
            this.nativeContext.miterLimit = this.appliedMiterLimit),
            this.nativeContext.stroke()
        }
        ;
        function CVCompElement(t, e, r) {
            this.completeLayers = !1,
            this.layers = t.layers,
            this.pendingElements = [],
            this.elements = createSizedArray(this.layers.length),
            this.initElement(t, e, r),
            this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }
        }
        extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement),
        CVCompElement.prototype.renderInnerContent = function() {
            var t = this.canvasContext;
            t.beginPath(),
            t.moveTo(0, 0),
            t.lineTo(this.data.w, 0),
            t.lineTo(this.data.w, this.data.h),
            t.lineTo(0, this.data.h),
            t.lineTo(0, 0),
            t.clip();
            var e, r = this.layers.length;
            for (e = r - 1; e >= 0; e -= 1)
                (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame()
        }
        ,
        CVCompElement.prototype.destroy = function() {
            var t, e = this.layers.length;
            for (t = e - 1; t >= 0; t -= 1)
                this.elements[t] && this.elements[t].destroy();
            this.layers = null,
            this.elements = null
        }
        ,
        CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t,this.globalData,this)
        }
        ;
        function CanvasRenderer(t, e) {
            this.animationItem = t,
            this.renderConfig = {
                clearCanvas: e && e.clearCanvas !== void 0 ? e.clearCanvas : !0,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || e.runExpressions === void 0 || e.runExpressions
            },
            this.renderConfig.dpr = e && e.dpr || 1,
            this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1),
            this.renderedFrame = -1,
            this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            },
            this.contextData = new CVContextData,
            this.elements = [],
            this.pendingElements = [],
            this.transformMat = new Matrix,
            this.completeLayers = !1,
            this.rendererType = "canvas",
            this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData),
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData),
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData),
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData),
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData),
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData),
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData),
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData),
            this.ctxFill = this.contextData.fill.bind(this.contextData),
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData),
            this.ctxStroke = this.contextData.stroke.bind(this.contextData),
            this.save = this.contextData.save.bind(this.contextData))
        }
        extendPrototype([CanvasRendererBase], CanvasRenderer),
        CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t,this.globalData,this)
        }
        ;
        function HBaseElement() {}
        HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"),
                this.data.hasMask ? (this.svgElement = createNS("svg"),
                this.layerElement = createNS("g"),
                this.maskedElement = this.layerElement,
                this.svgElement.appendChild(this.layerElement),
                this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement,
                styleDiv(this.baseElement)
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this),
                this.transformedElement = this.baseElement,
                this.maskedElement = this.layerElement,
                this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
                this.data.cl && this.layerElement.setAttribute("class", this.data.cl),
                this.data.bm !== 0 && this.setBlendMode()
            },
            renderElement: function() {
                var e = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var r = this.finalTransform.mat.toCSS();
                    e.transform = r,
                    e.webkitTransform = r
                }
                this.finalTransform._opMdf && (e.opacity = this.finalTransform.mProp.o.v)
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(),
                this.renderRenderable(),
                this.renderElement(),
                this.renderInnerContent(),
                this._isFirstFrame && (this._isFirstFrame = !1))
            },
            destroy: function() {
                this.layerElement = null,
                this.transformedElement = null,
                this.matteElement && (this.matteElement = null),
                this.maskManager && (this.maskManager.destroy(),
                this.maskManager = null)
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data,this,this.globalData)
            },
            addEffects: function() {},
            setMatte: function() {}
        },
        HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement,
        HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy,
        HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
        function HSolidElement(t, e, r) {
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement),
        HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? (t = createNS("rect"),
            t.setAttribute("width", this.data.sw),
            t.setAttribute("height", this.data.sh),
            t.setAttribute("fill", this.data.sc),
            this.svgElement.setAttribute("width", this.data.sw),
            this.svgElement.setAttribute("height", this.data.sh)) : (t = createTag("div"),
            t.style.width = this.data.sw + "px",
            t.style.height = this.data.sh + "px",
            t.style.backgroundColor = this.data.sc),
            this.layerElement.appendChild(t)
        }
        ;
        function HShapeElement(t, e, r) {
            this.shapes = [],
            this.shapesData = t.shapes,
            this.stylesList = [],
            this.shapeModifiers = [],
            this.itemsData = [],
            this.processedElements = [],
            this.animatedContents = [],
            this.shapesContainer = createNS("g"),
            this.initElement(t, e, r),
            this.prevViewData = [],
            this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }
        }
        extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement),
        HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent,
        HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0,
            this.data.hasMask)
                this.layerElement.appendChild(this.shapesContainer),
                t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w),
                t.setAttribute("height", e.h),
                t.appendChild(this.shapesContainer),
                this.layerElement.appendChild(t)
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0),
            this.filterUniqueShapes(),
            this.shapeCont = t
        }
        ,
        HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r, i = t.length;
            for (r = 0; r < i; r += 1)
                e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e
        }
        ,
        HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r = t.sh.v, i = t.transformers, s, n = r._length, a, l, o, h;
            if (!(n <= 1)) {
                for (s = 0; s < n - 1; s += 1)
                    a = this.getTransformedPoint(i, r.v[s]),
                    l = this.getTransformedPoint(i, r.o[s]),
                    o = this.getTransformedPoint(i, r.i[s + 1]),
                    h = this.getTransformedPoint(i, r.v[s + 1]),
                    this.checkBounds(a, l, o, h, e);
                r.c && (a = this.getTransformedPoint(i, r.v[s]),
                l = this.getTransformedPoint(i, r.o[s]),
                o = this.getTransformedPoint(i, r.i[0]),
                h = this.getTransformedPoint(i, r.v[0]),
                this.checkBounds(a, l, o, h, e))
            }
        }
        ,
        HShapeElement.prototype.checkBounds = function(t, e, r, i, s) {
            this.getBoundsOfCurve(t, e, r, i);
            var n = this.shapeBoundingBox;
            s.x = bmMin(n.left, s.x),
            s.xMax = bmMax(n.right, s.xMax),
            s.y = bmMin(n.top, s.y),
            s.yMax = bmMax(n.bottom, s.yMax)
        }
        ,
        HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        },
        HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        },
        HShapeElement.prototype.getBoundsOfCurve = function(t, e, r, i) {
            for (var s = [[t[0], i[0]], [t[1], i[1]]], n, a, l, o, h, p, S, c = 0; c < 2; ++c)
                a = 6 * t[c] - 12 * e[c] + 6 * r[c],
                n = -3 * t[c] + 9 * e[c] - 9 * r[c] + 3 * i[c],
                l = 3 * e[c] - 3 * t[c],
                a |= 0,
                n |= 0,
                l |= 0,
                n === 0 && a === 0 || (n === 0 ? (o = -l / a,
                o > 0 && o < 1 && s[c].push(this.calculateF(o, t, e, r, i, c))) : (h = a * a - 4 * l * n,
                h >= 0 && (p = (-a + bmSqrt(h)) / (2 * n),
                p > 0 && p < 1 && s[c].push(this.calculateF(p, t, e, r, i, c)),
                S = (-a - bmSqrt(h)) / (2 * n),
                S > 0 && S < 1 && s[c].push(this.calculateF(S, t, e, r, i, c)))));
            this.shapeBoundingBox.left = bmMin.apply(null, s[0]),
            this.shapeBoundingBox.top = bmMin.apply(null, s[1]),
            this.shapeBoundingBox.right = bmMax.apply(null, s[0]),
            this.shapeBoundingBox.bottom = bmMax.apply(null, s[1])
        }
        ,
        HShapeElement.prototype.calculateF = function(t, e, r, i, s, n) {
            return bmPow(1 - t, 3) * e[n] + 3 * bmPow(1 - t, 2) * t * r[n] + 3 * (1 - t) * bmPow(t, 2) * i[n] + bmPow(t, 3) * s[n]
        }
        ,
        HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r, i = t.length;
            for (r = 0; r < i; r += 1)
                t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e)
        }
        ,
        HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r = 0;
            if (t.keyframes) {
                for (var i = 0; i < t.keyframes.length; i += 1) {
                    var s = t.keyframes[i].s;
                    s > r && (r = s)
                }
                r *= t.mult
            } else
                r = t.v * t.mult;
            e.x -= r,
            e.xMax += r,
            e.y -= r,
            e.yMax += r
        }
        ,
        HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height
        }
        ,
        HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(),
            !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox
                  , e = 999999;
                if (t.x = e,
                t.xMax = -e,
                t.y = e,
                t.yMax = -e,
                this.calculateBoundingBox(this.itemsData, t),
                t.width = t.xMax < t.x ? 0 : t.xMax - t.x,
                t.height = t.yMax < t.y ? 0 : t.yMax - t.y,
                this.currentBoxContains(t))
                    return;
                var r = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width,
                this.shapeCont.setAttribute("width", t.width),
                r = !0),
                this.currentBBox.h !== t.height && (this.currentBBox.h = t.height,
                this.shapeCont.setAttribute("height", t.height),
                r = !0),
                r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width,
                    this.currentBBox.h = t.height,
                    this.currentBBox.x = t.x,
                    this.currentBBox.y = t.y,
                    this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style
                      , s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = s,
                    i.webkitTransform = s
                }
            }
        }
        ;
        function HTextElement(t, e, r) {
            this.textSpans = [],
            this.textPaths = [],
            this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            },
            this.renderType = "svg",
            this.isMasked = !1,
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement),
        HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(),
            this.isMasked) {
                this.renderType = "svg",
                this.compW = this.comp.data.w,
                this.compH = this.comp.data.h,
                this.svgElement.setAttribute("width", this.compW),
                this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t),
                this.innerElem = t
            } else
                this.renderType = "html",
                this.innerElem = this.layerElement;
            this.checkParenting()
        }
        ,
        HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style
              , r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r,
            e.color = r,
            t.sc && (e.stroke = this.buildColor(t.sc),
            e.strokeWidth = t.sw + "px");
            var i = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars)
                if (e.fontSize = t.finalSize + "px",
                e.lineHeight = t.finalSize + "px",
                i.fClass)
                    this.innerElem.className = i.fClass;
                else {
                    e.fontFamily = i.fFamily;
                    var s = t.fWeight
                      , n = t.fStyle;
                    e.fontStyle = n,
                    e.fontWeight = s
                }
            var a, l, o = t.l;
            l = o.length;
            var h, p, S, c = this.mHelper, g, v = "", d = 0;
            for (a = 0; a < l; a += 1) {
                if (this.globalData.fontManager.chars ? (this.textPaths[d] ? h = this.textPaths[d] : (h = createNS("path"),
                h.setAttribute("stroke-linecap", lineCapEnum[1]),
                h.setAttribute("stroke-linejoin", lineJoinEnum[2]),
                h.setAttribute("stroke-miterlimit", "4")),
                this.isMasked || (this.textSpans[d] ? (p = this.textSpans[d],
                S = p.children[0]) : (p = createTag("div"),
                p.style.lineHeight = 0,
                S = createNS("svg"),
                S.appendChild(h),
                styleDiv(p)))) : this.isMasked ? h = this.textPaths[d] ? this.textPaths[d] : createNS("text") : this.textSpans[d] ? (p = this.textSpans[d],
                h = this.textPaths[d]) : (p = createTag("span"),
                styleDiv(p),
                h = createTag("span"),
                styleDiv(h),
                p.appendChild(h)),
                this.globalData.fontManager.chars) {
                    var b = this.globalData.fontManager.getCharData(t.finalText[a], i.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily), u;
                    if (b ? u = b.data : u = null,
                    c.reset(),
                    u && u.shapes && u.shapes.length && (g = u.shapes[0].it,
                    c.scale(t.finalSize / 100, t.finalSize / 100),
                    v = this.createPathShape(c, g),
                    h.setAttribute("d", v)),
                    this.isMasked)
                        this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(p),
                        u && u.shapes) {
                            document.body.appendChild(S);
                            var m = S.getBBox();
                            S.setAttribute("width", m.width + 2),
                            S.setAttribute("height", m.height + 2),
                            S.setAttribute("viewBox", m.x - 1 + " " + (m.y - 1) + " " + (m.width + 2) + " " + (m.height + 2));
                            var f = S.style
                              , y = "translate(" + (m.x - 1) + "px," + (m.y - 1) + "px)";
                            f.transform = y,
                            f.webkitTransform = y,
                            o[a].yOffset = m.y - 1
                        } else
                            S.setAttribute("width", 1),
                            S.setAttribute("height", 1);
                        p.appendChild(S)
                    }
                } else if (h.textContent = o[a].val,
                h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"),
                this.isMasked)
                    this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(p);
                    var _ = h.style
                      , T = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    _.transform = T,
                    _.webkitTransform = T
                }
                this.isMasked ? this.textSpans[d] = h : this.textSpans[d] = p,
                this.textSpans[d].style.display = "block",
                this.textPaths[d] = h,
                d += 1
            }
            for (; d < this.textSpans.length; )
                this.textSpans[d].style.display = "none",
                d += 1
        }
        ,
        HTextElement.prototype.renderInnerContent = function() {
            this.validateText();
            var t;
            if (this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag)
                    return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH),
                    t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e,
                    t.webkitTransform = e
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag),
            !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
                var r, i, s = 0, n = this.textAnimator.renderedLetters, a = this.textProperty.currentData.l;
                i = a.length;
                var l, o, h;
                for (r = 0; r < i; r += 1)
                    a[r].n ? s += 1 : (o = this.textSpans[r],
                    h = this.textPaths[r],
                    l = n[s],
                    s += 1,
                    l._mdf.m && (this.isMasked ? o.setAttribute("transform", l.m) : (o.style.webkitTransform = l.m,
                    o.style.transform = l.m)),
                    o.style.opacity = l.o,
                    l.sw && l._mdf.sw && h.setAttribute("stroke-width", l.sw),
                    l.sc && l._mdf.sc && h.setAttribute("stroke", l.sc),
                    l.fc && l._mdf.fc && (h.setAttribute("fill", l.fc),
                    h.style.color = l.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    this.currentBBox.w !== p.width && (this.currentBBox.w = p.width,
                    this.svgElement.setAttribute("width", p.width)),
                    this.currentBBox.h !== p.height && (this.currentBBox.h = p.height,
                    this.svgElement.setAttribute("height", p.height));
                    var S = 1;
                    if (this.currentBBox.w !== p.width + S * 2 || this.currentBBox.h !== p.height + S * 2 || this.currentBBox.x !== p.x - S || this.currentBBox.y !== p.y - S) {
                        this.currentBBox.w = p.width + S * 2,
                        this.currentBBox.h = p.height + S * 2,
                        this.currentBBox.x = p.x - S,
                        this.currentBBox.y = p.y - S,
                        this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h),
                        t = this.svgElement.style;
                        var c = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = c,
                        t.webkitTransform = c
                    }
                }
            }
        }
        ;
        function HCameraElement(t, e, r) {
            this.initFrame(),
            this.initBaseData(t, e, r),
            this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this),
            t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this),
            this.py = i(this, t.ks.p.y, 1, 0, this),
            this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this),
            t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)),
            t.ks.or.k.length && t.ks.or.k[0].to) {
                var s, n = t.ks.or.k.length;
                for (s = 0; s < n; s += 1)
                    t.ks.or.k[s].to = null,
                    t.ks.or.k[s].ti = null
            }
            this.or = i(this, t.ks.or, 1, degToRads, this),
            this.or.sh = !0,
            this.rx = i(this, t.ks.rx, 0, degToRads, this),
            this.ry = i(this, t.ks.ry, 0, degToRads, this),
            this.rz = i(this, t.ks.rz, 0, degToRads, this),
            this.mat = new Matrix,
            this._prevMat = new Matrix,
            this._isFirstFrame = !0,
            this.finalTransform = {
                mProp: this
            }
        }
        extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement),
        HCameraElement.prototype.setup = function() {
            var t, e = this.comp.threeDElements.length, r, i, s;
            for (t = 0; t < e; t += 1)
                if (r = this.comp.threeDElements[t],
                r.type === "3d") {
                    i = r.perspectiveElem.style,
                    s = r.container.style;
                    var n = this.pe.v + "px"
                      , a = "0px 0px 0px"
                      , l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                    i.perspective = n,
                    i.webkitPerspective = n,
                    s.transformOrigin = a,
                    s.mozTransformOrigin = a,
                    s.webkitTransformOrigin = a,
                    i.transform = l,
                    i.webkitTransform = l
                }
        }
        ,
        HCameraElement.prototype.createElements = function() {}
        ,
        HCameraElement.prototype.hide = function() {}
        ,
        HCameraElement.prototype.renderFrame = function() {
            var t = this._isFirstFrame, e, r;
            if (this.hierarchy)
                for (r = this.hierarchy.length,
                e = 0; e < r; e += 1)
                    t = this.hierarchy[e].finalTransform.mProp._mdf || t;
            if (t || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(),
                this.hierarchy)
                    for (r = this.hierarchy.length - 1,
                    e = r; e >= 0; e -= 1) {
                        var i = this.hierarchy[e].finalTransform.mProp;
                        this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]),
                        this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]),
                        this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v),
                        this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]),
                        this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2])
                    }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
                this.a) {
                    var s;
                    this.p ? s = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : s = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
                    var n = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2))
                      , a = [s[0] / n, s[1] / n, s[2] / n]
                      , l = Math.sqrt(a[2] * a[2] + a[0] * a[0])
                      , o = Math.atan2(a[1], l)
                      , h = Math.atan2(a[0], -a[2]);
                    this.mat.rotateY(h).rotateX(-o)
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
                this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]),
                this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0),
                this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    r = this.comp.threeDElements.length;
                    var S, c, g;
                    for (e = 0; e < r; e += 1)
                        if (S = this.comp.threeDElements[e],
                        S.type === "3d") {
                            if (p) {
                                var v = this.mat.toCSS();
                                g = S.container.style,
                                g.transform = v,
                                g.webkitTransform = v
                            }
                            this.pe._mdf && (c = S.perspectiveElem.style,
                            c.perspective = this.pe.v + "px",
                            c.webkitPerspective = this.pe.v + "px")
                        }
                    this.mat.clone(this._prevMat)
                }
            }
            this._isFirstFrame = !1
        }
        ,
        HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0)
        }
        ,
        HCameraElement.prototype.destroy = function() {}
        ,
        HCameraElement.prototype.getBaseElement = function() {
            return null
        }
        ;
        function HImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId),
            this.initElement(t, e, r)
        }
        extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement),
        HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData)
              , e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"),
            this.imageElem.setAttribute("width", this.assetData.w + "px"),
            this.imageElem.setAttribute("height", this.assetData.h + "px"),
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
            this.layerElement.appendChild(this.imageElem),
            this.baseElement.setAttribute("width", this.assetData.w),
            this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e),
            e.crossOrigin = "anonymous",
            e.src = t,
            this.data.ln && this.baseElement.setAttribute("id", this.data.ln)
        }
        ;
        function HybridRendererBase(t, e) {
            this.animationItem = t,
            this.layers = null,
            this.renderedFrame = -1,
            this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && e.hideOnTransparent === !1),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            },
            this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            },
            this.pendingElements = [],
            this.elements = [],
            this.threeDElements = [],
            this.destroyed = !1,
            this.camera = null,
            this.supports3d = !0,
            this.rendererType = "html"
        }
        extendPrototype([BaseRenderer], HybridRendererBase),
        HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem,
        HybridRendererBase.prototype.checkPendingElements = function() {
            for (; this.pendingElements.length; ) {
                var t = this.pendingElements.pop();
                t.checkParenting()
            }
        }
        ,
        HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                var i = this.layers[e];
                if (!i.ddd || !this.supports3d)
                    if (this.threeDElements)
                        this.addTo3dContainer(r, e);
                    else {
                        for (var s = 0, n, a, l; s < e; )
                            this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement && (a = this.elements[s],
                            l = this.layers[s].ddd ? this.getThreeDContainerByPos(s) : a.getBaseElement(),
                            n = l || n),
                            s += 1;
                        n ? (!i.ddd || !this.supports3d) && this.layerElement.insertBefore(r, n) : (!i.ddd || !this.supports3d) && this.layerElement.appendChild(r)
                    }
                else
                    this.addTo3dContainer(r, e)
            }
        }
        ,
        HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t,this.globalData,this) : new SVGShapeElement(t,this.globalData,this)
        }
        ,
        HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t,this.globalData,this) : new SVGTextLottieElement(t,this.globalData,this)
        }
        ,
        HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t,this.globalData,this),
            this.camera
        }
        ,
        HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t,this.globalData,this) : new IImageElement(t,this.globalData,this)
        }
        ,
        HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t,this.globalData,this) : new ISolidElement(t,this.globalData,this)
        }
        ,
        HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull,
        HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for (var e = 0, r = this.threeDElements.length; e < r; ) {
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t)
                    return this.threeDElements[e].perspectiveElem;
                e += 1
            }
            return null
        }
        ,
        HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r = createTag("div"), i, s;
            styleDiv(r);
            var n = createTag("div");
            if (styleDiv(n),
            e === "3d") {
                i = r.style,
                i.width = this.globalData.compSize.w + "px",
                i.height = this.globalData.compSize.h + "px";
                var a = "50% 50%";
                i.webkitTransformOrigin = a,
                i.mozTransformOrigin = a,
                i.transformOrigin = a,
                s = n.style;
                var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                s.transform = l,
                s.webkitTransform = l
            }
            r.appendChild(n);
            var o = {
                container: n,
                perspectiveElem: r,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(o),
            o
        }
        ,
        HybridRendererBase.prototype.build3dContainers = function() {
            var t, e = this.layers.length, r, i = "";
            for (t = 0; t < e; t += 1)
                this.layers[t].ddd && this.layers[t].ty !== 3 ? (i !== "3d" && (i = "3d",
                r = this.createThreeDContainer(t, "3d")),
                r.endPos = Math.max(r.endPos, t)) : (i !== "2d" && (i = "2d",
                r = this.createThreeDContainer(t, "2d")),
                r.endPos = Math.max(r.endPos, t));
            for (e = this.threeDElements.length,
            t = e - 1; t >= 0; t -= 1)
                this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem)
        }
        ,
        HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for (var r = 0, i = this.threeDElements.length; r < i; ) {
                if (e <= this.threeDElements[r].endPos) {
                    for (var s = this.threeDElements[r].startPos, n; s < e; )
                        this.elements[s] && this.elements[s].getBaseElement && (n = this.elements[s].getBaseElement()),
                        s += 1;
                    n ? this.threeDElements[r].container.insertBefore(t, n) : this.threeDElements[r].container.appendChild(t);
                    break
                }
                r += 1
            }
        }
        ,
        HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div")
              , r = this.animationItem.wrapper
              , i = e.style;
            i.width = t.w + "px",
            i.height = t.h + "px",
            this.resizerElem = e,
            styleDiv(e),
            i.transformStyle = "flat",
            i.mozTransformStyle = "flat",
            i.webkitTransformStyle = "flat",
            this.renderConfig.className && e.setAttribute("class", this.renderConfig.className),
            r.appendChild(e),
            i.overflow = "hidden";
            var s = createNS("svg");
            s.setAttribute("width", "1"),
            s.setAttribute("height", "1"),
            styleDiv(s),
            this.resizerElem.appendChild(s);
            var n = createNS("defs");
            s.appendChild(n),
            this.data = t,
            this.setupGlobalData(t, s),
            this.globalData.defs = n,
            this.layers = t.layers,
            this.layerElement = this.resizerElem,
            this.build3dContainers(),
            this.updateContainerSize()
        }
        ,
        HybridRendererBase.prototype.destroy = function() {
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""),
            this.animationItem.container = null,
            this.globalData.defs = null;
            var t, e = this.layers ? this.layers.length : 0;
            for (t = 0; t < e; t += 1)
                this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0,
            this.destroyed = !0,
            this.animationItem = null
        }
        ,
        HybridRendererBase.prototype.updateContainerSize = function() {
            var t = this.animationItem.wrapper.offsetWidth, e = this.animationItem.wrapper.offsetHeight, r = t / e, i = this.globalData.compSize.w / this.globalData.compSize.h, s, n, a, l;
            i > r ? (s = t / this.globalData.compSize.w,
            n = t / this.globalData.compSize.w,
            a = 0,
            l = (e - this.globalData.compSize.h * (t / this.globalData.compSize.w)) / 2) : (s = e / this.globalData.compSize.h,
            n = e / this.globalData.compSize.h,
            a = (t - this.globalData.compSize.w * (e / this.globalData.compSize.h)) / 2,
            l = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + s + ",0,0,0,0," + n + ",0,0,0,0,1,0," + a + "," + l + ",0,1)",
            o.transform = o.webkitTransform
        }
        ,
        HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame,
        HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none"
        }
        ,
        HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block"
        }
        ,
        HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(),
            this.camera)
                this.camera.setup();
            else {
                var t = this.globalData.compSize.w, e = this.globalData.compSize.h, r, i = this.threeDElements.length;
                for (r = 0; r < i; r += 1) {
                    var s = this.threeDElements[r].perspectiveElem.style;
                    s.webkitPerspective = Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2)) + "px",
                    s.perspective = s.webkitPerspective
                }
            }
        }
        ,
        HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length, i = createTag("div");
            for (e = 0; e < r; e += 1)
                if (t[e].xt) {
                    var s = this.createComp(t[e], i, this.globalData.comp, null);
                    s.initExpressions(),
                    this.globalData.projectInterface.registerComposition(s)
                }
        }
        ;
        function HCompElement(t, e, r) {
            this.layers = t.layers,
            this.supports3d = !t.hasMask,
            this.completeLayers = !1,
            this.pendingElements = [],
            this.elements = this.layers ? createSizedArray(this.layers.length) : [],
            this.initElement(t, e, r),
            this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }
        }
        extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement),
        HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements,
        HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(),
            this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w),
            this.svgElement.setAttribute("height", this.data.h),
            this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement
        }
        ,
        HCompElement.prototype.addTo3dContainer = function(t, e) {
            for (var r = 0, i; r < e; )
                this.elements[r] && this.elements[r].getBaseElement && (i = this.elements[r].getBaseElement()),
                r += 1;
            i ? this.layerElement.insertBefore(t, i) : this.layerElement.appendChild(t)
        }
        ,
        HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t,this.globalData,this) : new SVGCompElement(t,this.globalData,this)
        }
        ;
        function HybridRenderer(t, e) {
            this.animationItem = t,
            this.layers = null,
            this.renderedFrame = -1,
            this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && e.hideOnTransparent === !1),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || e.runExpressions === void 0 || e.runExpressions
            },
            this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            },
            this.pendingElements = [],
            this.elements = [],
            this.threeDElements = [],
            this.destroyed = !1,
            this.camera = null,
            this.supports3d = !0,
            this.rendererType = "html"
        }
        extendPrototype([HybridRendererBase], HybridRenderer),
        HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t,this.globalData,this) : new SVGCompElement(t,this.globalData,this)
        }
        ;
        var CompExpressionInterface = function() {
            return function(t) {
                function e(r) {
                    for (var i = 0, s = t.layers.length; i < s; ) {
                        if (t.layers[i].nm === r || t.layers[i].ind === r)
                            return t.elements[i].layerInterface;
                        i += 1
                    }
                    return null
                }
                return Object.defineProperty(e, "_name", {
                    value: t.data.nm
                }),
                e.layer = e,
                e.pixelAspect = 1,
                e.height = t.data.h || t.globalData.compSize.h,
                e.width = t.data.w || t.globalData.compSize.w,
                e.pixelAspect = 1,
                e.frameDuration = 1 / t.globalData.frameRate,
                e.displayStartTime = 0,
                e.numLayers = t.layers.length,
                e
            }
        }();
        function _typeof$2(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(r) {
                return typeof r
            }
            : _typeof$2 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$2(t)
        }
        function seedRandom(t, e) {
            var r = this, i = 256, s = 6, n = 52, a = "random", l = e.pow(i, s), o = e.pow(2, n), h = o * 2, p = i - 1, S;
            function c(f, y, _) {
                var T = [];
                y = y === !0 ? {
                    entropy: !0
                } : y || {};
                var C = b(d(y.entropy ? [f, m(t)] : f === null ? u() : f, 3), T)
                  , x = new g(T)
                  , w = function() {
                    for (var k = x.g(s), L = l, V = 0; k < o; )
                        k = (k + V) * i,
                        L *= i,
                        V = x.g(1);
                    for (; k >= h; )
                        k /= 2,
                        L /= 2,
                        V >>>= 1;
                    return (k + V) / L
                };
                return w.int32 = function() {
                    return x.g(4) | 0
                }
                ,
                w.quick = function() {
                    return x.g(4) / 4294967296
                }
                ,
                w.double = w,
                b(m(x.S), t),
                (y.pass || _ || function(D, k, L, V) {
                    return V && (V.S && v(V, x),
                    D.state = function() {
                        return v(x, {})
                    }
                    ),
                    L ? (e[a] = D,
                    k) : D
                }
                )(w, C, "global"in y ? y.global : this == e, y.state)
            }
            e["seed" + a] = c;
            function g(f) {
                var y, _ = f.length, T = this, C = 0, x = T.i = T.j = 0, w = T.S = [];
                for (_ || (f = [_++]); C < i; )
                    w[C] = C++;
                for (C = 0; C < i; C++)
                    w[C] = w[x = p & x + f[C % _] + (y = w[C])],
                    w[x] = y;
                T.g = function(D) {
                    for (var k, L = 0, V = T.i, O = T.j, R = T.S; D--; )
                        k = R[V = p & V + 1],
                        L = L * i + R[p & (R[V] = R[O = p & O + k]) + (R[O] = k)];
                    return T.i = V,
                    T.j = O,
                    L
                }
            }
            function v(f, y) {
                return y.i = f.i,
                y.j = f.j,
                y.S = f.S.slice(),
                y
            }
            function d(f, y) {
                var _ = [], T = _typeof$2(f), C;
                if (y && T == "object")
                    for (C in f)
                        try {
                            _.push(d(f[C], y - 1))
                        } catch {}
                return _.length ? _ : T == "string" ? f : f + "\0"
            }
            function b(f, y) {
                for (var _ = f + "", T, C = 0; C < _.length; )
                    y[p & C] = p & (T ^= y[p & C] * 19) + _.charCodeAt(C++);
                return m(y)
            }
            function u() {
                try {
                    var f = new Uint8Array(i);
                    return (r.crypto || r.msCrypto).getRandomValues(f),
                    m(f)
                } catch {
                    var y = r.navigator
                      , _ = y && y.plugins;
                    return [+new Date, r, _, r.screen, m(t)]
                }
            }
            function m(f) {
                return String.fromCharCode.apply(0, f)
            }
            b(e.random(), t)
        }
        function initialize$2(t) {
            seedRandom([], t)
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(r) {
                return typeof r
            }
            : _typeof$1 = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof$1(t)
        }
        var ExpressionManager = function() {
            var ob = {}
              , Math = BMMath
              , window = null
              , document = null
              , XMLHttpRequest = null
              , fetch = null
              , frames = null
              , _lottieGlobal = {};
            initialize$2(BMMath);
            function resetFrame() {
                _lottieGlobal = {}
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array
            }
            function isNumerable(t, e) {
                return t === "number" || e instanceof Number || t === "boolean" || t === "string"
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if (e === "number" || t instanceof Number || e === "boolean")
                    return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r, i = t.length, s = [];
                    for (r = 0; r < i; r += 1)
                        s[r] = -t[r];
                    return s
                }
                return t.propType ? t.v : -t
            }
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get
              , easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get
              , easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r = _typeof$1(t)
                  , i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e) || r === "string" || i === "string")
                    return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
                    return t = t.slice(0),
                    t[0] += e,
                    t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
                    return e = e.slice(0),
                    e[0] = t + e[0],
                    e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for (var s = 0, n = t.length, a = e.length, l = []; s < n || s < a; )
                        (typeof t[s] == "number" || t[s]instanceof Number) && (typeof e[s] == "number" || e[s]instanceof Number) ? l[s] = t[s] + e[s] : l[s] = e[s] === void 0 ? t[s] : t[s] || e[s],
                        s += 1;
                    return l
                }
                return 0
            }
            var add = sum;
            function sub(t, e) {
                var r = _typeof$1(t)
                  , i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e))
                    return r === "string" && (t = parseInt(t, 10)),
                    i === "string" && (e = parseInt(e, 10)),
                    t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
                    return t = t.slice(0),
                    t[0] -= e,
                    t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
                    return e = e.slice(0),
                    e[0] = t - e[0],
                    e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for (var s = 0, n = t.length, a = e.length, l = []; s < n || s < a; )
                        (typeof t[s] == "number" || t[s]instanceof Number) && (typeof e[s] == "number" || e[s]instanceof Number) ? l[s] = t[s] - e[s] : l[s] = e[s] === void 0 ? t[s] : t[s] || e[s],
                        s += 1;
                    return l
                }
                return 0
            }
            function mul(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e), s;
                if (isNumerable(r, t) && isNumerable(i, e))
                    return t * e;
                var n, a;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) {
                    for (a = t.length,
                    s = createTypedArray("float32", a),
                    n = 0; n < a; n += 1)
                        s[n] = t[n] * e;
                    return s
                }
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) {
                    for (a = e.length,
                    s = createTypedArray("float32", a),
                    n = 0; n < a; n += 1)
                        s[n] = t * e[n];
                    return s
                }
                return 0
            }
            function div(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e), s;
                if (isNumerable(r, t) && isNumerable(i, e))
                    return t / e;
                var n, a;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) {
                    for (a = t.length,
                    s = createTypedArray("float32", a),
                    n = 0; n < a; n += 1)
                        s[n] = t[n] / e;
                    return s
                }
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) {
                    for (a = e.length,
                    s = createTypedArray("float32", a),
                    n = 0; n < a; n += 1)
                        s[n] = t / e[n];
                    return s
                }
                return 0
            }
            function mod(t, e) {
                return typeof t == "string" && (t = parseInt(t, 10)),
                typeof e == "string" && (e = parseInt(e, 10)),
                t % e
            }
            var $bm_sum = sum
              , $bm_sub = sub
              , $bm_mul = mul
              , $bm_div = div
              , $bm_mod = mod;
            function clamp(t, e, r) {
                if (e > r) {
                    var i = r;
                    r = e,
                    e = i
                }
                return Math.min(Math.max(t, e), r)
            }
            function radiansToDegrees(t) {
                return t / degToRads
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads
            }
            var degrees_to_radians = radiansToDegrees
              , helperLengthArray = [0, 0, 0, 0, 0, 0];
            function length(t, e) {
                if (typeof t == "number" || t instanceof Number)
                    return e = e || 0,
                    Math.abs(t - e);
                e || (e = helperLengthArray);
                var r, i = Math.min(t.length, e.length), s = 0;
                for (r = 0; r < i; r += 1)
                    s += Math.pow(e[r] - t[r], 2);
                return Math.sqrt(s)
            }
            function normalize(t) {
                return div(t, length(t))
            }
            function rgbToHsl(t) {
                var e = t[0], r = t[1], i = t[2], s = Math.max(e, r, i), n = Math.min(e, r, i), a, l, o = (s + n) / 2;
                if (s === n)
                    a = 0,
                    l = 0;
                else {
                    var h = s - n;
                    switch (l = o > .5 ? h / (2 - s - n) : h / (s + n),
                    s) {
                    case e:
                        a = (r - i) / h + (r < i ? 6 : 0);
                        break;
                    case r:
                        a = (i - e) / h + 2;
                        break;
                    case i:
                        a = (e - r) / h + 4;
                        break
                    }
                    a /= 6
                }
                return [a, l, o, t[3]]
            }
            function hue2rgb(t, e, r) {
                return r < 0 && (r += 1),
                r > 1 && (r -= 1),
                r < 1 / 6 ? t + (e - t) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t
            }
            function hslToRgb(t) {
                var e = t[0], r = t[1], i = t[2], s, n, a;
                if (r === 0)
                    s = i,
                    a = i,
                    n = i;
                else {
                    var l = i < .5 ? i * (1 + r) : i + r - i * r
                      , o = 2 * i - l;
                    s = hue2rgb(o, l, e + 1 / 3),
                    n = hue2rgb(o, l, e),
                    a = hue2rgb(o, l, e - 1 / 3)
                }
                return [s, n, a, t[3]]
            }
            function linear(t, e, r, i, s) {
                if ((i === void 0 || s === void 0) && (i = e,
                s = r,
                e = 0,
                r = 1),
                r < e) {
                    var n = r;
                    r = e,
                    e = n
                }
                if (t <= e)
                    return i;
                if (t >= r)
                    return s;
                var a = r === e ? 0 : (t - e) / (r - e);
                if (!i.length)
                    return i + (s - i) * a;
                var l, o = i.length, h = createTypedArray("float32", o);
                for (l = 0; l < o; l += 1)
                    h[l] = i[l] + (s[l] - i[l]) * a;
                return h
            }
            function random(t, e) {
                if (e === void 0 && (t === void 0 ? (t = 0,
                e = 1) : (e = t,
                t = void 0)),
                e.length) {
                    var r, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var s = createTypedArray("float32", i)
                      , n = BMMath.random();
                    for (r = 0; r < i; r += 1)
                        s[r] = t[r] + n * (e[r] - t[r]);
                    return s
                }
                t === void 0 && (t = 0);
                var a = BMMath.random();
                return t + a * (e - t)
            }
            function createPath(t, e, r, i) {
                var s, n = t.length, a = shapePool.newElement();
                a.setPathData(!!i, n);
                var l = [0, 0], o, h;
                for (s = 0; s < n; s += 1)
                    o = e && e[s] ? e[s] : l,
                    h = r && r[s] ? r[s] : l,
                    a.setTripleAt(t[s][0], t[s][1], h[0] + t[s][0], h[1] + t[s][1], o[0] + t[s][0], o[1] + t[s][1], s, !0);
                return a
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t
                }
                if (!elem.globalData.renderConfig.runExpressions)
                    return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime,
                Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v
                    }
                }),
                elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate,
                elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function t(e, r) {
                    var i, s, n = this.pv.length ? this.pv.length : 1, a = createTypedArray("float32", n);
                    e = 5;
                    var l = Math.floor(time * e);
                    for (i = 0,
                    s = 0; i < l; ) {
                        for (s = 0; s < n; s += 1)
                            a[s] += -r + r * 2 * BMMath.random();
                        i += 1
                    }
                    var o = time * e
                      , h = o - Math.floor(o)
                      , p = createTypedArray("float32", n);
                    if (n > 1) {
                        for (s = 0; s < n; s += 1)
                            p[s] = this.pv[s] + a[s] + (-r + r * 2 * BMMath.random()) * h;
                        return p
                    }
                    return this.pv + a[0] + (-r + r * 2 * BMMath.random()) * h
                }
                ).bind(this);
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty),
                loop_in = loopIn),
                thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty),
                loop_out = loopOut),
                thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0)
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0)
                }
                this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)),
                this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
                function lookAt(t, e) {
                    var r = [e[0] - t[0], e[1] - t[1], e[2] - t[2]]
                      , i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads
                      , s = -Math.atan2(r[1], r[2]) / degToRads;
                    return [s, i, 0]
                }
                function easeOut(t, e, r, i, s) {
                    return applyEase(easeOutBez, t, e, r, i, s)
                }
                function easeIn(t, e, r, i, s) {
                    return applyEase(easeInBez, t, e, r, i, s)
                }
                function ease(t, e, r, i, s) {
                    return applyEase(easeInOutBez, t, e, r, i, s)
                }
                function applyEase(t, e, r, i, s, n) {
                    s === void 0 ? (s = r,
                    n = i) : e = (e - r) / (i - r),
                    e > 1 ? e = 1 : e < 0 && (e = 0);
                    var a = t(e);
                    if ($bm_isInstanceOfArray(s)) {
                        var l, o = s.length, h = createTypedArray("float32", o);
                        for (l = 0; l < o; l += 1)
                            h[l] = (n[l] - s[l]) * a + s[l];
                        return h
                    }
                    return (n - s) * a + s
                }
                function nearestKey(t) {
                    var e, r = data.k.length, i, s;
                    if (!data.k.length || typeof data.k[0] == "number")
                        i = 0,
                        s = 0;
                    else if (i = -1,
                    t *= elem.comp.globalData.frameRate,
                    t < data.k[0].t)
                        i = 1,
                        s = data.k[0].t;
                    else {
                        for (e = 0; e < r - 1; e += 1)
                            if (t === data.k[e].t) {
                                i = e + 1,
                                s = data.k[e].t;
                                break
                            } else if (t > data.k[e].t && t < data.k[e + 1].t) {
                                t - data.k[e].t > data.k[e + 1].t - t ? (i = e + 2,
                                s = data.k[e + 1].t) : (i = e + 1,
                                s = data.k[e].t);
                                break
                            }
                        i === -1 && (i = e + 1,
                        s = data.k[e].t)
                    }
                    var n = {};
                    return n.index = i,
                    n.time = s / elem.comp.globalData.frameRate,
                    n
                }
                function key(t) {
                    var e, r, i;
                    if (!data.k.length || typeof data.k[0] == "number")
                        throw new Error("The property has no keyframe at index " + t);
                    t -= 1,
                    e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for (i = s.length,
                    r = 0; r < i; r += 1)
                        e[r] = s[r],
                        e.value[r] = s[r];
                    return e
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate),
                    t / e
                }
                function timeToFrames(t, e) {
                    return !t && t !== 0 && (t = time),
                    e || (e = elem.comp.globalData.frameRate),
                    t * e
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t)
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime()
                }
                function substring(t, e) {
                    return typeof value == "string" ? e === void 0 ? value.substring(t) : value.substring(t, e) : ""
                }
                function substr(t, e) {
                    return typeof value == "string" ? e === void 0 ? value.substr(t) : value.substr(t, e) : ""
                }
                function posterizeTime(t) {
                    time = t === 0 ? 0 : Math.floor(time * t) / t,
                    value = valueAtTime(time)
                }
                var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t,
                    this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex,
                    textTotal = this.textTotal,
                    selectorValue = this.selectorValue),
                    thisLayer || (text = elem.layerInterface.text,
                    thisLayer = elem.layerInterface,
                    thisComp = elem.comp.compInterface,
                    toWorld = thisLayer.toWorld.bind(thisLayer),
                    fromWorld = thisLayer.fromWorld.bind(thisLayer),
                    fromComp = thisLayer.fromComp.bind(thisLayer),
                    toComp = thisLayer.toComp.bind(thisLayer),
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null,
                    fromCompToSurface = fromComp),
                    transform || (transform = elem.layerInterface("ADBE Transform Group"),
                    $bm_transform = transform,
                    transform && (anchorPoint = transform.anchorPoint)),
                    elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")),
                    effect || (effect = thisLayer(4)),
                    hasParent = !!(elem.hierarchy && elem.hierarchy.length),
                    hasParent && !parent && (parent = elem.hierarchy[0].layerInterface),
                    time = this.comp.renderedFrame / this.comp.globalData.frameRate,
                    _needsRandom && seedRandom(randSeed + time),
                    needsVelocity && (velocity = velocityAtTime(time)),
                    expression_function(),
                    this.frameExpressionId = elem.globalData.frameId,
                    scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt,
                    scoped_bm_rt)
                }
                return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData],
                executeExpression
            }
            return ob.initiateExpression = initiateExpression,
            ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal],
            ob.resetFrame = resetFrame,
            ob
        }()
          , Expressions = function() {
            var t = {};
            t.initExpressions = e,
            t.resetFrame = ExpressionManager.resetFrame;
            function e(r) {
                var i = 0
                  , s = [];
                function n() {
                    i += 1
                }
                function a() {
                    i -= 1,
                    i === 0 && o()
                }
                function l(h) {
                    s.indexOf(h) === -1 && s.push(h)
                }
                function o() {
                    var h, p = s.length;
                    for (h = 0; h < p; h += 1)
                        s[h].release();
                    s.length = 0
                }
                r.renderer.compInterface = CompExpressionInterface(r.renderer),
                r.renderer.globalData.projectInterface.registerComposition(r.renderer),
                r.renderer.globalData.pushExpression = n,
                r.renderer.globalData.popExpression = a,
                r.renderer.globalData.registerExpressionProperty = l
            }
            return t
        }()
          , MaskManagerInterface = function() {
            function t(r, i) {
                this._mask = r,
                this._data = i
            }
            Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(),
                    this._mask.prop
                }
            }),
            Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(),
                    this._mask.op.v * 100
                }
            });
            var e = function(i) {
                var s = createSizedArray(i.viewData.length), n, a = i.viewData.length;
                for (n = 0; n < a; n += 1)
                    s[n] = new t(i.viewData[n],i.masksProperties[n]);
                var l = function(h) {
                    for (n = 0; n < a; ) {
                        if (i.masksProperties[n].nm === h)
                            return s[n];
                        n += 1
                    }
                    return null
                };
                return l
            };
            return e
        }()
          , ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }
              , e = {
                pv: [0, 0, 0],
                v: [0, 0, 0],
                mult: 1
            };
            function r(a, l, o) {
                Object.defineProperty(a, "velocity", {
                    get: function() {
                        return l.getVelocityAtTime(l.comp.currentFrame)
                    }
                }),
                a.numKeys = l.keyframes ? l.keyframes.length : 0,
                a.key = function(h) {
                    if (!a.numKeys)
                        return 0;
                    var p = "";
                    "s"in l.keyframes[h - 1] ? p = l.keyframes[h - 1].s : "e"in l.keyframes[h - 2] ? p = l.keyframes[h - 2].e : p = l.keyframes[h - 2].s;
                    var S = o === "unidimensional" ? new Number(p) : Object.assign({}, p);
                    return S.time = l.keyframes[h - 1].t / l.elem.comp.globalData.frameRate,
                    S.value = o === "unidimensional" ? p[0] : p,
                    S
                }
                ,
                a.valueAtTime = l.getValueAtTime,
                a.speedAtTime = l.getSpeedAtTime,
                a.velocityAtTime = l.getVelocityAtTime,
                a.propertyGroup = l.propertyGroup
            }
            function i(a) {
                (!a || !("pv"in a)) && (a = t);
                var l = 1 / a.mult
                  , o = a.pv * l
                  , h = new Number(o);
                return h.value = o,
                r(h, a, "unidimensional"),
                function() {
                    return a.k && a.getValue(),
                    o = a.v * l,
                    h.value !== o && (h = new Number(o),
                    h.value = o,
                    r(h, a, "unidimensional")),
                    h
                }
            }
            function s(a) {
                (!a || !("pv"in a)) && (a = e);
                var l = 1 / a.mult
                  , o = a.data && a.data.l || a.pv.length
                  , h = createTypedArray("float32", o)
                  , p = createTypedArray("float32", o);
                return h.value = p,
                r(h, a, "multidimensional"),
                function() {
                    a.k && a.getValue();
                    for (var S = 0; S < o; S += 1)
                        p[S] = a.v[S] * l,
                        h[S] = p[S];
                    return h
                }
            }
            function n() {
                return t
            }
            return function(a) {
                return a ? a.propType === "unidimensional" ? i(a) : s(a) : n
            }
        }()
          , TransformExpressionInterface = function() {
            return function(t) {
                function e(a) {
                    switch (a) {
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null
                    }
                }
                Object.defineProperty(e, "rotation", {
                    get: ExpressionPropertyInterface(t.r || t.rz)
                }),
                Object.defineProperty(e, "zRotation", {
                    get: ExpressionPropertyInterface(t.rz || t.r)
                }),
                Object.defineProperty(e, "xRotation", {
                    get: ExpressionPropertyInterface(t.rx)
                }),
                Object.defineProperty(e, "yRotation", {
                    get: ExpressionPropertyInterface(t.ry)
                }),
                Object.defineProperty(e, "scale", {
                    get: ExpressionPropertyInterface(t.s)
                });
                var r, i, s, n;
                return t.p ? n = ExpressionPropertyInterface(t.p) : (r = ExpressionPropertyInterface(t.px),
                i = ExpressionPropertyInterface(t.py),
                t.pz && (s = ExpressionPropertyInterface(t.pz))),
                Object.defineProperty(e, "position", {
                    get: function() {
                        return t.p ? n() : [r(), i(), s ? s() : 0]
                    }
                }),
                Object.defineProperty(e, "xPosition", {
                    get: ExpressionPropertyInterface(t.px)
                }),
                Object.defineProperty(e, "yPosition", {
                    get: ExpressionPropertyInterface(t.py)
                }),
                Object.defineProperty(e, "zPosition", {
                    get: ExpressionPropertyInterface(t.pz)
                }),
                Object.defineProperty(e, "anchorPoint", {
                    get: ExpressionPropertyInterface(t.a)
                }),
                Object.defineProperty(e, "opacity", {
                    get: ExpressionPropertyInterface(t.o)
                }),
                Object.defineProperty(e, "skew", {
                    get: ExpressionPropertyInterface(t.sk)
                }),
                Object.defineProperty(e, "skewAxis", {
                    get: ExpressionPropertyInterface(t.sa)
                }),
                Object.defineProperty(e, "orientation", {
                    get: ExpressionPropertyInterface(t.or)
                }),
                e
            }
        }()
          , LayerExpressionInterface = function() {
            function t(h) {
                var p = new Matrix;
                if (h !== void 0) {
                    var S = this._elem.finalTransform.mProp.getValueAtTime(h);
                    S.clone(p)
                } else {
                    var c = this._elem.finalTransform.mProp;
                    c.applyToMatrix(p)
                }
                return p
            }
            function e(h, p) {
                var S = this.getMatrix(p);
                return S.props[12] = 0,
                S.props[13] = 0,
                S.props[14] = 0,
                this.applyPoint(S, h)
            }
            function r(h, p) {
                var S = this.getMatrix(p);
                return this.applyPoint(S, h)
            }
            function i(h, p) {
                var S = this.getMatrix(p);
                return S.props[12] = 0,
                S.props[13] = 0,
                S.props[14] = 0,
                this.invertPoint(S, h)
            }
            function s(h, p) {
                var S = this.getMatrix(p);
                return this.invertPoint(S, h)
            }
            function n(h, p) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var S, c = this._elem.hierarchy.length;
                    for (S = 0; S < c; S += 1)
                        this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(h)
                }
                return h.applyToPointArray(p[0], p[1], p[2] || 0)
            }
            function a(h, p) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var S, c = this._elem.hierarchy.length;
                    for (S = 0; S < c; S += 1)
                        this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(h)
                }
                return h.inversePoint(p)
            }
            function l(h) {
                var p = new Matrix;
                if (p.reset(),
                this._elem.finalTransform.mProp.applyToMatrix(p),
                this._elem.hierarchy && this._elem.hierarchy.length) {
                    var S, c = this._elem.hierarchy.length;
                    for (S = 0; S < c; S += 1)
                        this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(p);
                    return p.inversePoint(h)
                }
                return p.inversePoint(h)
            }
            function o() {
                return [1, 1, 1, 1]
            }
            return function(h) {
                var p;
                function S(d) {
                    g.mask = new MaskManagerInterface(d,h)
                }
                function c(d) {
                    g.effect = d
                }
                function g(d) {
                    switch (d) {
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return g.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return p;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return g.effect;
                    case "ADBE Text Properties":
                        return g.textInterface;
                    default:
                        return null
                    }
                }
                g.getMatrix = t,
                g.invertPoint = a,
                g.applyPoint = n,
                g.toWorld = r,
                g.toWorldVec = e,
                g.fromWorld = s,
                g.fromWorldVec = i,
                g.toComp = r,
                g.fromComp = l,
                g.sampleImage = o,
                g.sourceRectAtTime = h.sourceRectAtTime.bind(h),
                g._elem = h,
                p = TransformExpressionInterface(h.finalTransform.mProp);
                var v = getDescriptor(p, "anchorPoint");
                return Object.defineProperties(g, {
                    hasParent: {
                        get: function() {
                            return h.hierarchy.length
                        }
                    },
                    parent: {
                        get: function() {
                            return h.hierarchy[0].layerInterface
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: v,
                    anchor_point: v,
                    transform: {
                        get: function() {
                            return p
                        }
                    },
                    active: {
                        get: function() {
                            return h.isInRange
                        }
                    }
                }),
                g.startTime = h.data.st,
                g.index = h.data.ind,
                g.source = h.data.refId,
                g.height = h.data.ty === 0 ? h.data.h : 100,
                g.width = h.data.ty === 0 ? h.data.w : 100,
                g.inPoint = h.data.ip / h.comp.globalData.frameRate,
                g.outPoint = h.data.op / h.comp.globalData.frameRate,
                g._name = h.data.nm,
                g.registerMaskInterface = S,
                g.registerEffectsInterface = c,
                g
            }
        }()
          , propertyGroupFactory = function() {
            return function(t, e) {
                return function(r) {
                    return r = r === void 0 ? 1 : r,
                    r <= 0 ? t : e(r - 1)
                }
            }
        }()
          , PropertyInterface = function() {
            return function(t, e) {
                var r = {
                    _name: t
                };
                function i(s) {
                    return s = s === void 0 ? 1 : s,
                    s <= 0 ? r : e(s - 1)
                }
                return i
            }
        }()
          , EffectsExpressionInterface = function() {
            var t = {
                createEffectsInterface: e
            };
            function e(s, n) {
                if (s.effectsManager) {
                    var a = [], l = s.data.ef, o, h = s.effectsManager.effectElements.length;
                    for (o = 0; o < h; o += 1)
                        a.push(r(l[o], s.effectsManager.effectElements[o], n, s));
                    var p = s.data.ef || []
                      , S = function(g) {
                        for (o = 0,
                        h = p.length; o < h; ) {
                            if (g === p[o].nm || g === p[o].mn || g === p[o].ix)
                                return a[o];
                            o += 1
                        }
                        return null
                    };
                    return Object.defineProperty(S, "numProperties", {
                        get: function() {
                            return p.length
                        }
                    }),
                    S
                }
                return null
            }
            function r(s, n, a, l) {
                function o(g) {
                    for (var v = s.ef, d = 0, b = v.length; d < b; ) {
                        if (g === v[d].nm || g === v[d].mn || g === v[d].ix)
                            return v[d].ty === 5 ? p[d] : p[d]();
                        d += 1
                    }
                    throw new Error
                }
                var h = propertyGroupFactory(o, a), p = [], S, c = s.ef.length;
                for (S = 0; S < c; S += 1)
                    s.ef[S].ty === 5 ? p.push(r(s.ef[S], n.effectElements[S], n.effectElements[S].propertyGroup, l)) : p.push(i(n.effectElements[S], s.ef[S].ty, l, h));
                return s.mn === "ADBE Color Control" && Object.defineProperty(o, "color", {
                    get: function() {
                        return p[0]()
                    }
                }),
                Object.defineProperties(o, {
                    numProperties: {
                        get: function() {
                            return s.np
                        }
                    },
                    _name: {
                        value: s.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }),
                o.enabled = s.en !== 0,
                o.active = o.enabled,
                o
            }
            function i(s, n, a, l) {
                var o = ExpressionPropertyInterface(s.p);
                function h() {
                    return n === 10 ? a.comp.compInterface(s.p.v) : o()
                }
                return s.p.setGroupProperty && s.p.setGroupProperty(PropertyInterface("", l)),
                h
            }
            return t
        }()
          , ShapePathInterface = function() {
            return function(e, r, i) {
                var s = r.sh;
                function n(l) {
                    return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? n.path : null
                }
                var a = propertyGroupFactory(n, i);
                return s.setGroupProperty(PropertyInterface("Path", a)),
                Object.defineProperties(n, {
                    path: {
                        get: function() {
                            return s.k && s.getValue(),
                            s
                        }
                    },
                    shape: {
                        get: function() {
                            return s.k && s.getValue(),
                            s
                        }
                    },
                    _name: {
                        value: e.nm
                    },
                    ix: {
                        value: e.ix
                    },
                    propertyIndex: {
                        value: e.ix
                    },
                    mn: {
                        value: e.mn
                    },
                    propertyGroup: {
                        value: i
                    }
                }),
                n
            }
        }()
          , ShapeExpressionInterface = function() {
            function t(v, d, b) {
                var u = [], m, f = v ? v.length : 0;
                for (m = 0; m < f; m += 1)
                    v[m].ty === "gr" ? u.push(r(v[m], d[m], b)) : v[m].ty === "fl" ? u.push(i(v[m], d[m], b)) : v[m].ty === "st" ? u.push(a(v[m], d[m], b)) : v[m].ty === "tm" ? u.push(l(v[m], d[m], b)) : v[m].ty === "tr" || (v[m].ty === "el" ? u.push(h(v[m], d[m], b)) : v[m].ty === "sr" ? u.push(p(v[m], d[m], b)) : v[m].ty === "sh" ? u.push(ShapePathInterface(v[m], d[m], b)) : v[m].ty === "rc" ? u.push(S(v[m], d[m], b)) : v[m].ty === "rd" ? u.push(c(v[m], d[m], b)) : v[m].ty === "rp" ? u.push(g(v[m], d[m], b)) : v[m].ty === "gf" ? u.push(s(v[m], d[m], b)) : u.push(n(v[m], d[m])));
                return u
            }
            function e(v, d, b) {
                var u, m = function(_) {
                    for (var T = 0, C = u.length; T < C; ) {
                        if (u[T]._name === _ || u[T].mn === _ || u[T].propertyIndex === _ || u[T].ix === _ || u[T].ind === _)
                            return u[T];
                        T += 1
                    }
                    return typeof _ == "number" ? u[_ - 1] : null
                };
                m.propertyGroup = propertyGroupFactory(m, b),
                u = t(v.it, d.it, m.propertyGroup),
                m.numProperties = u.length;
                var f = o(v.it[v.it.length - 1], d.it[d.it.length - 1], m.propertyGroup);
                return m.transform = f,
                m.propertyIndex = v.cix,
                m._name = v.nm,
                m
            }
            function r(v, d, b) {
                var u = function(_) {
                    switch (_) {
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return u.content;
                    default:
                        return u.transform
                    }
                };
                u.propertyGroup = propertyGroupFactory(u, b);
                var m = e(v, d, u.propertyGroup)
                  , f = o(v.it[v.it.length - 1], d.it[d.it.length - 1], u.propertyGroup);
                return u.content = m,
                u.transform = f,
                Object.defineProperty(u, "_name", {
                    get: function() {
                        return v.nm
                    }
                }),
                u.numProperties = v.np,
                u.propertyIndex = v.ix,
                u.nm = v.nm,
                u.mn = v.mn,
                u
            }
            function i(v, d, b) {
                function u(m) {
                    return m === "Color" || m === "color" ? u.color : m === "Opacity" || m === "opacity" ? u.opacity : null
                }
                return Object.defineProperties(u, {
                    color: {
                        get: ExpressionPropertyInterface(d.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(d.o)
                    },
                    _name: {
                        value: v.nm
                    },
                    mn: {
                        value: v.mn
                    }
                }),
                d.c.setGroupProperty(PropertyInterface("Color", b)),
                d.o.setGroupProperty(PropertyInterface("Opacity", b)),
                u
            }
            function s(v, d, b) {
                function u(m) {
                    return m === "Start Point" || m === "start point" ? u.startPoint : m === "End Point" || m === "end point" ? u.endPoint : m === "Opacity" || m === "opacity" ? u.opacity : null
                }
                return Object.defineProperties(u, {
                    startPoint: {
                        get: ExpressionPropertyInterface(d.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(d.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(d.o)
                    },
                    type: {
                        get: function() {
                            return "a"
                        }
                    },
                    _name: {
                        value: v.nm
                    },
                    mn: {
                        value: v.mn
                    }
                }),
                d.s.setGroupProperty(PropertyInterface("Start Point", b)),
                d.e.setGroupProperty(PropertyInterface("End Point", b)),
                d.o.setGroupProperty(PropertyInterface("Opacity", b)),
                u
            }
            function n() {
                function v() {
                    return null
                }
                return v
            }
            function a(v, d, b) {
                var u = propertyGroupFactory(C, b)
                  , m = propertyGroupFactory(T, u);
                function f(x) {
                    Object.defineProperty(T, v.d[x].nm, {
                        get: ExpressionPropertyInterface(d.d.dataProps[x].p)
                    })
                }
                var y, _ = v.d ? v.d.length : 0, T = {};
                for (y = 0; y < _; y += 1)
                    f(y),
                    d.d.dataProps[y].p.setGroupProperty(m);
                function C(x) {
                    return x === "Color" || x === "color" ? C.color : x === "Opacity" || x === "opacity" ? C.opacity : x === "Stroke Width" || x === "stroke width" ? C.strokeWidth : null
                }
                return Object.defineProperties(C, {
                    color: {
                        get: ExpressionPropertyInterface(d.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(d.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(d.w)
                    },
                    dash: {
                        get: function() {
                            return T
                        }
                    },
                    _name: {
                        value: v.nm
                    },
                    mn: {
                        value: v.mn
                    }
                }),
                d.c.setGroupProperty(PropertyInterface("Color", u)),
                d.o.setGroupProperty(PropertyInterface("Opacity", u)),
                d.w.setGroupProperty(PropertyInterface("Stroke Width", u)),
                C
            }
            function l(v, d, b) {
                function u(f) {
                    return f === v.e.ix || f === "End" || f === "end" ? u.end : f === v.s.ix ? u.start : f === v.o.ix ? u.offset : null
                }
                var m = propertyGroupFactory(u, b);
                return u.propertyIndex = v.ix,
                d.s.setGroupProperty(PropertyInterface("Start", m)),
                d.e.setGroupProperty(PropertyInterface("End", m)),
                d.o.setGroupProperty(PropertyInterface("Offset", m)),
                u.propertyIndex = v.ix,
                u.propertyGroup = b,
                Object.defineProperties(u, {
                    start: {
                        get: ExpressionPropertyInterface(d.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(d.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(d.o)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            function o(v, d, b) {
                function u(f) {
                    return v.a.ix === f || f === "Anchor Point" ? u.anchorPoint : v.o.ix === f || f === "Opacity" ? u.opacity : v.p.ix === f || f === "Position" ? u.position : v.r.ix === f || f === "Rotation" || f === "ADBE Vector Rotation" ? u.rotation : v.s.ix === f || f === "Scale" ? u.scale : v.sk && v.sk.ix === f || f === "Skew" ? u.skew : v.sa && v.sa.ix === f || f === "Skew Axis" ? u.skewAxis : null
                }
                var m = propertyGroupFactory(u, b);
                return d.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", m)),
                d.transform.mProps.p.setGroupProperty(PropertyInterface("Position", m)),
                d.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", m)),
                d.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", m)),
                d.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", m)),
                d.transform.mProps.sk && (d.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", m)),
                d.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", m))),
                d.transform.op.setGroupProperty(PropertyInterface("Opacity", m)),
                Object.defineProperties(u, {
                    opacity: {
                        get: ExpressionPropertyInterface(d.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(d.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(d.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(d.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(d.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(d.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(d.transform.mProps.sa)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.ty = "tr",
                u.mn = v.mn,
                u.propertyGroup = b,
                u
            }
            function h(v, d, b) {
                function u(y) {
                    return v.p.ix === y ? u.position : v.s.ix === y ? u.size : null
                }
                var m = propertyGroupFactory(u, b);
                u.propertyIndex = v.ix;
                var f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
                return f.s.setGroupProperty(PropertyInterface("Size", m)),
                f.p.setGroupProperty(PropertyInterface("Position", m)),
                Object.defineProperties(u, {
                    size: {
                        get: ExpressionPropertyInterface(f.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(f.p)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            function p(v, d, b) {
                function u(y) {
                    return v.p.ix === y ? u.position : v.r.ix === y ? u.rotation : v.pt.ix === y ? u.points : v.or.ix === y || y === "ADBE Vector Star Outer Radius" ? u.outerRadius : v.os.ix === y ? u.outerRoundness : v.ir && (v.ir.ix === y || y === "ADBE Vector Star Inner Radius") ? u.innerRadius : v.is && v.is.ix === y ? u.innerRoundness : null
                }
                var m = propertyGroupFactory(u, b)
                  , f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
                return u.propertyIndex = v.ix,
                f.or.setGroupProperty(PropertyInterface("Outer Radius", m)),
                f.os.setGroupProperty(PropertyInterface("Outer Roundness", m)),
                f.pt.setGroupProperty(PropertyInterface("Points", m)),
                f.p.setGroupProperty(PropertyInterface("Position", m)),
                f.r.setGroupProperty(PropertyInterface("Rotation", m)),
                v.ir && (f.ir.setGroupProperty(PropertyInterface("Inner Radius", m)),
                f.is.setGroupProperty(PropertyInterface("Inner Roundness", m))),
                Object.defineProperties(u, {
                    position: {
                        get: ExpressionPropertyInterface(f.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(f.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(f.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(f.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(f.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(f.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(f.is)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            function S(v, d, b) {
                function u(y) {
                    return v.p.ix === y ? u.position : v.r.ix === y ? u.roundness : v.s.ix === y || y === "Size" || y === "ADBE Vector Rect Size" ? u.size : null
                }
                var m = propertyGroupFactory(u, b)
                  , f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
                return u.propertyIndex = v.ix,
                f.p.setGroupProperty(PropertyInterface("Position", m)),
                f.s.setGroupProperty(PropertyInterface("Size", m)),
                f.r.setGroupProperty(PropertyInterface("Rotation", m)),
                Object.defineProperties(u, {
                    position: {
                        get: ExpressionPropertyInterface(f.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(f.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(f.s)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            function c(v, d, b) {
                function u(y) {
                    return v.r.ix === y || y === "Round Corners 1" ? u.radius : null
                }
                var m = propertyGroupFactory(u, b)
                  , f = d;
                return u.propertyIndex = v.ix,
                f.rd.setGroupProperty(PropertyInterface("Radius", m)),
                Object.defineProperties(u, {
                    radius: {
                        get: ExpressionPropertyInterface(f.rd)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            function g(v, d, b) {
                function u(y) {
                    return v.c.ix === y || y === "Copies" ? u.copies : v.o.ix === y || y === "Offset" ? u.offset : null
                }
                var m = propertyGroupFactory(u, b)
                  , f = d;
                return u.propertyIndex = v.ix,
                f.c.setGroupProperty(PropertyInterface("Copies", m)),
                f.o.setGroupProperty(PropertyInterface("Offset", m)),
                Object.defineProperties(u, {
                    copies: {
                        get: ExpressionPropertyInterface(f.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(f.o)
                    },
                    _name: {
                        value: v.nm
                    }
                }),
                u.mn = v.mn,
                u
            }
            return function(v, d, b) {
                var u;
                function m(y) {
                    if (typeof y == "number")
                        return y = y === void 0 ? 1 : y,
                        y === 0 ? b : u[y - 1];
                    for (var _ = 0, T = u.length; _ < T; ) {
                        if (u[_]._name === y)
                            return u[_];
                        _ += 1
                    }
                    return null
                }
                function f() {
                    return b
                }
                return m.propertyGroup = propertyGroupFactory(m, f),
                u = t(v, d, m.propertyGroup),
                m.numProperties = u.length,
                m._name = "Contents",
                m
            }
        }()
          , TextExpressionInterface = function() {
            return function(t) {
                var e;
                function r(i) {
                    switch (i) {
                    case "ADBE Text Document":
                        return r.sourceText;
                    default:
                        return null
                    }
                }
                return Object.defineProperty(r, "sourceText", {
                    get: function() {
                        t.textProperty.getValue();
                        var s = t.textProperty.currentData.t;
                        return (!e || s !== e.value) && (e = new String(s),
                        e.value = s || new String(s),
                        Object.defineProperty(e, "style", {
                            get: function() {
                                return {
                                    fillColor: t.textProperty.currentData.fc
                                }
                            }
                        })),
                        e
                    }
                }),
                r
            }
        }();
        function _typeof(t) {
            "@babel/helpers - typeof";
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(r) {
                return typeof r
            }
            : _typeof = function(r) {
                return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r
            }
            ,
            _typeof(t)
        }
        var FootageInterface = function() {
            var t = function(i) {
                var s = ""
                  , n = i.getFootageData();
                function a() {
                    return s = "",
                    n = i.getFootageData(),
                    l
                }
                function l(o) {
                    if (n[o])
                        return s = o,
                        n = n[o],
                        _typeof(n) === "object" ? l : n;
                    var h = o.indexOf(s);
                    if (h !== -1) {
                        var p = parseInt(o.substr(h + s.length), 10);
                        return n = n[p],
                        _typeof(n) === "object" ? l : n
                    }
                    return ""
                }
                return a
            }
              , e = function(i) {
                function s(n) {
                    return n === "Outline" ? s.outlineInterface() : null
                }
                return s._name = "Outline",
                s.outlineInterface = t(i),
                s
            };
            return function(r) {
                function i(s) {
                    return s === "Data" ? i.dataInterface : null
                }
                return i._name = "Data",
                i.dataInterface = e(r),
                i
            }
        }()
          , interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null
        }
        var expressionHelpers = function() {
            function t(a, l, o) {
                l.x && (o.k = !0,
                o.x = !0,
                o.initiateExpression = ExpressionManager.initiateExpression,
                o.effectsSequence.push(o.initiateExpression(a, l, o).bind(o)))
            }
            function e(a) {
                return a *= this.elem.globalData.frameRate,
                a -= this.offsetTime,
                a !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < a ? this._cachingAtTime.lastIndex : 0,
                this._cachingAtTime.value = this.interpolateValue(a, this._cachingAtTime),
                this._cachingAtTime.lastFrame = a),
                this._cachingAtTime.value
            }
            function r(a) {
                var l = -.01
                  , o = this.getValueAtTime(a)
                  , h = this.getValueAtTime(a + l)
                  , p = 0;
                if (o.length) {
                    var S;
                    for (S = 0; S < o.length; S += 1)
                        p += Math.pow(h[S] - o[S], 2);
                    p = Math.sqrt(p) * 100
                } else
                    p = 0;
                return p
            }
            function i(a) {
                if (this.vel !== void 0)
                    return this.vel;
                var l = -.001, o = this.getValueAtTime(a), h = this.getValueAtTime(a + l), p;
                if (o.length) {
                    p = createTypedArray("float32", o.length);
                    var S;
                    for (S = 0; S < o.length; S += 1)
                        p[S] = (h[S] - o[S]) / l
                } else
                    p = (h - o) / l;
                return p
            }
            function s() {
                return this.pv
            }
            function n(a) {
                this.propertyGroup = a
            }
            return {
                searchExpressions: t,
                getSpeedAtTime: r,
                getVelocityAtTime: i,
                getValueAtTime: e,
                getStaticValueAtTime: s,
                setGroupProperty: n
            }
        }();
        function addPropertyDecorator() {
            function t(c, g, v) {
                if (!this.k || !this.keyframes)
                    return this.pv;
                c = c ? c.toLowerCase() : "";
                var d = this.comp.renderedFrame
                  , b = this.keyframes
                  , u = b[b.length - 1].t;
                if (d <= u)
                    return this.pv;
                var m, f;
                v ? (g ? m = Math.abs(u - this.elem.comp.globalData.frameRate * g) : m = Math.max(0, u - this.elem.data.ip),
                f = u - m) : ((!g || g > b.length - 1) && (g = b.length - 1),
                f = b[b.length - 1 - g].t,
                m = u - f);
                var y, _, T;
                if (c === "pingpong") {
                    var C = Math.floor((d - f) / m);
                    if (C % 2 !== 0)
                        return this.getValueAtTime((m - (d - f) % m + f) / this.comp.globalData.frameRate, 0)
                } else if (c === "offset") {
                    var x = this.getValueAtTime(f / this.comp.globalData.frameRate, 0)
                      , w = this.getValueAtTime(u / this.comp.globalData.frameRate, 0)
                      , D = this.getValueAtTime(((d - f) % m + f) / this.comp.globalData.frameRate, 0)
                      , k = Math.floor((d - f) / m);
                    if (this.pv.length) {
                        for (T = new Array(x.length),
                        _ = T.length,
                        y = 0; y < _; y += 1)
                            T[y] = (w[y] - x[y]) * k + D[y];
                        return T
                    }
                    return (w - x) * k + D
                } else if (c === "continue") {
                    var L = this.getValueAtTime(u / this.comp.globalData.frameRate, 0)
                      , V = this.getValueAtTime((u - .001) / this.comp.globalData.frameRate, 0);
                    if (this.pv.length) {
                        for (T = new Array(L.length),
                        _ = T.length,
                        y = 0; y < _; y += 1)
                            T[y] = L[y] + (L[y] - V[y]) * ((d - u) / this.comp.globalData.frameRate) / 5e-4;
                        return T
                    }
                    return L + (L - V) * ((d - u) / .001)
                }
                return this.getValueAtTime(((d - f) % m + f) / this.comp.globalData.frameRate, 0)
            }
            function e(c, g, v) {
                if (!this.k)
                    return this.pv;
                c = c ? c.toLowerCase() : "";
                var d = this.comp.renderedFrame
                  , b = this.keyframes
                  , u = b[0].t;
                if (d >= u)
                    return this.pv;
                var m, f;
                v ? (g ? m = Math.abs(this.elem.comp.globalData.frameRate * g) : m = Math.max(0, this.elem.data.op - u),
                f = u + m) : ((!g || g > b.length - 1) && (g = b.length - 1),
                f = b[g].t,
                m = f - u);
                var y, _, T;
                if (c === "pingpong") {
                    var C = Math.floor((u - d) / m);
                    if (C % 2 === 0)
                        return this.getValueAtTime(((u - d) % m + u) / this.comp.globalData.frameRate, 0)
                } else if (c === "offset") {
                    var x = this.getValueAtTime(u / this.comp.globalData.frameRate, 0)
                      , w = this.getValueAtTime(f / this.comp.globalData.frameRate, 0)
                      , D = this.getValueAtTime((m - (u - d) % m + u) / this.comp.globalData.frameRate, 0)
                      , k = Math.floor((u - d) / m) + 1;
                    if (this.pv.length) {
                        for (T = new Array(x.length),
                        _ = T.length,
                        y = 0; y < _; y += 1)
                            T[y] = D[y] - (w[y] - x[y]) * k;
                        return T
                    }
                    return D - (w - x) * k
                } else if (c === "continue") {
                    var L = this.getValueAtTime(u / this.comp.globalData.frameRate, 0)
                      , V = this.getValueAtTime((u + .001) / this.comp.globalData.frameRate, 0);
                    if (this.pv.length) {
                        for (T = new Array(L.length),
                        _ = T.length,
                        y = 0; y < _; y += 1)
                            T[y] = L[y] + (L[y] - V[y]) * (u - d) / .001;
                        return T
                    }
                    return L + (L - V) * (u - d) / .001
                }
                return this.getValueAtTime((m - ((u - d) % m + u)) / this.comp.globalData.frameRate, 0)
            }
            function r(c, g) {
                if (!this.k)
                    return this.pv;
                if (c = (c || .4) * .5,
                g = Math.floor(g || 5),
                g <= 1)
                    return this.pv;
                var v = this.comp.renderedFrame / this.comp.globalData.frameRate, d = v - c, b = v + c, u = g > 1 ? (b - d) / (g - 1) : 1, m = 0, f = 0, y;
                this.pv.length ? y = createTypedArray("float32", this.pv.length) : y = 0;
                for (var _; m < g; ) {
                    if (_ = this.getValueAtTime(d + m * u),
                    this.pv.length)
                        for (f = 0; f < this.pv.length; f += 1)
                            y[f] += _[f];
                    else
                        y += _;
                    m += 1
                }
                if (this.pv.length)
                    for (f = 0; f < this.pv.length; f += 1)
                        y[f] /= g;
                else
                    y /= g;
                return y
            }
            function i(c) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var g = this._transformCachingAtTime.v;
                if (g.cloneFromProps(this.pre.props),
                this.appliedTransformations < 1) {
                    var v = this.a.getValueAtTime(c);
                    g.translate(-v[0] * this.a.mult, -v[1] * this.a.mult, v[2] * this.a.mult)
                }
                if (this.appliedTransformations < 2) {
                    var d = this.s.getValueAtTime(c);
                    g.scale(d[0] * this.s.mult, d[1] * this.s.mult, d[2] * this.s.mult)
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var b = this.sk.getValueAtTime(c)
                      , u = this.sa.getValueAtTime(c);
                    g.skewFromAxis(-b * this.sk.mult, u * this.sa.mult)
                }
                if (this.r && this.appliedTransformations < 4) {
                    var m = this.r.getValueAtTime(c);
                    g.rotate(-m * this.r.mult)
                } else if (!this.r && this.appliedTransformations < 4) {
                    var f = this.rz.getValueAtTime(c)
                      , y = this.ry.getValueAtTime(c)
                      , _ = this.rx.getValueAtTime(c)
                      , T = this.or.getValueAtTime(c);
                    g.rotateZ(-f * this.rz.mult).rotateY(y * this.ry.mult).rotateX(_ * this.rx.mult).rotateZ(-T[2] * this.or.mult).rotateY(T[1] * this.or.mult).rotateX(T[0] * this.or.mult)
                }
                if (this.data.p && this.data.p.s) {
                    var C = this.px.getValueAtTime(c)
                      , x = this.py.getValueAtTime(c);
                    if (this.data.p.z) {
                        var w = this.pz.getValueAtTime(c);
                        g.translate(C * this.px.mult, x * this.py.mult, -w * this.pz.mult)
                    } else
                        g.translate(C * this.px.mult, x * this.py.mult, 0)
                } else {
                    var D = this.p.getValueAtTime(c);
                    g.translate(D[0] * this.p.mult, D[1] * this.p.mult, -D[2] * this.p.mult)
                }
                return g
            }
            function s() {
                return this.v.clone(new Matrix)
            }
            var n = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(c, g, v) {
                var d = n(c, g, v);
                return d.dynamicProperties.length ? d.getValueAtTime = i.bind(d) : d.getValueAtTime = s.bind(d),
                d.setGroupProperty = expressionHelpers.setGroupProperty,
                d
            }
            ;
            var a = PropertyFactory.getProp;
            PropertyFactory.getProp = function(c, g, v, d, b) {
                var u = a(c, g, v, d, b);
                u.kf ? u.getValueAtTime = expressionHelpers.getValueAtTime.bind(u) : u.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(u),
                u.setGroupProperty = expressionHelpers.setGroupProperty,
                u.loopOut = t,
                u.loopIn = e,
                u.smooth = r,
                u.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(u),
                u.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(u),
                u.numKeys = g.a === 1 ? g.k.length : 0,
                u.propertyIndex = g.ix;
                var m = 0;
                return v !== 0 && (m = createTypedArray("float32", g.a === 1 ? g.k[0].s.length : g.k.length)),
                u._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: m
                },
                expressionHelpers.searchExpressions(c, g, u),
                u.k && b.addDynamicProperty(u),
                u
            }
            ;
            function l(c) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }),
                c *= this.elem.globalData.frameRate,
                c -= this.offsetTime,
                c !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < c ? this._caching.lastIndex : 0,
                this._cachingAtTime.lastTime = c,
                this.interpolateShape(c, this._cachingAtTime.shapeValue, this._cachingAtTime)),
                this._cachingAtTime.shapeValue
            }
            var o = ShapePropertyFactory.getConstructorFunction()
              , h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function p() {}
            p.prototype = {
                vertices: function(g, v) {
                    this.k && this.getValue();
                    var d = this.v;
                    v !== void 0 && (d = this.getValueAtTime(v, 0));
                    var b, u = d._length, m = d[g], f = d.v, y = createSizedArray(u);
                    for (b = 0; b < u; b += 1)
                        g === "i" || g === "o" ? y[b] = [m[b][0] - f[b][0], m[b][1] - f[b][1]] : y[b] = [m[b][0], m[b][1]];
                    return y
                },
                points: function(g) {
                    return this.vertices("v", g)
                },
                inTangents: function(g) {
                    return this.vertices("i", g)
                },
                outTangents: function(g) {
                    return this.vertices("o", g)
                },
                isClosed: function() {
                    return this.v.c
                },
                pointOnPath: function(g, v) {
                    var d = this.v;
                    v !== void 0 && (d = this.getValueAtTime(v, 0)),
                    this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(d));
                    for (var b = this._segmentsLength, u = b.lengths, m = b.totalLength * g, f = 0, y = u.length, _ = 0, T; f < y; ) {
                        if (_ + u[f].addedLength > m) {
                            var C = f
                              , x = d.c && f === y - 1 ? 0 : f + 1
                              , w = (m - _) / u[f].addedLength;
                            T = bez.getPointInSegment(d.v[C], d.v[x], d.o[C], d.i[x], w, u[f]);
                            break
                        } else
                            _ += u[f].addedLength;
                        f += 1
                    }
                    return T || (T = d.c ? [d.v[0][0], d.v[0][1]] : [d.v[d._length - 1][0], d.v[d._length - 1][1]]),
                    T
                },
                vectorOnPath: function(g, v, d) {
                    g == 1 ? g = this.v.c : g == 0 && (g = .999);
                    var b = this.pointOnPath(g, v)
                      , u = this.pointOnPath(g + .001, v)
                      , m = u[0] - b[0]
                      , f = u[1] - b[1]
                      , y = Math.sqrt(Math.pow(m, 2) + Math.pow(f, 2));
                    if (y === 0)
                        return [0, 0];
                    var _ = d === "tangent" ? [m / y, f / y] : [-f / y, m / y];
                    return _
                },
                tangentOnPath: function(g, v) {
                    return this.vectorOnPath(g, v, "tangent")
                },
                normalOnPath: function(g, v) {
                    return this.vectorOnPath(g, v, "normal")
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            },
            extendPrototype([p], o),
            extendPrototype([p], h),
            h.prototype.getValueAtTime = l,
            h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var S = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(c, g, v, d, b) {
                var u = S(c, g, v, d, b);
                return u.propertyIndex = g.ix,
                u.lock = !1,
                v === 3 ? expressionHelpers.searchExpressions(c, g.pt, u) : v === 4 && expressionHelpers.searchExpressions(c, g.ks, u),
                u.k && c.addDynamicProperty(u),
                u
            }
        }
        function initialize$1() {
            addPropertyDecorator()
        }
        function addDecorator() {
            function t() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this),
                this.addEffect(this.getExpressionValue.bind(this)),
                !0) : null
            }
            TextProperty.prototype.getExpressionValue = function(e, r) {
                var i = this.calculateExpression(r);
                if (e.t !== i) {
                    var s = {};
                    return this.copyData(s, e),
                    s.t = i.toString(),
                    s.__complete = !1,
                    s
                }
                return e
            }
            ,
            TextProperty.prototype.searchProperty = function() {
                var e = this.searchKeyframes()
                  , r = this.searchExpressions();
                return this.kf = e || r,
                this.kf
            }
            ,
            TextProperty.prototype.searchExpressions = t
        }
        function initialize() {
            addDecorator()
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function t(e, r) {
                var i = createNS("feMerge");
                i.setAttribute("result", e);
                var s, n;
                for (n = 0; n < r.length; n += 1)
                    s = createNS("feMergeNode"),
                    s.setAttribute("in", r[n]),
                    i.appendChild(s),
                    i.appendChild(s);
                return i
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r, i, s) {
            this.filterManager = e;
            var n = createNS("feColorMatrix");
            n.setAttribute("type", "matrix"),
            n.setAttribute("color-interpolation-filters", "linearRGB"),
            n.setAttribute("values", linearFilterValue + " 1 0"),
            this.linearFilter = n,
            n.setAttribute("result", i + "_tint_1"),
            t.appendChild(n),
            n = createNS("feColorMatrix"),
            n.setAttribute("type", "matrix"),
            n.setAttribute("color-interpolation-filters", "sRGB"),
            n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
            n.setAttribute("result", i + "_tint_2"),
            t.appendChild(n),
            this.matrixFilter = n;
            var a = this.createMergeNode(i, [s, i + "_tint_1", i + "_tint_2"]);
            t.appendChild(a)
        }
        extendPrototype([SVGComposableEffect], SVGTintFilter),
        SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v
                  , r = this.filterManager.effectElements[1].p.v
                  , i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"),
                this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0")
            }
        }
        ;
        function SVGFillFilter(t, e, r, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"),
            s.setAttribute("color-interpolation-filters", "sRGB"),
            s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
            s.setAttribute("result", i),
            t.appendChild(s),
            this.matrixFilter = s
        }
        SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v
                  , r = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0")
            }
        }
        ;
        function SVGStrokeEffect(t, e, r) {
            this.initialized = !1,
            this.filterManager = e,
            this.elem = r,
            this.paths = []
        }
        SVGStrokeEffect.prototype.initialize = function() {
            var t = this.elem.layerElement.children || this.elem.layerElement.childNodes, e, r, i, s;
            for (this.filterManager.effectElements[1].p.v === 1 ? (s = this.elem.maskManager.masksProperties.length,
            i = 0) : (i = this.filterManager.effectElements[0].p.v - 1,
            s = i + 1),
            r = createNS("g"),
            r.setAttribute("fill", "none"),
            r.setAttribute("stroke-linecap", "round"),
            r.setAttribute("stroke-dashoffset", 1),
            i; i < s; i += 1)
                e = createNS("path"),
                r.appendChild(e),
                this.paths.push({
                    p: e,
                    m: i
                });
            if (this.filterManager.effectElements[10].p.v === 3) {
                var n = createNS("mask")
                  , a = createElementID();
                n.setAttribute("id", a),
                n.setAttribute("mask-type", "alpha"),
                n.appendChild(r),
                this.elem.globalData.defs.appendChild(n);
                var l = createNS("g");
                for (l.setAttribute("mask", "url(" + getLocationHref() + "#" + a + ")"); t[0]; )
                    l.appendChild(t[0]);
                this.elem.layerElement.appendChild(l),
                this.masker = n,
                r.setAttribute("stroke", "#fff")
            } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
                if (this.filterManager.effectElements[10].p.v === 2)
                    for (t = this.elem.layerElement.children || this.elem.layerElement.childNodes; t.length; )
                        this.elem.layerElement.removeChild(t[0]);
                this.elem.layerElement.appendChild(r),
                this.elem.layerElement.removeAttribute("mask"),
                r.setAttribute("stroke", "#fff")
            }
            this.initialized = !0,
            this.pathMasker = r
        }
        ,
        SVGStrokeEffect.prototype.renderFrame = function(t) {
            this.initialized || this.initialize();
            var e, r = this.paths.length, i, s;
            for (e = 0; e < r; e += 1)
                if (this.paths[e].m !== -1 && (i = this.elem.maskManager.viewData[this.paths[e].m],
                s = this.paths[e].p,
                (t || this.filterManager._mdf || i.prop._mdf) && s.setAttribute("d", i.lastPath),
                t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || i.prop._mdf)) {
                    var n;
                    if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                        var a = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * .01
                          , l = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * .01
                          , o = s.getTotalLength();
                        n = "0 0 0 " + o * a + " ";
                        var h = o * (l - a), p = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * .01, S = Math.floor(h / p), c;
                        for (c = 0; c < S; c += 1)
                            n += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * .01 + " ";
                        n += "0 " + o * 10 + " 0 0"
                    } else
                        n = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * .01;
                    s.setAttribute("stroke-dasharray", n)
                }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2),
            (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v),
            (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var g = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(g[0] * 255) + "," + bmFloor(g[1] * 255) + "," + bmFloor(g[2] * 255) + ")")
            }
        }
        ;
        function SVGTritoneFilter(t, e, r, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"),
            s.setAttribute("color-interpolation-filters", "linearRGB"),
            s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"),
            t.appendChild(s);
            var n = createNS("feComponentTransfer");
            n.setAttribute("color-interpolation-filters", "sRGB"),
            n.setAttribute("result", i),
            this.matrixFilter = n;
            var a = createNS("feFuncR");
            a.setAttribute("type", "table"),
            n.appendChild(a),
            this.feFuncR = a;
            var l = createNS("feFuncG");
            l.setAttribute("type", "table"),
            n.appendChild(l),
            this.feFuncG = l;
            var o = createNS("feFuncB");
            o.setAttribute("type", "table"),
            n.appendChild(o),
            this.feFuncB = o,
            t.appendChild(n)
        }
        SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v
                  , r = this.filterManager.effectElements[1].p.v
                  , i = this.filterManager.effectElements[2].p.v
                  , s = i[0] + " " + r[0] + " " + e[0]
                  , n = i[1] + " " + r[1] + " " + e[1]
                  , a = i[2] + " " + r[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", s),
                this.feFuncG.setAttribute("tableValues", n),
                this.feFuncB.setAttribute("tableValues", a)
            }
        }
        ;
        function SVGProLevelsFilter(t, e, r, i) {
            this.filterManager = e;
            var s = this.filterManager.effectElements
              , n = createNS("feComponentTransfer");
            (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", n)),
            (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", n)),
            (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", n)),
            (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", n)),
            (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (n.setAttribute("color-interpolation-filters", "sRGB"),
            t.appendChild(n)),
            (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && (n = createNS("feComponentTransfer"),
            n.setAttribute("color-interpolation-filters", "sRGB"),
            n.setAttribute("result", i),
            t.appendChild(n),
            this.feFuncRComposed = this.createFeFunc("feFuncR", n),
            this.feFuncGComposed = this.createFeFunc("feFuncG", n),
            this.feFuncBComposed = this.createFeFunc("feFuncB", n))
        }
        SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r = createNS(t);
            return r.setAttribute("type", "table"),
            e.appendChild(r),
            r
        }
        ,
        SVGProLevelsFilter.prototype.getTableValue = function(t, e, r, i, s) {
            for (var n = 0, a = 256, l, o = Math.min(t, e), h = Math.max(t, e), p = Array.call(null, {
                length: a
            }), S, c = 0, g = s - i, v = e - t; n <= 256; )
                l = n / 256,
                l <= o ? S = v < 0 ? s : i : l >= h ? S = v < 0 ? i : s : S = i + g * Math.pow((l - t) / v, 1 / r),
                p[c] = S,
                c += 1,
                n += 256 / (a - 1);
            return p.join(" ")
        }
        ,
        SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v),
                this.feFuncRComposed.setAttribute("tableValues", e),
                this.feFuncGComposed.setAttribute("tableValues", e),
                this.feFuncBComposed.setAttribute("tableValues", e)),
                this.feFuncR && (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v),
                this.feFuncR.setAttribute("tableValues", e)),
                this.feFuncG && (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v),
                this.feFuncG.setAttribute("tableValues", e)),
                this.feFuncB && (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v),
                this.feFuncB.setAttribute("tableValues", e)),
                this.feFuncA && (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v),
                this.feFuncA.setAttribute("tableValues", e))
            }
        }
        ;
        function SVGDropShadowEffect(t, e, r, i, s) {
            var n = e.container.globalData.renderConfig.filterSize
              , a = e.data.fs || n;
            t.setAttribute("x", a.x || n.x),
            t.setAttribute("y", a.y || n.y),
            t.setAttribute("width", a.width || n.width),
            t.setAttribute("height", a.height || n.height),
            this.filterManager = e;
            var l = createNS("feGaussianBlur");
            l.setAttribute("in", "SourceAlpha"),
            l.setAttribute("result", i + "_drop_shadow_1"),
            l.setAttribute("stdDeviation", "0"),
            this.feGaussianBlur = l,
            t.appendChild(l);
            var o = createNS("feOffset");
            o.setAttribute("dx", "25"),
            o.setAttribute("dy", "0"),
            o.setAttribute("in", i + "_drop_shadow_1"),
            o.setAttribute("result", i + "_drop_shadow_2"),
            this.feOffset = o,
            t.appendChild(o);
            var h = createNS("feFlood");
            h.setAttribute("flood-color", "#00ff00"),
            h.setAttribute("flood-opacity", "1"),
            h.setAttribute("result", i + "_drop_shadow_3"),
            this.feFlood = h,
            t.appendChild(h);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"),
            p.setAttribute("in2", i + "_drop_shadow_2"),
            p.setAttribute("operator", "in"),
            p.setAttribute("result", i + "_drop_shadow_4"),
            t.appendChild(p);
            var S = this.createMergeNode(i, [i + "_drop_shadow_4", s]);
            t.appendChild(S)
        }
        extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
        SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4),
                t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(e[0] * 255), Math.round(e[1] * 255), Math.round(e[2] * 255)))
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255),
                t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r = this.filterManager.effectElements[3].p.v
                      , i = (this.filterManager.effectElements[2].p.v - 90) * degToRads
                      , s = r * Math.cos(i)
                      , n = r * Math.sin(i);
                    this.feOffset.setAttribute("dx", s),
                    this.feOffset.setAttribute("dy", n)
                }
            }
        }
        ;
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r) {
            this.initialized = !1,
            this.filterManager = e,
            this.filterElem = t,
            this.elem = r,
            r.matteElement = createNS("g"),
            r.matteElement.appendChild(r.layerElement),
            r.matteElement.appendChild(r.transformedElement),
            r.baseElement = r.matteElement
        }
        SVGMatte3Effect.prototype.findSymbol = function(t) {
            for (var e = 0, r = _svgMatteSymbols.length; e < r; ) {
                if (_svgMatteSymbols[e] === t)
                    return _svgMatteSymbols[e];
                e += 1
            }
            return null
        }
        ,
        SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r = t.layerElement.parentNode;
            if (r) {
                for (var i = r.children, s = 0, n = i.length; s < n && i[s] !== t.layerElement; )
                    s += 1;
                var a;
                s <= n - 2 && (a = i[s + 1]);
                var l = createNS("use");
                l.setAttribute("href", "#" + e),
                a ? r.insertBefore(l, a) : r.appendChild(l)
            }
        }
        ,
        SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r = createElementID()
                  , i = createNS("mask");
                i.setAttribute("id", e.layerId),
                i.setAttribute("mask-type", "alpha"),
                _svgMatteSymbols.push(e);
                var s = t.globalData.defs;
                s.appendChild(i);
                var n = createNS("symbol");
                n.setAttribute("id", r),
                this.replaceInParent(e, r),
                n.appendChild(e.layerElement),
                s.appendChild(n);
                var a = createNS("use");
                a.setAttribute("href", "#" + r),
                i.appendChild(a),
                e.data.hd = !1,
                e.show()
            }
            t.setMatte(e.layerId)
        }
        ,
        SVGMatte3Effect.prototype.initialize = function() {
            for (var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i; )
                e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]),
                r += 1;
            this.initialized = !0
        }
        ,
        SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize()
        }
        ;
        function SVGGaussianBlurEffect(t, e, r, i) {
            t.setAttribute("x", "-100%"),
            t.setAttribute("y", "-100%"),
            t.setAttribute("width", "300%"),
            t.setAttribute("height", "300%"),
            this.filterManager = e;
            var s = createNS("feGaussianBlur");
            s.setAttribute("result", i),
            t.appendChild(s),
            this.feGaussianBlur = s
        }
        SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3
                  , r = this.filterManager.effectElements[0].p.v * e
                  , i = this.filterManager.effectElements[1].p.v
                  , s = i == 3 ? 0 : r
                  , n = i == 2 ? 0 : r;
                this.feGaussianBlur.setAttribute("stdDeviation", s + " " + n);
                var a = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", a)
            }
        }
        ;
        function TransformEffect() {}
        TransformEffect.prototype.init = function(t) {
            this.effectsManager = t,
            this.type = effectTypes.TRANSFORM_EFFECT,
            this.matrix = new Matrix,
            this.opacity = -1,
            this._mdf = !1,
            this._opMdf = !1
        }
        ,
        TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1,
            this._mdf = !1,
            t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements
                  , r = e[0].p.v
                  , i = e[1].p.v
                  , s = e[2].p.v === 1
                  , n = e[3].p.v
                  , a = s ? n : e[4].p.v
                  , l = e[5].p.v
                  , o = e[6].p.v
                  , h = e[7].p.v;
                this.matrix.reset(),
                this.matrix.translate(-r[0], -r[1], r[2]),
                this.matrix.scale(a * .01, n * .01, 1),
                this.matrix.rotate(-h * degToRads),
                this.matrix.skewFromAxis(-l * degToRads, (o + 90) * degToRads),
                this.matrix.translate(i[0], i[1], 0),
                this._mdf = !0,
                this.opacity !== e[8].p.v && (this.opacity = e[8].p.v,
                this._opMdf = !0)
            }
        }
        ;
        function SVGTransformEffect(t, e) {
            this.init(e)
        }
        extendPrototype([TransformEffect], SVGTransformEffect);
        function CVTransformEffect(t) {
            this.init(t)
        }
        return extendPrototype([TransformEffect], CVTransformEffect),
        registerRenderer("canvas", CanvasRenderer),
        registerRenderer("html", HybridRenderer),
        registerRenderer("svg", SVGRenderer),
        ShapeModifiers.registerModifier("tm", TrimModifier),
        ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
        ShapeModifiers.registerModifier("rp", RepeaterModifier),
        ShapeModifiers.registerModifier("rd", RoundCornersModifier),
        ShapeModifiers.registerModifier("zz", ZigZagModifier),
        ShapeModifiers.registerModifier("op", OffsetPathModifier),
        setExpressionsPlugin(Expressions),
        setExpressionInterfaces(getInterface),
        initialize$1(),
        initialize(),
        registerEffect$1(20, SVGTintFilter, !0),
        registerEffect$1(21, SVGFillFilter, !0),
        registerEffect$1(22, SVGStrokeEffect, !1),
        registerEffect$1(23, SVGTritoneFilter, !0),
        registerEffect$1(24, SVGProLevelsFilter, !0),
        registerEffect$1(25, SVGDropShadowEffect, !0),
        registerEffect$1(28, SVGMatte3Effect, !1),
        registerEffect$1(29, SVGGaussianBlurEffect, !0),
        registerEffect$1(35, SVGTransformEffect, !1),
        registerEffect(35, CVTransformEffect),
        lottie
    })
}
)(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = getDefaultExportFromCjs(lottieExports);
function _defineProperties(t, e) {
    for (var r = 0; r < e.length; r++) {
        var i = e[r];
        i.enumerable = i.enumerable || !1,
        i.configurable = !0,
        "value"in i && (i.writable = !0),
        Object.defineProperty(t, i.key, i)
    }
}
function _createClass(t, e, r) {
    return e && _defineProperties(t.prototype, e),
    r && _defineProperties(t, r),
    Object.defineProperty(t, "prototype", {
        writable: !1
    }),
    t
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)"
  , CREATED = 1
  , MOUNTED = 2
  , IDLE = 3
  , MOVING = 4
  , SCROLLING = 5
  , DRAGGING = 6
  , DESTROYED = 7
  , STATES = {
    CREATED,
    MOUNTED,
    IDLE,
    MOVING,
    SCROLLING,
    DRAGGING,
    DESTROYED
};
function empty$1(t) {
    t.length = 0
}
function slice$2(t, e, r) {
    return Array.prototype.slice.call(t, e, r)
}
function apply$2(t) {
    return t.bind.apply(t, [null].concat(slice$2(arguments, 1)))
}
var nextTick = setTimeout
  , noop = function t() {};
function raf$1(t) {
    return requestAnimationFrame(t)
}
function typeOf$2(t, e) {
    return typeof e === t
}
function isObject$1(t) {
    return !isNull$1(t) && typeOf$2("object", t)
}
var isArray$2 = Array.isArray
  , isFunction = apply$2(typeOf$2, "function")
  , isString = apply$2(typeOf$2, "string")
  , isUndefined$1 = apply$2(typeOf$2, "undefined");
function isNull$1(t) {
    return t === null
}
function isHTMLElement(t) {
    try {
        return t instanceof (t.ownerDocument.defaultView || window).HTMLElement
    } catch {
        return !1
    }
}
function toArray$2(t) {
    return isArray$2(t) ? t : [t]
}
function forEach$2(t, e) {
    toArray$2(t).forEach(e)
}
function includes(t, e) {
    return t.indexOf(e) > -1
}
function push(t, e) {
    return t.push.apply(t, toArray$2(e)),
    t
}
function toggleClass$1(t, e, r) {
    t && forEach$2(e, function(i) {
        i && t.classList[r ? "add" : "remove"](i)
    })
}
function addClass(t, e) {
    toggleClass$1(t, isString(e) ? e.split(" ") : e, !0)
}
function append(t, e) {
    forEach$2(e, t.appendChild.bind(t))
}
function before(t, e) {
    forEach$2(t, function(r) {
        var i = (e || r).parentNode;
        i && i.insertBefore(r, e)
    })
}
function matches(t, e) {
    return isHTMLElement(t) && (t.msMatchesSelector || t.matches).call(t, e)
}
function children(t, e) {
    var r = t ? slice$2(t.children) : [];
    return e ? r.filter(function(i) {
        return matches(i, e)
    }) : r
}
function child(t, e) {
    return e ? children(t, e)[0] : t.firstElementChild
}
var ownKeys$2 = Object.keys;
function forOwn$2(t, e, r) {
    return t && (r ? ownKeys$2(t).reverse() : ownKeys$2(t)).forEach(function(i) {
        i !== "__proto__" && e(t[i], i)
    }),
    t
}
function assign$2(t) {
    return slice$2(arguments, 1).forEach(function(e) {
        forOwn$2(e, function(r, i) {
            t[i] = e[i]
        })
    }),
    t
}
function merge(t) {
    return slice$2(arguments, 1).forEach(function(e) {
        forOwn$2(e, function(r, i) {
            isArray$2(r) ? t[i] = r.slice() : isObject$1(r) ? t[i] = merge({}, isObject$1(t[i]) ? t[i] : {}, r) : t[i] = r
        })
    }),
    t
}
function omit(t, e) {
    forEach$2(e || ownKeys$2(t), function(r) {
        delete t[r]
    })
}
function removeAttribute$1(t, e) {
    forEach$2(t, function(r) {
        forEach$2(e, function(i) {
            r && r.removeAttribute(i)
        })
    })
}
function setAttribute$1(t, e, r) {
    isObject$1(e) ? forOwn$2(e, function(i, s) {
        setAttribute$1(t, s, i)
    }) : forEach$2(t, function(i) {
        isNull$1(r) || r === "" ? removeAttribute$1(i, e) : i.setAttribute(e, String(r))
    })
}
function create(t, e, r) {
    var i = document.createElement(t);
    return e && (isString(e) ? addClass(i, e) : setAttribute$1(i, e)),
    r && append(r, i),
    i
}
function style(t, e, r) {
    if (isUndefined$1(r))
        return getComputedStyle(t)[e];
    isNull$1(r) || (t.style[e] = "" + r)
}
function display(t, e) {
    style(t, "display", e)
}
function focus(t) {
    t.setActive && t.setActive() || t.focus({
        preventScroll: !0
    })
}
function getAttribute(t, e) {
    return t.getAttribute(e)
}
function hasClass(t, e) {
    return t && t.classList.contains(e)
}
function rect(t) {
    return t.getBoundingClientRect()
}
function remove(t) {
    forEach$2(t, function(e) {
        e && e.parentNode && e.parentNode.removeChild(e)
    })
}
function parseHtml(t) {
    return child(new DOMParser().parseFromString(t, "text/html").body)
}
function prevent(t, e) {
    t.preventDefault(),
    e && (t.stopPropagation(),
    t.stopImmediatePropagation())
}
function query(t, e) {
    return t && t.querySelector(e)
}
function queryAll(t, e) {
    return e ? slice$2(t.querySelectorAll(e)) : []
}
function removeClass(t, e) {
    toggleClass$1(t, e, !1)
}
function timeOf(t) {
    return t.timeStamp
}
function unit(t) {
    return isString(t) ? t : t ? t + "px" : ""
}
var PROJECT_CODE = "splide"
  , DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(t, e) {
    if (!t)
        throw new Error("[" + PROJECT_CODE + "] " + (e || ""))
}
var min$2 = Math.min
  , max$1 = Math.max
  , floor$1 = Math.floor
  , ceil$1 = Math.ceil
  , abs$1 = Math.abs;
function approximatelyEqual(t, e, r) {
    return abs$1(t - e) < r
}
function between(t, e, r, i) {
    var s = min$2(e, r)
      , n = max$1(e, r);
    return i ? s < t && t < n : s <= t && t <= n
}
function clamp$1(t, e, r) {
    var i = min$2(e, r)
      , s = max$1(e, r);
    return min$2(max$1(i, t), s)
}
function sign(t) {
    return +(t > 0) - +(t < 0)
}
function format(t, e) {
    return forEach$2(e, function(r) {
        t = t.replace("%s", "" + r)
    }),
    t
}
function pad(t) {
    return t < 10 ? "0" + t : "" + t
}
var ids = {};
function uniqueId(t) {
    return "" + t + pad(ids[t] = (ids[t] || 0) + 1)
}
function EventBinder$1() {
    var t = [];
    function e(a, l, o, h) {
        s(a, l, function(p, S, c) {
            var g = "addEventListener"in p
              , v = g ? p.removeEventListener.bind(p, S, o, h) : p.removeListener.bind(p, o);
            g ? p.addEventListener(S, o, h) : p.addListener(o),
            t.push([p, S, c, o, v])
        })
    }
    function r(a, l, o) {
        s(a, l, function(h, p, S) {
            t = t.filter(function(c) {
                return c[0] === h && c[1] === p && c[2] === S && (!o || c[3] === o) ? (c[4](),
                !1) : !0
            })
        })
    }
    function i(a, l, o) {
        var h, p = !0;
        return typeof CustomEvent == "function" ? h = new CustomEvent(l,{
            bubbles: p,
            detail: o
        }) : (h = document.createEvent("CustomEvent"),
        h.initCustomEvent(l, p, !1, o)),
        a.dispatchEvent(h),
        h
    }
    function s(a, l, o) {
        forEach$2(a, function(h) {
            h && forEach$2(l, function(p) {
                p.split(" ").forEach(function(S) {
                    var c = S.split(".");
                    o(h, c[0], c[1])
                })
            })
        })
    }
    function n() {
        t.forEach(function(a) {
            a[4]()
        }),
        empty$1(t)
    }
    return {
        bind: e,
        unbind: r,
        dispatch: i,
        destroy: n
    }
}
var EVENT_MOUNTED = "mounted"
  , EVENT_READY = "ready"
  , EVENT_MOVE$1 = "move"
  , EVENT_MOVED$1 = "moved"
  , EVENT_CLICK = "click"
  , EVENT_ACTIVE = "active"
  , EVENT_INACTIVE = "inactive"
  , EVENT_VISIBLE = "visible"
  , EVENT_HIDDEN = "hidden"
  , EVENT_REFRESH = "refresh"
  , EVENT_UPDATED$1 = "updated"
  , EVENT_RESIZE = "resize"
  , EVENT_RESIZED = "resized"
  , EVENT_DRAG$1 = "drag"
  , EVENT_DRAGGING = "dragging"
  , EVENT_DRAGGED$1 = "dragged"
  , EVENT_SCROLL$1 = "scroll"
  , EVENT_SCROLLED$1 = "scrolled"
  , EVENT_OVERFLOW = "overflow"
  , EVENT_DESTROY$1 = "destroy"
  , EVENT_ARROWS_MOUNTED = "arrows:mounted"
  , EVENT_ARROWS_UPDATED = "arrows:updated"
  , EVENT_PAGINATION_MOUNTED = "pagination:mounted"
  , EVENT_PAGINATION_UPDATED = "pagination:updated"
  , EVENT_NAVIGATION_MOUNTED = "navigation:mounted"
  , EVENT_AUTOPLAY_PLAY = "autoplay:play"
  , EVENT_AUTOPLAY_PLAYING = "autoplay:playing"
  , EVENT_AUTOPLAY_PAUSE = "autoplay:pause"
  , EVENT_LAZYLOAD_LOADED = "lazyload:loaded"
  , EVENT_SLIDE_KEYDOWN = "sk"
  , EVENT_SHIFTED = "sh"
  , EVENT_END_INDEX_CHANGED = "ei";
function EventInterface$1(t) {
    var e = t ? t.event.bus : document.createDocumentFragment()
      , r = EventBinder$1();
    function i(n, a) {
        r.bind(e, toArray$2(n).join(" "), function(l) {
            a.apply(a, isArray$2(l.detail) ? l.detail : [])
        })
    }
    function s(n) {
        r.dispatch(e, n, slice$2(arguments, 1))
    }
    return t && t.event.on(EVENT_DESTROY$1, r.destroy),
    assign$2(r, {
        bus: e,
        on: i,
        off: apply$2(r.unbind, e),
        emit: s
    })
}
function RequestInterval$1(t, e, r, i) {
    var s = Date.now, n, a = 0, l, o = !0, h = 0;
    function p() {
        if (!o) {
            if (a = t ? min$2((s() - n) / t, 1) : 1,
            r && r(a),
            a >= 1 && (e(),
            n = s(),
            i && ++h >= i))
                return c();
            l = raf$1(p)
        }
    }
    function S(u) {
        u || v(),
        n = s() - (u ? a * t : 0),
        o = !1,
        l = raf$1(p)
    }
    function c() {
        o = !0
    }
    function g() {
        n = s(),
        a = 0,
        r && r(a)
    }
    function v() {
        l && cancelAnimationFrame(l),
        a = 0,
        l = 0,
        o = !0
    }
    function d(u) {
        t = u
    }
    function b() {
        return o
    }
    return {
        start: S,
        rewind: g,
        pause: c,
        cancel: v,
        set: d,
        isPaused: b
    }
}
function State(t) {
    var e = t;
    function r(s) {
        e = s
    }
    function i(s) {
        return includes(toArray$2(s), e)
    }
    return {
        set: r,
        is: i
    }
}
function Throttle$1(t, e) {
    var r = RequestInterval$1(e || 0, t, null, 1);
    return function() {
        r.isPaused() && r.start()
    }
}
function Media(t, e, r) {
    var i = t.state
      , s = r.breakpoints || {}
      , n = r.reducedMotion || {}
      , a = EventBinder$1()
      , l = [];
    function o() {
        var v = r.mediaQuery === "min";
        ownKeys$2(s).sort(function(d, b) {
            return v ? +d - +b : +b - +d
        }).forEach(function(d) {
            p(s[d], "(" + (v ? "min" : "max") + "-width:" + d + "px)")
        }),
        p(n, MEDIA_PREFERS_REDUCED_MOTION),
        S()
    }
    function h(v) {
        v && a.destroy()
    }
    function p(v, d) {
        var b = matchMedia(d);
        a.bind(b, "change", S),
        l.push([v, b])
    }
    function S() {
        var v = i.is(DESTROYED)
          , d = r.direction
          , b = l.reduce(function(u, m) {
            return merge(u, m[1].matches ? m[0] : {})
        }, {});
        omit(r),
        g(b),
        r.destroy ? t.destroy(r.destroy === "completely") : v ? (h(!0),
        t.mount()) : d !== r.direction && t.refresh()
    }
    function c(v) {
        matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches && (v ? merge(r, n) : omit(r, ownKeys$2(n)))
    }
    function g(v, d, b) {
        merge(r, v),
        d && merge(Object.getPrototypeOf(r), v),
        (b || !i.is(CREATED)) && t.emit(EVENT_UPDATED$1, r)
    }
    return {
        setup: o,
        destroy: h,
        reduce: c,
        set: g
    }
}
var ARROW = "Arrow"
  , ARROW_LEFT = ARROW + "Left"
  , ARROW_RIGHT = ARROW + "Right"
  , ARROW_UP = ARROW + "Up"
  , ARROW_DOWN = ARROW + "Down"
  , RTL = "rtl"
  , TTB = "ttb"
  , ORIENTATION_MAP = {
    width: ["height"],
    left: ["top", "right"],
    right: ["bottom", "left"],
    x: ["y"],
    X: ["Y"],
    Y: ["X"],
    ArrowLeft: [ARROW_UP, ARROW_RIGHT],
    ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(t, e, r) {
    function i(n, a, l) {
        l = l || r.direction;
        var o = l === RTL && !a ? 1 : l === TTB ? 0 : -1;
        return ORIENTATION_MAP[n] && ORIENTATION_MAP[n][o] || n.replace(/width|left|right/i, function(h, p) {
            var S = ORIENTATION_MAP[h.toLowerCase()][o] || h;
            return p > 0 ? S.charAt(0).toUpperCase() + S.slice(1) : S
        })
    }
    function s(n) {
        return n * (r.direction === RTL ? 1 : -1)
    }
    return {
        resolve: i,
        orient: s
    }
}
var ROLE = "role"
  , TAB_INDEX = "tabindex"
  , DISABLED = "disabled"
  , ARIA_PREFIX = "aria-"
  , ARIA_CONTROLS = ARIA_PREFIX + "controls"
  , ARIA_CURRENT = ARIA_PREFIX + "current"
  , ARIA_SELECTED = ARIA_PREFIX + "selected"
  , ARIA_LABEL = ARIA_PREFIX + "label"
  , ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby"
  , ARIA_HIDDEN = ARIA_PREFIX + "hidden"
  , ARIA_ORIENTATION = ARIA_PREFIX + "orientation"
  , ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription"
  , ARIA_LIVE = ARIA_PREFIX + "live"
  , ARIA_BUSY = ARIA_PREFIX + "busy"
  , ARIA_ATOMIC = ARIA_PREFIX + "atomic"
  , ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION]
  , CLASS_PREFIX = PROJECT_CODE + "__"
  , STATUS_CLASS_PREFIX = "is-"
  , CLASS_ROOT = PROJECT_CODE
  , CLASS_TRACK = CLASS_PREFIX + "track"
  , CLASS_LIST = CLASS_PREFIX + "list"
  , CLASS_SLIDE = CLASS_PREFIX + "slide"
  , CLASS_CLONE = CLASS_SLIDE + "--clone"
  , CLASS_CONTAINER = CLASS_SLIDE + "__container"
  , CLASS_ARROWS = CLASS_PREFIX + "arrows"
  , CLASS_ARROW = CLASS_PREFIX + "arrow"
  , CLASS_ARROW_PREV = CLASS_ARROW + "--prev"
  , CLASS_ARROW_NEXT = CLASS_ARROW + "--next"
  , CLASS_PAGINATION = CLASS_PREFIX + "pagination"
  , CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page"
  , CLASS_PROGRESS = CLASS_PREFIX + "progress"
  , CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar"
  , CLASS_TOGGLE = CLASS_PREFIX + "toggle"
  , CLASS_SPINNER = CLASS_PREFIX + "spinner"
  , CLASS_SR = CLASS_PREFIX + "sr"
  , CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized"
  , CLASS_ACTIVE$1 = STATUS_CLASS_PREFIX + "active"
  , CLASS_PREV = STATUS_CLASS_PREFIX + "prev"
  , CLASS_NEXT = STATUS_CLASS_PREFIX + "next"
  , CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible"
  , CLASS_LOADING = STATUS_CLASS_PREFIX + "loading"
  , CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in"
  , CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow"
  , STATUS_CLASSES = [CLASS_ACTIVE$1, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW]
  , CLASSES = {
    slide: CLASS_SLIDE,
    clone: CLASS_CLONE,
    arrows: CLASS_ARROWS,
    arrow: CLASS_ARROW,
    prev: CLASS_ARROW_PREV,
    next: CLASS_ARROW_NEXT,
    pagination: CLASS_PAGINATION,
    page: CLASS_PAGINATION_PAGE,
    spinner: CLASS_SPINNER
};
function closest(t, e) {
    if (isFunction(t.closest))
        return t.closest(e);
    for (var r = t; r && r.nodeType === 1 && !matches(r, e); )
        r = r.parentElement;
    return r
}
var FRICTION = 5
  , LOG_INTERVAL = 200
  , POINTER_DOWN_EVENTS = "touchstart mousedown"
  , POINTER_MOVE_EVENTS = "touchmove mousemove"
  , POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.bind, a = t.root, l = r.i18n, o = {}, h = [], p = [], S = [], c, g, v;
    function d() {
        f(),
        y(),
        m()
    }
    function b() {
        s(EVENT_REFRESH, u),
        s(EVENT_REFRESH, d),
        s(EVENT_UPDATED$1, m),
        n(document, POINTER_DOWN_EVENTS + " keydown", function(C) {
            v = C.type === "keydown"
        }, {
            capture: !0
        }),
        n(a, "focusin", function() {
            toggleClass$1(a, CLASS_FOCUS_IN, !!v)
        })
    }
    function u(C) {
        var x = ALL_ATTRIBUTES.concat("style");
        empty$1(h),
        removeClass(a, p),
        removeClass(c, S),
        removeAttribute$1([c, g], x),
        removeAttribute$1(a, C ? x : ["style", ARIA_ROLEDESCRIPTION])
    }
    function m() {
        removeClass(a, p),
        removeClass(c, S),
        p = T(CLASS_ROOT),
        S = T(CLASS_TRACK),
        addClass(a, p),
        addClass(c, S),
        setAttribute$1(a, ARIA_LABEL, r.label),
        setAttribute$1(a, ARIA_LABELLEDBY, r.labelledby)
    }
    function f() {
        c = _("." + CLASS_TRACK),
        g = child(c, "." + CLASS_LIST),
        assert(c && g, "A track/list element is missing."),
        push(h, children(g, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")")),
        forOwn$2({
            arrows: CLASS_ARROWS,
            pagination: CLASS_PAGINATION,
            prev: CLASS_ARROW_PREV,
            next: CLASS_ARROW_NEXT,
            bar: CLASS_PROGRESS_BAR,
            toggle: CLASS_TOGGLE
        }, function(C, x) {
            o[x] = _("." + C)
        }),
        assign$2(o, {
            root: a,
            track: c,
            list: g,
            slides: h
        })
    }
    function y() {
        var C = a.id || uniqueId(PROJECT_CODE)
          , x = r.role;
        a.id = C,
        c.id = c.id || C + "-track",
        g.id = g.id || C + "-list",
        !getAttribute(a, ROLE) && a.tagName !== "SECTION" && x && setAttribute$1(a, ROLE, x),
        setAttribute$1(a, ARIA_ROLEDESCRIPTION, l.carousel),
        setAttribute$1(g, ROLE, "presentation")
    }
    function _(C) {
        var x = query(a, C);
        return x && closest(x, "." + CLASS_ROOT) === a ? x : void 0
    }
    function T(C) {
        return [C + "--" + r.type, C + "--" + r.direction, r.drag && C + "--draggable", r.isNavigation && C + "--nav", C === CLASS_ROOT && CLASS_ACTIVE$1]
    }
    return assign$2(o, {
        setup: d,
        mount: b,
        destroy: u
    })
}
var SLIDE$1 = "slide"
  , LOOP = "loop"
  , FADE$1 = "fade";
function Slide$1(t, e, r, i) {
    var s = EventInterface$1(t), n = s.on, a = s.emit, l = s.bind, o = t.Components, h = t.root, p = t.options, S = p.isNavigation, c = p.updateOnMove, g = p.i18n, v = p.pagination, d = p.slideFocus, b = o.Direction.resolve, u = getAttribute(i, "style"), m = getAttribute(i, ARIA_LABEL), f = r > -1, y = child(i, "." + CLASS_CONTAINER), _;
    function T() {
        f || (i.id = h.id + "-slide" + pad(e + 1),
        setAttribute$1(i, ROLE, v ? "tabpanel" : "group"),
        setAttribute$1(i, ARIA_ROLEDESCRIPTION, g.slide),
        setAttribute$1(i, ARIA_LABEL, m || format(g.slideLabel, [e + 1, t.length]))),
        C()
    }
    function C() {
        l(i, "click", apply$2(a, EVENT_CLICK, E)),
        l(i, "keydown", apply$2(a, EVENT_SLIDE_KEYDOWN, E)),
        n([EVENT_MOVED$1, EVENT_SHIFTED, EVENT_SCROLLED$1], k),
        n(EVENT_NAVIGATION_MOUNTED, w),
        c && n(EVENT_MOVE$1, D)
    }
    function x() {
        _ = !0,
        s.destroy(),
        removeClass(i, STATUS_CLASSES),
        removeAttribute$1(i, ALL_ATTRIBUTES),
        setAttribute$1(i, "style", u),
        setAttribute$1(i, ARIA_LABEL, m || "")
    }
    function w() {
        var A = t.splides.map(function(F) {
            var I = F.splide.Components.Slides.getAt(e);
            return I ? I.slide.id : ""
        }).join(" ");
        setAttribute$1(i, ARIA_LABEL, format(g.slideX, (f ? r : e) + 1)),
        setAttribute$1(i, ARIA_CONTROLS, A),
        setAttribute$1(i, ROLE, d ? "button" : ""),
        d && removeAttribute$1(i, ARIA_ROLEDESCRIPTION)
    }
    function D() {
        _ || k()
    }
    function k() {
        if (!_) {
            var A = t.index;
            L(),
            V(),
            toggleClass$1(i, CLASS_PREV, e === A - 1),
            toggleClass$1(i, CLASS_NEXT, e === A + 1)
        }
    }
    function L() {
        var A = R();
        A !== hasClass(i, CLASS_ACTIVE$1) && (toggleClass$1(i, CLASS_ACTIVE$1, A),
        setAttribute$1(i, ARIA_CURRENT, S && A || ""),
        a(A ? EVENT_ACTIVE : EVENT_INACTIVE, E))
    }
    function V() {
        var A = P()
          , F = !A && (!R() || f);
        if (t.state.is([MOVING, SCROLLING]) || setAttribute$1(i, ARIA_HIDDEN, F || ""),
        setAttribute$1(queryAll(i, p.focusableNodes || ""), TAB_INDEX, F ? -1 : ""),
        d && setAttribute$1(i, TAB_INDEX, F ? -1 : 0),
        A !== hasClass(i, CLASS_VISIBLE) && (toggleClass$1(i, CLASS_VISIBLE, A),
        a(A ? EVENT_VISIBLE : EVENT_HIDDEN, E)),
        !A && document.activeElement === i) {
            var I = o.Slides.getAt(t.index);
            I && focus(I.slide)
        }
    }
    function O(A, F, I) {
        style(I && y || i, A, F)
    }
    function R() {
        var A = t.index;
        return A === e || p.cloneStatus && A === r
    }
    function P() {
        if (t.is(FADE$1))
            return R();
        var A = rect(o.Elements.track)
          , F = rect(i)
          , I = b("left", !0)
          , N = b("right", !0);
        return floor$1(A[I]) <= ceil$1(F[I]) && floor$1(F[N]) <= ceil$1(A[N])
    }
    function M(A, F) {
        var I = abs$1(A - e);
        return !f && (p.rewind || t.is(LOOP)) && (I = min$2(I, t.length - I)),
        I <= F
    }
    var E = {
        index: e,
        slideIndex: r,
        slide: i,
        container: y,
        isClone: f,
        mount: T,
        destroy: x,
        update: k,
        style: O,
        isWithin: M
    };
    return E
}
function Slides(t, e, r) {
    var i = EventInterface$1(t)
      , s = i.on
      , n = i.emit
      , a = i.bind
      , l = e.Elements
      , o = l.slides
      , h = l.list
      , p = [];
    function S() {
        c(),
        s(EVENT_REFRESH, g),
        s(EVENT_REFRESH, c)
    }
    function c() {
        o.forEach(function(k, L) {
            d(k, L, -1)
        })
    }
    function g() {
        _(function(k) {
            k.destroy()
        }),
        empty$1(p)
    }
    function v() {
        _(function(k) {
            k.update()
        })
    }
    function d(k, L, V) {
        var O = Slide$1(t, L, V, k);
        O.mount(),
        p.push(O),
        p.sort(function(R, P) {
            return R.index - P.index
        })
    }
    function b(k) {
        return k ? T(function(L) {
            return !L.isClone
        }) : p
    }
    function u(k) {
        var L = e.Controller
          , V = L.toIndex(k)
          , O = L.hasFocus() ? 1 : r.perPage;
        return T(function(R) {
            return between(R.index, V, V + O - 1)
        })
    }
    function m(k) {
        return T(k)[0]
    }
    function f(k, L) {
        forEach$2(k, function(V) {
            if (isString(V) && (V = parseHtml(V)),
            isHTMLElement(V)) {
                var O = o[L];
                O ? before(V, O) : append(h, V),
                addClass(V, r.classes.slide),
                x(V, apply$2(n, EVENT_RESIZE))
            }
        }),
        n(EVENT_REFRESH)
    }
    function y(k) {
        remove(T(k).map(function(L) {
            return L.slide
        })),
        n(EVENT_REFRESH)
    }
    function _(k, L) {
        b(L).forEach(k)
    }
    function T(k) {
        return p.filter(isFunction(k) ? k : function(L) {
            return isString(k) ? matches(L.slide, k) : includes(toArray$2(k), L.index)
        }
        )
    }
    function C(k, L, V) {
        _(function(O) {
            O.style(k, L, V)
        })
    }
    function x(k, L) {
        var V = queryAll(k, "img")
          , O = V.length;
        O ? V.forEach(function(R) {
            a(R, "load error", function() {
                --O || L()
            })
        }) : L()
    }
    function w(k) {
        return k ? o.length : p.length
    }
    function D() {
        return p.length > r.perPage
    }
    return {
        mount: S,
        destroy: g,
        update: v,
        register: d,
        get: b,
        getIn: u,
        getAt: m,
        add: f,
        remove: y,
        forEach: _,
        filter: T,
        style: C,
        getLength: w,
        isEnough: D
    }
}
function Layout(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.bind, a = i.emit, l = e.Slides, o = e.Direction.resolve, h = e.Elements, p = h.root, S = h.track, c = h.list, g = l.getAt, v = l.style, d, b, u;
    function m() {
        f(),
        n(window, "resize load", Throttle$1(apply$2(a, EVENT_RESIZE))),
        s([EVENT_UPDATED$1, EVENT_REFRESH], f),
        s(EVENT_RESIZE, y)
    }
    function f() {
        d = r.direction === TTB,
        style(p, "maxWidth", unit(r.width)),
        style(S, o("paddingLeft"), _(!1)),
        style(S, o("paddingRight"), _(!0)),
        y(!0)
    }
    function y(E) {
        var A = rect(p);
        (E || b.width !== A.width || b.height !== A.height) && (style(S, "height", T()),
        v(o("marginRight"), unit(r.gap)),
        v("width", x()),
        v("height", w(), !0),
        b = A,
        a(EVENT_RESIZED),
        u !== (u = M()) && (toggleClass$1(p, CLASS_OVERFLOW, u),
        a(EVENT_OVERFLOW, u)))
    }
    function _(E) {
        var A = r.padding
          , F = o(E ? "right" : "left");
        return A && unit(A[F] || (isObject$1(A) ? 0 : A)) || "0px"
    }
    function T() {
        var E = "";
        return d && (E = C(),
        assert(E, "height or heightRatio is missing."),
        E = "calc(" + E + " - " + _(!1) + " - " + _(!0) + ")"),
        E
    }
    function C() {
        return unit(r.height || rect(c).width * r.heightRatio)
    }
    function x() {
        return r.autoWidth ? null : unit(r.fixedWidth) || (d ? "" : D())
    }
    function w() {
        return unit(r.fixedHeight) || (d ? r.autoHeight ? null : D() : C())
    }
    function D() {
        var E = unit(r.gap);
        return "calc((100%" + (E && " + " + E) + ")/" + (r.perPage || 1) + (E && " - " + E) + ")"
    }
    function k() {
        return rect(c)[o("width")]
    }
    function L(E, A) {
        var F = g(E || 0);
        return F ? rect(F.slide)[o("width")] + (A ? 0 : R()) : 0
    }
    function V(E, A) {
        var F = g(E);
        if (F) {
            var I = rect(F.slide)[o("right")]
              , N = rect(c)[o("left")];
            return abs$1(I - N) + (A ? 0 : R())
        }
        return 0
    }
    function O(E) {
        return V(t.length - 1) - V(0) + L(0, E)
    }
    function R() {
        var E = g(0);
        return E && parseFloat(style(E.slide, o("marginRight"))) || 0
    }
    function P(E) {
        return parseFloat(style(S, o("padding" + (E ? "Right" : "Left")))) || 0
    }
    function M() {
        return t.is(FADE$1) || O(!0) > k()
    }
    return {
        mount: m,
        resize: y,
        listSize: k,
        slideSize: L,
        sliderSize: O,
        totalSize: V,
        getPadding: P,
        isOverflow: M
    }
}
var MULTIPLIER = 2;
function Clones(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = e.Elements, a = e.Slides, l = e.Direction.resolve, o = [], h;
    function p() {
        s(EVENT_REFRESH, S),
        s([EVENT_UPDATED$1, EVENT_RESIZE], g),
        (h = b()) && (v(h),
        e.Layout.resize(!0))
    }
    function S() {
        c(),
        p()
    }
    function c() {
        remove(o),
        empty$1(o),
        i.destroy()
    }
    function g() {
        var u = b();
        h !== u && (h < u || !u) && i.emit(EVENT_REFRESH)
    }
    function v(u) {
        var m = a.get().slice()
          , f = m.length;
        if (f) {
            for (; m.length < u; )
                push(m, m);
            push(m.slice(-u), m.slice(0, u)).forEach(function(y, _) {
                var T = _ < u
                  , C = d(y.slide, _);
                T ? before(C, m[0].slide) : append(n.list, C),
                push(o, C),
                a.register(C, _ - u + (T ? 0 : f), y.index)
            })
        }
    }
    function d(u, m) {
        var f = u.cloneNode(!0);
        return addClass(f, r.classes.clone),
        f.id = t.root.id + "-clone" + pad(m + 1),
        f
    }
    function b() {
        var u = r.clones;
        if (!t.is(LOOP))
            u = 0;
        else if (isUndefined$1(u)) {
            var m = r[l("fixedWidth")] && e.Layout.slideSize(0)
              , f = m && ceil$1(rect(n.track)[l("width")] / m);
            u = f || r[l("autoWidth")] && t.length || r.perPage * MULTIPLIER
        }
        return u
    }
    return {
        mount: p,
        destroy: c
    }
}
function Move(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.emit, a = t.state.set, l = e.Layout, o = l.slideSize, h = l.getPadding, p = l.totalSize, S = l.listSize, c = l.sliderSize, g = e.Direction, v = g.resolve, d = g.orient, b = e.Elements, u = b.list, m = b.track, f;
    function y() {
        f = e.Transition,
        s([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED$1, EVENT_REFRESH], _)
    }
    function _() {
        e.Controller.isBusy() || (e.Scroll.cancel(),
        C(t.index),
        e.Slides.update())
    }
    function T(F, I, N, $) {
        F !== I && E(F > N) && (k(),
        x(D(O(), F > N), !0)),
        a(MOVING),
        n(EVENT_MOVE$1, I, N, F),
        f.start(I, function() {
            a(IDLE),
            n(EVENT_MOVED$1, I, N, F),
            $ && $()
        })
    }
    function C(F) {
        x(V(F, !0))
    }
    function x(F, I) {
        if (!t.is(FADE$1)) {
            var N = I ? F : w(F);
            style(u, "transform", "translate" + v("X") + "(" + N + "px)"),
            F !== N && n(EVENT_SHIFTED)
        }
    }
    function w(F) {
        if (t.is(LOOP)) {
            var I = L(F)
              , N = I > e.Controller.getEnd()
              , $ = I < 0;
            ($ || N) && (F = D(F, N))
        }
        return F
    }
    function D(F, I) {
        var N = F - M(I)
          , $ = c();
        return F -= d($ * (ceil$1(abs$1(N) / $) || 1)) * (I ? 1 : -1),
        F
    }
    function k() {
        x(O(), !0),
        f.cancel()
    }
    function L(F) {
        for (var I = e.Slides.get(), N = 0, $ = 1 / 0, H = 0; H < I.length; H++) {
            var W = I[H].index
              , B = abs$1(V(W, !0) - F);
            if (B <= $)
                $ = B,
                N = W;
            else
                break
        }
        return N
    }
    function V(F, I) {
        var N = d(p(F - 1) - P(F));
        return I ? R(N) : N
    }
    function O() {
        var F = v("left");
        return rect(u)[F] - rect(m)[F] + d(h(!1))
    }
    function R(F) {
        return r.trimSpace && t.is(SLIDE$1) && (F = clamp$1(F, 0, d(c(!0) - S()))),
        F
    }
    function P(F) {
        var I = r.focus;
        return I === "center" ? (S() - o(F, !0)) / 2 : +I * o(F) || 0
    }
    function M(F) {
        return V(F ? e.Controller.getEnd() : 0, !!r.trimSpace)
    }
    function E(F) {
        var I = d(D(O(), F));
        return F ? I >= 0 : I <= u[v("scrollWidth")] - rect(m)[v("width")]
    }
    function A(F, I) {
        I = isUndefined$1(I) ? O() : I;
        var N = F !== !0 && d(I) < d(M(!1))
          , $ = F !== !1 && d(I) > d(M(!0));
        return N || $
    }
    return {
        mount: y,
        move: T,
        jump: C,
        translate: x,
        shift: D,
        cancel: k,
        toIndex: L,
        toPosition: V,
        getPosition: O,
        getLimit: M,
        exceededLimit: A,
        reposition: _
    }
}
function Controller(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.emit, a = e.Move, l = a.getPosition, o = a.getLimit, h = a.toPosition, p = e.Slides, S = p.isEnough, c = p.getLength, g = r.omitEnd, v = t.is(LOOP), d = t.is(SLIDE$1), b = apply$2(O, !1), u = apply$2(O, !0), m = r.start || 0, f, y = m, _, T, C;
    function x() {
        w(),
        s([EVENT_UPDATED$1, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], w),
        s(EVENT_RESIZED, D)
    }
    function w() {
        _ = c(!0),
        T = r.perMove,
        C = r.perPage,
        f = E();
        var B = clamp$1(m, 0, g ? f : _ - 1);
        B !== m && (m = B,
        a.reposition())
    }
    function D() {
        f !== E() && n(EVENT_END_INDEX_CHANGED)
    }
    function k(B, q, X) {
        if (!W()) {
            var U = V(B)
              , j = M(U);
            j > -1 && (q || j !== m) && (N(j),
            a.move(U, j, y, X))
        }
    }
    function L(B, q, X, U) {
        e.Scroll.scroll(B, q, X, function() {
            var j = M(a.toIndex(l()));
            N(g ? min$2(j, f) : j),
            U && U()
        })
    }
    function V(B) {
        var q = m;
        if (isString(B)) {
            var X = B.match(/([+\-<>])(\d+)?/) || []
              , U = X[1]
              , j = X[2];
            U === "+" || U === "-" ? q = R(m + +("" + U + (+j || 1)), m) : U === ">" ? q = j ? A(+j) : b(!0) : U === "<" && (q = u(!0))
        } else
            q = v ? B : clamp$1(B, 0, f);
        return q
    }
    function O(B, q) {
        var X = T || (H() ? 1 : C)
          , U = R(m + X * (B ? -1 : 1), m, !(T || H()));
        return U === -1 && d && !approximatelyEqual(l(), o(!B), 1) ? B ? 0 : f : q ? U : M(U)
    }
    function R(B, q, X) {
        if (S() || H()) {
            var U = P(B);
            U !== B && (q = B,
            B = U,
            X = !1),
            B < 0 || B > f ? !T && (between(0, B, q, !0) || between(f, q, B, !0)) ? B = A(F(B)) : v ? B = X ? B < 0 ? -(_ % C || C) : _ : B : r.rewind ? B = B < 0 ? f : 0 : B = -1 : X && B !== q && (B = A(F(q) + (B < q ? -1 : 1)))
        } else
            B = -1;
        return B
    }
    function P(B) {
        if (d && r.trimSpace === "move" && B !== m)
            for (var q = l(); q === h(B, !0) && between(B, 0, t.length - 1, !r.rewind); )
                B < m ? --B : ++B;
        return B
    }
    function M(B) {
        return v ? (B + _) % _ || 0 : B
    }
    function E() {
        for (var B = _ - (H() || v && T ? 1 : C); g && B-- > 0; )
            if (h(_ - 1, !0) !== h(B, !0)) {
                B++;
                break
            }
        return clamp$1(B, 0, _ - 1)
    }
    function A(B) {
        return clamp$1(H() ? B : C * B, 0, f)
    }
    function F(B) {
        return H() ? min$2(B, f) : floor$1((B >= f ? _ - 1 : B) / C)
    }
    function I(B) {
        var q = a.toIndex(B);
        return d ? clamp$1(q, 0, f) : q
    }
    function N(B) {
        B !== m && (y = m,
        m = B)
    }
    function $(B) {
        return B ? y : m
    }
    function H() {
        return !isUndefined$1(r.focus) || r.isNavigation
    }
    function W() {
        return t.state.is([MOVING, SCROLLING]) && !!r.waitForTransition
    }
    return {
        mount: x,
        go: k,
        scroll: L,
        getNext: b,
        getPrev: u,
        getAdjacent: O,
        getEnd: E,
        setIndex: N,
        getIndex: $,
        toIndex: A,
        toPage: F,
        toDest: I,
        hasFocus: H,
        isBusy: W
    }
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg"
  , PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
  , SIZE = 40;
function Arrows(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.bind, a = i.emit, l = r.classes, o = r.i18n, h = e.Elements, p = e.Controller, S = h.arrows, c = h.track, g = S, v = h.prev, d = h.next, b, u, m = {};
    function f() {
        _(),
        s(EVENT_UPDATED$1, y)
    }
    function y() {
        T(),
        f()
    }
    function _() {
        var L = r.arrows;
        L && !(v && d) && w(),
        v && d && (assign$2(m, {
            prev: v,
            next: d
        }),
        display(g, L ? "" : "none"),
        addClass(g, u = CLASS_ARROWS + "--" + r.direction),
        L && (C(),
        k(),
        setAttribute$1([v, d], ARIA_CONTROLS, c.id),
        a(EVENT_ARROWS_MOUNTED, v, d)))
    }
    function T() {
        i.destroy(),
        removeClass(g, u),
        b ? (remove(S ? [v, d] : g),
        v = d = null) : removeAttribute$1([v, d], ALL_ATTRIBUTES)
    }
    function C() {
        s([EVENT_MOUNTED, EVENT_MOVED$1, EVENT_REFRESH, EVENT_SCROLLED$1, EVENT_END_INDEX_CHANGED], k),
        n(d, "click", apply$2(x, ">")),
        n(v, "click", apply$2(x, "<"))
    }
    function x(L) {
        p.go(L, !0)
    }
    function w() {
        g = S || create("div", l.arrows),
        v = D(!0),
        d = D(!1),
        b = !0,
        append(g, [v, d]),
        !S && before(g, c)
    }
    function D(L) {
        var V = '<button class="' + l.arrow + " " + (L ? l.prev : l.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (r.arrowPath || PATH) + '" />';
        return parseHtml(V)
    }
    function k() {
        if (v && d) {
            var L = t.index
              , V = p.getPrev()
              , O = p.getNext()
              , R = V > -1 && L < V ? o.last : o.prev
              , P = O > -1 && L > O ? o.first : o.next;
            v.disabled = V < 0,
            d.disabled = O < 0,
            setAttribute$1(v, ARIA_LABEL, R),
            setAttribute$1(d, ARIA_LABEL, P),
            a(EVENT_ARROWS_UPDATED, v, d, V, O)
        }
    }
    return {
        arrows: m,
        mount: f,
        destroy: T,
        update: k
    }
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.bind, a = i.emit, l = RequestInterval$1(r.interval, t.go.bind(t, ">"), C), o = l.isPaused, h = e.Elements, p = e.Elements, S = p.root, c = p.toggle, g = r.autoplay, v, d, b = g === "pause";
    function u() {
        g && (m(),
        c && setAttribute$1(c, ARIA_CONTROLS, h.track.id),
        b || f(),
        T())
    }
    function m() {
        r.pauseOnHover && n(S, "mouseenter mouseleave", function(w) {
            v = w.type === "mouseenter",
            _()
        }),
        r.pauseOnFocus && n(S, "focusin focusout", function(w) {
            d = w.type === "focusin",
            _()
        }),
        c && n(c, "click", function() {
            b ? f() : y(!0)
        }),
        s([EVENT_MOVE$1, EVENT_SCROLL$1, EVENT_REFRESH], l.rewind),
        s(EVENT_MOVE$1, x)
    }
    function f() {
        o() && e.Slides.isEnough() && (l.start(!r.resetProgress),
        d = v = b = !1,
        T(),
        a(EVENT_AUTOPLAY_PLAY))
    }
    function y(w) {
        w === void 0 && (w = !0),
        b = !!w,
        T(),
        o() || (l.pause(),
        a(EVENT_AUTOPLAY_PAUSE))
    }
    function _() {
        b || (v || d ? y(!1) : f())
    }
    function T() {
        c && (toggleClass$1(c, CLASS_ACTIVE$1, !b),
        setAttribute$1(c, ARIA_LABEL, r.i18n[b ? "play" : "pause"]))
    }
    function C(w) {
        var D = h.bar;
        D && style(D, "width", w * 100 + "%"),
        a(EVENT_AUTOPLAY_PLAYING, w)
    }
    function x(w) {
        var D = e.Slides.getAt(w);
        l.set(D && +getAttribute(D.slide, INTERVAL_DATA_ATTRIBUTE) || r.interval)
    }
    return {
        mount: u,
        destroy: l.cancel,
        play: f,
        pause: y,
        isPaused: o
    }
}
function Cover(t, e, r) {
    var i = EventInterface$1(t)
      , s = i.on;
    function n() {
        r.cover && (s(EVENT_LAZYLOAD_LOADED, apply$2(l, !0)),
        s([EVENT_MOUNTED, EVENT_UPDATED$1, EVENT_REFRESH], apply$2(a, !0)))
    }
    function a(o) {
        e.Slides.forEach(function(h) {
            var p = child(h.container || h.slide, "img");
            p && p.src && l(o, p, h)
        })
    }
    function l(o, h, p) {
        p.style("background", o ? 'center/cover no-repeat url("' + h.src + '")' : "", !0),
        display(h, o ? "none" : "")
    }
    return {
        mount: n,
        destroy: apply$2(a, !1)
    }
}
var BOUNCE_DIFF_THRESHOLD = 10
  , BOUNCE_DURATION = 600
  , FRICTION_FACTOR = .6
  , BASE_VELOCITY = 1.5
  , MIN_DURATION = 800;
function Scroll(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.emit, a = t.state.set, l = e.Move, o = l.getPosition, h = l.getLimit, p = l.exceededLimit, S = l.translate, c = t.is(SLIDE$1), g, v, d = 1;
    function b() {
        s(EVENT_MOVE$1, y),
        s([EVENT_UPDATED$1, EVENT_REFRESH], _)
    }
    function u(C, x, w, D, k) {
        var L = o();
        if (y(),
        w && (!c || !p())) {
            var V = e.Layout.sliderSize()
              , O = sign(C) * V * floor$1(abs$1(C) / V) || 0;
            C = l.toPosition(e.Controller.toDest(C % V)) + O
        }
        var R = approximatelyEqual(L, C, 1);
        d = 1,
        x = R ? 0 : x || max$1(abs$1(C - L) / BASE_VELOCITY, MIN_DURATION),
        v = D,
        g = RequestInterval$1(x, m, apply$2(f, L, C, k), 1),
        a(SCROLLING),
        n(EVENT_SCROLL$1),
        g.start()
    }
    function m() {
        a(IDLE),
        v && v(),
        n(EVENT_SCROLLED$1)
    }
    function f(C, x, w, D) {
        var k = o()
          , L = C + (x - C) * T(D)
          , V = (L - k) * d;
        S(k + V),
        c && !w && p() && (d *= FRICTION_FACTOR,
        abs$1(V) < BOUNCE_DIFF_THRESHOLD && u(h(p(!0)), BOUNCE_DURATION, !1, v, !0))
    }
    function y() {
        g && g.cancel()
    }
    function _() {
        g && !g.isPaused() && (y(),
        m())
    }
    function T(C) {
        var x = r.easingFunc;
        return x ? x(C) : 1 - Math.pow(1 - C, 4)
    }
    return {
        mount: b,
        destroy: y,
        scroll: u,
        cancel: _
    }
}
var SCROLL_LISTENER_OPTIONS = {
    passive: !1,
    capture: !0
};
function Drag(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.emit, a = i.bind, l = i.unbind, o = t.state, h = e.Move, p = e.Scroll, S = e.Controller, c = e.Elements.track, g = e.Media.reduce, v = e.Direction, d = v.resolve, b = v.orient, u = h.getPosition, m = h.exceededLimit, f, y, _, T, C, x = !1, w, D, k;
    function L() {
        a(c, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS),
        a(c, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS),
        a(c, POINTER_DOWN_EVENTS, O, SCROLL_LISTENER_OPTIONS),
        a(c, "click", M, {
            capture: !0
        }),
        a(c, "dragstart", prevent),
        s([EVENT_MOUNTED, EVENT_UPDATED$1], V)
    }
    function V() {
        var G = r.drag;
        Z(!G),
        T = G === "free"
    }
    function O(G) {
        if (w = !1,
        !D) {
            var z = j(G);
            U(G.target) && (z || !G.button) && (S.isBusy() ? prevent(G, !0) : (k = z ? c : window,
            C = o.is([MOVING, SCROLLING]),
            _ = null,
            a(k, POINTER_MOVE_EVENTS, R, SCROLL_LISTENER_OPTIONS),
            a(k, POINTER_UP_EVENTS, P, SCROLL_LISTENER_OPTIONS),
            h.cancel(),
            p.cancel(),
            E(G)))
        }
    }
    function R(G) {
        if (o.is(DRAGGING) || (o.set(DRAGGING),
        n(EVENT_DRAG$1)),
        G.cancelable)
            if (C) {
                h.translate(f + X(H(G)));
                var z = W(G) > LOG_INTERVAL
                  , K = x !== (x = m());
                (z || K) && E(G),
                w = !0,
                n(EVENT_DRAGGING),
                prevent(G)
            } else
                I(G) && (C = F(G),
                prevent(G))
    }
    function P(G) {
        o.is(DRAGGING) && (o.set(IDLE),
        n(EVENT_DRAGGED$1)),
        C && (A(G),
        prevent(G)),
        l(k, POINTER_MOVE_EVENTS, R),
        l(k, POINTER_UP_EVENTS, P),
        C = !1
    }
    function M(G) {
        !D && w && prevent(G, !0)
    }
    function E(G) {
        _ = y,
        y = G,
        f = u()
    }
    function A(G) {
        var z = N(G)
          , K = $(z)
          , J = r.rewind && r.rewindByDrag;
        g(!1),
        T ? S.scroll(K, 0, r.snap) : t.is(FADE$1) ? S.go(b(sign(z)) < 0 ? J ? "<" : "-" : J ? ">" : "+") : t.is(SLIDE$1) && x && J ? S.go(m(!0) ? ">" : "<") : S.go(S.toDest(K), !0),
        g(!0)
    }
    function F(G) {
        var z = r.dragMinThreshold
          , K = isObject$1(z)
          , J = K && z.mouse || 0
          , tt = (K ? z.touch : +z) || 10;
        return abs$1(H(G)) > (j(G) ? tt : J)
    }
    function I(G) {
        return abs$1(H(G)) > abs$1(H(G, !0))
    }
    function N(G) {
        if (t.is(LOOP) || !x) {
            var z = W(G);
            if (z && z < LOG_INTERVAL)
                return H(G) / z
        }
        return 0
    }
    function $(G) {
        return u() + sign(G) * min$2(abs$1(G) * (r.flickPower || 600), T ? 1 / 0 : e.Layout.listSize() * (r.flickMaxPages || 1))
    }
    function H(G, z) {
        return q(G, z) - q(B(G), z)
    }
    function W(G) {
        return timeOf(G) - timeOf(B(G))
    }
    function B(G) {
        return y === G && _ || y
    }
    function q(G, z) {
        return (j(G) ? G.changedTouches[0] : G)["page" + d(z ? "Y" : "X")]
    }
    function X(G) {
        return G / (x && t.is(SLIDE$1) ? FRICTION : 1)
    }
    function U(G) {
        var z = r.noDrag;
        return !matches(G, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!z || !matches(G, z))
    }
    function j(G) {
        return typeof TouchEvent < "u" && G instanceof TouchEvent
    }
    function Y() {
        return C
    }
    function Z(G) {
        D = G
    }
    return {
        mount: L,
        disable: Z,
        isDragging: Y
    }
}
var NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: ARROW_RIGHT,
    Left: ARROW_LEFT,
    Up: ARROW_UP,
    Down: ARROW_DOWN
};
function normalizeKey(t) {
    return t = isString(t) ? t : t.key,
    NORMALIZATION_MAP[t] || t
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.bind, a = i.unbind, l = t.root, o = e.Direction.resolve, h, p;
    function S() {
        c(),
        s(EVENT_UPDATED$1, g),
        s(EVENT_UPDATED$1, c),
        s(EVENT_MOVE$1, d)
    }
    function c() {
        var u = r.keyboard;
        u && (h = u === "global" ? window : l,
        n(h, KEYBOARD_EVENT, b))
    }
    function g() {
        a(h, KEYBOARD_EVENT)
    }
    function v(u) {
        p = u
    }
    function d() {
        var u = p;
        p = !0,
        nextTick(function() {
            p = u
        })
    }
    function b(u) {
        if (!p) {
            var m = normalizeKey(u);
            m === o(ARROW_LEFT) ? t.go("<") : m === o(ARROW_RIGHT) && t.go(">")
        }
    }
    return {
        mount: S,
        destroy: g,
        disable: v
    }
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy"
  , SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset"
  , IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(t, e, r) {
    var i = EventInterface$1(t)
      , s = i.on
      , n = i.off
      , a = i.bind
      , l = i.emit
      , o = r.lazyLoad === "sequential"
      , h = [EVENT_MOVED$1, EVENT_SCROLLED$1]
      , p = [];
    function S() {
        r.lazyLoad && (c(),
        s(EVENT_REFRESH, c))
    }
    function c() {
        empty$1(p),
        g(),
        o ? u() : (n(h),
        s(h, v),
        v())
    }
    function g() {
        e.Slides.forEach(function(m) {
            queryAll(m.slide, IMAGE_SELECTOR).forEach(function(f) {
                var y = getAttribute(f, SRC_DATA_ATTRIBUTE)
                  , _ = getAttribute(f, SRCSET_DATA_ATTRIBUTE);
                if (y !== f.src || _ !== f.srcset) {
                    var T = r.classes.spinner
                      , C = f.parentElement
                      , x = child(C, "." + T) || create("span", T, C);
                    p.push([f, m, x]),
                    f.src || display(f, "none")
                }
            })
        })
    }
    function v() {
        p = p.filter(function(m) {
            var f = r.perPage * ((r.preloadPages || 1) + 1) - 1;
            return m[1].isWithin(t.index, f) ? d(m) : !0
        }),
        p.length || n(h)
    }
    function d(m) {
        var f = m[0];
        addClass(m[1].slide, CLASS_LOADING),
        a(f, "load error", apply$2(b, m)),
        setAttribute$1(f, "src", getAttribute(f, SRC_DATA_ATTRIBUTE)),
        setAttribute$1(f, "srcset", getAttribute(f, SRCSET_DATA_ATTRIBUTE)),
        removeAttribute$1(f, SRC_DATA_ATTRIBUTE),
        removeAttribute$1(f, SRCSET_DATA_ATTRIBUTE)
    }
    function b(m, f) {
        var y = m[0]
          , _ = m[1];
        removeClass(_.slide, CLASS_LOADING),
        f.type !== "error" && (remove(m[2]),
        display(y, ""),
        l(EVENT_LAZYLOAD_LOADED, y, _),
        l(EVENT_RESIZE)),
        o && u()
    }
    function u() {
        p.length && d(p.shift())
    }
    return {
        mount: S,
        destroy: apply$2(empty$1, p),
        check: v
    }
}
function Pagination(t, e, r) {
    var i = EventInterface$1(t), s = i.on, n = i.emit, a = i.bind, l = e.Slides, o = e.Elements, h = e.Controller, p = h.hasFocus, S = h.getIndex, c = h.go, g = e.Direction.resolve, v = o.pagination, d = [], b, u;
    function m() {
        f(),
        s([EVENT_UPDATED$1, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], m);
        var D = r.pagination;
        v && display(v, D ? "" : "none"),
        D && (s([EVENT_MOVE$1, EVENT_SCROLL$1, EVENT_SCROLLED$1], w),
        y(),
        w(),
        n(EVENT_PAGINATION_MOUNTED, {
            list: b,
            items: d
        }, x(t.index)))
    }
    function f() {
        b && (remove(v ? slice$2(b.children) : b),
        removeClass(b, u),
        empty$1(d),
        b = null),
        i.destroy()
    }
    function y() {
        var D = t.length
          , k = r.classes
          , L = r.i18n
          , V = r.perPage
          , O = p() ? h.getEnd() + 1 : ceil$1(D / V);
        b = v || create("ul", k.pagination, o.track.parentElement),
        addClass(b, u = CLASS_PAGINATION + "--" + C()),
        setAttribute$1(b, ROLE, "tablist"),
        setAttribute$1(b, ARIA_LABEL, L.select),
        setAttribute$1(b, ARIA_ORIENTATION, C() === TTB ? "vertical" : "");
        for (var R = 0; R < O; R++) {
            var P = create("li", null, b)
              , M = create("button", {
                class: k.page,
                type: "button"
            }, P)
              , E = l.getIn(R).map(function(F) {
                return F.slide.id
            })
              , A = !p() && V > 1 ? L.pageX : L.slideX;
            a(M, "click", apply$2(_, R)),
            r.paginationKeyboard && a(M, "keydown", apply$2(T, R)),
            setAttribute$1(P, ROLE, "presentation"),
            setAttribute$1(M, ROLE, "tab"),
            setAttribute$1(M, ARIA_CONTROLS, E.join(" ")),
            setAttribute$1(M, ARIA_LABEL, format(A, R + 1)),
            setAttribute$1(M, TAB_INDEX, -1),
            d.push({
                li: P,
                button: M,
                page: R
            })
        }
    }
    function _(D) {
        c(">" + D, !0)
    }
    function T(D, k) {
        var L = d.length
          , V = normalizeKey(k)
          , O = C()
          , R = -1;
        V === g(ARROW_RIGHT, !1, O) ? R = ++D % L : V === g(ARROW_LEFT, !1, O) ? R = (--D + L) % L : V === "Home" ? R = 0 : V === "End" && (R = L - 1);
        var P = d[R];
        P && (focus(P.button),
        c(">" + R),
        prevent(k, !0))
    }
    function C() {
        return r.paginationDirection || r.direction
    }
    function x(D) {
        return d[h.toPage(D)]
    }
    function w() {
        var D = x(S(!0))
          , k = x(S());
        if (D) {
            var L = D.button;
            removeClass(L, CLASS_ACTIVE$1),
            removeAttribute$1(L, ARIA_SELECTED),
            setAttribute$1(L, TAB_INDEX, -1)
        }
        if (k) {
            var V = k.button;
            addClass(V, CLASS_ACTIVE$1),
            setAttribute$1(V, ARIA_SELECTED, !0),
            setAttribute$1(V, TAB_INDEX, "")
        }
        n(EVENT_PAGINATION_UPDATED, {
            list: b,
            items: d
        }, D, k)
    }
    return {
        items: d,
        mount: m,
        destroy: f,
        getAt: x,
        update: w
    }
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(t, e, r) {
    var i = r.isNavigation
      , s = r.slideFocus
      , n = [];
    function a() {
        t.splides.forEach(function(v) {
            v.isParent || (h(t, v.splide),
            h(v.splide, t))
        }),
        i && p()
    }
    function l() {
        n.forEach(function(v) {
            v.destroy()
        }),
        empty$1(n)
    }
    function o() {
        l(),
        a()
    }
    function h(v, d) {
        var b = EventInterface$1(v);
        b.on(EVENT_MOVE$1, function(u, m, f) {
            d.go(d.is(LOOP) ? f : u)
        }),
        n.push(b)
    }
    function p() {
        var v = EventInterface$1(t)
          , d = v.on;
        d(EVENT_CLICK, c),
        d(EVENT_SLIDE_KEYDOWN, g),
        d([EVENT_MOUNTED, EVENT_UPDATED$1], S),
        n.push(v),
        v.emit(EVENT_NAVIGATION_MOUNTED, t.splides)
    }
    function S() {
        setAttribute$1(e.Elements.list, ARIA_ORIENTATION, r.direction === TTB ? "vertical" : "")
    }
    function c(v) {
        t.go(v.index)
    }
    function g(v, d) {
        includes(TRIGGER_KEYS, normalizeKey(d)) && (c(v),
        prevent(d))
    }
    return {
        setup: apply$2(e.Media.set, {
            slideFocus: isUndefined$1(s) ? i : s
        }, !0),
        mount: a,
        destroy: l,
        remount: o
    }
}
function Wheel(t, e, r) {
    var i = EventInterface$1(t)
      , s = i.bind
      , n = 0;
    function a() {
        r.wheel && s(e.Elements.track, "wheel", l, SCROLL_LISTENER_OPTIONS)
    }
    function l(h) {
        if (h.cancelable) {
            var p = h.deltaY
              , S = p < 0
              , c = timeOf(h)
              , g = r.wheelMinThreshold || 0
              , v = r.wheelSleep || 0;
            abs$1(p) > g && c - n > v && (t.go(S ? "<" : ">"),
            n = c),
            o(S) && prevent(h)
        }
    }
    function o(h) {
        return !r.releaseWheel || t.state.is(MOVING) || e.Controller.getAdjacent(h) !== -1
    }
    return {
        mount: a
    }
}
var SR_REMOVAL_DELAY = 90;
function Live(t, e, r) {
    var i = EventInterface$1(t)
      , s = i.on
      , n = e.Elements.track
      , a = r.live && !r.isNavigation
      , l = create("span", CLASS_SR)
      , o = RequestInterval$1(SR_REMOVAL_DELAY, apply$2(p, !1));
    function h() {
        a && (c(!e.Autoplay.isPaused()),
        setAttribute$1(n, ARIA_ATOMIC, !0),
        l.textContent = "…",
        s(EVENT_AUTOPLAY_PLAY, apply$2(c, !0)),
        s(EVENT_AUTOPLAY_PAUSE, apply$2(c, !1)),
        s([EVENT_MOVED$1, EVENT_SCROLLED$1], apply$2(p, !0)))
    }
    function p(g) {
        setAttribute$1(n, ARIA_BUSY, g),
        g ? (append(n, l),
        o.start()) : (remove(l),
        o.cancel())
    }
    function S() {
        removeAttribute$1(n, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]),
        remove(l)
    }
    function c(g) {
        a && setAttribute$1(n, ARIA_LIVE, g ? "off" : "polite")
    }
    return {
        mount: h,
        disable: c,
        destroy: S
    }
}
var ComponentConstructors = Object.freeze({
    __proto__: null,
    Media,
    Direction,
    Elements,
    Slides,
    Layout,
    Clones,
    Move,
    Controller,
    Arrows,
    Autoplay,
    Cover,
    Scroll,
    Drag,
    Keyboard,
    LazyLoad,
    Pagination,
    Sync,
    Wheel,
    Live
})
  , I18N$1 = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
}
  , DEFAULTS$1 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: !0,
    arrows: !0,
    pagination: !0,
    paginationKeyboard: !0,
    interval: 5e3,
    pauseOnHover: !0,
    pauseOnFocus: !0,
    resetProgress: !0,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: !0,
    direction: "ltr",
    trimSpace: !0,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: !0,
    classes: CLASSES,
    i18n: I18N$1,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function Fade(t, e, r) {
    var i = e.Slides;
    function s() {
        EventInterface$1(t).on([EVENT_MOUNTED, EVENT_REFRESH], n)
    }
    function n() {
        i.forEach(function(l) {
            l.style("transform", "translateX(-" + 100 * l.index + "%)")
        })
    }
    function a(l, o) {
        i.style("transition", "opacity " + r.speed + "ms " + r.easing),
        nextTick(o)
    }
    return {
        mount: s,
        start: a,
        cancel: noop
    }
}
function Slide(t, e, r) {
    var i = e.Move, s = e.Controller, n = e.Scroll, a = e.Elements.list, l = apply$2(style, a, "transition"), o;
    function h() {
        EventInterface$1(t).bind(a, "transitionend", function(g) {
            g.target === a && o && (S(),
            o())
        })
    }
    function p(g, v) {
        var d = i.toPosition(g, !0)
          , b = i.getPosition()
          , u = c(g);
        abs$1(d - b) >= 1 && u >= 1 ? r.useScroll ? n.scroll(d, u, !1, v) : (l("transform " + u + "ms " + r.easing),
        i.translate(d, !0),
        o = v) : (i.jump(g),
        v())
    }
    function S() {
        l(""),
        n.cancel()
    }
    function c(g) {
        var v = r.rewindSpeed;
        if (t.is(SLIDE$1) && v) {
            var d = s.getIndex(!0)
              , b = s.getEnd();
            if (d === 0 && g >= b || d >= b && g === 0)
                return v
        }
        return r.speed
    }
    return {
        mount: h,
        start: p,
        cancel: S
    }
}
var _Splide = function() {
    function t(r, i) {
        this.event = EventInterface$1(),
        this.Components = {},
        this.state = State(CREATED),
        this.splides = [],
        this._o = {},
        this._E = {};
        var s = isString(r) ? query(document, r) : r;
        assert(s, s + " is invalid."),
        this.root = s,
        i = merge({
            label: getAttribute(s, ARIA_LABEL) || "",
            labelledby: getAttribute(s, ARIA_LABELLEDBY) || ""
        }, DEFAULTS$1, t.defaults, i || {});
        try {
            merge(i, JSON.parse(getAttribute(s, DATA_ATTRIBUTE)))
        } catch {
            assert(!1, "Invalid JSON")
        }
        this._o = Object.create(merge({}, i))
    }
    var e = t.prototype;
    return e.mount = function(i, s) {
        var n = this
          , a = this.state
          , l = this.Components;
        assert(a.is([CREATED, DESTROYED]), "Already mounted!"),
        a.set(CREATED),
        this._C = l,
        this._T = s || this._T || (this.is(FADE$1) ? Fade : Slide),
        this._E = i || this._E;
        var o = assign$2({}, ComponentConstructors, this._E, {
            Transition: this._T
        });
        return forOwn$2(o, function(h, p) {
            var S = h(n, l, n._o);
            l[p] = S,
            S.setup && S.setup()
        }),
        forOwn$2(l, function(h) {
            h.mount && h.mount()
        }),
        this.emit(EVENT_MOUNTED),
        addClass(this.root, CLASS_INITIALIZED),
        a.set(IDLE),
        this.emit(EVENT_READY),
        this
    }
    ,
    e.sync = function(i) {
        return this.splides.push({
            splide: i
        }),
        i.splides.push({
            splide: this,
            isParent: !0
        }),
        this.state.is(IDLE) && (this._C.Sync.remount(),
        i.Components.Sync.remount()),
        this
    }
    ,
    e.go = function(i) {
        return this._C.Controller.go(i),
        this
    }
    ,
    e.on = function(i, s) {
        return this.event.on(i, s),
        this
    }
    ,
    e.off = function(i) {
        return this.event.off(i),
        this
    }
    ,
    e.emit = function(i) {
        var s;
        return (s = this.event).emit.apply(s, [i].concat(slice$2(arguments, 1))),
        this
    }
    ,
    e.add = function(i, s) {
        return this._C.Slides.add(i, s),
        this
    }
    ,
    e.remove = function(i) {
        return this._C.Slides.remove(i),
        this
    }
    ,
    e.is = function(i) {
        return this._o.type === i
    }
    ,
    e.refresh = function() {
        return this.emit(EVENT_REFRESH),
        this
    }
    ,
    e.destroy = function(i) {
        i === void 0 && (i = !0);
        var s = this.event
          , n = this.state;
        return n.is(CREATED) ? EventInterface$1(this).on(EVENT_READY, this.destroy.bind(this, i)) : (forOwn$2(this._C, function(a) {
            a.destroy && a.destroy(i)
        }, !0),
        s.emit(EVENT_DESTROY$1),
        s.destroy(),
        i && empty$1(this.splides),
        n.set(DESTROYED)),
        this
    }
    ,
    _createClass(t, [{
        key: "options",
        get: function() {
            return this._o
        },
        set: function(i) {
            this._C.Media.set(i, !0, !0)
        }
    }, {
        key: "length",
        get: function() {
            return this._C.Slides.getLength(!0)
        }
    }, {
        key: "index",
        get: function() {
            return this._C.Controller.getIndex()
        }
    }]),
    t
}()
  , Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;
/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
function empty(t) {
    t.length = 0
}
function slice$1(t, e, r) {
    return Array.prototype.slice.call(t, e, r)
}
function apply$1(t) {
    return t.bind.apply(t, [null].concat(slice$1(arguments, 1)))
}
function raf(t) {
    return requestAnimationFrame(t)
}
function typeOf$1(t, e) {
    return typeof e === t
}
var isArray$1 = Array.isArray;
apply$1(typeOf$1, "function");
apply$1(typeOf$1, "string");
apply$1(typeOf$1, "undefined");
function toArray$1(t) {
    return isArray$1(t) ? t : [t]
}
function forEach$1(t, e) {
    toArray$1(t).forEach(e)
}
var ownKeys$1 = Object.keys;
function forOwn$1(t, e, r) {
    if (t) {
        var i = ownKeys$1(t);
        i = r ? i.reverse() : i;
        for (var s = 0; s < i.length; s++) {
            var n = i[s];
            if (n !== "__proto__" && e(t[n], n) === !1)
                break
        }
    }
    return t
}
function assign$1(t) {
    return slice$1(arguments, 1).forEach(function(e) {
        forOwn$1(e, function(r, i) {
            t[i] = e[i]
        })
    }),
    t
}
var min$1 = Math.min;
function EventBinder() {
    var t = [];
    function e(a, l, o, h) {
        s(a, l, function(p, S, c) {
            var g = "addEventListener"in p
              , v = g ? p.removeEventListener.bind(p, S, o, h) : p.removeListener.bind(p, o);
            g ? p.addEventListener(S, o, h) : p.addListener(o),
            t.push([p, S, c, o, v])
        })
    }
    function r(a, l, o) {
        s(a, l, function(h, p, S) {
            t = t.filter(function(c) {
                return c[0] === h && c[1] === p && c[2] === S && (!o || c[3] === o) ? (c[4](),
                !1) : !0
            })
        })
    }
    function i(a, l, o) {
        var h, p = !0;
        return typeof CustomEvent == "function" ? h = new CustomEvent(l,{
            bubbles: p,
            detail: o
        }) : (h = document.createEvent("CustomEvent"),
        h.initCustomEvent(l, p, !1, o)),
        a.dispatchEvent(h),
        h
    }
    function s(a, l, o) {
        forEach$1(a, function(h) {
            h && forEach$1(l, function(p) {
                p.split(" ").forEach(function(S) {
                    var c = S.split(".");
                    o(h, c[0], c[1])
                })
            })
        })
    }
    function n() {
        t.forEach(function(a) {
            a[4]()
        }),
        empty(t)
    }
    return {
        bind: e,
        unbind: r,
        dispatch: i,
        destroy: n
    }
}
var EVENT_MOVE = "move"
  , EVENT_MOVED = "moved"
  , EVENT_UPDATED = "updated"
  , EVENT_DRAG = "drag"
  , EVENT_DRAGGED = "dragged"
  , EVENT_SCROLL = "scroll"
  , EVENT_SCROLLED = "scrolled"
  , EVENT_DESTROY = "destroy";
function EventInterface(t) {
    var e = t ? t.event.bus : document.createDocumentFragment()
      , r = EventBinder();
    function i(n, a) {
        r.bind(e, toArray$1(n).join(" "), function(l) {
            a.apply(a, isArray$1(l.detail) ? l.detail : [])
        })
    }
    function s(n) {
        r.dispatch(e, n, slice$1(arguments, 1))
    }
    return t && t.event.on(EVENT_DESTROY, r.destroy),
    assign$1(r, {
        bus: e,
        on: i,
        off: apply$1(r.unbind, e),
        emit: s
    })
}
function RequestInterval(t, e, r, i) {
    var s = Date.now, n, a = 0, l, o = !0, h = 0;
    function p() {
        if (!o) {
            if (a = t ? min$1((s() - n) / t, 1) : 1,
            r && r(a),
            a >= 1 && (e(),
            n = s(),
            i && ++h >= i))
                return c();
            raf(p)
        }
    }
    function S(u) {
        !u && v(),
        n = s() - (u ? a * t : 0),
        o = !1,
        raf(p)
    }
    function c() {
        o = !0
    }
    function g() {
        n = s(),
        a = 0,
        r && r(a)
    }
    function v() {
        l && cancelAnimationFrame(l),
        a = 0,
        l = 0,
        o = !0
    }
    function d(u) {
        t = u
    }
    function b() {
        return o
    }
    return {
        start: S,
        rewind: g,
        pause: c,
        cancel: v,
        set: d,
        isPaused: b
    }
}
function Throttle(t, e) {
    var r;
    function i() {
        r || (r = RequestInterval(e || 0, function() {
            t(),
            r = null
        }, null, 1),
        r.start())
    }
    return i
}
var CLASS_ACTIVE = "is-active"
  , SLIDE = "slide"
  , FADE = "fade";
function slice(t, e, r) {
    return Array.prototype.slice.call(t, e, r)
}
function apply(t) {
    return t.bind(null, ...slice(arguments, 1))
}
function typeOf(t, e) {
    return typeof e === t
}
function isObject(t) {
    return !isNull(t) && typeOf("object", t)
}
const isArray = Array.isArray;
apply(typeOf, "function");
apply(typeOf, "string");
const isUndefined = apply(typeOf, "undefined");
function isNull(t) {
    return t === null
}
function toArray(t) {
    return isArray(t) ? t : [t]
}
function forEach(t, e) {
    toArray(t).forEach(e)
}
function toggleClass(t, e, r) {
    t && forEach(e, i=>{
        i && t.classList[r ? "add" : "remove"](i)
    }
    )
}
const ownKeys = Object.keys;
function forOwn(t, e, r) {
    if (t) {
        let i = ownKeys(t);
        i = r ? i.reverse() : i;
        for (let s = 0; s < i.length; s++) {
            const n = i[s];
            if (n !== "__proto__" && e(t[n], n) === !1)
                break
        }
    }
    return t
}
function assign(t) {
    return slice(arguments, 1).forEach(e=>{
        forOwn(e, (r,i)=>{
            t[i] = e[i]
        }
        )
    }
    ),
    t
}
function removeAttribute(t, e) {
    forEach(t, r=>{
        forEach(e, i=>{
            r && r.removeAttribute(i)
        }
        )
    }
    )
}
function setAttribute(t, e, r) {
    isObject(e) ? forOwn(e, (i,s)=>{
        setAttribute(t, s, i)
    }
    ) : forEach(t, i=>{
        isNull(r) || r === "" ? removeAttribute(i, e) : i.setAttribute(e, String(r))
    }
    )
}
const {min, max, floor, ceil, abs} = Math;
function clamp(t, e, r) {
    const i = min(e, r)
      , s = max(e, r);
    return min(max(i, t), s)
}
const DEFAULTS = {
    speed: 1,
    autoStart: !0,
    pauseOnHover: !0,
    pauseOnFocus: !0
}
  , I18N = {
    startScroll: "Start auto scroll",
    pauseScroll: "Pause auto scroll"
};
function AutoScroll(t, e, r) {
    const {on: i, off: s, bind: n, unbind: a} = EventInterface(t)
      , {translate: l, getPosition: o, toIndex: h, getLimit: p} = e.Move
      , {setIndex: S, getIndex: c} = e.Controller
      , {orient: g} = e.Direction
      , {toggle: v} = e.Elements
      , {Live: d} = e
      , {root: b} = t
      , u = Throttle(e.Arrows.update, 500);
    let m = {}, f, y, _, T, C, x;
    function w() {
        const {autoScroll: $} = r;
        m = assign({}, DEFAULTS, isObject($) ? $ : {})
    }
    function D() {
        t.is(FADE) || !f && r.autoScroll !== !1 && (f = RequestInterval(0, E),
        L(),
        O())
    }
    function k() {
        f && (f.cancel(),
        f = null,
        x = void 0,
        s([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL, EVENT_MOVED, EVENT_SCROLLED]),
        a(b, "mouseenter mouseleave focusin focusout"),
        a(v, "click"))
    }
    function L() {
        m.pauseOnHover && n(b, "mouseenter mouseleave", $=>{
            _ = $.type === "mouseenter",
            M()
        }
        ),
        m.pauseOnFocus && n(b, "focusin focusout", $=>{
            T = $.type === "focusin",
            M()
        }
        ),
        m.useToggleButton && n(v, "click", ()=>{
            y ? R() : P()
        }
        ),
        i(EVENT_UPDATED, V),
        i([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL], ()=>{
            C = !0,
            P(!1)
        }
        ),
        i([EVENT_MOVED, EVENT_DRAGGED, EVENT_SCROLLED], ()=>{
            C = !1,
            M()
        }
        )
    }
    function V() {
        const {autoScroll: $} = r;
        $ !== !1 ? (m = assign({}, m, isObject($) ? $ : {}),
        D()) : k(),
        f && !isUndefined(x) && l(x)
    }
    function O() {
        m.autoStart && (document.readyState === "complete" ? R() : n(window, "load", R))
    }
    function R() {
        N() && (f.start(!0),
        d.disable(!0),
        T = _ = y = !1,
        I())
    }
    function P($=!0) {
        y || (y = $,
        I(),
        N() || (f.pause(),
        d.disable(!1)))
    }
    function M() {
        y || (_ || T || C ? P(!1) : R())
    }
    function E() {
        const $ = o()
          , H = A($);
        $ !== H ? (l(H),
        F(x = o())) : (P(!1),
        m.rewind && t.go(m.speed > 0 ? 0 : e.Controller.getEnd())),
        u()
    }
    function A($) {
        const H = m.speed || 1;
        return $ += g(H),
        t.is(SLIDE) && ($ = clamp($, p(!1), p(!0))),
        $
    }
    function F($) {
        const {length: H} = t
          , W = (h($) + H) % H;
        W !== c() && (S(W),
        e.Slides.update(),
        e.Pagination.update(),
        r.lazyLoad === "nearby" && e.LazyLoad.check())
    }
    function I() {
        if (v) {
            const $ = y ? "startScroll" : "pauseScroll";
            toggleClass(v, CLASS_ACTIVE, !y),
            setAttribute(v, "aria-label", r.i18n[$] || I18N[$])
        }
    }
    function N() {
        return !f || f.isPaused()
    }
    return {
        setup: w,
        mount: D,
        destroy: k,
        play: R,
        pause: P,
        isPaused: N
    }
}
function getCoords(t) {
    let e = t.getBoundingClientRect();
    return {
        top: e.top + window.pageYOffset,
        right: e.right + window.pageXOffset,
        bottom: e.bottom + window.pageYOffset,
        left: e.left + window.pageXOffset
    }
}
function header() {
    const t = document.querySelector(".nav")
      , e = document.querySelector(".open-nav")
      , r = document.querySelector(".close-nav");
    e.addEventListener("click", i=>{
        i.preventDefault(),
        t.classList.add("open")
    }
    ),
    r.addEventListener("click", i=>{
        i.preventDefault(),
        t.classList.remove("open")
    }
    )
}
header();
function customCursor() {
    document.querySelectorAll(".cursor").forEach(e=>{
        const r = e.querySelector(".js-cursor");
        e.addEventListener("mousemove", i=>{
            const s = getCoords(e)
              , n = i.pageX - s.left - r.clientWidth / 2
              , a = i.pageY - s.top - r.clientHeight / 2;
            r.style.left = `${n}px`,
            r.style.top = `${a}px`
        }
        )
    }
    )
}
document.querySelector(".js-cursor") !== null && customCursor();
function anhor() {
    const t = document.querySelectorAll('a[href*="#"]');
    for (let e of t)
        e.addEventListener("click", function(r) {
            r.preventDefault();
            const i = e.getAttribute("href").substr(1)
              , s = document.getElementById(i)
              , n = document.getElementById("header");
            if (s != null) {
                let a = s.getBoundingClientRect().top + window.pageYOffset;
                a = a - n.offsetHeight - 50,
                window.scrollTo({
                    top: a,
                    behavior: "smooth"
                })
            }
        })
}
anhor();
function animationIcon() {
    let t = document.querySelectorAll(".icon");
    document.addEventListener("scroll", e),
    document.addEventListener("DOMContentLoaded", e);
    function e() {
        t.forEach(i=>{
            let s = null;
            r(i) && i.dataset.start == "true" && (s = lottie.loadAnimation({
                container: i,
                path: "cdn/shop/files/" + i.dataset.src + ".json",
                renderer: i.dataset.render,
                loop: !!i.dataset.loop,
                autoplay: !0
            }),
            i.dataset.start = !1,
            i.dataset.src == "coin" && s.goToAndStop(s.totalFrames + 1, !0)),
            i.closest(".icon-hover") != null && (i.closest(".icon-hover").addEventListener("mouseenter", n=>{
                s != null && (s.stop(),
                s.play())
            }
            ),
            i.closest(".icon-hover").addEventListener("mouseleave", n=>{
                s != null && s.stop()
            }
            ))
        }
        )
    }
    function r(i) {
        var s = i.getBoundingClientRect()
          , n = s.top
          , a = s.bottom;
        return n >= 0 && a <= window.innerHeight + 300
    }
}
animationIcon();
document.querySelector(".reviews .splide") != null && new Splide(".reviews .splide",{
    type: "loop",
    drag: "free",
    focus: "center",
    perPage: 6,
    gap: 30,
    padding: "10%",
    autoScroll: {
        speed: .5
    },
    arrows: !1,
    pagination: !1,
    direction: "rtl",
    breakpoints: {
        1600: {
            perPage: 5,
            gap: 20
        },
        1024: {
            perPage: 4,
            gap: 15,
            padding: "5%"
        },
        767: {
            perPage: 3,
            gap: 30,
            padding: "10%"
        },
        600: {
            perPage: 2,
            padding: "15%"
        },
        500: {
            perPage: 1,
            padding: "18%"
        }
    }
}).mount({
    AutoScroll
});
document.querySelector(".doctors .splide") != null && new Splide(".doctors .splide",{
    type: "fade",
    rewind: !0,
    perPage: 1,
    autoplay: !0,
    mediaQuery: "min",
    pagination: !1,
    breakpoints: {
        767: {
            destroy: !0
        }
    }
}).mount();
if (document.querySelector(".main-slider") != null) {
    const t = new Splide(".main-slider",{
        type: "fade",
        pagination: !1,
        arrows: !0,
        cover: !0
    })
      , e = new Splide(".thumbnail-slider",{
        perPage: 4,
        isNavigation: !0,
        gap: 29,
        pagination: !1,
        arrows: !1,
        dragMinThreshold: {
            mouse: 4,
            touch: 10
        },
        breakpoints: {
            1600: {
                gap: 20
            },
            500: {
                gap: 15
            }
        }
    });
    t.sync(e),
    t.mount(),
    e.mount()
}
document.querySelector(".company-slider .splide") != null && new Splide(".company-slider .splide",{
    type: "loop",
    perPage: 3,
    padding: "30px",
    mediaQuery: "min",
    arrows: !1,
    pagination: !1,
    gap: 20,
    autoplay: !0,
    breakpoints: {
        767: {
            destroy: !0
        }
    }
}).mount();

function pauseAllVideo() {
    document.querySelectorAll("video").forEach(e=>{
        e.pause();
        document.querySelectorAll(".splide__slide").forEach(_QQ=>{
	        _QQ.classList.remove("playing")
	    })
    })
}
pauseAllVideo();

function pauseCurrentVideo() {
    document.querySelectorAll("video").forEach(e=>{
        e.addEventListener("click", r=>{
			pauseAllVideo();
	        document.querySelectorAll(".splide__slide").forEach(_QQ=>{
		        _QQ.classList.remove("playing")
		    })
        })
    })
}
pauseCurrentVideo();

function reviewsVideo() {
    document.querySelectorAll(".reviews .btn-play").forEach(e=>{
        e.addEventListener("click", r=>{
			pauseAllVideo();
            // document.querySelector("video").play(),
            r.target.closest(".image").querySelector("video").play(),
            console.log(r.target.closest(".splide__slide")),
            r.target.closest(".splide__slide").classList.add("playing")
        }
        )
    }
    )
}
reviewsVideo();

function pillowSlider() {
    const t = {
        left: "left",
        right: "right"
    }
      , e = document.querySelector(".pillow-slider");
    let r = e.querySelectorAll(".item")
      , i = r.length
      , s = e.querySelector(".btn-prev")
      , n = e.querySelector(".btn-next");
    s.addEventListener("click", l=>{
        a("left")
    }
    ),
    n.addEventListener("click", l=>{
        a("right")
    }
    ),
    r.forEach((l,o)=>{
        l.setAttribute("position", o + 1)
    }
    );
    function a(l) {
        t.right === l ? r.forEach((o,h)=>{
            let p = +o.getAttribute("position")
              , S = p - 1 < 1 ? 3 : p - 1;
            o.setAttribute("position", S)
        }
        ) : r.forEach((o,h)=>{
            let p = +o.getAttribute("position")
              , S = p + 1 > i ? 1 : p + 1;
            o.setAttribute("position", S)
        }
        )
    }
}
document.querySelector(".pillow-slider") != null && pillowSlider();
function perspective() {
    const t = document.querySelector(".perspective .pillow-order");
    let e;
    function r(i) {
        const s = i.clientX
          , n = i.clientY
          , a = s - e.x
          , l = n - e.y
          , o = {
            x: a - e.width / 2,
            y: l - e.height / 2
        }
          , h = Math.sqrt(o.x ** 2 + o.y ** 2);
        t.style.transform = `
            rotate3d(
                ${-o.y / 100},
                ${o.x / 100},
                0,
                ${Math.log(h) * .7}deg
            )
        `
    }
    t.addEventListener("mouseenter", ()=>{
        e = t.getBoundingClientRect(),
        document.addEventListener("mousemove", r)
    }
    ),
    t.addEventListener("mouseleave", ()=>{
        document.removeEventListener("mousemove", r),
        t.style.transform = "",
        t.style.background = ""
    }
    )
}
document.querySelector(".perspective .pillow-order") != null && perspective();
function homeSlider() {
    const t = document.querySelector(".home-slider")
      , e = t.querySelector(".controls.left")
      , r = t.querySelector(".controls.right")
      , i = t.querySelector(".slide");
    r.querySelectorAll("li").forEach(n=>{
        n.addEventListener("click", a=>{
            a.preventDefault();
            const l = a.target.closest("li").dataset.type;
            e.dataset.type = l,
            e.querySelectorAll("li").forEach(o=>o.classList.remove("active")),
            r.querySelectorAll("li").forEach(o=>o.classList.remove("active")),
            n.classList.add("active"),
            s(l)
        }
        , !0)
    }
    );
    function s(n) {
        e.querySelector("li:first-child").classList.add("active"),
        n == "sleep" ? i.querySelector("img").src = e.querySelector("li:first-child").dataset.srcSleep : n == "travel" ? i.querySelector("img").src = e.querySelector("li:first-child").dataset.srcTravel : i.querySelector("img").src = e.querySelector("li:first-child").dataset.srcSit,
        e.querySelectorAll("li").forEach(a=>{
            const l = a.querySelector("img");
            a.classList.remove("hidden"),
            n == "sleep" ? l.src = a.dataset.srcSleep : n == "travel" ? l.src = a.dataset.srcTravel : (l.src = a.dataset.srcSit,
            a.dataset.srcSit == null && a.classList.add("hidden"))
        }
        )
    }
    e.querySelectorAll("li").forEach(n=>{
        n.addEventListener("click", a=>{
            i.querySelector("img").src = a.target.closest("li").querySelector("img").src,
            i.classList.add("active"),
            e.querySelectorAll("li").forEach(l=>l.classList.remove("active")),
            n.classList.add("active"),
            i.addEventListener("animationend", l=>{
                i.classList.remove("active")
            }
            )
        }
        )
    }
    )
}
document.querySelector(".home-slider") != null && homeSlider();
function bgAnimation() {
    const t = document.querySelector(".bg-animation");
    t.classList.remove("active"),
    t.classList.remove("hid"),
    setTimeout(()=>{
        t.classList.add("active")
    }
    , 1e3),
    t.addEventListener("transitionend", e=>{
        t.classList.add("hid")
    }
    )
}
document.querySelector(".bg-animation") != null && bgAnimation();
function perfectTab() {
    const t = document.querySelector(".perfect-sleep")
      , e = t.querySelectorAll(".buttons a")
      , r = t.querySelectorAll(".content .item")
      , i = t.querySelectorAll(".image .item");
    let s = null;
    e.forEach((n,a)=>{
        n.addEventListener("click", l=>{
            l.preventDefault(),
            s && s.classList.remove("active"),
            r.forEach(o=>{
                o.classList.remove("active")
            }
            ),
            i[a].classList.add("active"),
            r[a].classList.add("active"),
            s = i[a]
        }
        )
    }
    )
}
document.querySelector(".perfect-sleep") != null && perfectTab();
function animScrollPage() {
    const t = document.querySelectorAll(".animated")
      , e = {
        rootMargin: "0px"
    }
      , r = new IntersectionObserver(i=>{
        i.forEach(s=>{
            s.isIntersecting && s.target.classList.add("show")
        }
        )
    }
    ,e);
    t.forEach(i=>{
        r.observe(i)
    }
    )
}
animScrollPage();
function typer() {
    const t = "DISCOVER DREAM SLEEP"
      , e = document.querySelector(".typer");
    let r, i = !0;
    function s() {
        e.innerHTML = "",
        r = 0,
        a(t, e)
    }
    function n(o) {
        return o == ";" || o == "." || o == "," ? Math.floor(Math.random() * 1e3 + 1e3) : Math.floor(Math.random() * 300 + 5)
    }
    function a(o, h) {
        typeof o[r] < "u" && (h.innerHTML += o[r]),
        r++,
        r < o.length && setTimeout(function() {
            a(o, h)
        }, n(o[r - 1]))
    }
    new IntersectionObserver(o=>{
        o.forEach(h=>{
            h.isIntersecting && i && (s(),
            i = !1)
        }
        )
    }
    ,{
        rootMargin: "0px"
    }).observe(e)
}
document.querySelector(".typer") != null && typer();
function faq() {
    const t = document.querySelectorAll(".faq li");
    t.forEach(e=>{
        e.querySelector("h3").addEventListener("click", r=>{
            t.forEach(i=>i.classList.remove("active")),
            e.classList.add("active")
        }
        )
    }
    )
}
document.querySelector(".faq") != null && faq();
function select() {
    document.querySelectorAll(".select").forEach(e=>{
        e.querySelector(".selected").addEventListener("click", r=>{
            e.classList.toggle("active"),
            e.querySelectorAll("ul li").forEach(i=>{
                i.addEventListener("click", s=>{
                    e.querySelector(".selected span").textContent = s.target.textContent,
                    e.classList.remove("active")
                }
                )
            }
            )
        }
        )
    }
    )
}
select();
function accordeon() {
    let t = document.querySelectorAll(".accordeon");
    if (t != null)
        for (var e = 0; e < t.length; e++) {
            const s = t[e].querySelectorAll(".item-accordeon");
            for (var r = 0; r < s.length; r++)
                if (s[r].querySelector(".btn-accordeon").addEventListener("click", i),
                s[r].classList.contains("active")) {
                    let a = s[r].querySelector(".content-accordeon")
                      , l = s[r].querySelector(".inner-accordeon");
                    a.style.height = l.clientHeight + 2 + "px"
                }
        }
    function i(s) {
        this.closest(".accordeon").querySelectorAll(".item-accordeon");
        let n = this.parentNode.querySelector(".inner-accordeon")
          , a = this.parentNode.querySelector(".content-accordeon");
        this.parentNode.classList.contains("active") ? (this.parentNode.classList.remove("active"),
        a.removeAttribute("style")) : (this.parentNode.classList.add("active"),
        a.style.height = n.clientHeight + 2 + "px")
    }
}
accordeon();
function popup() {
    let t = document.querySelectorAll(".btn-popup")
      , e = document.querySelector(".popup-overlay")
      , r = null
      , i = null;
    for (var s = 0; s < t.length; s++)
        t[s].addEventListener("click", function(a) {
            a.preventDefault(),
            r = document.querySelector(".popup-" + this.getAttribute("data-popup")),
            i = r.querySelector(".popup-close");
            let l = window.pageYOffset || document.documentElement.scrollTop;
            window.pageXOffset || document.documentElement.scrollLeft,
            this.dataset.popup == "order" ? e = document.querySelector(".overlay-product") : e = document.querySelector(".popup-overlay"),
            console.log(e),
            e.classList.add("active"),
            r.classList.add("active"),
            r.style.top = l + 100 + "px",
            i.addEventListener("click", n),
            r.querySelector("video").play(),
            e.addEventListener("click", n)
        });
    document.addEventListener("keydown", function(a) {
        a.keyCode == 27 && n(a)
    });
    function n(a) {
        a.preventDefault(),
        e.classList.remove("active"),
        r.classList.remove("active"),
        r.querySelector("video").pause()
    }
}
popup();
